(function () {
    'use strict';

    angular
        .module('app.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.login', {
            url: '/app/login',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.login': {
                    templateUrl: 'app/main/login/login.html',
                    controller: 'LoginController as vm'
                }
            },
            bodyClass: 'Login',
            ModuleName: 'Login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/login');

        // Navigation
        // msNavigationServiceProvider.saveItem('Demo.login', {
        //     title : 'Authentication',
        //     icon  : 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Demo.login', {
        //     title: 'Login',
        //     state: 'app.login',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.login')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController($http, $mdDialog, $mdToast, $scope, $rootScope, $cookieStore, Tasks, event, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;

        $scope.init = function () {
            $scope.model = {
                email: '',
                username: '',
                password: '',
                cpassword: '',
                phone: '',
                country: '',
                state: '',
                city: '',
                gender: '',
                createdby: '',
                createddate: new Date(),
            };
            GetAllCountry();
        }

        function GetAllCountry() {
            $http.get($rootScope.RoutePath + "country/GetAllCountry").then(function (data) {
                $scope.lstCountry = data.data;
            });
        }

        $scope.GetAllStateByCountry = function (idCountry) {
            for (var i = 0; i < $scope.lstCountry.length; i++) {
                if ($scope.lstCountry[i].Country == idCountry) {
                    idCountry = $scope.lstCountry[i].id;
                }
            }
            $scope.model.idState = '';
            $scope.lstState = '';
            var params = {
                CountryId: idCountry
            };
            $http.get($rootScope.RoutePath + "state/GetAllStateByCountryId", { params: params }).success(function (data) {
                $scope.lstState = data.data;

            });
        }


        $scope.Register = function (o) {
            o.createdby = o.username;
            if (o.password.length < 6) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent("Enter six digit Password.")
                        .position('top right')
                        .hideDelay(3000)
                );

                return;
            } else if (o.password != o.cpassword) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent("Password and confirm password must be same.")
                        .position('top right')
                        .hideDelay(3000)
                );

                return;
            } else {
                $http.post($rootScope.RoutePath + "account/register", o).success(function (data) {
                    if (data.success == 1) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                        $mdDialog.hide();
                        $scope.init();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                    }
                });

            }
        }

        $scope.Cancel = function () {
            $mdDialog.hide();
            $scope.init();
        }
        $scope.init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.login')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController($http, $mdDialog, $mdToast, $scope, $rootScope, $cookieStore, Tasks, event, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;

        $scope.init = function () {
            $scope.model = {
                Email: '',
            };

        }

        //Forgot Password
        $scope.SubmitForgotPassword = 0;
        $scope.ForgotPassword = function (o) {
            // if (form.$valid) {
            var params = {
                Email: o.Email,
            }
            //     $http.get(route.Lookup.ForgotPassword, { params: params }).success(function(data) {
            //         if (data.success == 1) {
            //             toastr.success(data.message);
            //               $scope.SubmitForgotPassword = 0;
            //             $scope.Reset();
            //         } else {
            //             toastr.error(data.message);
            //         }
            //     });
            // } else {
            //     $scope.SubmitForgotPassword = 1;
            // }
        }
        //End Forgot Password
        // if (objCountry == 0) {
        //     $scope.tab = { selectedIndex: 1 };
        // }
        // else {
        // }

        $scope.init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.Zipcode', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.Zipcode', {
                url: '/Zipcode',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Zipcode/Zipcode.html',
                        controller: 'ZipcodeController as vm'
                    }
                },
                bodyClass: 'Zipcode',
                ModuleName: 'Zipcode'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/roles');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Roles',
        //     state: 'app.roles',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.Zipcode')
        .controller('ZipCodeInformationController', ZipCodeInformationController);

    /** @ngInject */
    function ZipCodeInformationController($mdToast, $document, $http, $mdDialog, $scope, Order_Id, VM, DTOptionsBuilder, $rootScope) {

        var vm = this;
        var MainVM = VM;
        $scope.search_enable = false
        $scope.model = {
            zip  : ''
        }
        $scope.init = function () {

        }

        $scope.closeModel = function () {
            $scope.search_enable = false
            $mdDialog.hide();
        }

        $scope.search_zip = function (zip) {
            if(zip.zip != "" ){
            $scope.search_enable = true
            $http.get($rootScope.RoutePath + 'zipcode/getzipcode/' + $scope.model.zip ).then(function (res) {
                if(res.data.success) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Zip code available')
                            .position('top right')
                            .hideDelay(3000)
                    );
                $scope.search_zip_result = res.data;
                $scope.zipcode = $scope.search_zip_result.message.zip
                $scope.no_zip =  false
                console.log($scope.search_zip_result)
                } else if (!res.data.success ){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Zip code not available !')
                            .position('top right')
                            .hideDelay(3000)
                    );
                $scope.search_zip_result = res.data;
                $scope.no_zip =  true

                }
            })
        }
        else {
            return alert('Please enter zipcode')
        }
        }



        $scope.delete_zip =  function(){
            
            var confirm = $mdDialog.confirm()
            .title('Are you sure to delete this Zipcode?')
            .textContent('')
            .ariaLabel('Lucky day')
            .targetEvent($scope.zipcode)
            .ok('Yes')
            .cancel('No');

            $mdDialog.show(confirm).then(function () {
                if($scope.zipcode != undefined || $scope.zipcode != null){

                $http.delete($rootScope.RoutePath + "zipcode/deletezip/" + $scope.zipcode).then(function (data) {
                    console.log(data)
                    
                    if (data.data.success) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                    } else {
                        if (data.data.data == 'TOKEN') {
                            //$cookieStore.remove('UserName');
                            //$cookieStore.remove('token');
                            //window.location.href = '/app/login';
                            $rootScope.logout();
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(data.data.message)
                                    .position('top right')
                                    .hideDelay(3000)
                            );
                        }
                    }
                        location.reload()

                });
            }

            
            }, function () { });

        }

        $scope.init();

    }
})();
(function() {
    'use strict';

    angular
        .module('app.user', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.user', {
                url: '/user',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/User/User.html',
                        controller: 'UserController as vm'
                    }
                },
                bodyClass: 'Users',
                ModuleName: 'Users'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.owneruser', {
        //     title: 'Owner Users',
        //     state: 'app.owneruser',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.user')
        .controller('UserPasswordConifrmationController', UserPasswordConifrmationController);

    /** @ngInject */
    function UserPasswordConifrmationController($mdToast, $http, $mdDialog, $scope, obj, Tasks, event, VM, $rootScope, flg) {

        $scope.username = obj.email;
        var vm = this;
        $scope.RoutePath = $rootScope.RoutePath;
        $scope.flg = flg;
        $scope.init = function() {
            $scope.pssword = '';
        }

        $scope.RestPassword = function(password) {
            var params = {
                // email: $scope.obj.email,
                // idApp: $rootScope.appId,
                id: obj.id,
                AppName: obj.AppName,
                password: password
            }
            ShowLoader();
            $http.get($rootScope.RoutePath + "account/forgotpasswordfromOwnerCustomerNew", { params: params }).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                } else {
                    if (data.data.data == 'TOKEN') {
                        $cookieStore.remove('UserName');
                        $cookieStore.remove('token');
                        $state.go('app.login', {
                            cache: false
                        });
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                    }

                }
                $mdDialog.hide();
                HideLoader();
            });

        }

        $scope.changePassword = function(pass) {
            var params = {
                password: pass,
            }
            ShowLoader();
            $http.get($rootScope.RoutePath + "account/passwordVerification", { params: params }).then(function(data) {
                if (data.data.success == true) {
                    // obj.AppName = localStorage.getItem('appName');
                    $http.post($rootScope.RoutePath + "account/changepasswordNew", obj).then(function(response) {
                        if (response.data.success == true) {
                            $mdToast.show(
                                $mdToast.simple()
                                .textContent(response.data.message)
                                .position('top right')
                                .hideDelay(3000)
                            );
                            $rootScope.FlgAddedEditlocal = false;
                            $scope.closeModel1();
                            HideLoader();
                        } else {
                            if (response.data.data == 'TOKEN') {
                                $rootScope.logout();
                            } else {
                                $mdToast.show(
                                    $mdToast.simple()
                                    .textContent(response.data.message)
                                    .position('top right')
                                    .hideDelay(3000)
                                );
                            }
                        }
                        $mdDialog.hide();
                        HideLoader();
                    });
                } else {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                    $mdDialog.hide();
                    HideLoader();
                }
            })

        }

        $scope.Reset = function() {
            $scope.pssword = '';
            $mdDialog.hide();
        }

        $scope.closeModel1 = function() {
            $mdDialog.hide();
        }

        function ShowLoader() {
            document.getElementById('processing1').style.display = "block";
            document.body.scrollTop = "0px";
        }

        function HideLoader() {
            document.getElementById('processing1').style.display = "none";
        }
        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.user')
        .controller('UserChangePasswordController', UserChangePasswordController);

    /** @ngInject */
    function UserChangePasswordController($mdToast, $document, $http, $mdDialog, $scope, obj, Tasks, event, VM, $rootScope) {

        var vm = this;
        $scope.RoutePath = $rootScope.RoutePath;
        $scope.DisplayEmail = obj.email;
        $scope.init = function() {
            $scope.model = {
                username: obj.username,
                oldpassword: '',
                password: '',
                confirmpassword: '',
                UserId: obj.id,
                AppName: obj.AppName,
            };
        }

        $scope.ChangePassword = function(ev, o) {
            if (o.confirmpassword != o.password) {
                $mdToast.show(
                    $mdToast.simple()
                    .textContent('Password and Confirm Password does not match...')
                    .position('top right')
                    .hideDelay(3000)
                );
            } else {
                $mdDialog.show({
                    // skipHide: true,
                    controller: 'UserPasswordConifrmationController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/User/dialogs/PasswordConfirmation/PasswordConfirmation.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    locals: {
                        obj: o,
                        Tasks: [],
                        event: ev,
                        VM: vm,
                        flg: 0
                    }
                })
            }
        }

        $scope.ChangePassword1 = function(o) {
            $http.post($rootScope.RoutePath + "account/changepassword", o).then(function(response) {

                if (response.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(response.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                    // $scope.GetAllBanner();
                    $rootScope.FlgAddedEditlocal = false;
                    $scope.closeModel1();
                } else {
                    if (response.data.data == 'TOKEN') {
                        //$cookieStore.remove('UserName');
                        //$cookieStore.remove('token');
                        //window.location.href = '/app/login';
                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(response.data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                    }
                }
            });
        }

        $scope.Reset = function() {
            if ($rootScope.FlgAddedAccess == true) {
                $scope.model = {
                    username: obj.username,
                    oldpassword: '',
                    password: '',
                    confirmpassword: '',
                    UserId: obj.id,
                    AppName: obj.AppName,
                };
                $scope.FormChangePassword.$setUntouched();
                $scope.FormChangePassword.$setPristine();
            }
        }

        $scope.closeModel1 = function() {
            $mdDialog.hide();
        }
        $scope.init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.ScheduleDelivery', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.ScheduleDelivery', {
                url: '/ScheduleDelivery',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/ScheduleDelivery/ScheduleDelivery.html',
                        controller: 'ScheduleDeliveryController as vm'
                    }
                },
                bodyClass: 'Schedule Delivery',
                ModuleName: 'Schedule Delivery'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.owneruser', {
        //     title: 'Owner Users',
        //     state: 'app.owneruser',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.ScheduleDelivery')
        .controller('ViewScheduleDeliveryController', ViewScheduleDeliveryController);

    /** @ngInject */
    function ViewScheduleDeliveryController($mdToast, $document, $http, bucket_no, $mdDialog, $scope, $rootScope) {

        var vm = this;

        $scope.init = function () {

            $scope.bucket_no = bucket_no;
            $scope.getAllBucketData(bucket_no);
            $scope.optimizedRouteWaypoints = [];

        }
        $scope.getAllBucketData = function (bucket_no) {
            $http.get($rootScope.RoutePath + "bucket/getAllDetailedBucketData?bucket_no=" + bucket_no).then(function (data) {
                console.log('data: ', data.data);
                $scope.lstdata1 = data.data.data;
                $scope.optimizedRouteWaypoints = data.data.optimizedRouteWaypoints;
                // console.log("test", $scope.lstdata1);
                // $scope.bingmap_route = (data.data.data[0].bucket[0].bingmap_response == undefined || data.data.data[0].bucket[0].bingmap_response.length == 0) ? '' : data.data.data[0].bucket[0].bingmap_response[0].route;
                // console.log('data.data.data[0].bucket[0].bingmap_response[0].route: ', data.data.data[0].bucket[0].bingmap_response[0].route);

                // if ($scope.bingmap_route) {
                //     var bingMapDeliveryInstruction = data.data.data[0].bucket[0].bingmap_response[0].instructions;
                //     var lst_order = [];
                //     for (var i = 0; i < bingMapDeliveryInstruction.length; i++) {
                //         var obj = {}
                //         if (bingMapDeliveryInstruction[i].instructionType == 'VisitLocation') {
                //             for (var j = 0; j < $scope.lstdata1.length; j++) {
                //                 if (bingMapDeliveryInstruction[i].itineraryItem.name == $scope.lstdata1[j].order_ids) {
                //                     obj = $scope.lstdata1[j]
                //                 }
                //             }
                //             lst_order.push(obj);
                //         }
                //     }
                //     $scope.lstdata1 = lst_order;
                // }
                _.filter($scope.lstdata1, function (item) {
                    item.displayDeliveryDate = dateTimeFormate(item.delivery_date, item.delivery_time);
                })
            });
        }
        vm.dtInstance = {};

        $scope.closeModel = function () {
            $mdDialog.hide();
        }
        // $scope.openRoute = function () {
        //     var url = "https://www.google.com/maps/dir/'" + $scope.bingmap_route.startLocation.latitude + ',' + $scope.bingmap_route.startLocation.longitude + "'/";
        //     for (var i = 0; i < $scope.bingmap_route.wayPoints.length; i++) {
        //         const element = $scope.bingmap_route.wayPoints[i];
        //         url += "'" + element.latitude + ',' + element.longitude + "'/";
        //     }
        //     url += "'" + $scope.bingmap_route.endLocation.latitude + ',' + $scope.bingmap_route.endLocation.longitude + "'/";
        //     window.open(url, '_system');
        // }
        $scope.openRoute = function () {
            var url = "https://www.google.com/maps/dir/";
            for (var i = 0; i < $scope.optimizedRouteWaypoints.length; i++) {
                const element = $scope.optimizedRouteWaypoints[i];
                url += "'" + element.latitude + ',' + element.longitude + "'/";
            }
            window.open(url, '_system');
        }
        function dateTimeFormate(date, time) {
            var date = moment(date).utc().format('MM-DD-YYYY');
            return date + " " + time;
        }
        $scope.uploadedFile = null;

        $scope.fileChanged = function (event) {
            var files = event.target.files;
            if (files.length > 0) {
                $scope.uploadedFile = files[0];
            }
        };

        $scope.submitFile = function (order_id, deliveryDateTime) {
            console.log('deliveryDateTime: ', deliveryDateTime);
            if (deliveryDateTime) {
                deliveryDateTime = moment(deliveryDateTime).local().format('YYYY-MM-DDTHH:mm:ss');
                console.log('Converted deliveryDateTime: ', deliveryDateTime);
            } else {
                return $mdToast.show(
                    $mdToast.simple()
                        .textContent('Please select a delivery date and time.')
                        .position('top right')
                        .hideDelay(3000)
                );
            }
            if ($scope.uploadedFile) {
                if ($scope.uploadedFile.type.startsWith('image/')) {
                    console.log("File submitted:", $scope.uploadedFile);
                } else {
                    return $mdToast.show(
                        $mdToast.simple()
                            .textContent('Please select a valid image file.')
                            .position('top right')
                            .hideDelay(3000)
                    );
                }

                var formData = new FormData();
                formData.append('file', $scope.uploadedFile);
                formData.append('delivered_at', deliveryDateTime);

                $http.post($rootScope.RoutePath + "bucket/update_order/" + order_id, formData, {
                    headers: { 'Content-Type': undefined },
                    transformRequest: angular.identity
                }).then(function (data) {
                    $scope.getAllBucketData(bucket_no);
                })
            } else {
                return $mdToast.show(
                    $mdToast.simple()
                        .textContent('Please select a file before submitting.')
                        .position('top right')
                        .hideDelay(3000)
                );
            }
        };


        $scope.init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.ScheduleDelivery')
        .controller('LyftBatchingDeliveryController', LyftBatchingDeliveryController);

    /** @ngInject */
    function LyftBatchingDeliveryController($mdToast, $document, $http, bucket_no, $mdDialog, $scope, $rootScope) {
        $scope.transferDate = null;
        $scope.transferDateDropoff = null;
        $scope.valid_date = false;
        $scope.valid_date_dropoff = false;
        $scope.showLoader = false;
        var vm = this;
        $scope.init = function () {
            $scope.bucket_no = bucket_no;
            $scope.getAllBucketData(bucket_no);
            $scope.bingmap_route;

        }

        $scope.handler = function () {
            document.getElementById('dateTime').blur()
        }
        $scope.handler2 = function () {
            document.getElementById('dateTimeDropoff').blur()
        }
        $scope.getAllBucketData = function (bucket_no) {
            $http.get($rootScope.RoutePath + "bucket/getAllDetailedBucketData?bucket_no=" + bucket_no).then(function (data) {
                $scope.lstdata1 = data.data.data;
                $scope.bingmap_route = (data.data.data[0].bucket[0].bingmap_response == undefined || data.data.data[0].bucket[0].bingmap_response.length == 0) ? '' : data.data.data[0].bucket[0].bingmap_response[0].route;
                if ($scope.bingmap_route) {
                    var bingMapDeliveryInstruction = data.data.data[0].bucket[0].bingmap_response[0].instructions;
                    var lst_order = [];
                    for (var i = 0; i < bingMapDeliveryInstruction.length; i++) {
                        var obj = {}
                        if (bingMapDeliveryInstruction[i].instructionType == 'VisitLocation') {
                            for (var j = 0; j < $scope.lstdata1.length; j++) {
                                if (bingMapDeliveryInstruction[i].itineraryItem.name == $scope.lstdata1[j].order_ids) {
                                    obj = $scope.lstdata1[j]
                                }
                            }
                            lst_order.push(obj);
                        }
                    }
                    $scope.lstdata1 = lst_order;
                }
                _.filter($scope.lstdata1, function (item) {
                    item.displayDeliveryDate = dateTimeFormate(item.delivery_date, item.delivery_time);
                })
            });
        }
        vm.dtInstance = {};

        $scope.closeModel = function () {
            $mdDialog.hide();
        }
        $scope.openRoute = function () {
            var url = "https://www.google.com/maps/dir/'" + $scope.bingmap_route.startLocation.latitude + ',' + $scope.bingmap_route.startLocation.longitude + "'/";
            for (var i = 0; i < $scope.bingmap_route.wayPoints.length; i++) {
                var element = $scope.bingmap_route.wayPoints[i];
                url += "'" + element.latitude + ',' + element.longitude + "'/";
            }
            url += "'" + $scope.bingmap_route.endLocation.latitude + ',' + $scope.bingmap_route.endLocation.longitude + "'/";
            window.open(url, '_system');
        }
        function dateTimeFormate(date, time) {
            var date = moment(date).utc().format('MM-DD-YYYY');
            return date + " " + time;
        }

        $scope.transfer = function () {

            var confirm = $mdDialog.confirm()
                .title('Are you sure to transfer order to Doordash?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent(bucket_no)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {

                if (bucket_no != undefined || bucket_no != null) {
                    var body = {
                        bucket_no: bucket_no
                    }

                    $('#loaderDiv').show();

                    //  $http.post($rootScope.RoutePath + "v1/baltoToLyftOrders", body).then(function (data) {
                    $http.post($rootScope.RoutePath + "v1/baltoToDoordashMultipleOrders", body).then(function (data) {
                        $('#loaderDiv').hide();
                        if (data.data.success) {
                            var allMessages = data.data.data.map(function (item) {
                                return item.message;
                            }).join('<br>');
                            $mdDialog.show({
                                template:
                                    '<md-dialog>' +
                                    '  <md-dialog-content style="color: red;">' +
                                    '    <h2>Order Transferred status : </h2>' +
                                    '    <div ng-bind-html="allMessages"></div>' + // Use ng-bind-html to render HTML content
                                    '  </md-dialog-content>' +
                                    '  <md-dialog-actions>' +
                                    '    <md-button ng-click="closeDialog()" class="md-primary">Close</md-button>' +
                                    '  </md-dialog-actions>' +
                                    '</md-dialog>',
                                locals: {
                                    allMessages: allMessages
                                },
                                controller: function ($scope, $mdDialog, $sce, allMessages) {
                                    // Use $sce.trustAsHtml to render HTML content
                                    $scope.allMessages = $sce.trustAsHtml(allMessages);
                        
                                    $scope.closeDialog = function () {
                                        $mdDialog.hide();
                                    };
                                }
                            });

                            // vm.dtInstance.reloadData(callback, true);
                            $('#ScheduleDeliveryTable').dataTable()._fnAjaxUpdate();
                        }
                        else if (data.data) {

                            $('#loaderDiv').hide();
                            return $mdDialog.show(
                                $mdDialog.alert()
                                    .parent(angular.element(document.querySelector('#popupContainer')))
                                    .clickOutsideToClose(true)
                                    .title('Order transferred failed.')
                                    .textContent(data.data.message)
                                    .ok('close')
                                    .targetEvent()
                            );
                        }
                    })
                        .catch(function (_error) {
                            $('#loaderDiv').hide();
                            // console.log(JSON.stringify(err))
                            if (_error.data){
                            if (_error.data.error_detail) {
                                for (var property in _error.data.error_detail[0]) {
                                    $mdDialog.show(
                                        $mdDialog.alert()
                                            .parent(angular.element(document.querySelector('#popupContainer')))
                                            .clickOutsideToClose(true)
                                            .title('Order transfer failed.')
                                            .textContent(_error.data.error_detail[0][property])
                                            .ok('close')
                                            .targetEvent()
                                    );
                                    return
                                }
                            }
                            else {
                                if (_error.data.error_description) {
                                    alert("Error", _error.data.error_description);
                                    $mdDialog.show(
                                        $mdDialog.alert()
                                            .parent(angular.element(document.querySelector('#popupContainer')))
                                            .clickOutsideToClose(true)
                                            .title('Order transfer failed.')
                                            .textContent(_error.data.error.error_description)
                                            .ok('close')
                                            .targetEvent()
                                    );
                                    return
                                } else {
                                    alert("Error", "OOPS ..!!! Error occurred ! ");
                                    return
                                }
                            }
                        }

                        })
                }
            }
            )




        }


        $scope.init();
    }
}) ();
(function () {
    'use strict';

    angular
        .module('app.ScheduleDelivery')
        .controller('ChangeDriverController', ChangeDriverController);

    /** @ngInject */
    function ChangeDriverController($http, $compile, $scope, Task, $rootScope, $state, $mdToast, $document, $mdDialog, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $timeout, $window, ObjVm, ObjDriver , oldDriverData, bucketData)  {
        var vm = this;
        $scope.lstData1 = ObjDriver;
        // console.log($scope.lstData1)
        $scope.init = function () {
            if ($scope.lstData1.driver_id != null) {
                $scope.model = {
                    _id: $scope.lstData1.driver_id,
                }
            } else {
                $scope.model = {
                    _id: null,
                }
            }
            $scope.getAllDriver();
        }

        $scope.getAllDriver = function () {
            $http.get($rootScope.RoutePath + "driver/getAllDriver").then(function (data) {
                $scope.lstfullname = [];
                $scope.lstAllDriver = data.data.data;
            });
        }
        $scope.UpdateDriverName = function () {

            var obj = {
                old_driver_id: $scope.lstData1.driver_id,
                bucket_no: $scope.lstData1.bucket_no,
                new_driver_id: $scope.model._id
            }

            if ($scope.lstData1.driver_id != null && $scope.lstData1.driver_id != '' && $scope.lstData1.driver_id != undefined) {
                $http.post($rootScope.RoutePath + "bucket/changeDriver", obj).then(function (data) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    );
                    $('#ScheduleDeliveryTable').dataTable()._fnAjaxUpdate();
                    $scope.closeModel();
                });
            } else {
                var data = _.findWhere($scope.lstAllDriver, {
                    _id: $scope.model._id
                });

                var objData = {
                    driver_name: data.first_name + ' ' + data.last_name + ' ' + data.middle_name,
                    driver_image: data.image_path,
                    driver_id: $scope.model._id,
                    bucket_no: $scope.lstData1.bucket_no,
                    request_status: 'accept'
                }
                $http.post($rootScope.RoutePath + "bucket/assignNewDriver", objData).then(function (data) {
                    // console.log(data)
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.success)
                            .position('top right')
                            .hideDelay(3000)
                    );
                    $('#ScheduleDeliveryTable').dataTable()._fnAjaxUpdate();
                    $scope.closeModel();
                });
            }
        }

        $scope.closeModel = function (ev) {
            $mdDialog.hide();
        }

        $scope.Reset = function () {
            $mdDialog.hide();
        }
        $scope.sendToLyft = function () {
            var orderToLyftData = {
                old_driver_id :  oldDriverData,
                bucket_no : bucketData
            }
            // console.log(orderToLyftData)
            $http.post($rootScope.RoutePath + "bucket/changeDriverToLyft", orderToLyftData).then(function (data) {
                // console.log(data)
                if(data.data.status){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    );
                }else {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    );
                }
              
                $('#ScheduleDeliveryTable').dataTable()._fnAjaxUpdate();
                $scope.closeModel();
            }).catch(function(err) {
                // console.log(err)
            })
            
        }

        $scope.init();
    }
})();

(function () {
    'use strict';

    angular
        .module('app.SuggestPharmacy', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.SuggestPharmacy', {
                url: '/SuggestPharmacy',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/SuggestPharmacy/SuggestPharmacy.html',
                        controller: 'SuggestPharmacyController as vm'
                    }
                },
                bodyClass: 'SuggestPharmacy',
                ModuleName: 'SuggestPharmacy'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/roles');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Roles',
        //     state: 'app.roles',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.SuggestPharmacy')
        .controller('suggestpharmacyEditController', suggestpharmacyEditController);

    /** @ngInject */
    function suggestpharmacyEditController($mdToast, patient_id, old_email, zip_code, VM, $document, $http, $mdDialog, $scope, $rootScope) {
        var vm = this;
        $('#loaderDiv').hide();
        $scope.show_loader = false

        var old_email_suggest_pharm = angular.copy(old_email);
        angular.module('app.SuggestPharmacy').constant('OLD_EMAIL_SUGGEST_PHARM', old_email_suggest_pharm);


        $scope.init = function () {
            $scope.initModel();
        }
        $scope.initModel = function () {
            $scope.model = {
                "new_email": old_email,
                "patient_id": patient_id,
                "zip_code": zip_code,
                "old_email": old_email_suggest_pharm
            };
            $scope.resetForm();
        }

        $scope.save = function () {

            $scope.show_loader = true

            var body = {
                "new_email": $scope.model.old_email,
                "patient_id": patient_id,
                "zip_code": zip_code,
                "old_email": old_email_suggest_pharm
            }

            $http.post($rootScope.RoutePath + "editEmailSuggestedPharm", body).then(function (data) {
                $scope.show_loader = false
                $mdToast.show(
                    $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                );
                if (data.data.success) {
                    VM.Reset();
                    $mdDialog.hide();
                }
            }).catch(function (err) {
                $scope.show_loader = false
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('An error ocurred')
                        .position('top right')
                        .hideDelay(3000)
                );
            });
        }

        $scope.resetForm = function () {
            if ($scope.AddStatusForm) {
                $scope.AddStatusForm.$setPristine();
                $scope.AddStatusForm.$setUntouched();
            }
            VM.Reset();
        }

        $scope.closeModel = function () {
            $mdDialog.hide();
            VM.Reset();
        }
        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.roles', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.roles', {
                url: '/roles',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Roles/Roles.html',
                        controller: 'RolesController as vm'
                    }
                },
                bodyClass: 'Roles',
                ModuleName: 'Roles'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/roles');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Roles',
        //     state: 'app.roles',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.roles')
        .controller('RemoveCountryModelController', RemoveCountryModelController);

    /** @ngInject */
    function RemoveCountryModelController(CountrydtColumnDefs1, $http, DTOptionsBuilder, DTColumnDefBuilder, $mdDialog, $mdToast, $scope, $rootScope, CountryList, event, RoleVM, RoleCountry, FlgDeletedAccess, RoleObj) {
        var vm = this;
        vm.FlgDeletedAccess = FlgDeletedAccess
        vm.CountrydtColumnDefs1 = CountrydtColumnDefs1
        $scope.init = function () {
            $scope.model = {
                Country: 'All',
            };
            // GetAllLanguage();
        }

        $scope.lstCountry = CountryList;
        $scope.RoleObj = RoleObj;

        if (RoleCountry != "" && RoleCountry != null) {
            $scope.lstCountryData = RoleCountry.split(',');
        };

        $scope.DeleteCountry = function (country, ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to delete this Country?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {

                $scope.countrylist = _($scope.lstCountryData).filter(function (item) {
                    return item !== country
                });

                var Country = "";

                if ($scope.countrylist.length > 0) {

                    for (var i = 0; i < $scope.countrylist.length; i++) {
                        if (Country == "") {
                            Country = $scope.countrylist[i];
                        } else {
                            Country = Country + "," + $scope.countrylist[i];
                        }
                    }
                }

                $scope.RoleObj.Country = Country;

                $http.post($rootScope.RoutePath + "role/SaveRole", $scope.RoleObj).then(function (response) {
                    if (response.data.success == true) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Country Deleted Successfully.")
                                .position('top right')
                                .hideDelay(3000)
                        );
                        $scope.init();
                        $scope.closeModel();
                        RoleVM.GetAllRoles();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Country could not Delete.")
                                .position('top right')
                                .hideDelay(3000)
                        );
                    }
                });
            }, function () {
                RoleVM.RemoveCountryToRole($scope.RoleObj);
            });
        }

        $scope.SaveCountry = function (country) {
            var IsCountryExist = false;

            if (RoleCountry != "" && RoleCountry != null) {
                var lstCountryData = RoleCountry.split(',');

                var objCountry = _.find(lstCountryData, function (item) {
                    return item == country;
                })


                if (objCountry) {
                    IsCountryExist = true;
                };
            };
            if (!IsCountryExist) {

                var Value = "";

                if (RoleCountry == "" || RoleCountry == null) {
                    Value = country;
                    RoleCountry = Value;
                } else {
                    Value = RoleCountry + "," + country;
                    RoleCountry = Value;
                }

                $scope.RoleObj.Country = RoleCountry;
                $http.post($rootScope.RoutePath + "role/SaveRole", $scope.RoleObj).then(function (response) {
                    if (response.data.success == true) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Country Added Successfully.")
                                .position('top right')
                                .hideDelay(3000)
                        );
                        $scope.init();
                        $scope.closeModel();
                        RoleVM.GetAllRoles();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Country could not Added.")
                                .position('top right')
                                .hideDelay(3000)
                        );
                    }
                });
            } else {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent("Country already Exist.")
                        .position('top right')
                        .hideDelay(3000)
                );
            }
        }

        $scope.CountrydtColumnDefs1 = [
            DTColumnDefBuilder.newColumnDef(0).notSortable().withOption('width', '4%').withOption('class', 'text-center'),
            DTColumnDefBuilder.newColumnDef(1),
            DTColumnDefBuilder.newColumnDef(2).notSortable().withOption('class', 'text-center'),
        ];

        $scope.closeModel = function () {
            $mdDialog.hide();
        }

        $scope.Reset = function () {

        }
        $scope.init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.DemandOrder', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.DemandOrder', {
                url: '/DemandOrder',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/DemandOrder/DemandOrder.html',
                        controller: 'DemandOrderController as vm'
                    }
                },
                bodyClass: 'DemandOrder',
                ModuleName: 'DemandOrder'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('SPI.Bank Deposit', {
        //     title: 'Bank Deposit',
        //     state: 'app.bankdeposit',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.DemandOrder')
        .controller('OrderDetailsController', DemandOrderDetailsController);

    /** @ngInject */
    function DemandOrderDetailsController($mdToast, $document, $http, $mdDialog, $scope, Order_Id, VM, OrderDetailData, DTOptionsBuilder, $rootScope) {

        var vm = this;
        var MainVM = VM;
        $scope.OrderDetails = Order_Id;
        $scope.init = function () {
            $scope.getOrderDetailData = OrderDetailData;
        }
        $scope.closeModel1 = function () {
            $mdDialog.hide();
        }
        vm.dtInstance = {};
        $scope.dtOptionsOrderDetails = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDisplayLength(10)
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            .withOption('aaSorting', [0, 'asc'])
            .withOption('deferRender', true)
            .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [0] }])
            .withOption('language', {
                'zeroRecords': "No Record Found",
                'emptyTable': "No Record Found"
            })
            .withOption('dom', '<"top"<"left"<"length"l>>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>');
        $scope.init();

    }
})();
(function () {
    'use strict';

    angular
        .module('app.DemandOrder')
        .controller('OrderDetailInformationController', DemandOrderDetailInformationController);

    /** @ngInject */
    function DemandOrderDetailInformationController($mdToast, $document, $http, $mdDialog, $scope, Order_Id, VM, DTOptionsBuilder, $rootScope) {

        var vm = this;
        var MainVM = VM;
        $scope.ORDER_STATUS = {
            accepted: "Order accepted.",
            pending: "Pending",
            picked_up: "Picked up",
            arrived_dropoff: "Arrived Droppoff",
            dropped_off: "Dropped off",
            canceled: "Cancelled",
            failed: "Failed",
            arrived_pickup: "Arrived pickup"
          }
        $scope.OrderDetails = Order_Id;
        $scope.init = function () {
             
            $scope.orderInformation();

        }

        $scope.orderInformation = function () {
            var params = {
                order_id: Order_Id
            }
            $http.get($rootScope.RoutePath + 'order/orderInformation', { params: params }).then(function (res) {
                $scope.lstorderInformation = res.data.data;
                console.log(res.data.data)
            })
        }

        $scope.closeModel = function () {
            $mdDialog.hide();
        }

        $scope.init();

    }
})();
(function () {
    'use strict';

    angular
        .module('app.Pharmacy', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.Pharmacy', {
                url: '/Pharmacy',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Pharmacy/Pharmacy.html',
                        controller: 'PharmacyController as vm'
                    }
                },
                bodyClass: 'Pharmacy',
                ModuleName: 'Pharmacy'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/roles');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Roles',
        //     state: 'app.roles',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.Pharmacy')
        .controller('pharmacyEditController', pharmacyEditController);

    /** @ngInject */
    function pharmacyEditController($mdToast, _id, billing_period_days, VM, payment_period_days, token, $document, $http, $mdDialog, $scope, $rootScope) {
        var vm = this;

        $scope.init = function () {
            $scope.initModel();
        }
        $scope.initModel = function () {
            $scope.model = {
                _id: _id,
                billing_period_days: billing_period_days,
                payment_period_days: payment_period_days,
                token: token,
            };
            $scope.resetForm();
        }

        $scope.AddDays = function () {
            $http.post($rootScope.RoutePath + "pharmacy/updateBillingDaysAndPaymentDays", $scope.model).then(function (data) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                );
                if (data.data.success) {
                    VM.Reset();
                    $mdDialog.hide();
                }
            });
        }

        $scope.resetForm = function () {
            if ($scope.AddStatusForm) {
                $scope.AddStatusForm.$setPristine();
                $scope.AddStatusForm.$setUntouched();
            }
            VM.Reset();
        }

        $scope.closeModel = function () {
            $mdDialog.hide();
            VM.Reset();
        }
        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.Pharmacy')
        .controller('pharmacyAnnouncementController', pharmacyAnnouncementController);

    /** @ngInject */
    function pharmacyAnnouncementController($mdToast, $document, $http, $mdDialog, $scope, VM, $rootScope) {

        var vm = this;
        $scope.init = function() {
            $scope.initModel();
        }
        $scope.initModel = function() {
            $scope.modelSearch = {
                search: '',
            }
            $scope.model = {
                _id: null,
                type: null,
                title: null,
                message: null,
            };
            $scope.resetForm();
        }

        $scope.resetForm = function() {
            if ($scope.formAnnouncement) {
                $scope.formAnnouncement.$setPristine();
                $scope.formAnnouncement.$setUntouched();
            }
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }
        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.Patient', ['ngMaterial'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.Patient', {
                url: '/Patient',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Patient/Patient.html',
                        controller: 'PatientController as vm'
                    }
                },
                bodyClass: 'Patient',
                ModuleName: 'Patient'
            });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.Patient')
        .controller('ReFillOrderDetailInformationController', ReFillOrderDetailInformationController);

    /** @ngInject */
    function ReFillOrderDetailInformationController($mdToast, $document, $http, data, $mdDialog, $scope, DTOptionsBuilder, $rootScope) {

        var vm = this;
        // console.log(data)
        $scope.init = function() {
            $scope.orderInformation();
        }

        $scope.orderInformation = function() {
            var params = {
                refillId: data._id
            }
            // console.log(params)
            $http.get($rootScope.RoutePath + 'patient/getRefillOrderById', { params: params }).then(function(res) {
                $scope.lstorderInformation = res.data.data;
                // console.log($scope.lstorderInformation)
            })
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();

    }
})();
(function() {
    'use strict';

    angular
        .module('app.Patient')
        .controller('PreferedPharmacyDetailInformationController', PreferedPharmacyDetailInformationController);

    /** @ngInject */
    function PreferedPharmacyDetailInformationController($mdToast, $document, $http, data, $mdDialog, $scope, DTOptionsBuilder, $rootScope) {

        var vm = this;
        // console.log(data)
        $scope.init = function() {
            $scope.orderInformation();
        }

        $scope.orderInformation = function() {
            var params = {
                patientId: data
            }
            // console.log(params)
            $http.get($rootScope.RoutePath + 'patient/GetPreffredPharmacyList', { params: params }).then(function(res) {
                $scope.lstorderInformation = res.data.data;
                // console.log($scope.lstorderInformation)
            })
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();

    }
})();
(function() {
    'use strict';

    angular
        .module('app.Patient')
        .controller('OneTimeOrderDetailInformationController', OneTimeOrderDetailInformationController);

    /** @ngInject */
    function OneTimeOrderDetailInformationController($mdToast, $document, $http, $mdDialog, $scope, data, DTOptionsBuilder, $rootScope) {

        var vm = this;
        // console.log(data)
        $scope.data = data;
        $scope.init = function() {}

        $scope.closeModel = function() {
            $mdDialog.hide();
        }

        $scope.init();

    }
})();
(function () {
    'use strict';

    angular
        .module('app.Order', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.Order', {
                url: '/Order',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Order/Order.html',
                        controller: 'OrderController as vm'
                    }
                },
                bodyClass: 'Order',
                ModuleName: 'Order'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('SPI.Bank Deposit', {
        //     title: 'Bank Deposit',
        //     state: 'app.bankdeposit',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.Order')
        .controller('OrderDetailsController', OrderDetailsController);

    /** @ngInject */
    function OrderDetailsController($mdToast, $document, $http, $mdDialog, $scope, Order_Id, VM, OrderDetailData, DTOptionsBuilder, $rootScope) {

        var vm = this;
        var MainVM = VM;
        $scope.OrderDetails = Order_Id;
        $scope.init = function () {
            $scope.getOrderDetailData = OrderDetailData;
        }
        $scope.closeModel1 = function () {
            $mdDialog.hide();
        }
        vm.dtInstance = {};
        $scope.dtOptionsOrderDetails = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDisplayLength(10)
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            .withOption('aaSorting', [0, 'asc'])
            .withOption('deferRender', true)
            .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [0] }])
            .withOption('language', {
                'zeroRecords': "No Record Found",
                'emptyTable': "No Record Found"
            })
            .withOption('dom', '<"top"<"left"<"length"l>>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>');
        $scope.init();

    }
})();
(function () {
    'use strict';

    angular
        .module('app.Order')
        .controller('OrderDetailInformationController', OrderDetailInformationController);

    /** @ngInject */
    function OrderDetailInformationController($mdToast, $document, $http, $mdDialog, $scope, Order_Id, VM, DTOptionsBuilder, $rootScope) {

        var vm = this;
        var MainVM = VM;
        $scope.ORDER_STATUS = {
            accepted: "Order accepted.",
            pending: "Pending",
            picked_up: "Picked up",
            arrived_dropoff: "Arrived Droppoff",
            dropped_off: "Dropped off",
            canceled: "Cancelled",
            failed: "Failed",
            arrived_pickup: "Arrived pickup"
          }
        $scope.OrderDetails = Order_Id;
        $scope.init = function () {
             
            $scope.orderInformation();

        }

        $scope.orderInformation = function () {
            var params = {
                order_id: Order_Id
            }
            $http.get($rootScope.RoutePath + 'order/orderInformation', { params: params }).then(function (res) {
                $scope.lstorderInformation = res.data.data;
            })
        }

        $scope.closeModel = function () {
            $mdDialog.hide();
        }

        $scope.init();

    }
})();
(function () {
    'use strict';

    angular
        .module('app.Invoice', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.Invoice', {
                url: '/Invoice',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Invoice/Invoice.html',
                        controller: 'InvoiceController as vm'
                    }
                },
                bodyClass: 'Invoice',
                ModuleName: 'Invoice'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.owneruser', {
        //     title: 'Owner Users',
        //     state: 'app.owneruser',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.Invoice')
        .controller('invoiceUpdateController', invoiceUpdateController);

    /** @ngInject */
    function invoiceUpdateController($mdToast, invoice_no , VM, $document, $http, $mdDialog, $scope, $rootScope) {
        var vm = this;
        $('#loaderDiv').hide();
     
        $scope.show_loader = false;
         $scope.invoice_no = invoice_no 
        var old_email_suggest_pharm = angular.copy(invoice_no);
        angular.module('app.Invoice').constant('OLD_EMAIL_SUGGEST_PHARM', old_email_suggest_pharm);


        $scope.init = function () {
            $scope.initModel();
        }
        $scope.initModel = function () {
            $scope.model = {
                // "new_email": old_email,
                // "patient_id": patient_id,
                // "zip_code": zip_code,
                invoice_no: invoice_no,
                payment_type : ''
            };
            $scope.resetForm();
        }

        $scope.save = function () {

            $scope.show_loader = true

            var body = {
                invoice_no:  $scope.model.invoice_no,
                payment_type : $scope.model.payment_type
                
                  }

            $http.post($rootScope.RoutePath + "invoice/updatePaymentRequest", body).then(function (data) {
                $scope.show_loader = false
                $mdToast.show(
                    $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                );
                if (data.data.success) {
                    // VM.Reset();
                    $mdDialog.hide({ success: true });
                }
            }).catch(function (err) {
                $scope.show_loader = false
                $mdToast.show(
                    $mdToast.simple()
                        .textContent(err)
                        .position('top right')
                        .hideDelay(3000)
                );
            });
        }

        $scope.selectPaymentMode = function(mode) {
            $scope.model.payment_type = mode;
        };

        $scope.resetForm = function () {
            if ($scope.AddStatusForm) {
                $scope.AddStatusForm.$setPristine();
                $scope.AddStatusForm.$setUntouched();
            }
            // VM.Reset();
        }

        $scope.closeModel = function () {
            $mdDialog.hide();
            VM.Reset();
        }
        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.Hospital', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.Hospital', {
                url: '/Hospital',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Hospital/Hospital.html',
                        controller: 'HospitalController as vm'
                    }
                },
                bodyClass: 'Hospital',
                ModuleName: 'Hospital'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/roles');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Roles',
        //     state: 'app.roles',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.Hospital')
        .controller('HospitalAnnouncementController', HospitalAnnouncementController);

    /** @ngInject */
    function HospitalAnnouncementController($mdToast, $document, $http, $mdDialog, $scope, VM, $rootScope) {

        var vm = this;
        $scope.init = function() {
            $scope.initModel();
        }
        $scope.initModel = function() {
            $scope.modelSearch = {
                search: '',
            }
            $scope.model = {
                _id: null,
                type: null,
                title: null,
                message: null,
            };
            $scope.resetForm();
        }

        $scope.resetForm = function() {
            if ($scope.formAnnouncement) {
                $scope.formAnnouncement.$setPristine();
                $scope.formAnnouncement.$setUntouched();
            }
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }
        $scope.init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.Pharmacy')
        .controller('pharmacyEditController', pharmacyEditController);

    /** @ngInject */
    function pharmacyEditController($mdToast, _id, billing_period_days, VM, payment_period_days, token, $document, $http, $mdDialog, $scope, $rootScope) {
        var vm = this;

        $scope.init = function () {
            $scope.initModel();
        }
        $scope.initModel = function () {
            $scope.model = {
                _id: _id,
                billing_period_days: billing_period_days,
                payment_period_days: payment_period_days,
                token: token,
            };
            $scope.resetForm();
        }

        $scope.AddDays = function () {
            $http.post($rootScope.RoutePath + "pharmacy/updateBillingDaysAndPaymentDays", $scope.model).then(function (data) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                );
                if (data.data.success) {
                    VM.Reset();
                    $mdDialog.hide();
                }
            });
        }

        $scope.resetForm = function () {
            if ($scope.AddStatusForm) {
                $scope.AddStatusForm.$setPristine();
                $scope.AddStatusForm.$setUntouched();
            }
            VM.Reset();
        }

        $scope.closeModel = function () {
            $mdDialog.hide();
            VM.Reset();
        }
        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.Pharmacy')
        .controller('pharmacyAnnouncementController', pharmacyAnnouncementController);

    /** @ngInject */
    function pharmacyAnnouncementController($mdToast, $document, $http, $mdDialog, $scope, VM, $rootScope) {

        var vm = this;
        $scope.init = function() {
            $scope.initModel();
        }
        $scope.initModel = function() {
            $scope.modelSearch = {
                search: '',
            }
            $scope.model = {
                _id: null,
                type: null,
                title: null,
                message: null,
            };
            $scope.resetForm();
        }

        $scope.resetForm = function() {
            if ($scope.formAnnouncement) {
                $scope.formAnnouncement.$setPristine();
                $scope.formAnnouncement.$setUntouched();
            }
        }

        $scope.closeModel = function() {
            $mdDialog.hide();
        }
        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.Driver', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.Driver', {
                url: '/Driver',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Driver/Driver.html',
                        controller: 'DriverController as vm'
                    }
                },
                bodyClass: 'Driver',
                ModuleName: 'Driver'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.owneruser', {
        //     title: 'Owner Users',
        //     state: 'app.owneruser',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.Driver')
        .controller('DriverAnnouncementController', DriverAnnouncementController);

    /** @ngInject */
    function DriverAnnouncementController($mdToast, $document, $http, $mdDialog, $scope, VM, $rootScope, SelectUser) {
        var vm = this;
        $scope.init = function () {
            $scope.initModel();
        }
        $scope.initModel = function () {
            $scope.modelSearch = {
                search: '',
            }
            $scope.model = {
                _id: null,
                type: null,
                title: null,
                message: null,
            };
            $scope.resetForm();
        }

        $scope.SendAnnouncement = function (title, message) {

            var params = {
                selectedusers: SelectUser,
                title: title,
                message: message
            }
            $http.post($rootScope.RoutePath + "driver/SendAnnouncementforDriver", params).then(function (data) {

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(data.data.success)
                        .position('top right')
                        .hideDelay(3000)
                );
                $scope.init();
            });
        };


        $scope.resetForm = function () {
            if ($scope.formAnnouncement) {
                $scope.formAnnouncement.$setPristine();
                $scope.formAnnouncement.$setUntouched();
            }
        }

        $scope.closeModel = function () {
            $mdDialog.hide();
        }
        $scope.init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.Driver')
        .controller('DriverApplicationDetailController', DriverApplicationDetailController);

    /** @ngInject */
    function DriverApplicationDetailController($mdToast, $document, $window, current_address, $http, $mdDialog, $scope, id, VM, $rootScope) {

        var vm = this;
        var MainVM = VM;
        var id = id;
        $scope.init = function () {
            $scope.getDriverAplicationByID();
        }

        $scope.getDriverAplicationByID = function () {
            var parmas = {
                driver_id: id,
            }
            $http.get($rootScope.RoutePath + "driverapplication/getDriverApplicartionByID", { params: parmas }).then(function (data) {

                if (data.data.success) {
                    $scope.objDriverApplication = data.data.data;
                    if ($scope.objDriverApplication.current_address != '' && $scope.objDriverApplication.current_address != null) {
                        $scope.objDriverApplication.current_address = current_address;
                    }
                    if ($scope.objDriverApplication.previous_address != '' && $scope.objDriverApplication.previous_address != null) {
                        $scope.objDriverApplication.previous_address = '-';
                    }
                }
            });
        }
        $scope.DownloadApplication = function () {
            $window.open($rootScope.RoutePath + "driverapplication/printDriverApplicationByID?driver_id=" + id,
                '_blank')
        }


        $scope.closeModel1 = function () {
            $mdDialog.hide();
        }
        $scope.init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.DemandOrder')
        .controller('OrderDetailsController', DemandOrderDetailsController);

    /** @ngInject */
    function DemandOrderDetailsController($mdToast, $document, $http, $mdDialog, $scope, Order_Id, VM, OrderDetailData, DTOptionsBuilder, $rootScope) {

        var vm = this;
        var MainVM = VM;
        $scope.OrderDetails = Order_Id;
        $scope.init = function () {
            $scope.getOrderDetailData = OrderDetailData;
        }
        $scope.closeModel1 = function () {
            $mdDialog.hide();
        }
        vm.dtInstance = {};
        $scope.dtOptionsOrderDetails = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDisplayLength(10)
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            .withOption('aaSorting', [0, 'asc'])
            .withOption('deferRender', true)
            .withOption('aoColumnDefs', [{ bSortable: false, aTargets: [0] }])
            .withOption('language', {
                'zeroRecords': "No Record Found",
                'emptyTable': "No Record Found"
            })
            .withOption('dom', '<"top"<"left"<"length"l>>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>');
        $scope.init();

    }
})();
(function () {
    'use strict';

    angular
        .module('app.DemandOrder')
        .controller('OrderDetailInformationController', DemandOrderDetailInformationController);

    /** @ngInject */
    function DemandOrderDetailInformationController($mdToast, $document, $http, $mdDialog, $scope, Order_Id, VM, DTOptionsBuilder, $rootScope) {

        var vm = this;
        var MainVM = VM;
        $scope.ORDER_STATUS = {
            accepted: "Order accepted.",
            pending: "Pending",
            picked_up: "Picked up",
            arrived_dropoff: "Arrived Droppoff",
            dropped_off: "Dropped off",
            canceled: "Cancelled",
            failed: "Failed",
            arrived_pickup: "Arrived pickup"
          }
        $scope.OrderDetails = Order_Id;
        $scope.init = function () {
             
            $scope.orderInformation();

        }

        $scope.orderInformation = function () {
            var params = {
                order_id: Order_Id
            }
            $http.get($rootScope.RoutePath + 'order/orderInformation', { params: params }).then(function (res) {
                $scope.lstorderInformation = res.data.data;
                console.log(res.data.data)
            })
        }

        $scope.closeModel = function () {
            $mdDialog.hide();
        }

        $scope.init();

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.Testimonial', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.Testimonial', {
                url: '/Testimonial',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Testimonial/Testimonial.html',
                        controller: 'TestimonialController as vm'
                    }
                },
                bodyClass: 'Testimonial',
                ModuleName: 'Testimonial'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.owneruser', {
        //     title: 'Owner Users',
        //     state: 'app.owneruser',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.Testimonial')
        .controller('TestimonialDetailController', TestimonialDetailController);

    /** @ngInject */
    function TestimonialDetailController($mdToast, $document, $window, $http, objData, $mdDialog, $scope, VM, $rootScope) {

        var vm = this;
        var MainVM = VM;
        $scope.objTestimonial = null;
        $scope.Path = $rootScope.RoutePath;
        $scope.init = function () {
            // console.log(objData)
            $scope.objTestimonial = objData;
            // $scope.getAllDynamicDriverApplication();
        }

        // $scope.getAllDynamicDriverApplication = function () {
        //     var parmas = {
        //         driver_id: id,
        //     }
        //     $http.get($rootScope.RoutePath + "driverapplication/getDriverApplicartionByID", { params: parmas }).then(function (data) {
        //         if (data.data.success) {
        //             $scope.objDriverApplication = data.data.data;
        //             console.log($scope.objDriverApplication.proof_of_insurance)
        //             if ($scope.objDriverApplication.current_address != '' && $scope.objDriverApplication.current_address != null) {
        //                 $scope.objDriverApplication.current_address = current_address;
        //             }
        //             if ($scope.objDriverApplication.previous_address != '' && $scope.objDriverApplication.previous_address != null) {
        //                 $scope.objDriverApplication.previous_address = previous_address;
        //             }
        //         }
        //     });
        // }

        // $scope.DownloadApplication = function () {
        //     $window.open($rootScope.RoutePath + "driverapplication/printDriverApplicationByID?driver_id=" + id,
        //         '_blank')
        // }

        $scope.closeModel1 = function () {
            $mdDialog.hide();
        }
        $scope.init();
    }
})();
(function() {
    'use strict';

    angular
        .module('app.DriverApplication', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.DriverApplication', {
                url: '/DriverApplication',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/DriverApplication/DriverApplication.html',
                        controller: 'DriverApplicationController as vm'
                    }
                },
                bodyClass: 'DriverApplication',
                ModuleName: 'DriverApplication'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.owneruser', {
        //     title: 'Owner Users',
        //     state: 'app.owneruser',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.DriverApplication')
        .controller('ApplicationDetailController', ApplicationDetailController);

    /** @ngInject */
    function ApplicationDetailController($mdToast, $document, $window, $http, current_address, previous_address, objData, $mdDialog, $scope, id, VM, $rootScope) {

        var vm = this;
        var MainVM = VM;
        $scope.objDriverApplication = null;
        $scope.init = function () {
            // console.log(objData)
            $scope.objDriverApplication = objData;
            if ($scope.objDriverApplication.current_address != '' && $scope.objDriverApplication.current_address != null) {
                $scope.objDriverApplication.current_address = current_address;
            }
            if ($scope.objDriverApplication.previous_address != '' && $scope.objDriverApplication.previous_address != null) {
                $scope.objDriverApplication.previous_address = previous_address;
            }
            // $scope.getAllDynamicDriverApplication();
        }

        // $scope.getAllDynamicDriverApplication = function () {
        //     var parmas = {
        //         driver_id: id,
        //     }
        //     $http.get($rootScope.RoutePath + "driverapplication/getDriverApplicartionByID", { params: parmas }).then(function (data) {
        //         if (data.data.success) {
        //             $scope.objDriverApplication = data.data.data;
        //             console.log($scope.objDriverApplication.proof_of_insurance)
        //             if ($scope.objDriverApplication.current_address != '' && $scope.objDriverApplication.current_address != null) {
        //                 $scope.objDriverApplication.current_address = current_address;
        //             }
        //             if ($scope.objDriverApplication.previous_address != '' && $scope.objDriverApplication.previous_address != null) {
        //                 $scope.objDriverApplication.previous_address = previous_address;
        //             }
        //         }
        //     });
        // }

        $scope.DownloadApplication = function () {
            $window.open($rootScope.RoutePath + "driverapplication/printDriverApplicationByID?driver_id=" + id,
                '_blank')
        }

        $scope.closeModel1 = function () {
            $mdDialog.hide();
        }
        $scope.init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core', [
            'ngAnimate',
            'ngAria',
            'ngCookies',
            'ngMessages',
            'ngResource',
            'ngSanitize',
            'ngMaterial',
            'chart.js',
            'pascalprecht.translate',
            'ui.router',
            'ngRoute',
            'dndLists',
            'datatables',

            'lfNgMdFileInput',
            'ngCkeditor',
            'angAccordion',
            'ngTagsInput',
            'ngMaterialDatePicker',
            'ngImgCrop',
            'underscore'
        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            })
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for ( var i = 0; i < vm.steps.length; i++ )
            {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            vm.setCurrentStep(vm.currentStepNumber - 1);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            vm.setCurrentStep(vm.currentStepNumber + 1);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective()
    {
        return {
            restrict        : 'A',
            require         : ['form', 'msStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        }
    }

    /** @ngInject */
    function msStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate, $rootScope, $cookieStore) {
        return {
            restrict: 'E',
            link: function (scope, iElement) {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function () {
                    $animate.leave(iElement).then(function () {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    var moduledata;

    function msNavigationServiceProvider() {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');
        var initInjector = angular.injector(['ng', 'ngCookies', 'ui.router']);
        // var initInjector1 = angular.injector(['ngCookies']);
        // var initInjector2 = angular.injector(['ui.router']);
        var $http = initInjector.get('$http');
        var $rootScope = initInjector.get('$rootScope');
        var $cookieStore = initInjector.get('$cookieStore');
        var $window = initInjector.get('$window');


        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item) {

            // var token = $cookieStore.get('token');
            // $http.defaults.headers.common['Authorization'] = token;
            var l = [];
            // var params = {
            //     tablename: item.title,
            //     permission: "Show"
            // }

            // // var RoutePath = "http://localhost:7100/";
            // // var RoutePath = "http://localhost:10026/";
            // // var RoutePath = "http://182.70.126.194:10026/";
            // // var RoutePath = "http://45.64.169.32:4444/";


            // $http.get(RoutePath + "userPermission/CheckRights", { params: params }).then(function(data) {
            //     // moduledata = (data.data);

            //     // console.log(item.title)
            //     // console.log(data.data)
            //     //console.log(data.data.success)
            //     // var l = _.where(moduledata, { Module: item.title });

            //     // console.log(l);
            //     if (data.data.success == false) {
            //         if (data.data.data == "TOKEN") {
            //             if (window.location.href.indexOf('app/login') == -1) {
            //                 //$state.go("app.login");
            //                 $window.location.href = '/#/app/login';
            //             } else {
            //                 return;
            //             };
            //         } else {
            //             return;
            //         };

            //     };



            // if (l.length > 0) {
            //     if (l[0].IsActive == false) {
            //         // console.log(item.title);
            //         return;
            //     };
            // }

            if (!angular.isString(path)) {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }
            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts, item.order);

            // Decide if we are going to update or create
            var updateItem = false;

            for (var i = 0; i < parent.length; i++) {
                if (parent[i]._id === id) {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if (updateItem) {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if (angular.isUndefined(item.weight) || !angular.isNumber(item.weight)) {
                    item.weight = 1;
                }

                item.weight = item.order;

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);

                parent.sort(function(a, b) {
                    // console.log(a)
                    // console.log(b)
                    return parseFloat(a.weight) - parseFloat(b.weight);
                });
            }
            // });
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path) {
            if (!angular.isString(path)) {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for (var p = 0; p < parts.length; p++) {
                var id = parts[p];

                for (var i = 0; i < item.length; i++) {
                    if (item[i]._id === id) {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if (item[i]._path === path) {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent) {
            // If parent not provided, sort the root items
            if (!parent) {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for (var i = 0; i < parent.length; i++) {
                var children = parent[i].children;

                if (children.length > 1) {
                    children.sort(_byWeight);
                }

                if (children.length > 0) {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts, weight) {

            navigation.sort(function(a, b) {

                return parseFloat(a.weight) - parseFloat(b.weight);
            });

            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if (parts.length === 1) {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for (var i = 0; i < parts.length; i++) {
                var _id = parts[i],
                    createParent = true;

                for (var p = 0; p < parent.length; p++) {
                    if (parent[p]._id === _id) {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if (createParent) {
                    var item = {
                        _id: _id,
                        _path: parts.join('.'),
                        title: _id,
                        weight: weight,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y) {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item) {
            var uisref = '';

            if (angular.isDefined(item.state)) {
                uisref = item.state;

                if (angular.isDefined(item.stateParams) && angular.isObject(item.stateParams)) {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function() {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem: saveItem,
                deleteItem: deleteItem,
                sort: sortByWeight,
                clearNavigation: clearNavigation,
                setActiveItem: setActiveItem,
                getActiveItem: getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope: setNavigationScope,
                setFolded: setFolded,
                getFolded: getFolded,
                setFoldedOpen: setFoldedOpen,
                getFoldedOpen: getFoldedOpen,
                toggleFolded: toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation() {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if (navigationScope) {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope) {
                activeItem = {
                    node: node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem() {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root) {

                if (root) {
                    for (var i = 0; i < navigation.length; i++) {

                        if (navigation[i]._id === root) {
                            return [navigation[i]];
                        }
                    }
                }
                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope) {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status) {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded() {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status) {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen() {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded() {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService) {
        var vm = this;
        // Data

        if ($scope.root) {
            $scope.navigation = msNavigationService.getNavigationObject($scope.root);
        } else {

            $scope.navigation = msNavigationService.getNavigationObject();
        }


        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                folded: '=',
                root: '@'
            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude: true,
            compile: function(tElement) {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement) {

                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init() {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if (msNavigationService.getFolded() === null) {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if (msNavigationService.getFolded()) {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function() {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function() {
                        return sidenav.isLockedOpen();
                    }, function(current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if (folded) {
                            if (current) {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            } else {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if (activeItem) {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function(current, old) {
                        if (angular.isUndefined(current) || angular.equals(current, old)) {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded) {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if (folded) {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        } else {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if (activeItem) {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander() {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function() {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser() {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser() {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if (activeItem) {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event) {
                        if (event) {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function() {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function() {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if (msNavigationService.getFolded()) {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function() {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if (!vm.hasChildren || vm.group) {
                vm.collapsable = false;
            } else {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if (!vm.collapsable) {
                vm.collapsed = false;
            } else {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function() {
                // Expand if the current scope is collapsable and is collapsed
                if (vm.collapsable && vm.collapsed) {
                    $scope.$evalAsync(function() {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function(event, path) {
                if (vm.collapsed || !vm.collapsable) {
                    return;
                }

                // If there is no path defined, collapse
                if (angular.isUndefined(path)) {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if (activeItem) {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if (givenPathParts.indexOf(vm.node._id) > -1) {
                        return;
                    }

                    // Test for active path
                    if (activePathParts.indexOf(vm.node._id) > -1) {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function() {
                if (vm.node.state === $state.current.name) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed() {
            if (vm.collapsed) {
                vm.expand();
            } else {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse() {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function() {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl, {
                        'display': 'block',
                        'height': height + 'px'
                    }, {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function() {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height': ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand() {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position': 'absolute',
                'visibility': 'hidden',
                'display': 'block',
                'height': 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position': '',
                'visibility': '',
                'display': '',
                'height': ''
            });

            $scope.$evalAsync(function() {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl, {
                        'display': 'block',
                        'height': '0px'
                    }, {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function() {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass() {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden() {
            if (angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden)) {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective() {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller: 'MsNavigationNodeController as vm',
            compile: function(tElement) {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationNodeCtrl.group) {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective() {
        return {
            restrict: 'A',
            require: '^msNavigationNode',
            compile: function(tElement) {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
                    // If the item is collapsable...
                    if (MsNavigationNodeCtrl.collapsable) {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function() {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                root: '@'
            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude: true,
            compile: function(tElement) {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope) {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function() {
                // Mark as active if has children
                if (vm.hasChildren) {
                    $scope.$evalAsync(function() {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function() {
                if (!vm.hasChildren) {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if (activeItem) {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if (activePathParts.indexOf(vm.node._id) > -1) {
                    $scope.$evalAsync(function() {
                        vm.isActive = true;
                    });
                } else {
                    $scope.$evalAsync(function() {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function() {
                if (vm.node.state === $state.current.name) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass() {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective() {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller: 'MsNavigationHorizontalNodeController as vm',
            compile: function(tElement) {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if (MsNavigationHorizontalNodeCtrl.group) {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia) {
        return {
            restrict: 'A',
            require: '^msNavigationHorizontalNode',
            compile: function(tElement) {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
                    iElement.on('click', onClick);

                    function onClick() {
                        if (!MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md')) {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function() {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPicker($mdMenu, $mdColorPalette, fuseGenerator)
    {
        return {
            require    : 'ngModel',
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function ($scope, element, attrs, ngModel)
            {
                // Material Color Palette
                $scope.palettes = $mdColorPalette;
                $scope.selectedPalette = false;
                $scope.selectedHues = false;

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                $scope.msModelType = $scope.msModelType || 'class';

                /**
                 * Initialize / Watch model changes
                 */
                $scope.$watch('ngModel', setSelectedColor);

                /**
                 * Activate Hue Selection
                 * @param palette
                 * @param hues
                 */
                $scope.activateHueSelection = function (palette, hues)
                {
                    $scope.selectedPalette = palette;
                    $scope.selectedHues = hues;
                };

                /**
                 * Select Color
                 * @type {selectColor}
                 */
                $scope.selectColor = function (palette, hue)
                {
                    // Update Selected Color
                    updateSelectedColor(palette, hue);

                    // Update Model Value
                    updateModel();

                    // Hide The picker
                    $mdMenu.hide();
                };

                $scope.removeColor = function ()
                {

                    $scope.selectedColor = {
                        palette: '',
                        hue    : '',
                        class  : ''
                    };

                    $scope.activateHueSelection(false, false);

                    updateModel();
                };

                /**
                 * Set SelectedColor by model type
                 */
                function setSelectedColor()
                {
                    if ( !ngModel.$viewValue || ngModel.$viewValue === '' )
                    {
                        return;
                    }

                    var palette, hue;

                    // If ModelType Class
                    if ( $scope.msModelType === 'class' )
                    {
                        var color = ngModel.$viewValue.split('-');
                        if ( color.length >= 5 )
                        {
                            palette = color[1] + '-' + color[2];
                            hue = color[3];
                        }
                        else
                        {
                            palette = color[1];
                            hue = color[2];
                        }
                    }
                    // If ModelType Object
                    else if ( $scope.msModelType === 'obj' )
                    {
                        palette = ngModel.$viewValue.palette;
                        hue = ngModel.$viewValue.hue || 500;
                    }

                    // Update Selected Color
                    updateSelectedColor(palette, hue);
                }


                /**
                 * Update Selected Color
                 * @param palette
                 * @param hue
                 */
                function updateSelectedColor(palette, hue)
                {
                    $scope.selectedColor = {
                        palette     : palette,
                        hue         : hue,
                        class       : 'md-' + palette + '-' + hue + '-bg',
                        bgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].value),
                        fgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].contrast)
                    };

                    // If Model object not Equals the selectedColor update it
                    // it can be happen when the model only have pallete and hue values
                    if ( $scope.msModelType === 'obj' && !angular.equals($scope.selectedColor, ngModel.$viewValue) )
                    {
                        // Update Model Value
                        updateModel();
                    }

                    $scope.activateHueSelection(palette, $scope.palettes[palette]);
                }

                /**
                 * Update Model Value by model type
                 */
                function updateModel()
                {
                    if ( $scope.msModelType === 'class' )
                    {
                        ngModel.$setViewValue($scope.selectedColor.class);
                    }
                    else if ( $scope.msModelType === 'obj' )
                    {
                        ngModel.$setViewValue($scope.selectedColor);
                    }
                }
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '@template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core').directive('errSrc', function() {
            return {
                link: function(scope, element, attrs) {
                    element.bind('error', function() {
                        if (attrs.src != attrs.errSrc) {
                            attrs.$set('src', attrs.errSrc);
                        }
                    });
                }
            }
        }).directive('sbLoad', ['$parse', function($parse) {
            return {
                restrict: 'A',
                link: function(scope, elem, attrs) {
                    var fn = $parse(attrs.sbLoad);
                    elem.on('load', function(event) {
                        scope.$apply(function() {
                            fn(scope, { $event: event });
                        });
                    });
                }
            };
        }])

    // angular
    //     .module('app.core').directive('numbersOnly', function() {
    //         return {
    //             require: 'ngModel',
    //             link: function(scope, element, attrs, modelCtrl) {
    //                 modelCtrl.$parsers.push(function(inputValue) {
    //                     if (inputValue == undefined) return ''
    //                     var transformedInput = inputValue.replace(/[^0-9]/g, '');
    //                     if (transformedInput != inputValue) {
    //                         modelCtrl.$setViewValue(transformedInput);
    //                         modelCtrl.$render();
    //                     }

    //                     return transformedInput;
    //                 });
    //             }
    //         };
    //     })
})();
(function () {
    'use strict';

    angular
        .module('app.login')
        .controller('LoginController', LoginController)
        .directive('autoFillableField', [
            '$timeout',
            function ($timeout) {
                return {
                    require: '?ngModel',
                    restrict: 'A',
                    link: function (scope, element, attrs, ngModel) {

                        $timeout(function () {
                            if (ngModel.$viewValue !== element.val()) {
                                ngModel.$setViewValue(element.val());
                            }
                        }, 1500);
                    }
                };
            }
        ]);

    /** @ngInject */
    function LoginController($scope, $state, $rootScope, $timeout, $http, $cookieStore, $mdDialog, $document, $mdToast, $stateParams, $window, msNavigationService) {
        var vm = this;
        $('.logo').css('background-image', 'url(./assets/images/final-logo.png)');

        $scope.init = function () {
            $scope.model = {
                UserName: '',
                Password: '',
                RemeberMe: false
            }

            var Remeber = $cookieStore.get('RemeberMe');
            var Logout = $cookieStore.get('FlagLogout');
            if (Remeber == true) {
                $scope.model.UserName = $cookieStore.get('RemeberUserName');
                $scope.model.Password = $cookieStore.get('RemeberPassword');
                $scope.model.RemeberMe = true;
            } else {
                $scope.model.RemeberMe = false;
                $cookieStore.remove('RemeberMe');
                $cookieStore.remove('RemeberUserName');
                $cookieStore.remove('RemeberPassword');
                $cookieStore.remove('FlagLogout');

            }

            // if ($rootScope.flgLogout != true) {
            //     $rootScope.flgLogout = false;
            //     if (Remeber == 'true' && Logout == 'false') {
            //         $scope.Login($scope.model, true, false);
            //     }
            // }

        }

        $scope.setUserName = function () {

            if ($scope.model.UserName !== document.getElementsByName("email")[0].value) {
                $scope.model.UserName = document.getElementsByName("email")[0].value;
            }
            // alert("Call")
        }

        $scope.setPassword = function () {

            if ($scope.model.Password !== document.getElementsByName("password")[0].value) {
                $scope.model.Password = document.getElementsByName("password")[0].value;
            }
            // alert("Call")
        }

        $scope.Login = function (o, form, isLogout) {
            if (form) {
                $cookieStore.put('isAllowMultipleTabs', true);
                sessionStorage.setItem('isLogin', true);
                $cookieStore.put('RemeberMe', o.RemeberMe);
                $cookieStore.put('RemeberUserName', o.UserName);
                localStorage.setItem('UserName', o.UserName);
                $cookieStore.put('RemeberPassword', o.Password);
                $cookieStore.put('FlagLogout', false);
                var params = {
                    email: o.UserName,
                    password: o.Password,
                }
                $http.post($rootScope.RoutePath + "account/signin", params).then(function (data) {
                    if (data.data.success == true) {
                        $cookieStore.put('role_id', data.data.data.role_id);
                        $cookieStore.put('UserId', data.data.data._id);
                        $cookieStore.put('UserRoles', data.data.data.RoleName);

                        $rootScope.UserImage = $cookieStore.get('UserImage');
                        $cookieStore.put('email', data.data.data.email);
                        $cookieStore.put('token', data.data.data.token);
                        msNavigationService.clearNavigation();
                        $http.defaults.headers.common['Authorization'] = data.data.data.token; // jshint ignore:line
                        $rootScope.MenuSet();

                        $state.go('app.ScheduleDelivery');

                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                    };
                });
            }
        }

        $scope.ShowForgotPassword = function (ev, o) {
            $state.go('app.Forgotpassword');
        }

        $scope.ShowRegister = function (ev, o) {
            $state.go('app.Register');
        }
        $scope.init();

        //////////
    }
})();
(function () {
    'use strict';

    angular
        .module('app.Zipcode')
        .controller('ZipcodeController', ZipcodeController);

    /** @ngInject */
    function ZipcodeController($http, $window, $scope, $rootScope, $state, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTColumnBuilder, DTOptionsBuilder, DTColumnDefBuilder, $compile) {
        var vm = this;
        vm.SearchBrand
        $scope.init = function () {
            $scope.model = {
                Search: '',
                zip: '',
                actions: ''

            };

            $scope.modelSearch = {
                number: '',
                zip: '',
                actions: ''
            };
            $scope.GetAllZipcode();
            $scope.flag = false;
        }


        vm.dtInstanceHospital = {};


        $scope.clearSearchTerm = function () {
            vm.SearchBrand = '';
        };

        $scope.onSearchChange = function ($event) {
            $event.stopPropagation();
        }

        $scope.AdjustColumn = function () {

            vm.dtInstanceHospital.DataTable.columns.adjust();
        }

        function NumberHtml(data, type, full, meta) {
            return parseInt((meta.settings._iDisplayStart) + (meta.row + 1));
        }

        function ZipHtml(data, type, full, meta) {
            if (full.zip != null || full.zip != undefined) {
                return full.zip
            }
        }
        function actionsHtml(data, type, full, meta) {
            if (full.zip != undefined || full.zip != null) {
                var btns = '<div layout="row" layout-align="center">';
                var method = "ShowZipcodeInformation('" + full.zip + "')";

                btns += '<b><md-button ng-click="' + method + '"> <md-icon md-font-icon="icon-trash" class="s18 red-500-fg"></md-icon><md-tooltip md-visible="" md-direction="">Delete Zip</md-tooltip></md-button></b>'

                return btns
            }
        }


        $scope.ShowOrderDetailInformation = function (Order_Id) {
            var orderData = _.findWhere($scope.lstHospital, {
                order_id: Order_Id
            });
            // $scope.orderDetailData = orderData.order_charges;
            $mdDialog.show({
                controller: 'ZipCodeInformationController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Zipcode/dialogs/ZipCodeInformation/ZipCodeInformation.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    Order_Id: Order_Id,
                }
            })
        }


        $scope.find_zip = function () {

            $scope.ShowOrderDetailInformation()

        }

        $scope.reloadData = function () { }

        function callback(json) { }

        $scope.ShowZipcodeInformation = function (data) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to delete this Zipcode?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent(data)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                if (data != undefined || data != null) {

                    $http.delete($rootScope.RoutePath + "zipcode/deletezip/" + data).then(function (data) {
                        // console.log(data)

                        if (data.data.success) {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(data.data.message)
                                    .position('top right')
                                    .hideDelay(3000)
                            );
                            // $scope.init();
                            $scope.GetAllZipcode();
                            vm.dtInstanceHospital.reloadData(callback, false);
                            $('#Hospital').dataTable()._fnAjaxUpdate();
                        } else {
                            if (data.data.data == 'TOKEN') {
                                //$cookieStore.remove('UserName');
                                //$cookieStore.remove('token');
                                //window.location.href = '/app/login';
                                $rootScope.logout();
                            } else {
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent(data.data.message)
                                        .position('top right')
                                        .hideDelay(3000)
                                );
                            }
                        }
                    });
                }
            }, function () { });

        }
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }


        $scope.ResetEdit = function () {

            $scope.flag = true;
            $scope.model.zip = ''
        }

        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
            $scope.init();
        })


        $scope.createZip = function (o, form) {
                const fd = new FormData()
            var file = document.getElementById("myFileInput").files[0];
            fd.append('file', file);
            // "text/csv" //CSV
            // "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"  //xlsx 
            if (file) {
                if (file.type == "text/csv" || file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                    var obj = {
                        zip: file
                    }
                    $http.post($rootScope.RoutePath + "zipcode/upload", fd, {
                        transformRequest: angular.identity,
                        headers: {'Content-Type': undefined} ,
                        body : obj
                    }).success(function(res){
                        // console.log(res)
                           if(res.success){
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(res.message)
                                    .position('top right')
                                    .hideDelay(3000)
                            );
                            $scope.flag = false
                           } 

                    }).error(function(){
                        // console.log('err')
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Error occurred while uploading please try again')
                                .position('top right')
                                .hideDelay(3000)
                        );
                    })                    
                }
                else {
                    return alert("Please select excel file only.")
                }
            } else {
                if (o.zip == "" || o.zip == undefined || o.zip == null) {
                    return alert("Zipcode cannot be empty")
                } else {
                    if (o.zip.length == 5 || o.zip.length == 6) {
                        var obj = {
                            zip: o.zip
                        }
                        $http.post($rootScope.RoutePath + "zipcode/zips", obj).then(function (data) {
                            if (data.data.success) {
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent(data.data.message)
                                        .position('top right')
                                        .hideDelay(3000)
                                );
            
                                //  $scope.init();
            
                                vm.dtInstanceHospital.reloadData(callback, false);
                                $('#Hospital').dataTable()._fnAjaxUpdate();
                                $scope.flag = false
                            } else {
                                if (data.data.data == 'TOKEN') {
                                    $rootScope.logout();
                                } else {
                                    $mdToast.show(
                                        $mdToast.simple()
                                            .textContent(data.data.message)
                                            .position('top right')
                                            .hideDelay(3000)
                                    );
                                }
                            }
                        });
                    } else {
                      return  alert('Please enter valid zipcode')
                    }

                }
            }
        };

        $scope.cancel = function () {
            $scope.flag = false
        }

        $scope.GetAllZipcode = function () {
            try {
                $scope.dtColumnsHospital = [
                    DTColumnBuilder.newColumn('number').renderWith(NumberHtml).notSortable().withOption('width', '5%').withOption('class', 'text-center'),
                    DTColumnBuilder.newColumn('zip').renderWith(ZipHtml).withOption('width', '5%').withOption('class', 'text-center'),
                    DTColumnBuilder.newColumn(null).notSortable().renderWith(actionsHtml).withOption('width', '5%').withOption('class', 'text-center')
                ]
            }
            catch (error) {
                // console.log(error)
            }

            $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {

                $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                    url: $rootScope.RoutePath + "zipcode/getAllzipcode",
                    data: function (d) {
                        return d;
                    },
                    type: "get",
                    dataSrc: function (json) {
                        // console.log(json.data)
                        if (json.success != false) {
                            $scope.lstdata = json;
                            return json.data;
                        } else {
                            return [];
                        }
                    }
                })
                    .withOption('processing', true) //for show progress bar
                    .withOption('serverSide', true) // for server side processing
                    .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                    .withDisplayLength(10) // Page size
                    .withOption('aaSorting', [0, 'desc'])
                    .withOption('responsive', true)
                    .withOption('createdRow', createdRow)
                    .withOption('autoWidth', true)
                    // .withOption('initComplete', function () {
                    //     $scope.AdjustColumn();
                    // })
                    .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
                    .withOption('scrollY', 'auto');

            });

        }

        $scope.backToAllZip = function () {
            $scope.GetAllZipcode();
            vm.dtInstanceHospital.reloadData(callback, false);
            $('#Hospital').dataTable()._fnAjaxUpdate();
            $scope.flag = false

        }




    }



})();
(function() {
    'use strict';

    angular
        .module('app.UserPermission', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.UserPermission', {
                url: '/UserPermission',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/UserPermission/UserPermission.html',
                        controller: 'UserPermissionController'
                    }
                },
                bodyClass: 'User Permission',
                ModuleName: 'User Permission'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/UserPermission');

        // msNavigationServiceProvider.saveItem('Users.UserPermission', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.UserPermission', {
        //     title: 'User Permission',
        //     state: 'app.UserPermission',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.UserPermission')
        .controller('UserPermissionController', UserPermissionController);

    /** @ngInject */
    function UserPermissionController($http, $scope, $mdDialog, $document, $cookieStore, $mdToast, DTOptionsBuilder, DTColumnDefBuilder, $rootScope) {
        var vm = this;

        $scope.init = function () {
            $scope.model = {
                role_id: '',
                module_id: '',
            };

            $scope.modelPermission = {
                View: false,
                Add: false,
                Update: false,
                Delete: false
            };

            $scope.GetAllRoles();
            $scope.GetAllModule();
        }

        $scope.GetAllRoles = function () {
            $http.get($rootScope.RoutePath + "role/getAllRole").then(function (response) {

                //$scope.lstRoles = response.data;
                $scope.RoleSuperAdmin = _.filter($cookieStore.get('UserRoles'), function (item) {
                    return item == "Super Admin";
                })[0];
                if ($scope.RoleSuperAdmin != undefined) {
                    $scope.lstRoles = response.data.data;
                } else {
                    $scope.lstRoles = _.filter(response.data.data, function (item) {
                        if (item.RoleName != "Super Admin") {
                            return item;
                        }
                    });
                }
            });
        }

        $scope.GetAllModule = function () {
            $http.get($rootScope.RoutePath + "module/getAllModule").then(function (response) {
                $scope.lstModules = response.data.data;
                for (var i = 0; i < $scope.lstModules.length; i++) {
                    $scope.lstModules[i]["Added"] = null;
                    $scope.lstModules[i]["Deleted"] = null;
                    $scope.lstModules[i]["role_id"] = null;
                    $scope.lstModules[i]["Show"] = null;
                    $scope.lstModules[i]["Modified"] = null;
                    $scope.lstModules[i]["module_id"] = $scope.lstModules[i]._id;
                    // $scope.lstModules[i]._id = $scope.lstModules[i]._id;
                }
            });
        }

        $scope.GetAllPermissionByRole = function () {
            $http.get($rootScope.RoutePath + "userPermission/GetAllPermissionByRole?role_id=" + $scope.model.role_id).then(function (response) {
                $scope.lstUserPermission = response.data.data;
                if ($scope.lstUserPermission.length > 0) {
                    $scope.ClearDataItems();
                    $scope.GetDataItems();
                } else {
                    $scope.GetAllModule();
                }
                $scope.modelPermission = {
                    View: false,
                    Add: false,
                    Update: false,
                    Delete: false
                };
            });
        }

        $scope.GetDataItems = function () {
            for (var i = 0; i < $scope.lstUserPermission.length; i++) {
                for (var j = 0; j < $scope.lstModules.length; j++) {
                    if ($scope.lstUserPermission[i].module_id == $scope.lstModules[j].module_id && $scope.model.RoleName == $scope.lstUserPermission[i].RoleName) {
                        if ($scope.lstUserPermission[i].Added == 1 || $scope.lstUserPermission[i].Added == true) {
                            $scope.lstModules[j].Added = true;
                        }
                        if ($scope.lstUserPermission[i].Modified == 1 || $scope.lstUserPermission[i].Modified == true) {
                            $scope.lstModules[j].Modified = true;
                        }
                        if ($scope.lstUserPermission[i].Deleted == 1 || $scope.lstUserPermission[i].Deleted == true) {
                            $scope.lstModules[j].Deleted = true;
                        }
                        if ($scope.lstUserPermission[i].Show == 1 || $scope.lstUserPermission[i].Show == true) {
                            $scope.lstModules[j].Show = true;
                        }
                    }
                }
            }
        }

        $scope.ClearDataItems = function () {
            for (var i = 0; i < $scope.lstUserPermission.length; i++) {
                for (var j = 0; j < $scope.lstModules.length; j++) {
                    $scope.lstModules[j].Added = false;
                    $scope.lstModules[j].Modified = false;
                    $scope.lstModules[j].Deleted = false;
                    $scope.lstModules[j].Show = false;
                }
            }
        }
        $scope.ChangePermission = function (o) {
            if ($scope.model.role_id != null && $scope.model.role_id != '' && $scope.model.role_id != undefined) {
                o.role_id = $scope.model.role_id;
                $http.post($rootScope.RoutePath + "userPermission/ChangePermission", o).then(function (response) {
                    if(o.module_name == "demand"){
                         $rootScope.demandViewAccess =  o.Show
            
                    }
                    if (response.data.data == 'TOKEN') {
                        //$cookieStore.remove('UserName');
                        //$cookieStore.remove('token');
                        //window.location.href = '/app/login';
                        $rootScope.logout();
                    }
                });
            } else {
                var confirm = $mdDialog.confirm()
                    .title('You must select user role.')
                    .ok('ok')
                $mdDialog.show(confirm).then(function () {

                }, function () {

                });
            }
        }

        // $scope.ChangePermissionAllView = function() {
        //     if ($scope.model.RoleName != null && $scope.model.RoleName != '' && $scope.model.RoleName != undefined) {
        //         for (var i = 0; i < $scope.lstModules.length; i++) {
        //             $scope.lstModules[i].Show = $scope.modelPermission.View;
        //             $scope.lstModules[i].RoleName = $scope.model.RoleName;
        //             $http.post($rootScope.RoutePath + "userPermission/ChangePermission", $scope.lstModules[i]).then(function(response) {
        //                 if (response.data.data == 'TOKEN') {
        //                     $cookieStore.remove('UserName');
        //                     $cookieStore.remove('token');
        //                     window.location.href = '/app/login';
        //                 }
        //             });
        //         }
        //     } else {
        //         var confirm = $mdDialog.confirm()
        //             .title('You must select user role.')
        //             .ok('ok')
        //         $mdDialog.show(confirm).then(function() {
        //             $scope.modelPermission.View = false;
        //         }, function() {

        //         });
        //     }
        // }

        $scope.ChangePermissionAllView = function () {
            if ($scope.model.role_id != null && $scope.model.role_id != '' && $scope.model.role_id != undefined) {

                var obj = new Object();
                obj.Value = $scope.modelPermission.View;
                // obj.Data = $scope.lstModules;
                obj.role_id = $scope.model.role_id;
                obj.Type = "View"

                for (var i = 0; i < $scope.lstModules.length; i++) {
                    $scope.lstModules[i].Show = $scope.modelPermission.View;
                }
                $http.post($rootScope.RoutePath + "userpermission/ChangeAllPermissions", obj).then(function (response) {
                    if (response.data.data == 'TOKEN') {
                        $rootScope.logout();
                    }
                });

            } else {
                var confirm = $mdDialog.confirm()
                    .title('You must select user role.')
                    .ok('ok')
                $mdDialog.show(confirm).then(function () {
                    $scope.modelPermission.View = false;
                }, function () {

                });
            }
        }
        $scope.ChangePermissionAllAdd = function () {
            if ($scope.model.role_id != null && $scope.model.role_id != '' && $scope.model.role_id != undefined) {

                for (var i = 0; i < $scope.lstModules.length; i++) {
                    $scope.lstModules[i].Added = $scope.modelPermission.Add;
                }

                var obj = new Object();
                obj.Value = $scope.modelPermission.Add;
                // obj.Data = $scope.lstModules;
                obj.role_id = $scope.model.role_id;
                obj.Type = "Add"
                $http.post($rootScope.RoutePath + "userpermission/ChangeAllPermissions", obj).then(function (response) {
                    if (response.data.data == 'TOKEN') {
                        $rootScope.logout();
                    }
                });

            } else {
                var confirm = $mdDialog.confirm()
                    .title('You must select user role.')
                    .ok('ok')
                $mdDialog.show(confirm).then(function () {
                    $scope.modelPermission.Add = false;
                }, function () {

                });
            }
        }

        $scope.ChangePermissionAllUpdate = function () {
            if ($scope.model.role_id != null && $scope.model.role_id != '' && $scope.model.role_id != undefined) {

                for (var i = 0; i < $scope.lstModules.length; i++) {
                    $scope.lstModules[i].Modified = $scope.modelPermission.Update;
                }

                var obj = new Object();
                obj.Value = $scope.modelPermission.Update;
                // obj.Data = $scope.lstModules;
                obj.role_id = $scope.model.role_id;
                obj.Type = "Update"
                $http.post($rootScope.RoutePath + "userpermission/ChangeAllPermissions", obj).then(function (response) {
                    if (response.data.data == 'TOKEN') {
                        $rootScope.logout();
                    }
                });

            } else {
                var confirm = $mdDialog.confirm()
                    .title('You must select user role.')
                    .ok('ok')
                $mdDialog.show(confirm).then(function () {
                    $scope.modelPermission.Update = false;
                }, function () {

                });
            }
        }

        $scope.ChangePermissionAllDelete = function () {
            if ($scope.model.role_id != null && $scope.model.role_id != '' && $scope.model.role_id != undefined) {

                for (var i = 0; i < $scope.lstModules.length; i++) {
                    $scope.lstModules[i].Deleted = $scope.modelPermission.Delete;
                }

                var obj = new Object();
                obj.Value = $scope.modelPermission.Delete;
                // obj.Data = $scope.lstModules;
                obj.role_id = $scope.model.role_id;
                obj.Type = "Delete"
                $http.post($rootScope.RoutePath + "userpermission/ChangeAllPermissions", obj).then(function (response) {
                    if (response.data.data == 'TOKEN') {
                        $rootScope.logout();
                    }
                });

            } else {
                var confirm = $mdDialog.confirm()
                    .title('You must select user role.')
                    .ok('ok')
                $mdDialog.show(confirm).then(function () {
                    $scope.modelPermission.Delete = false;
                }, function () {

                });
            }
        }
        $scope.dtCustomOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('simple') // for get full pagination options // first / last / prev / next and page numbers
            .withDisplayLength(100) // Page size
            .withOption('aaSorting', [0, 'asc'])
            .withOption('responsive', true)
            .withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('scrollY', 'auto');

        $scope.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0),
            DTColumnDefBuilder.newColumnDef(1),
            DTColumnDefBuilder.newColumnDef(2).notSortable().withOption('width', '15%'),
            DTColumnDefBuilder.newColumnDef(3).notSortable().withOption('width', '15%'),
            DTColumnDefBuilder.newColumnDef(4).notSortable().withOption('width', '15%'),
            DTColumnDefBuilder.newColumnDef(5).notSortable().withOption('width', '15%'),
        ];
        $scope.dtInstance = {};

        $scope.GetSerch = function (Search) {
            $scope.dtInstance.DataTable.search(Search);

            $scope.dtInstance.DataTable.search(Search).draw();
        };
        $scope.Reset = function () {
            $scope.init();
        }

        $scope.init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.user')
        .controller('UserController', UserController)


    /** @ngInject */
    function UserController($http, $scope, $rootScope, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {

        var vm = this;
        $scope.init = function () {
            $scope.model = {
                id: '',
                email: '',
                // fullname: '',
                firstName: '',
                password: '',
                lastName: '',
                role_id: '',
            };
            $scope.tab = {
                selectedIndex: 0
            };
            $scope.GetAllRoles();
            $scope.editflg = false
            $scope.Search = '';
            $scope.flag = false;
            $scope.modelSearch = {
                Search: '',
            }
        }
        $scope.onSearchChange = function ($event) {
            $event.stopPropagation();
        }


        $scope.GetAllRoles = function () {
            $http.get($rootScope.RoutePath + "role/getAllRole").then(function (response) {
                $scope.lstRoles = response.data.data;
            });
        }


        //Create New User With It's Role
        // $scope.CreateUser = function (o) {
        //     console.log(o)
        //     $http.post($rootScope.RoutePath + "user/saveUser", o).then(function (data) {
        //         console.log(data)
        //         //$scope.SaveUserInRole(o);
        //         if (data.data.success == true) {

        //             $mdToast.show(
        //                 $mdToast.simple()
        //                     .textContent(data.data.message)
        //                     .position('top right')
        //                     .hideDelay(3000)
        //             );
        //             $scope.init();
        //             $scope.GetAllUser(true);
        //         } else {
        //             if (data.data.data == 'TOKEN') {
        //                 //$cookieStore.remove('UserName');
        //                 //$cookieStore.remove('token');
        //                 //window.location.href = '/app/login';
        //             } else {
        //                 $mdToast.show(
        //                     $mdToast.simple()
        //                         .textContent(data.data.message)
        //                         .position('top right')
        //                         .hideDelay(3000)
        //                 );
        //             }
        //         }
        //     });
        // } else {
        //     $mdToast.show(
        //         $mdToast.simple()
        //             .textContent('Please Select atleast One Role...')
        //             .position('top right')
        //             .hideDelay(3000)
        //     );
        // }

        // }




        //Dynamic Pagging
        $scope.FilterStatus = 1;
        $scope.dtColumns = [
            DTColumnBuilder.newColumn('createddate').renderWith(NumberHtml).notSortable().withOption('class', 'text-center'),

            DTColumnBuilder.newColumn('email').renderWith(emailHtml).withOption('class', 'text-left'),

            DTColumnBuilder.newColumn('fullname').renderWith(nameHtml).withOption('class', 'text-left'),
            DTColumnBuilder.newColumn('RoleName').renderWith(RoleHtml).withOption('class', 'text-left'),
            DTColumnBuilder.newColumn(null).notSortable().renderWith(actionsHtml).withOption('width', '18%').withOption('class', 'dt-body-center'),
        ]

        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
            $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                url: $rootScope.RoutePath + "user/GetAllUser",
                data: function (d) {
                    if ($scope.modelSearch.Search == '') {
                        d.search = '';
                    } else {
                        d.search = $scope.modelSearch.Search;
                    }
                    d.UserRoles = $rootScope.UserRoles;
                    return d;
                },
                type: "get",
                dataSrc: function (json) {
                    if (json.success != false) {
                        $scope.lstdata = json.data;
                        return json.data;
                    } else {
                        return [];
                    }
                },
            })
                .withOption('processing', true) //for show progress bar
                .withOption('serverSide', true) // for server side processing
                .withPaginationType('simple') // for get full pagination options // first / last / prev / next and page numbers
                .withDisplayLength(25) // Page size
                .withOption('aaSorting', [0, 'desc'])
                .withOption('responsive', true)
                .withOption('createdRow', createdRow)
                .withOption('autoWidth', true)
                .withOption('initComplete', function () {
                    $scope.AdjustColumn();
                })
                .withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                .withOption('scrollY', 'auto');
        });
        $scope.dtInstance = {};
        $(window).resize(function () {
            $scope.AdjustColumn();
        });

        $scope.AdjustColumn = function () {
            $scope.dtInstance.DataTable.columns.adjust();
        }

        //Reload Datatable
        $scope.GetAllUser = function (IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            $scope.dtInstance.reloadData(callback, resetPaging);
            $('#Usertable').dataTable()._fnPageChange(0);
            $('#Usertable').dataTable()._fnAjaxUpdate();

        }

        $scope.reloadData = function () { }

        function callback(json) { }

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }


        function NumberHtml(data, type, full, meta) {
            return parseInt((meta.settings._iDisplayStart) + (meta.row + 1));
        }

        function nameHtml(data, type, full, meta) {

            if (full != null && full != undefined && full != '') {
                return full.firstName + ' ' + full.lastName;
            } else {
                return 'N/A';

            }
        }
        function RoleHtml(data, type, full, meta) {
            if (data != null) {
                if (full != null && full != undefined && full != '') {

                    try {
                        return full.RoleName;
                    }
                    catch (error) {
                        return 'N/A';
                    }
                }
            } else {
                return 'N/A';

            }
        }

        function emailHtml(data, type, full, meta) {
            if (data != null && data != undefined && data != '') {
                return data;
            } else {
                return 'N/A';

            }
        }

        function actionsHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">'
            // btns += '<md-button  class="md-icon-button md-accent md-raised md-hue-2" ng-if="' + $rootScope.FlgModifiedAccess + '" ng-click="FetchRoleById(' + data.id + ')" aria-label="">' +
            //     '<md-icon md-font-icon="icon-pencil-box-outline"></md-icon> <md-tooltip md-visible="" md-direction="">Edit User </md-tooltip>' +
            //     '</md-button>';

            var method1 = "FetchRoleById('" + data._id + "')";

            btns += '<md-button class="edit-button md-icon-button"  ng-click="' + method1 + '" aria-label="">' +
                '<md-icon md-font-icon="icon-pencil"  class="s18 green-500-fg"></md-icon>' +
                '<md-tooltip md-visible="" md-direction="">Edit</md-tooltip>' +
                '</md-button>';

            var method2 = "DeleteUser('" + data._id + "')";
            btns += '<md-button class="edit-button md-icon-button"  ng-click="' + method2 + '" aria-label="">' +
                '<md-icon md-font-icon="icon-trash" class="s18 red-500-fg"></md-icon>' +
                '<md-tooltip md-visible="" md-direction="">Delete</md-tooltip>' +
                '</md-button>';

            // btns += '<md-button class="edit-button md-icon-button"  ng-click="ResetPassword(' + data.id + ')" aria-label="">' +
            //     '<md-icon md-font-icon="icon-account-alert"  class="s18 blue-500-fg"></md-icon>' +
            //     '<md-tooltip md-visible="" md-direction="">Reset Password</md-tooltip>' +
            //     '</md-button>';

            // console.log(data.userId)

            btns += '</div>'
            return btns;
        };

        //Dynamic Pagging End

        $scope.CreateUser = function (o, form) {
            $http.post($rootScope.RoutePath + "user/saveUser", o).then(function (data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    );
                    $scope.init();
                    $scope.GetAllUser(true);
                } else {
                    if (data.data.data == 'TOKEN') {
                        //$cookieStore.remove('UserName');
                        //$cookieStore.remove('token');
                        //window.location.href = '/app/login';
                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                    }
                }
            });
        };

        $scope.FetchRoleById = function (id) {
            $scope.editflg = true
            var o = _.findWhere($scope.lstdata, {
                _id: id
            });
            $scope.tab.selectedIndex = 1;

            $scope.model.email = o.email;
            $scope.model.id = o._id;
            // $scope.model._id = $scope.model.id;
            $scope.model.userId = o._id;
            $scope.model.firstName = o.firstName;
            $scope.model.lastName = o.lastName;
            $scope.model.role_id = o.role_id
            $scope.model.password = o.password;
            $scope.flag = true;
        }

        $scope.DeleteUser = function (id) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to Delete this User?')
                .ok('Ok')
                .cancel('Cancel')
            $mdDialog.show(confirm).then(function () {
                var params = {
                    user_id: id,
                };
                $http.get($rootScope.RoutePath + "user/DeleteUser", {
                    params: params
                }).success(function (data) {
                    if (data.success == true) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                        $scope.init();
                        $scope.GetAllUser(true);
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                    }
                });
            });
        }

        $scope.restForm = function () {
            $scope.AddUserForm.$setUntouched();
            $scope.AddUserForm.$setPristine();
        }

        $scope.GetSerch = function (Search) {
            $scope.modelSearch.Search = Search;
            $scope.GetAllUser(true);
        }



        $scope.ResetEdit = function () {
            $scope.flag = true;
            $scope.model = {
                id: '',
                // _id: '',
                email: '',
                // fullname: '',
                firstName: '',
                password: '',
                lastName: '',
            };

            $scope.restForm();
        }

        $scope.ResetModel = function () {
            $scope.init();

            $scope.restForm();


            $scope.modelSearch = {
                Search: '',
            }
            $scope.GetAllUser(true);
            //$scope.GetAllStateByCountry($scope.idCountry);
        }



        $scope.Reset = function () {
            $scope.init();
        }

        $scope.init();
    }

})();
(function() {
    'use strict';

    angular
        .module('app.Testimonial')
        .controller('TestimonialController', TestimonialController)


    /** @ngInject */
    function TestimonialController($http, $scope, $rootScope, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {

        var vm = this;
        $rootScope.appId = localStorage.getItem('appId');
        $rootScope.UserRoles = localStorage.getItem('UserRoles');
        $scope.init = function() {                  
            $scope.model = {
                Search: '',
            }

            $scope.modelSearch = {
                type: 'patient',
            }
            // $scope.getAllTestimonial();
            $scope.flaglink = 0;
        }
        
        $scope.GetSearch = function(Search) {
            $scope.model.Search = Search;
            $scope.GetAllDynamicTestimonials(true);
        }
        // $scope.getAllTestimonial = function() {
        //     $http.get($rootScope.RoutePath + "testimonial/getAllTestimonial").then(function(data) {
        //         $scope.lstTestimonial = data.data.data;
        //     });
        // };


        //Dynamic Pagging
        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function(response) {
            $scope.FilterStatus = 1;
            $scope.dtColumns = [
                DTColumnBuilder.newColumn("created_on").renderWith(NumberHtml),
                DTColumnBuilder.newColumn("firstname").renderWith(PatientInfoHtml),
                DTColumnBuilder.newColumn("name").renderWith(DataToDisplayHtml),
                DTColumnBuilder.newColumn("driver_courteous").renderWith(CourteousDriverHtml),
                DTColumnBuilder.newColumn("recommended").renderWith(Recommended),
                DTColumnBuilder.newColumn("comments").renderWith(Comments),
                DTColumnBuilder.newColumn("experience").renderWith(Experience),
                DTColumnBuilder.newColumn("created_on").renderWith(dateFormat),
                DTColumnBuilder.newColumn("video_record").renderWith(DocumentsHtml).notSortable(),
                DTColumnBuilder.newColumn("picture").renderWith(PictureHtml).notSortable().withOption('class', 'dt-body-center'),
                DTColumnBuilder.newColumn(null).notSortable().renderWith(actionsHtml).withOption('width', '5%').withOption('class', 'text-center')
            ]
                // bucket/getAllBucketOrder
            $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                    url: $rootScope.RoutePath + "testimonial/getAllTestimonial",
                    data: function(d) {
                        d.search = $scope.model.Search;
                        d.type = $scope.modelSearch.type;
                        return d;
                    },
                    type: "get",
                    dataSrc: function(json) {
                        if (json.success != false) {
                            $scope.lstdata = json.data;
                            return json.data;
                        } else {
                            return [];
                        }
                    },
                })
                .withOption('processing', true) //for show progress bar
                .withOption('serverSide', true) // for server side processing
                .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                .withDisplayLength(10) // Page size
                .withOption('aaSorting', [0, 'desc'])
                .withOption('responsive', true)
                .withOption('createdRow', createdRow)
                .withOption('autoWidth', true)
                .withOption('initComplete', function() {
                    $scope.AdjustColumn();
                })
                .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
                .withOption('scrollY', 'auto');
        });
        vm.dtInstance = {};
        $(window).resize(function() {
            // console.log("$$$$$$$$$$$$$")
            $scope.AdjustColumn();
        });

        $scope.AdjustColumn = function() {

            vm.dtInstance.DataTable.columns.adjust();
        }
        $scope.GetAllDynamicHospital = function(IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            vm.dtInstance.reloadData(callback, resetPaging);
            $('#TestimonialTable').dataTable()._fnAjaxUpdate();
        }
        $scope.onSearchChange = function($event) {
            $event.stopPropagation();
        }
        $scope.clearSearchTerm = function() {
            vm.search1 = '';
        };


        $scope.reloadData = function() {}

        function callback(json) {}

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }


        function NumberHtml(data, type, full, meta) {
            return "<div style='text-align: center;'>" + (meta.row + 1) + "</div>";
        }

        function PatientInfoHtml(data, type, full, meta) {
            var btns = '';
            btns += '<span><b> Name : </b>' + full.firstname + ' ' + full.lastname + '</span><br>';
            if (full.pharmacy != null) {
                btns += '<span><b> Pharmacy : </b>' + full.pharmacy + '  </span><br>';
            }
            btns += '<span><b> Phone Number : </b>' + full.phone_number + '  </span><br>';
            btns += '<span><b> E-mail : </b>' + full.email + '  </span><br>';
            btns += '<span><b> City : </b>' + full.city + '  </span><br>';
            btns += '<span><b> State : </b>' + full.state + '  </span><br>';

            return btns;
        }

        function DataToDisplayHtml(data, type, full, meta) {
            var btns = '';
            if(full.name != null) {
                btns += ' <span><b> Name : </b>' + full.name + '</span><br>';
            }
            if (full.pharmacy_name != null) {
                btns += '<span><b> Pharmacy Name : </b>' + full.pharmacy_name + '  </span><br>';
            }
            if (full.Pharmacist_name != null) {
                btns += '<span><b> Pharmacist Name : </b>' + full.Pharmacist_name + '  </span><br>';
            }
            btns += '<span><b> City : </b>' + full.display_city + '  </span><br>';
            btns += '<span><b> State : </b>' + full.display_state + '  </span><br>';

            return btns;
        }

        function CourteousDriverHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if(full.driver_courteous == true){
                btns += '<div style="font-size: 20px;color: green"> &#x2714;' + '</div>';
            }else {
                btns += '<div style="font-size: 20px;color: red">&#x2716;' + '</div>';
            }
            btns += '<div>';
            return btns;
        };
        
        function Recommended(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if(full.recommended == true){
                btns += '<div style="font-size: 20px;color: green"> &#x2714;' + '</div>';
            }else {
                btns += '<div style="font-size: 20px;color: red">&#x2716;' + '</div>';
            }
            btns += '<div>';
            return btns;
        };

        function Comments(data, type, full, meta) {
            if (data != null && data != '') {
                return data;
            } else {
                return "<div style='text-align: center;'>-</div>";
            }
        };

        function Experience(data, type, full, meta) {
            if (data != null && data != '') {
                return data;
            } else {
                return "<div style='text-align: center;'>-</div>";
            }
        };

        function dateFormat(data, type, full, meta) {
            if (data != null && data != '') {
                return "<div style='text-align: center;'>" + moment(data).format('MM-DD-YYYY') + "</div>"
            } else {
                return "<div style='text-align: center;'>-</div>";
            }
        }

        function DocumentsHtml(data, type, full, meta) {
            var btns = '';
            if(full.video_record != null) {
                btns += '<span style="display: flex;"><b> Video: </b> <a target="_blank" href="' +  $rootScope.RoutePath + 'Testimonial/Video/' + full.video_record +'">' + full.video_record + '</a></span><br>';
            }else {
                btns += '<span><b> Video: </b>' + '' + '</span><br>';
            }
            if(full.audio_record != null) {
                btns += '<span style="display: flex;"><b> Audio: </b> <a target="_blank" href="' +  $rootScope.RoutePath + 'Testimonial/Audio/' + full.audio_record +'">' + full.audio_record + '</a></span><br>';
            }else {
                btns += '<span><b> Audio: </b>' + '' + '</span><br>';
            }
            return btns;
        }

        function PictureHtml(data, type, full, meta) {
            var btns = '';
            if(data != null) {
                btns += '<a target="_blank" href="' + $rootScope.RoutePath + 'Testimonial/Image/' + data +'"><img src="' + $rootScope.RoutePath + 'Testimonial/Image/' + data + '" /></a>'
                // btns += '<h1>' + data + '</h1>';
            }else {
                btns += '-'
            }
            return btns;
        }

        function actionsHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            var method = "ShowApplicationModal('" + full._id + "')";
            btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                '<md-icon md-font-icon="icon-receipt"  class="orange-500-fg"></md-icon>' +
                '<md-tooltip md-visible="" md-direction="">Testimonial</md-tooltip>' +
                '</md-button>';
            // }
           
            btns += '<div>';
            return btns;
        };

        $scope.ResetModel1 = function (type) {
            $scope.flag = false;
            $scope.flaglink = 0;
            $scope.searchtype1(type)
        }
        $scope.ResetModel2 = function (type) {

            $scope.flag = false;
            $scope.flaglink = 1;
            $scope.searchtype1(type)
        }

        $scope.searchtype1 = function (type) {
            $scope.modelSearch.type = type
            $scope.GetAllDynamicTestimonials(true);
        }

        $scope.reloadData = function () { }

        vm.dtInstance = {};
        $scope.GetAllDynamicTestimonials = function (IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            vm.dtInstance.reloadData(callback, resetPaging);
            $('#TestimonialTable').dataTable()._fnAjaxUpdate();
        }

        $scope.ShowApplicationModal = function (id) {
            var obj = _.findWhere($scope.lstdata, { _id: id });
            $mdDialog.show({
                controller: 'TestimonialDetailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Testimonial/dialogs/TestimonialDetail.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    objData: obj
                }
            })
        }

        $scope.init();
    }

})();
(function() {
    'use strict';

    angular
        .module('app.TransferPharamcy', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.TransferPharamcy', {
                url: '/TransferPharamcy',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/TransferPharamcy/TransferPharamcy.html',
                        controller: 'TransferPharamcyController as vm'
                    }
                },
                bodyClass: 'Transfer Pharamcy',
                ModuleName: 'Transfer Pharamcy'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.owneruser', {
        //     title: 'Owner Users',
        //     state: 'app.owneruser',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.TransferPharamcy')
        .controller('TransferPharamcyController', TransferPharamcyController)


    /** @ngInject */
    function TransferPharamcyController($http, $scope, $rootScope, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {

        var vm = this;
        $rootScope.appId = localStorage.getItem('appId');
        $rootScope.UserRoles = localStorage.getItem('UserRoles');
        $scope.init = function () {
            $scope.modelSearch = {
                search: '',
            }
            $scope.advanceSearch = {
                status: null,
            }
        }


        //Dynamic Pagging
        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
            $scope.FilterStatus = 1;
            $scope.dtColumns = [
                DTColumnBuilder.newColumn('created_on').renderWith(NumberHtml).notSortable().withOption('width', '4%').withOption('class', 'text-center'),
                DTColumnBuilder.newColumn('pharmacy_name').renderWith(currentPharmacyHtml).notSortable(),
                DTColumnBuilder.newColumn('patient_id').renderWith(patientHtml).notSortable(),
                DTColumnBuilder.newColumn('preferred_pharmacy').renderWith(preferredPharmacyHtml).notSortable(),
                DTColumnBuilder.newColumn(null).renderWith(medicationsHtml).notSortable(),
                DTColumnBuilder.newColumn('created_on').renderWith(dateFormat).notSortable(),
                DTColumnBuilder.newColumn('status').renderWith(StatusHtml),

                DTColumnBuilder.newColumn(null).renderWith(actionsHtml),
            ]
            $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                url: $rootScope.RoutePath + "transferpharmacy/getAllDaynamicTransferPharmacyRequest",
                data: function (d) {
                    d.search = $scope.modelSearch.search;
                    d.status = $scope.advanceSearch.status;
                    return d;
                },
                type: "get",
                dataSrc: function (json) {
                    if (json.success != false) {
                        $scope.lstdata = json.data;
                        return json.data;
                    } else {
                        return [];
                    }
                },
            })
                .withOption('processing', true) //for show progress bar
                .withOption('serverSide', true) // for server side processing
                .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                .withDisplayLength(10) // Page size
                .withOption('aaSorting', [0, 'desc'])
                .withOption('responsive', true)
                .withOption('createdRow', createdRow)
                .withOption('autoWidth', true)
                .withOption('initComplete', function () {
                    $scope.AdjustColumn();
                })
                // .withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
                .withOption('scrollY', 'auto');
        });



        vm.dtInstance = {};
        vm.dtInstance1 = {};
        $scope.dtInstance = {};
        $(window).resize(function () {
            $scope.AdjustColumn();
        });

        $scope.AdjustColumn = function () {
            $scope.dtInstance.DataTable.columns.adjust();
        }
        //Reload Datatable
        $scope.reloadTable = function (IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            vm.dtInstance.reloadData(callback, resetPaging);
            $('#transferPharmacyTable').dataTable()._fnPageChange(0);
            $('#transferPharmacyTable').dataTable()._fnAjaxUpdate();
        }

        $scope.reloadData = function () { }

        function callback(json) { }

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }

        function dateFormat(data, type, full, meta) {
            if (data != null && data != '') {
                return moment(data).format('MM-DD-YYYY')
            } else {
                return "";
            }

        }

        function currentPharmacyHtml(data, type, full, meta) {
            var btns = '';
            btns += '<span><b> Name: </b>' + full.pharmacy_name + '</span><br>';
            btns += '<span><b> City: </b>' + full.city + '  </span><br>';
            btns += '<span><b> State: </b>' + full.state + '  </span><br>';
            btns += '<span><b> Zip: </b>' + full.zip_code + '  </span><br>';
            btns += '<span><b> Mobile No.: </b>' + full.mobile_number + '</span>';
            return btns;
        };


        function patientHtml(data, type, full, meta) {
            var btns = '';
            btns += '<span><b> Name: </b>' + full.patientdetails[0].first_name + ' ' + full.patientdetails[0].last_name + '</span><br>';
            btns += '<span><b> Email: </b>' + full.patientdetails[0].email + '  </span><br>';
            btns += '<span><b> Mobile No: </b>' + full.patientdetails[0].mobile_number + '  </span><br>';
            return btns;
        };

        function preferredPharmacyHtml(data, type, full, meta) {
            var btns = '';
            btns += '<span><b> Name: </b>' + full.pharmacy_name + '</span><br>';
            btns += '<span><b> Email: </b>' + full.pharmacy[0].email + '  </span><br>';
            btns += '<span><b> Mobile No.: </b>' + full.pharmacy[0].mobile_number + '</span>';
            return btns;
        };

        function medicationsHtml(data, type, full, meta) {
            var btns = '<table >';
            for (var i = 0; i < full.medicines.length; i++) {
                btns += '<tr><td style="border:none">' + (i + 1) + '</td><td style="border:none">' + full.medicines[i] + '</td></tr>';
            }
            btns += '</table>';
            return btns;
        };


        function actionsHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if (full.status == 'Pending') {
                var method = "approveRequest('" + full._id + "')";
                btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                    '<md-icon md-font-icon="icon-checkbox-marked-circle" class="s28 green-500-fg">' +
                    '</md-icon>' +
                    '<md-tooltip md-visible="" md-direction="">Approve</md-tooltip>' +
                    '</md-button>';
                var method = "rejectRequest('" + full._id + "')";
                btns += '<md-button  class="edit-button md-icon-button" ng-click="' + method + '" aria-label="">' +
                    '<md-icon md-font-icon="icon-close-circle" class="s28 red-500-fg"></md-icon>' +
                    '<md-tooltip md-visible="" md-direction="">Reject</md-tooltip>' +
                    '</md-button>';
            }
            if (full.status == 'Reject' && full.reason != null) {

                var method = "OpenReason('" + full._id + "')";
                btns += '<md-button class="edit-button md-icon-button"  ng-click="' + method + '" aria-label="">' +
                    '<md-icon md-font-icon="icon-comment-outline"  class="green-500-fg"></md-icon>' +
                    '<md-tooltip md-visible="" md-direction="">Reason</md-tooltip>' +
                    '</md-button>';
            }
            btns += '<div>';
            return btns;
        };

        function NameHtml(data, type, full, meta) {

            var data = full.last_name + " " + full.first_name;
            return data;
        };



        function StatusHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if (data == "Pending") {
                btns += '<span style="font-size: 15px;background-color: orange;color:white;padding:5px; ">Pending</span>';
            } else if (data == "Approve") {
                btns += '<span style="font-size: 15px;background-color: green;color:white;padding:5px;">Approve</span>';
            } else if (data == "Reject") {
                btns += '<span style="font-size: 15px;background-color: red;color:white;padding:5px;">Reject</span>';
            }
            btns += '<div>';
            return btns;
        }



        function urlHtml(data, type, full, meta) {
            var btns = '';
            if (data != "" && data != undefined && data != null) {
                btns += '<a href="' + data + '" target="_blank">' + data + '</a>';
            }
            return btns;
        }



        $scope.OpenReason = function (_id) {
            var objData = _.findWhere($scope.lstdata, {
                _id: _id
            });
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#popupContainer')))
                    .clickOutsideToClose(true)
                    .title('Reject Reason')
                    .textContent(objData.reason)
                    .ok('close')
                    .targetEvent()
            );
        };


        $scope.approveRequest = function (_id) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to approve this request?')
                .textContent('')
                .ariaLabel('Lucky day')
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                var params = {
                    _id: _id,
                };
                $http.post($rootScope.RoutePath + 'transferpharmacy/approvePharmacyTranferRequest', params)
                    .then(function (data) {
                        if (data.data.success == true) {
                            $mdToast.show(
                                $mdToast
                                    .simple()
                                    .textContent(data.data.message)
                                    .position("top right")
                                    .hideDelay(3000)
                            );
                            $scope.reloadTable(true);
                        } else {
                            $mdToast.show(
                                $mdToast
                                    .simple()
                                    .textContent(data.data.message)
                                    .position("top right")
                                    .hideDelay(3000)
                            );
                        }
                    });
            })
        };

        $scope.rejectRequest = function (_id) {
            var confirm = $mdDialog.prompt()
                .title('Reject Reason')
                .textContent('Please Enter Reason.')
                .placeholder('Reason')
                .ariaLabel('Reason')
                .initialValue('')
                .ok('Save')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function (result) {
                if (result == undefined) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Please enter Reason.')
                            .position('top right')
                            .hideDelay(3000)
                    );
                    $scope.ChangeStatus(ev, id, status);
                } else {
                    var params = {
                        _id: _id,
                        reason: result
                    };
                    $http.post($rootScope.RoutePath + 'transferpharmacy/rejectPharmacyTranferRequest', params)
                        .then(function (data) {
                            if (data.data.success == true) {
                                $mdToast.show(
                                    $mdToast
                                        .simple()
                                        .textContent(data.data.message)
                                        .position("top right")
                                        .hideDelay(3000)
                                );
                                $scope.reloadTable(true);
                            } else {
                                $mdToast.show(
                                    $mdToast
                                        .simple()
                                        .textContent(data.data.message)
                                        .position("top right")
                                        .hideDelay(3000)
                                );
                            }
                        });
                }
            })

        };
        $scope.toggle = function () {
            if (!$scope.flgforIcon) {
                $scope.flgforIcon = true;
            } else {
                $scope.flgforIcon = false;
            }

            $(function () {
                $(".showBtn").toggleClass("active");
                $(".ShowContentBox").slideToggle();
            });
        };

        $scope.init();
    }

})();
(function () {
    'use strict';

    angular
        .module('app.ScheduleDelivery')
        .controller('ScheduleDeliveryController', ScheduleDeliveryController)


    /** @ngInject */
    function ScheduleDeliveryController($http, $scope, $rootScope, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {

        var vm = this;
        $rootScope.appId = localStorage.getItem('appId');
        $rootScope.UserRoles = localStorage.getItem('UserRoles');

        $('#loaderDiv').hide();

        $scope.init = function () {
            $scope.model = {
                Search: ''
            }

            $scope.modelSearch = {
                search: '',
                pharmacy_id: '',
                driver_id: '',
                from_date: null,
                to_date: null,
                status: null
            }
            $scope.getAllPharmacy();
            $scope.GetAllDynamicDriver();
        }
        $scope.GetSearch = function (Search) {
            $scope.model.Search = Search;
            $scope.GetAllDynamicHospital(true);
        }
        $scope.getAllPharmacy = function () {
            $http.get($rootScope.RoutePath + "pharmacy/getAllPharmacy").then(function (data) {
                $scope.lstPharmacy = data.data.data;
            });
        };

        $scope.GetAllDynamicDriver = function () {
            $http.get($rootScope.RoutePath + "driver/getAllDriver").then(function (data) {
                $scope.lstdriver = data.data.data;
            })
        };


        //Dynamic Pagging
        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
            $scope.FilterStatus = 1;
            $scope.dtColumns = [
                DTColumnBuilder.newColumn('created_date').renderWith(NumberHtml).notSortable().withOption('width', '4%').withOption('class', 'text-center').withOption('responsivePriority', 0),
                DTColumnBuilder.newColumn('bucket_no').renderWith(bucketNumberHtml).notSortable().withOption('class', 'text-center').withOption('width', '4%').withOption('responsivePriority', 1),
                DTColumnBuilder.newColumn('order_ids').renderWith(orderIdsHtml).notSortable(),
                DTColumnBuilder.newColumn('first_name').renderWith(currentPharmacyHtml).notSortable().withOption('responsivePriority', 2),
                DTColumnBuilder.newColumn('total_order').renderWith(orderHtml).notSortable().withOption('width', '5%').withOption('class', 'text-center').withOption('responsivePriority', 3),
                DTColumnBuilder.newColumn('delivery_date').renderWith(dateFormat).notSortable().withOption('responsivePriority', 4),
                // DTColumnBuilder.newColumn('delivery_time').renderWith(timeFormat).notSortable().withOption('class', 'text-center'),
                DTColumnBuilder.newColumn('driver_detail').renderWith(driverDetail).notSortable().withOption('responsivePriority', 5),
                DTColumnBuilder.newColumn('status').renderWith(StatusHtml).notSortable().withOption('width', '4%').withOption('responsivePriority', 6),
                DTColumnBuilder.newColumn(null).notSortable().renderWith(actionsHtml).withOption('width', '7%').withOption('class', 'text-center').withOption('responsivePriority', 7)
            ]
            // bucket/getAllBucketOrder
            $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                url: $rootScope.RoutePath + "bucket/getAllBucketData",
                data: function (d) {
                    d.search = $scope.model.Search;
                    // d.search = $scope.modelSearch.search;
                    d.pharmacy_name = $scope.modelSearch.pharmacy_name;
                    d.driver_id = $scope.modelSearch.driver_id;
                    d.pharmacy_id = $scope.modelSearch.pharmacy_id;
                    d.from_date = $scope.modelSearch.from_date;
                    d.to_date = $scope.modelSearch.to_date;
                    d.status = $scope.modelSearch.status;
                    return d;
                },
                type: "get",
                dataSrc: function (json) {
                    if (json.success != false) {
                        $scope.lstdata = json.data;
                        return json.data;
                    } else {
                        return [];
                    }
                },
            })
                .withOption('processing', true) //for show progress bar
                .withOption('serverSide', true) // for server side processing
                .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                .withDisplayLength(10) // Page size
                .withOption('aaSorting', [0, 'desc'])
                .withOption('responsive', true)
                .withOption('createdRow', createdRow)
                .withOption('autoWidth', true)
                .withOption('initComplete', function () {
                    $scope.AdjustColumn();
                })
                .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
                .withOption('scrollY', 'auto');
        });
        vm.dtInstance = {};
        $(window).resize(function () {
            // console.log("$$$$$$$$$$$$$")
            $scope.AdjustColumn();
        });

        $scope.AdjustColumn = function () {

            vm.dtInstance.DataTable.columns.adjust();
        }
        $scope.GetAllDynamicHospital = function (IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            vm.dtInstance.reloadData(callback, resetPaging);
            $('#ScheduleDeliveryTable').dataTable()._fnAjaxUpdate();
        }
        $scope.onSearchChange = function ($event) {
            $event.stopPropagation();
        }
        $scope.clearSearchTerm = function () {
            vm.search1 = '';
        };


        $scope.reloadData = function () { }

        function callback(json) { }

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }


        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }


        function bucketNumberHtml(data, type, full, meta) {
            if (full != null && full != '') {
                if (full.demandOrder == true) {
                    return "<span style='color:darkcyan'><b>" + full.bucket_no + "</b></span><span style='color:darkcyan'> <br> (Demand)</span> "
                }
                else {
                    return "<b>" + full.bucket_no + "</b>"
                }

            } else {
                return "";
            }
        }


        function orderIdsHtml(data, type, full, meta) {
            var order_id = "";
            if (full != null && full != '' && angular.isArray(full.order_info)) {
                for (var i = 0; i < full.order_info.length; i++) {
                    order_id = order_id.concat(full.order_info[i].order_id + "  ")
                }
                return order_id

            } else {
                return "";
            }
        }

        function dateFormat(data, type, full, meta) {
            var btns = '';
            if (full != null && full != '') {
                if (full.schedule_start_time != null && full.schedule_end_time != null) {
                    btns += '<span><b> Schedule Date : </b>' + moment(full.schedule_start_time).format('MM-DD-YYYY') + '</span><br>';
                    btns += '<span><b> Schedule Pickup Time : </b>' + moment(full.schedule_start_time).format('hh:mm:ss a') + '  </span>';
                    btns += '<span><b> To  </b>' + moment(full.schedule_end_time).format('hh:mm:ss a') + '  </span><br>';
                }
                if (full.pickedup_at != null) {
                    btns += '<span><b> Actual Pickup : </b>' + moment(full.pickedup_at).format('MM-DD-YYYY hh:mm:ss a') + '</span><br>';
                }
                if (full.accepted_at != null) {
                    btns += '<span><b> Accepted Date : </b>' + moment(full.accepted_at).format('MM-DD-YYYY hh:mm:ss a') + '</span><br>';
                }
            } else {
                return btns += '-';
            }
            return btns;
        }

        // function timeFormat(data, type, full, meta) {
        //     if (full != null && full != '') {
        //         return full.pharmacy_orders[0].delivery_time;
        //     } else {
        //         return 'N/A';
        //     }
        // }

        function driverDetail(data, type, full, meta) {
            var btns = '';
            // if (full.drivers.length > 0) {
            btns += '<span><b> Name : </b>' + full.driver_first_name + ' ' + full.driver_last_name + '</span><br>';
            btns += '<span><b> Gender : </b>' + full.driver_gender + '  </span><br>';
            if (full.driver_email != null) {
                btns += '<span><b> E-mail : </b>' + full.driver_email + '  </span><br>';
            }
            if (full.driver_vehicle_license != null) {
                btns += '<span><b> Driving License Number : </b>' + full.driver_vehicle_license + '  </span><br>';
            }
            // }
            else {
                return btns += '-';
            }
            return btns;
        }

        function currentPharmacyHtml(data, type, full, meta) {
            var btns = '';
            btns += '<span><b>Pharmacy Name : </b>' + full.pharmacy_name + '</span><br>';
            btns += '<span><b> Name : </b>' + full.first_name + ' ' + full.last_name + '</span><br>';
            btns += '<span><b> City : </b>' + full.city + '  </span><br>';
            btns += '<span><b> State : </b>' + full.state + '  </span><br>';
            btns += '<span><b> Zip : </b>' + full.zip_code + '  </span><br>';
            btns += '<span><b> Mobile No. : </b>' + full.mobile_number + '</span><br>';
            btns += '<span><b> Address : </b>' + full.address + '  </span><br>';
            return btns;
        };


        function orderHtml(data, type, full, meta) {
            if (data != null && data != '') {
                return data;
            } else {
                return "";
            }
        };

        function actionsHtml(data, type, full, meta) {

            var btns = '<div layout="row" layout-align="center" class="res-btn">';
            if (full.approval != 0) {
                var method = "ViewOrderSchedule('" + full.bucket_no + "')";
                btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                    '<md-icon md-font-icon="icon-receipt"  class="s22 orange-500-fg"></md-icon>' +
                    '<md-tooltip md-visible="" md-direction="">Order Schedule View</md-tooltip>' +
                    '</md-button>';

            }
            // if (full.drivers.length != 0) {

            if (full.status == 'accept' || full.status == 'Accept' || full.status == 'sent to driver' || full.status == 'Sent to Driver' || full.status == 'picked up' || full.status == 'Picked up') {
                // var method1 = "ChangeDriver('" + full._id + "')";
                var method1 = "ChangeDriver('" + full._id + "', '" + full.driver_id + "', '" + full.bucket_no + "')";

                if (!full.lyft_order) {
                    btns += '<md-button class="edit-button md-icon-button" ng-click="' + method1 + '">' +
                        '<md-icon md-font-icon="icon-account-plus" class="s20 brown-500-fg"></md-icon>' +
                        '<md-tooltip md-visible="" md-direction="">Assign/Change Driver</md-tooltip>' +
                        '</md-button>';
                    btns += '<div>';
                }
            }

            // trasnfer order to doordash
            if (full.status == 'accept' || full.status == 'Accept' || full.status == 'sent to driver' || full.status == 'Sent to Driver' || full.status == 'picked up' || full.status == 'Picked up') {
                if (!full.lyft_order) { // Disabled Doordash
                    var failed_dd_bucket = full.bucket_no.includes("BD")
                    if ((full.status == 'pending' && !full.is_one_price && !failed_dd_bucket) || (full.status == 'Pending' && !full.is_one_price && !failed_dd_bucket) || (full.status == 'sent to driver' && !full.is_one_price && !failed_dd_bucket)
                        || (full.status == 'pending' && (full.is_one_price && full.is_one_price_local)) 
                    || (full.status == 'Pending' && (full.is_one_price && full.is_one_price_local)) 
                    || (full.status == 'sent to driver' && (full.is_one_price && full.is_one_price_local))
                        || !failed_dd_bucket) {

                        var lyft_btn = '<div layout="row" layout-align="center">';
                        var transfer_order_lyft = "baltoToLyftOrder('" + data.bucket_no + "')";
                        btns += '<md-button class="edit-button md-icon-button" ng-click="' + transfer_order_lyft + '">' +
                            '<md-icon md-font-icon="icon-transfer"  class="orange-500-fg"></md-icon>' +
                            '<md-tooltip md-visible="" md-direction="">Transfer to doordash </md-tooltip>' +
                            '</md-button>';
                        btns += '<div>';
                        btns + lyft_btn
                    }
                }
            }
            if (full.status == 'pending' || full.status == 'Pending') {
                var method1 = "AssignDriver('" + full._id + "')";
                if (!full.lyft_order) {
                    btns += '<md-button class="edit-button md-icon-button" ng-click="' + method1 + '">' +
                        '<md-icon md-font-icon="icon-bike" class="s20 brown-500-fg"></md-icon>' +
                        '<md-tooltip md-visible="" md-direction="">Assign to All Drivers</md-tooltip>' +
                        '</md-button>';
                    btns += '<div>';
                }

            }
            if (full.status == 'accept' || full.status == 'Accept' || full.status == 'Picked up' || full.status == 'picked up') {
                var method2 = "CreateBingMapRoute('" + full.bucket_no + "')";
                btns += '<md-button class="edit-button md-icon-button" ng-click="' + method2 + '">' +
                    '<md-icon md-font-icon="icon-directions" class="s20 brown-500-fg"></md-icon>' +
                    '<md-tooltip md-visible="" md-direction="">Map route for driver</md-tooltip>' +
                    '</md-button>';
                btns += '<div>';
            }
            return btns;

        }

        function StatusHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';

            if (!full.lyft_order) {
                if (data == "picked up") {
                    btns += '<span style="font-size: 15px;background-color: #ff9790;color:white;padding:5px; ">Picked Up</span>';
                } else if (data == "delivered") {
                    btns += '<span style="font-size: 15px;background-color: orange;color:white;padding:5px; ">Delivered</span>';
                } else if (data == "pending") {
                    btns += '<span style="font-size: 15px;background-color:#423c32;color:white;padding:5px; ">Pending</span>';
                } else if (data == "sent to driver") {
                    btns += '<span style="font-size: 15px;background-color: #ff00ff;color:white;padding:5px; ">Sent to Driver</span>';
                } else if (data == "completed") {
                    btns += '<span style="font-size: 15px;background-color: blue;color:white;padding:5px; ">Completed</span>';
                } else if (data == "accept") {
                    btns += '<span style="font-size: 15px;background-color: green;color:white;padding:5px; ">Accept</span>';
                } else if (data == "reject") {
                    btns += '<span style="font-size: 15px;background-color: red;color:white;padding:5px; ">Reject</span>';
                }

            } else {
                if (data == "picked up") {
                    btns += '<span style="font-size: 15px;background-color: #ff9790;color:white;padding:5px; ">Doordash - Picked Up</span>';
                } else if (data == "delivered") {
                    btns += '<span style="font-size: 15px;background-color: orange;color:white;padding:5px; ">Doordash - Delivered</span>';
                } else if (data == "pending") {
                    btns += '<span style="font-size: 15px;background-color:#423c32;color:white;padding:5px; ">Doordash - Pending</span>';
                } else if (data == "sent to driver") {
                    btns += '<span style="font-size: 15px;background-color: #ff00ff;color:white;padding:5px; ">Doordash - Sent to Driver</span>';
                } else if (data == "completed") {
                    btns += '<span style="font-size: 15px;background-color: blue;color:white;padding:5px; ">Doordash - Completed</span>';
                } else if (data == "accept") {
                    btns += '<span style="font-size: 15px;background-color: green;color:white;padding:5px; ">Doordash - Accept</span>';
                } else if (data == "reject") {
                    btns += '<span style="font-size: 15px;background-color: red;color:white;padding:5px; ">Doordash - Reject</span>';
                }

            }


            btns += '<div>';
            return btns;
        }

        $scope.toggle = function () {
            if (!$scope.flgforIcon) {
                $scope.flgforIcon = true;
            } else {
                $scope.flgforIcon = false;
            }

            $(function () {
                $(".showBtn").toggleClass("active");
                $(".ShowContentBox").slideToggle();
            });
        };

        //bucket order show
        $scope.ViewOrderSchedule = function (bucket_no, ev) {
            // var data = _.findWhere($scope.lstdata, {
            //     bucket_no: bucket_no
            // });

            $mdDialog.show({
                controller: 'ViewScheduleDeliveryController',
                controllerAs: 'vm',
                templateUrl: 'app/main/ScheduleDelivery/dialog/ViewScheduleDelivery/ViewScheduleDelivery.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    // data: data,
                    bucket_no: bucket_no
                }
            })
            $scope.GetAllDynamicHospital();
        }

        //change and assign driver to bucket
        $scope.ChangeDriver = function (id, old_driver_id, bucket_no) {
            var obj = _.findWhere($scope.lstdata, { _id: id });

            if (id) {
                $mdDialog.show({
                    controller: 'ChangeDriverController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/ScheduleDelivery/dialog/ChangeDriver/ChangeDriver.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    locals: {
                        Task: [],
                        ObjVm: vm,
                        ObjDriver: obj,
                        oldDriverData: old_driver_id,
                        bucketData: bucket_no
                    }
                })
            }
        }

        //bucket assign to all drivers
        $scope.AssignDriver = function (id) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to send to driver this bucket?')
                .textContent('')
                .ariaLabel('Lucky day')
                // .targetEvent(ev)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                var obj = _.findWhere($scope.lstdata, { _id: id });
                var obj1 = {
                    pharmacy_name: obj.pharmacy_name,
                    bucket_no: obj.bucket_no,
                }
                $http.post($rootScope.RoutePath + "bucket/assignDriver", obj1).then(function (data) {
                    if (data) {
                        $rootScope.loadingProgress = false;
                    }
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    );
                    $('#ScheduleDeliveryTable').dataTable()._fnAjaxUpdate();
                });
            })
        }

        // Create or send bingmap route request after all order picked up
        $scope.CreateBingMapRoute = function (no) {
            $rootScope.loadingProgress = true;
            // console.log(no);
            var obj = {
                bucket_no: no
            }
            $http.post($rootScope.RoutePath + "api/v1/createBingmapRoute", obj).then(function (data) {
                if (data) {
                    $rootScope.loadingProgress = false;
                }
                $mdToast.show(
                    $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                );
            })
        }

        // Order transfers to Lyft Drivers 
        $scope.baltoToLyftOrder = function (bucket_no) {
            $mdDialog.show({
                controller: 'LyftBatchingDeliveryController',
                controllerAs: 'vm',
                templateUrl: 'app/main/ScheduleDelivery/dialog/LyftBatchingDelivery/LyftBatchingDelivery.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    // data: data,
                    bucket_no: bucket_no
                }
            })


        }

        $scope.init();
    }

})();
(function() {
    'use strict';

    angular
        .module('app.SuggestPharmacy')
        .controller('SuggestPharmacyController', SuggestPharmacyController);

    /** @ngInject */
    function SuggestPharmacyController($http, $scope, $rootScope, $cookieStore, $mdToast, $mdDialog, DTOptionsBuilder, DTColumnBuilder, $compile) {
        var vm = this;

        vm.Reset = function() {
            $scope.reloadTableData();
        }

        $scope.init = function() {
            $scope.modelData = {
                _id: null,
                billing_period_days: null,
                payment_period_days: null,
                // token: null,
            }
            $scope.initModel();
        }

        $scope.initModel = function() {

            $scope.modelSearch = {
                search: '',
                zip_code: '',
                verified: '',
                Approved: '',
            }
            $scope.selected = [];
        }
        $rootScope.role_id = $cookieStore.get('role_id');

        //Dynamic Pagging
        // $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
        $scope.FilterStatus = 1;

        $scope.dtColumns = [
            DTColumnBuilder.newColumn('signup_at').renderWith(NumberHtml).notSortable().withOption('width', '4%').withOption('class', 'text-center'),
            // DTColumnBuilder.newColumn(null).notSortable().renderWith(ImageHtml).withOption('width', '4%'),
            DTColumnBuilder.newColumn('pharmacy_name'),
            DTColumnBuilder.newColumn('patient_name').renderWith(PatientHtml),
            DTColumnBuilder.newColumn('email'),
            DTColumnBuilder.newColumn('mobile_number'),
            DTColumnBuilder.newColumn('address').renderWith(AddressHtml),
            DTColumnBuilder.newColumn('zip_code'),
            DTColumnBuilder.newColumn('signup_at').renderWith(dateFormat),
            DTColumnBuilder.newColumn(null).notSortable().renderWith(ActionHtml).withOption('width', '5%').withOption('class', 'text-center')
        ]
        $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                url: $rootScope.RoutePath + "getAllSuggestPharmacy",
                data: function(d) {
                    d.search = $scope.modelSearch.search;
                    d.zip_code = $scope.modelSearch.zip_code;
                    d.verified = $scope.modelSearch.verified;
                    d.Approved = $scope.modelSearch.Approved;
                    return d;
                },
                type: "get",
                dataSrc: function(json) {
                  
                    if (json.success != false) {
                        $scope.lstdata = json.data;
                        return json.data;
                    } else {
                        return [];
                    }
                },
            })
            .withOption('processing', true) //for show progress bar
            .withOption('serverSide', true) // for server side processing
            .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
            .withDisplayLength(25) // Page size
            .withOption('aaSorting', [0, 'desc'])
            .withOption('responsive', true)
            .withOption('createdRow', createdRow)
            .withOption('autoWidth', true)
            .withOption('initComplete', function() {
                $scope.AdjustColumn();
            })
            // .withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
            .withOption('scrollY', 'auto');
        // });


        vm.dtInstance = {};
        vm.dtInstance1 = {};
        $scope.dtInstance = {};
        // $(window).resize(function() {
        //     $scope.AdjustColumn();
        // });

        $scope.AdjustColumn = function() {
   
                vm.dtInstance.DataTable.columns.adjust();
            }
            //Reload Datatable
        $scope.reloadTableData = function(IsUpdate) {
            
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            }
            vm.dtInstance.reloadData(callback, resetPaging);
            $('#pharmacyTable').dataTable()._fnPageChange(0);
            $('#pharmacyTable').dataTable()._fnAjaxUpdate();
        }

        $scope.reloadData = function() {}

        function callback(json) {}

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }

        function dateFormat(data, type, full, meta) {
            if (data != null && data != '') {
                return moment(data).format('MM-DD-YYYY hh:mm:ss a')
            } else {
                return "";
            }
        }
        function AddressHtml(data, type, full, meta) {
            var btns = '';
            if (full.address) {
                btns += full.address;
            }
            if (full.city) {
                btns += "," + full.city;
            }
            if (full.state) {
                btns += "," + full.state;
            }

            return btns;
        }

            function PatientHtml(data, type, full, meta) {
            var btns = '';
            if (full.patient_data) {

                btns += full.patient_data.first_name + " " + full.patient_data.last_name + " "  +  full.patient_data.middle_name  ;

            }
            return btns;
        }


        function ActionHtml(data, type, full, meta) {
    
           
            // // var model = 'selected[' + full._id + '].isChecked';
            // var datavalue = '';
            // // datavalue = '<div layout="row" layout-align="center"><md-checkbox aria-label="assign"  ng-model="' + model + '"></md-checkbox></div>';
            // return datavalue;

            // var btns = '<div layout="row" layout-align="center">'; 
            var btns = '<div layout="row" layout-align="center" class="res-btn">';
            var method = "EditEmail('" +  full.patient_id + "','" + full.email +  "','" + full.zip_code + "')";
 
                                    btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' + 
                '<md-icon md-font-icon="icon-pencil"  class="s18 grey-500-fg"></md-icon>' +
                '<md-tooltip md-visible="" md-direction="">Edit Email Id</md-tooltip>' +
                '</md-button>';
            btns += '<div>';
            return btns;
        }

        $scope.EditEmail = function(patient_id, email, zip) {
            
            $mdDialog.show({
                controller: 'suggestpharmacyEditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/SuggestPharmacy/dialogs/suggestpharmacyEdit/suggestpharmacyEdit.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    old_email: (email),
                    patient_id: patient_id,
                    zip_code : zip
                    // token: $cookieStore.get('token'),
                }
            })

        }

     

        $scope.ResetModel = function() {
            $scope.init();

            $scope.restForm();
        }

        $scope.restForm = function() {
            $scope.AddStatusForm.$setUntouched();
            $scope.AddStatusForm.$setPristine();
        }

       


        $scope.init();

    }

})();
(function () {
    'use strict';

    angular
        .module('app.roles')
        .controller('RolesController', RolesController);

    /** @ngInject */
    function RolesController($http, $scope, $rootScope, $state, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder) {

        var vm = this;
        // vm.GetAllRoles = GetAllRoles;
        vm.RemoveCountryToRole = RemoveCountryToRole;
        $scope.init = function () {

            $scope.model = {
                RoleName: '',
                Description: '',
                id: '',

            };
            $scope.Search = '';
            $scope.GetAllRoles();
            $scope.RoleCountry = "";
            $scope.tab = {
                selectedIndex: 0
            };
            $scope.flag = false;
        }


        vm.dtInstance = {};


        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDisplayLength(25)
            .withOption('lengthMenu', [25, 50, 100])
            .withOption('responsive', true)
            .withOption('autoWidth', true)
            .withOption('language', {
                'zeroRecords': "No Record Found",
                'emptyTable': "No Record Found"
            })
            .withOption('scrollY', 'auto')
            // .withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
        // .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');

        $scope.GetAllCountry = function () {
            $http.get($rootScope.RoutePath + "country/GetAllCountry").then(function (data) {
                $scope.lstCountry = data.data;
            });
        }


        $scope.GetAllRoles = function () {
            // Data
            $http.get($rootScope.RoutePath + "role/getAllRole").then(function (data) {
                $scope.lstRoles = data.data.data;
                // $scope.GetAllCountry();
            });
        }

        $scope.DeleteRole = function (item, ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to delete this Role?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No');


            $mdDialog.show(confirm).then(function () {
                $http.get($rootScope.RoutePath + "role/DeleteRole?id=" + item._id).then(function (data) {
                    if (data.data.success) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                        $scope.init();
                    } else {
                        if (data.data.data == 'TOKEN') {
                            //$cookieStore.remove('UserName');
                            //$cookieStore.remove('token');
                            //window.location.href = '/app/login';
                            $rootScope.logout();
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(data.data.message)
                                    .position('top right')
                                    .hideDelay(3000)
                            );
                        }
                    }
                });
            }, function () { });

        }

        $scope.FetchRoleById = function (o) {
            $rootScope.FlgAddedEditlocal = true;

            $scope.tab.selectedIndex = 1;
            $scope.model.Description = o.Description;
            $scope.model.RoleName = o.RoleName;
            $scope.model.id = o._id;
            $scope.flag = true;
        }

        $scope.CreateRole = function (o, form) {
            $http.post($rootScope.RoutePath + "role/saveRole", o).then(function (data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    );
                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }

                    $scope.init();
                } else {
                    if (data.data.data == 'TOKEN') {
                        //$cookieStore.remove('UserName');
                        //$cookieStore.remove('token');
                        //window.location.href = '/app/login';
                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                    }
                }
            });
        };

        function RemoveCountryToRole(o, ev) {
            $mdDialog.show({
                controller: 'RemoveCountryModelController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Roles/dialogs/RemoveCountryModel/RemoveCountryModel.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    CountryList: $scope.lstCountry,
                    event: ev,
                    RoleVM: vm,
                    RoleCountry: o.Country,
                    FlgDeletedAccess: $rootScope.FlgDeletedAccess,
                    RoleObj: o,
                    CountrydtColumnDefs1: $scope.CountrydtColumnDefs1
                }
            })
        }


        $scope.RemoveCountryToRole = function (o, ev) {
            $mdDialog.show({
                controller: 'RemoveCountryModelController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Roles/dialogs/RemoveCountryModel/RemoveCountryModel.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    CountryList: $scope.lstCountry,
                    event: ev,
                    RoleVM: vm,
                    RoleCountry: o.Country,
                    FlgDeletedAccess: $rootScope.FlgDeletedAccess,
                    RoleObj: o,
                    CountrydtColumnDefs1: $scope.CountrydtColumnDefs1
                }
            })
        }

        // $scope.dtOptions = DTOptionsBuilder.newOptions()
        //     .withPaginationType('full_numbers')
        //     .withDisplayLength(10)
        //     .withOption('responsive', true)
        //     .withOption('autoWidth', true)
        //      .withOption('language', {
        //          'zeroRecords': "No Record Found",
        //          'emptyTable': "No Record Found"
        //      })
        //     .withOption('dom', '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');
        // .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>');
        $scope.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable().withOption('width', '4%').withOption('class', 'text-center'),
            DTColumnDefBuilder.newColumnDef(1),
            DTColumnDefBuilder.newColumnDef(2),
            DTColumnDefBuilder.newColumnDef(3).notSortable().withOption('class', 'text-center'),

        ];

        $scope.CountrydtColumnDefs1 = [
            DTColumnDefBuilder.newColumnDef(0).notSortable().withOption('width', '4%').withOption('class', 'text-center'),
            DTColumnDefBuilder.newColumnDef(1),
            DTColumnDefBuilder.newColumnDef(2).notSortable().withOption('class', 'text-center'),
        ];


        $scope.ResetTab = function () {
            if ($rootScope.FlgAddedAccess != true) {
                $scope.FlgAddedEditlocal = false;
            }
        }

        $scope.ResetEdit = function () {
            // if ($rootScope.FlgAddedAccess == true) {
            $scope.flag = true;
            $scope.FormManageRoles.$setPristine();
            $scope.FormManageRoles.$setUntouched();
            $scope.model = {
                RoleName: '',
                Description: '',
                id: '',

            };
            // }
            // $scope.CreateRole();

        }
        $scope.ResetData = function () {
            $scope.model = {
                RoleName: '',
                Description: '',
                id: '',

            };
            $scope.FormManageRoles.$setPristine();
            $scope.FormManageRoles.$setUntouched();
        }
        $scope.Reset = function () {
            $rootScope.FlgAddedEditlocal = false;
            if ($rootScope.FlgAddedAccess == true) {
                $rootScope.FlgAddedEditlocal = true
            }
            $scope.init();
        }
        $scope.dtCustomOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDisplayLength(10)
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            .withOption('aaSorting', [0, 'asc'])
            .withOption('deferRender', true)
            .withOption('language', {
                'zeroRecords': "No Record Found",
                'emptyTable': "No Record Found"
            })
            .withOption('dom', 'rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>');
        $scope.dtInstance = {};

        $scope.GetSerch = function (Search) {
            $scope.dtInstance.DataTable.search(Search);

            $scope.dtInstance.DataTable.search(Search).draw();
        };
        $scope.gotoOrderList = function () {
            $scope.init();
        }
        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
            $scope.init();
        })
    }

})();
(function () {
    'use strict';

    angular
        .module('app.PickupOrder', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.PickupOrder', {
                url: '/PickupOrder',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/PickupOrder/PickupOrder.html',
                        controller: 'PickupOrderController as vm'
                    }
                },
                bodyClass: 'PickupOrder',
                ModuleName: 'PickupOrder'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('SPI.Bank Deposit', {
        //     title: 'Bank Deposit',
        //     state: 'app.bankdeposit',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.PickupOrder')
        .controller('PickupOrderController', PickupOrderController);

    /** @ngInject */
    function PickupOrderController($http, $scope, $rootScope, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {
        var vm = this;
        $scope.init = function () {
            $scope.model = {
                Search: '',
                pharmacy_id: ''
            }

            // var date = new Date();
            // var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

            $scope.modelSearch = {
                search: '',
                order_status: '',
                pharmacy_name: '',
                hospice_name: '',
                hospital_name: '',
                patient_firstname: '',
                StartDate: '',
                EndDate: '',
                // Lyft
                lyft_order: ''

                // StartDate: firstDay,
                // EndDate: date
            }


            $scope.searchtype = 'pickup';
            $scope.role = $cookieStore.get("UserRoles")
            $scope.getAllPharmacy();
            $scope.getAllPatient();
            $scope.getHospital();
            $scope.flaglink = 3;



        }

        $scope.GetSerch = function (Search) {
            $scope.model.Search = Search;
            $scope.GetAllDynamicHospital(true);
        }
        $scope.searchtype1 = function (type) {
            $scope.searchtype = type
            $scope.GetAllDynamicHospital(true);
        }
        $scope.onSearchChange = function ($event) {
            $event.stopPropagation();
        }
        $scope.getAllPharmacy = function () {

            $http.get($rootScope.RoutePath + "pharmacy/getAllPharmacy").then(function (data) {
                $scope.lstPharmacy = data.data.data;
            });
        };
        $scope.getHospital = function () {

            $http.get($rootScope.RoutePath + "hospital/getAllHospital").then(function (data) {
                $scope.lstHospitalname = data.data.data;
            });
        };
        $scope.getAllPatient = function () {

            $http.get($rootScope.RoutePath + "order/getAllPatient").then(function (data) {
                $scope.lstPatient = data.data.data;
                // console.log($scope.lstPatient)
            });
        };
        //Dynamic Pagging for Hospital
        //Reload Datatable
        $scope.FilterStatus = '';
        try {
            $scope.dtColumnsHospital = [
                DTColumnBuilder.newColumn('created_on').renderWith(NumberHtml).notSortable(),
                DTColumnBuilder.newColumn('pharmacy_name').renderWith(currentPharmacyHtml),
                DTColumnBuilder.newColumn('hospital_name').renderWith(HospitalInfoHtml),
                DTColumnBuilder.newColumn('hospice_name').renderWith(currentHospiceHtml),
                DTColumnBuilder.newColumn('patient_firstname').renderWith(patientInfoHtml),
                // DTColumnBuilder.newColumn('patient_lastname').renderWith(NAHtml),
                // DTColumnBuilder.newColumn('patient_dob').renderWith(NAHtml),
                DTColumnBuilder.newColumn('order_id').renderWith(orderHtml),
                DTColumnBuilder.newColumn('delivery_date').renderWith(DeliverdDateHtml),
                DTColumnBuilder.newColumn('created_on').renderWith(DateHtml),
                DTColumnBuilder.newColumn('pharmacy_charge').renderWith(NAHtml),
                DTColumnBuilder.newColumn('order_status').renderWith(StatusHtml).notSortable().withOption('class', 'dt-body-center'),
                DTColumnBuilder.newColumn(null).notSortable().renderWith(actionsHtml).withOption('width', '5%').withOption('class', 'text-center'),
                DTColumnBuilder.newColumn('lyft_order').renderWith(checkLyftOrderHtml).notSortable().withOption('class', 'dt-body-center')

            ]
        }
        catch (error) {
            console.log(error)
        }


        // console.log( $cookieStore.get("UserRoles"), $scope.dtColumnsHospital )

        $http.get($rootScope.RoutePath + "userpermission/CheckRightsbyPage", {
            params: {
                tablename: "demand"
            }
        }).then(function (data) {
            $scope.demandView = $rootScope.demandViewAccess
            if (data.data.success == true) {

                $scope.demandView = true
                var objpermission = data.data.data;
                $rootScope.FlgAddedAccess = objpermission.Added;
                $rootScope.FlgAddedEditlocal = objpermission.Added;
                $rootScope.FlgModifiedAccess = objpermission.Modified;
                $rootScope.FlgDeletedAccess = objpermission.Deleted;
            } else {
                $rootScope.FlgAddedAccess = false;
                $rootScope.FlgAddedEditlocal = false;
                $rootScope.FlgModifiedAccess = false;
                $rootScope.FlgDeletedAccess = false;
                $scope.demandView = false
            }
        })

        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {

            $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                url: $rootScope.RoutePath + "order/getAllOrder",
                data: function (d) {
                    d.type = $scope.searchtype;
                    d.order_status = $scope.modelSearch.order_status;
                    d.pharmacy_name = $scope.modelSearch.pharmacy_name;
                    d.hospice_name = $scope.modelSearch.hospice_name;
                    d.hospital_name = $scope.modelSearch.hospital_name;
                    d.patient_firstname = $scope.modelSearch.patient_firstname;
                    d.Search = $scope.model.Search;
                    d.StartDate = $scope.modelSearch.StartDate;
                    d.EndDate = $scope.modelSearch.EndDate;
                    // For lyft
                    d.lyft_order = $scope.modelSearch.lyft_order
                    return d;
                },
                type: "get",
                dataSrc: function (json) {
                    if (json.success != false) {
                        $scope.lstHospital = json.data;
                        // console.log($scope.lstHospital)
                        return json.data;

                    } else {
                        return [];
                    }
                }
            })

                .withOption('processing', true) //for show progress bar
                .withOption('serverSide', true) // for server side processing
                .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                .withDisplayLength(10) // Page size
                .withOption('aaSorting', [0, 'desc'])
                .withOption('responsive', true)
                .withOption('createdRow', createdRow)
                .withOption('autoWidth', true)
                .withOption('initComplete', function () {
                    $scope.AdjustColumn();
                })
                .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
                .withOption('scrollY', 'auto');
        });

        // $scope.AdvanceSearch = function (o) {
        //     console.log(o)



        //     $scope.GetAllDynamicHospital(true)
        // }
        vm.dtInstanceHospital = {};
        $(window).resize(function () {
            // console.log("$$$$$$$$$$$$$")
            $scope.AdjustColumn();
        });
        $scope.AdjustColumn = function () {

            vm.dtInstanceHospital.DataTable.columns.adjust();
        }
        $scope.GetAllDynamicHospital = function (IsUpdate) {
            // $scope.searchtype = searchtype
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            vm.dtInstanceHospital.reloadData(callback, resetPaging);
            $('#Hospital').dataTable()._fnAjaxUpdate();

        }

        $(window).resize(function () {
            // console.log("$$$$$$$$$$$$$")
            $scope.AdjustColumn();
        });
        function currentPharmacyHtml(data, type, full, meta) {
            var btns = '';

            if (full.pharmacy_name != null && full.pharmacy_name != undefined) {
                btns += '<span><b>Pharmacy Name : </b>' + full.pharmacy_name + '</span><br>';
                btns += '<span><b> Payment Status : </b>' + full.pharmacy_payment_status + '  </span><br>';
            }
            // if (full.pharmacy_charge != null && full.pharmacy_charge != undefined) {
            //     btns += '<span><b> Charge ($): </b>' + full.pharmacy_charge + '  </span><br>';
            // }
            if (full.pharmacy_latitude != null && full.pharmacy_latitude != undefined) {
                btns += '<span><b> Latitude : </b>' + full.pharmacy_latitude + '</span><br>';
            } if (full.pharmacy_longitude != null && full.pharmacy_longitude != undefined) {
                btns += '<span><b> Logitude : </b>' + full.pharmacy_longitude + '</span><br>';
            } if (full.pharmacy_address != null && full.pharmacy_address != undefined) {
                btns += '<span><b> Address : </b>' + full.pharmacy_address + '  </span><br>';
            } if ((full.pharmacy_name == null && full.pharmacy_name == undefined) && (full.pharmacy_charge == null && full.pharmacy_charge == undefined) &&
                (full.pharmacy_latitude == null && full.pharmacy_latitude == undefined) && (full.pharmacy_longitude == null && full.pharmacy_longitude == undefined) &&
                (full.pharmacy_address == null && full.pharmacy_address == undefined) && (full.pharmacy_payment_status == null && full.pharmacy_payment_status == undefined)) {
                return 'N/A';
            }
            return btns;
        };

        function currentHospiceHtml(data, type, full, meta) {
            var btns = '';
            if (full.hospice_name != null && full.hospice_name != undefined) {
                btns += '<span><b> Hospice Name : </b>' + full.hospice_name + '</span><br>';
                btns += '<span><b> Payment Status : </b>' + full.hospice_payment_status + '</span><br>';
            } if (full.hospice_latitude != null && full.hospice_latitude != undefined) {
                btns += '<span><b> Latitude : </b>' + full.hospice_latitude + '</span><br>';
            } if (full.hospice_longitude != null && full.hospice_longitude != undefined) {
                btns += '<span><b> Longitude : </b>' + full.hospice_longitude + '</span><br>';
            } if (full.hospice_address != null && full.hospice_address != undefined) {
                btns += '<span><b> Address : </b>' + full.hospice_address + '</span><br>';
            } if ((full.hospice_name == null && full.hospice_name == undefined) && (full.hospice_latitude == null && full.hospice_latitude == undefined) &&
                (full.hospice_longitude == null && full.hospice_longitude == undefined) && (full.hospice_address == null && full.hospice_address == undefined) &&
                (full.hospice_payment_status == null && full.hospice_payment_status == undefined)) {
                return 'N/A';
            }
            return btns;
        }

        function HospitalInfoHtml(data, type, full, meta) {
            var btns = '';
            if (full.hospital_name != null && full.hospital_name != undefined) {
                btns += '<span><b> Name : </b>' + full.hospital_name + '</span><br>';
            } if (full.hospital_number != null && full.hospital_number != undefined) {
                btns += '<span><b> Hospital Number : </b>' + full.hospital_number + '  </span><br>';
            } if (full.hospital_instructions != null && full.hospital_instructions != undefined && full.hospital_instructions != '') {
                btns += '<span><b> Hospital Instructions : </b>' + full.hospital_instructions + '</span><br>';
            } if ((full.hospital_name == null && full.hospital_name == undefined) && (full.hospital_number == null && full.hospital_number == undefined) && (full.hospital_instructions == null && full.hospital_instructions == undefined || full.hospital_instructions == '')) {
                btns += '-'
            }
            return btns;
        }
        function orderHtml(data, type, full, meta) {
            var btns = '';
            if (full.order_id != null && full.order_id != undefined) {
                btns += '<span><b> Order Id : </b>' + full.order_id + '</span><br>';
            } if (full.ordering_personnel != null && full.ordering_personnel != undefined) {
                btns += '<span><b> Order Person Name : </b>' + full.ordering_personnel + '  </span><br>';
            } if (full.ordering_personnel_role != null && full.ordering_personnel_role != undefined) {
                btns += '<span><b> Order Person Role : </b>' + full.ordering_personnel_role + '</span><br>';
            } if ((full.order_id == null && full.order_id == undefined) && (full.ordering_personnel == null && full.ordering_personnel == undefined) && (full.ordering_personnel_role == null && full.ordering_personnel_role == undefined)) {
                return 'N/A';
            }
            // btns += '<span><b> Order Status : </b>' + full.order_status + '</span><br>';

            return btns;

        }
        // by Afzan for lyft order 
        function checkLyftOrderHtml(data, type, full, meta) {
            var btns = '';
            if (full.order_id != null && full.order_id != undefined) {
                // btns += '<span>' + full. + '</span><br>';
                if (full.lyft_delivery_order_id != null && full.lyft_delivery_order_id != undefined) {
                    btns += "<span>" + '<br><b> Doordash Order id : </b>' + full.lyft_delivery_order_id + '  </span><br>';
                } else {
                    btns += "No"
                }
            }
            // btns += '<span><b> Order Status : </b>' + full.order_status + '</span><br>';

            return btns;

        }
        function patientInfoHtml(data, type, full, meta) {
            var btns = '';
            if (full.patients.length > 0) {
                if (full.patients[0].first_name != null || full.patients[0].patient_lastname != null || full.patients[0].middle_name != null) {
                    btns += '<span><b>  Name : </b>' + full.patients[0].first_name + '</span> <span>' + full.patients[0].middle_name + '</span> <span>' + full.patients[0].last_name + '<br>';
                }
            }
            else {
                return 'N/A';
            }
            if ((full.patient_address1 != null && full.patient_address1 != undefined) || (full.patient_state != null && full.patient_state != undefined) || (full.patient_zip_code != null && full.patient_zip_code != undefined)) {
                btns += '<span><b>  Address : </b>' + full.patient_address1 + '</span> ,<span>' + full.patient_state + '</span> , <span>' + full.patient_zip_code + ' </span><br>';
            } if (full.patient_dob != null && full.patient_dob != undefined) {
                btns += '<span><b>  DOB : </b>' + full.patient_dob + '  </span><br>';
            } if (full.patient_phone_number != null && full.patient_phone_number != undefined) {
                btns += '<span><b> Phone Number : </b>' + full.patient_phone_number + '  </span><br>';
            }
            if ((full.patients[0].first_name == null && full.patients[0].patient_lastname == null && full.patients[0].middle_name == null)) {
                return 'N/A';
            }


            return btns;
        }
        function actionsHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if (data != null) {
                var method = "ShowOrderDetailInformation('" + data.order_id + "')";
                btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                    '<md-icon md-font-icon="icon-note"  class="orange-500-fg"></md-icon>' +
                    '<md-tooltip md-visible="" md-direction="">Order Information</md-tooltip>' +
                    '</md-button>';
                btns += '<div>';
            }
            // if (data.order_charges.length > 0) {
            //     var method = "ShowOrderDetailsModal('" + data.order_id + "')";
            //     btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
            //         '<md-icon md-font-icon="icon-receipt"  class="orange-500-fg"></md-icon>' +
            //         '<md-tooltip md-visible="" md-direction="">Order Details</md-tooltip>' +
            //         '</md-button>';
            //     btns += '<div>';
            // }
            return btns;

            // var btns = '<div layout="row" layout-align="center center">';

            // if ($rootScope.FlgModifiedAccess) {
            //     btns += '<md-button class="edit-button md-icon-button"  ng-click="EditBankDepositeById(' + data.id + ',' + data.Status + ')" aria-label="Edit Location">' +
            //         '<md-icon md-font-icon="icon-pencil"  class="s18 green-500-fg"></md-icon>' +
            //         '<md-tooltip md-visible="" md-direction="">Edit</md-tooltip>' +
            //         '</md-button>';
            // }
            // if ($rootScope.FlgDeletedAccess) {
            //     btns += '<md-button class="edit-button md-icon-button" ng-click="DeleteBankDepositeById(' + data.id + ',' + data.Status + ',$event)" aria-label="Add Sub-Location">' +
            //         '<md-icon md-font-icon="icon-trash"  class="s18 red-600-fg"></md-icon>' +
            //         '<md-tooltip md-visible="" md-direction="">Delete</md-tooltip>' +
            //         '</md-button>';
            // }

            // btns += '</div>'
            // return btns;
        };

        function NAHtml(data, type, full, meta) {
            if ($cookieStore.get("UserRoles") == "Admin" || $cookieStore.get("UserRoles") == "Owner") {
                if (data != null && data != undefined && data != '') {
                    return "<b>Balto : </b>" + data + ',&nbsp;&nbsp;<b>Doordash : </b>' + full.pharmacy_lyft_charge;
                } else {
                    return 'N/A';
                }
            } else {
                if (data != null && data != undefined && data != '') {
                    return "<b> - </b>"
                } else {
                    return 'N/A';
                }
            }

        }

        $scope.reloadData = function () { }

        function callback(json) { }

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

        function NumberHtml(data, type, full, meta) {
            return parseInt((meta.settings._iDisplayStart) + (meta.row + 1));
        }

        $rootScope.convertdatetimeformat = function (date1) {
            var date = new Date(date1);
            var firstdayDay = date.getDate();
            var firstdayMonth = date.getMonth() + 1;
            var firstdayYear = date.getFullYear();
            var hour = date.getHours();
            var minute = date.getMinutes();
            var sec = date.getSeconds();
            return ("00" + firstdayMonth.toString()).slice(-2) + "-" + ("00" + firstdayDay.toString()).slice(-2) + "-" + ("0000" + firstdayYear.toString()).slice(-4) + " " + ("00" + hour.toString()).slice(-2) + ":" + ("00" + minute.toString()).slice(-2) + ":" + ("00" + sec.toString()).slice(-2);
        }

        function DateHtml(data, type, full, meta) {
            if (full != null && full != undefined && full != '') {
                var date = new Date(full.created_on)
                return $rootScope.convertdatetimeformat(date);
                // return $rootScope.convertdatetimeformat(date + ' UTC');
            } else {
                return 'N/A';
            }
        }

        function DeliverdDateHtml(data, type, full, meta) {
            if (full != null && full != undefined && full != '') {
                var date = new Date(full.delivered_at)
                return $rootScope.convertdatetimeformat(date);
                // return $rootScope.convertdatetimeformat(date + ' UTC');
            } else {
                return 'N/A';
            }
        }

        function StatusHtml(data, type, full, meta) {
            if (full.order_status != null && full.order_status != undefined && full.order_status != '') {
                var btns = '<div layout-align="center">';
                if (full.order_status == -2) {
                    btns += '<span style="font-size: 15px;background-color:  #ff9790;color:white;padding:5px;" >Co-pay Verification</span>';
                }
                else if (full.order_status == -1) {
                    btns += '<span style="font-size: 15px;background-color:  #ceb5f9;color:white;padding:5px;">Co-pay Approval</span>';
                }
                else if (full.order_status == 1) {
                    btns += '<span style="font-size: 15px;background-color:#00bde3;color:white;padding:5px;">New</span>';
                }
                else if (full.order_status == 2) {
                    btns += '<span style="font-size: 15px;background-color:#ff9790;color:white;padding:5px;">OnHold</span>';
                }
                else if (full.order_status == 3) {
                    btns += '<span style="font-size: 15px;background-color: orange;color:white;padding:5px;">Ready to Pick</span>';
                }
                else if (full.order_status == 4) {
                    btns += '<span style="font-size: 15px;background-color: green;color:white;padding:5px;">Driver Picked Up</span>';
                }
                else if (full.order_status == 5) {
                    btns += '<span style="font-size: 15px;background-color: blue;color:white;padding:5px;">Completed</span>';
                }
                else if (full.order_status == 6) {
                    btns += '<span style="font-size: 15px;background-color: red;color:white;padding:5px;">Canceled</span>';
                }
                else if (full.order_status == 7) {
                    btns += '<span style="font-size: 15px;background-color:#abc343;color:white;padding:5px;">Co-pay Direct to Pharmacy</span>';
                }
                else if (full.order_status == 8) {
                    btns += '<span style="font-size: 15px;background-color: lightgray;color:white;padding:5px;">Return Pending</span>';
                }
                // else if (full.order_status == 9) {
                //     btns += '<span style="font-size: 15px;background-color:  #ceb5f9;color:white;padding:5px;">Return Completed</span><br>' +
                //         '<br><span><b>  Return Reason : </b>' + full.return_order[0].reason + '  </span><br>' +
                //         '<span><b>  Receiver Name : </b>' + full.return_order[0].recived_name + '  </span><br>';
                // }
                else if (full.order_status == 9) {
                    btns += '<span style="font-size: 15px;background-color:  #ceb5f9;color:white;padding:5px;">Return Completed</span><br>' +
                        '<br><span><b>  Return Reason : </b>' + 'N/A' + '  </span><br>' +
                        '<span><b>  Receiver Name : </b>' + 'N/A' + '  </span><br>';
                }
                else {
                    return 'N/A'
                }
                btns += '<div>';
                return btns;

            } else {
                return 'N/A';
            }
        }


        $(document).on('click', '#okbtn1', function () {
            $mdDialog.hide();
        });

        //Dynamic pagging End


        $scope.toggle = function () {
            if (!$scope.flgforIcon) {
                $scope.flgforIcon = true;
            } else {
                $scope.flgforIcon = false;
            }

            $(function () {
                $(".showBtn").toggleClass("active");
                $(".ShowContentBox").slideToggle();
            });
        };
        $scope.ShowOrderDetailsModal = function (Order_Id) {
            var orderData = _.findWhere($scope.lstHospital, {
                order_id: Order_Id
            });
            $scope.orderDetailData = orderData.order_charges;
            $mdDialog.show({
                controller: 'OrderDetailsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Order/dialogs/OrderDetails/OrderDetails.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    Order_Id: Order_Id,
                    OrderDetailData: $scope.orderDetailData
                }
            })
        }

        $scope.ShowOrderDetailInformation = function (Order_Id) {
            var orderData = _.findWhere($scope.lstHospital, {
                order_id: Order_Id
            });
            $scope.orderDetailData = orderData.order_charges;
            $mdDialog.show({
                controller: 'OrderDetailInformationController',
                controllerAs: 'vm',
                templateUrl: 'app/main/PickupOrder/dialogs/OrderDetailInformation/PickupOrderControllerDetailInformation.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    Order_Id: Order_Id,
                }
            })
        }

        $scope.ResetTab = function (type) {
            $scope.flag = false;

            $scope.flaglink = 0;
            $scope.searchtype1(type)

        }

        $scope.ResetModel1 = function (type) {
            $scope.flag = false;
            $scope.flaglink = 1;
            $scope.searchtype1(type)
        }
        $scope.ResetModel2 = function (type) {

            $scope.flag = false;
            $scope.flaglink = 2;
            $scope.searchtype1(type)
        }
        $scope.ResetModel3 = function (type) {

            $scope.flag = false;
            $scope.flaglink = 3;
            $scope.searchtype1(type)
        }

        $scope.dtInstance = {};
        $scope.init();
    }

})();
(function () {
    'use strict';

    angular
        .module('app.PharmacyUserManual', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.PharmacyUserManual', {
                url: '/PharmacyUserManual',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/PharmacyUserManual/PharmacyUserManual.html',
                        controller: 'PharmacyUserManualController as vm'
                    }
                },
                bodyClass: 'PharmacyUserManual',
                ModuleName: 'PharmacyUserManual'
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.PharmacyUserManual')
        .controller('PharmacyUserManualController', PharmacyUserManualController);

    /** @ngInject */
    function PharmacyUserManualController($http, $scope, $mdDialog, $document, $mdToast, $cookieStore, DTOptionsBuilder, DTColumnDefBuilder, $rootScope, $timeout) {
        var vm = this;
        $scope.init = function () {
            $scope.model = {
                id: '',
                type: '',
                name: '',
                url: '',
                is_active: true,
            };
            $scope.btn = "Save";
            $scope.modelSearch = { Search: '' };
            $scope.GetAllUserManual();
            $scope.tab = {
                selectedIndex: 0
            };
            $scope.flag = false;
        }


        vm.dtInstance = {};
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [],
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#modelsearch');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            lengthMenu: [10, 20, 30, 50, 100],
            pageLength: 20,
            scrollY: 'auto',
            responsive: true
        };


        //get all team list
        $scope.GetAllUserManual = function () {
            $http.get($rootScope.RoutePath + "pharmacyusermanual/get_pharmacy_usermanual").then(function (data) {
                $scope.lstUsermanual = data.data.success;
            });
        }
        //delete team by id 
        $scope.DeleteManual = function (_id, ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to delete this Manual?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                $http.get($rootScope.RoutePath + "pharmacyusermanual/delete_pharmacy_manual?id=" + _id).then(function (data) {
                    if (data.data.success) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                        $scope.init();
                    } else {
                        if (data.data.data == 'TOKEN') {
                            //$cookieStore.remove('UserName');
                            //$cookieStore.remove('token');
                            //window.location.href = '/app/login';
                            $rootScope.logout();
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(data.data.message)
                                    .position('top right')
                                    .hideDelay(3000)
                            );
                        }
                    }
                });
            }, function () { });

        }
        $scope.CreateManual = function (form, o) {
            // ShowLoader();
            var formData = new FormData();
            if ($scope.MediafilesPDF.length == 0 && o.id == 0) {
                alert("Please Upload the PDF file.")
                return false;
            }
            formData.append("id", o.id)
            formData.append("type", o.type)
            formData.append("name", o.name)
            formData.append("created_date", o.created_date)
            formData.append("created_by", o.created_by)
            if ($scope.MediafilesPDF.length > 0) {

                if ($scope.MediafilesPDF.length > 0) {
                    angular.forEach($scope.MediafilesPDF, function (obj) {
                        var AI = 'PDFname';
                        formData.append(AI, obj.lfFile);
                        formData.append("isFile", true);
                    });
                }
            } else {
                formData.append("isFile", false);
            }
            $http.post($rootScope.RoutePath + 'pharmacyusermanual/uploadPDF', formData, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            }).then(function (data) {
                if (data.data.success) {
                    // HideLoader();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    );
                    $scope.ResetData();
                    $scope.init();
                } else {
                    // HideLoader();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    )
                }

            })

        }

        $scope.UpdatePDF = function (o) {
            // console.log(o)
            $scope.model.id = o._id;
            $scope.model.type = o.type;
            $scope.model.name = o.name;
            $scope.flag = true;
            $scope.url = o.url
            if ($scope.url != '') {
                $scope.FlgImage = true;
            } else {
                $scope.FlgImage = false;
            }

            $scope.btn = "Update";
        }


        $scope.UpdateIsActive = function (_id, flg) {
            var params = {
                id: _id,
                is_active: flg,
            };

            $http.get($rootScope.RoutePath + 'pharmacyusermanual/UpdateAccount', { params: params })
                .then(function (data) {
                    if (data.data.success == true) {
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .textContent(data.data.message)
                                .position("top right")
                                .hideDelay(3000)
                        );
                        $scope.ResetData();
                        $scope.init();
                    } else {
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .textContent(data.data.message)
                                .position("top right")
                                .hideDelay(3000)
                        );
                    }
                });
        };
        $scope.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0),
            DTColumnDefBuilder.newColumnDef(1),
            DTColumnDefBuilder.newColumnDef(2).notSortable(),
            DTColumnDefBuilder.newColumnDef(3).notSortable(),

        ];
        $scope.RemoveImage = function () {

            $scope.PDFFileName = "";
            $scope.model.url = null;
            $scope.FlgImage = false;
            $scope.MediafilesPDF = [];
        }
        $scope.ResetTab = function () {
            if ($rootScope.FlgAddedAccess != true) {
                $scope.FlgAddedEditlocal = false;
            }
        }


        $scope.ResetEdit = function () {
            $scope.FlgAddedEditlocal = false;
            // if ($scope.FlgModifiedAccess == true)
            $scope.FlgAddedEditlocal = true;
            $scope.RestForm();
            $scope.init();
            $scope.apiMediaPDF.removeAll();
            $scope.PDFFileName = "";
            $scope.FlgImage = false;
            $scope.MediafilesPDF = [];
            $scope.flag = true;
        }
        $scope.RestForm = function () {
            // $scope.form.$setPristine();
            // $scope.form.$setUntouched();
        }
        //cancel btn

        $scope.ResetData = function () {
            $scope.model = {
                id: '',
                type: '',
                name: '',
                url: '',
                is_active: true,
            };
            $scope.RestForm();
            $scope.apiMediaPDF.removeAll();
            $scope.PDFFileName = "";
            $scope.FlgImage = false;
            $scope.MediafilesPDF = [];
            $scope.btn = "Save"
        }

        $scope.Cancel = function () {
            // $scope.FlgAddedEditlocal = true;
            $scope.RestForm();
            $scope.init();
            $scope.apiMediaPDF.removeAll();
            $scope.PDFFileName = "";
            $scope.FlgImage = false;
            $scope.MediafilesPDF = [];

        }
        $rootScope.convertdatetimeformat = function (date1) {
            var date = new Date(date1);
            var firstdayDay = date.getDate();
            var firstdayMonth = date.getMonth() + 1;
            var firstdayYear = date.getFullYear();
            var hour = date.getHours();
            var minute = date.getMinutes();
            var sec = date.getSeconds();
            return ("00" + firstdayMonth.toString()).slice(-2) + "-" + ("00" + firstdayDay.toString()).slice(-2) + "-" + ("0000" + firstdayYear.toString()).slice(-4) + " " + ("00" + hour.toString()).slice(-2) + ":" + ("00" + minute.toString()).slice(-2) + ":" + ("00" + sec.toString()).slice(-2);
        }
        //back btn
        $scope.gotoOrderList = function () {
            $scope.init();
        }

        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
            $scope.init();
        })


    }
})();
(function () {
    'use strict';

    angular
        .module('app.PharmacyTraining', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.PharmacyTraining', {
                url: '/PharmacyTraining',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/PharmacyTraining/PharmacyTraining.html',
                        controller: 'PharmacyTrainingController as vm'
                    }
                },
                bodyClass: 'PharmacyTraining',
                ModuleName: 'PharmacyTraining'
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.PharmacyTraining')
        .controller('PharmacyTrainingController', PharmacyTrainingController);

    /** @ngInject */
    function PharmacyTrainingController($http, $scope, $mdDialog, $document, $mdToast, $cookieStore, DTOptionsBuilder, DTColumnDefBuilder, $rootScope, $timeout) {
        var vm = this;
        $scope.init = function () {
            $scope.initModel();
            $scope.btn = "Save";
            $scope.modelSearch = { Search: '' };
            $scope.GetAllTraining();
            $scope.flag = false;
        }

        $scope.initModel = function () {
            $scope.model = {
                _id: null,
                type: null,
                name: null,
                video_url: null,
                is_active: false,
            };
        }

        vm.dtInstance = {};
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [],
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#modelsearch');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            lengthMenu: [10, 20, 30, 50, 100],
            pageLength: 20,
            scrollY: 'auto',
            responsive: true,
            aaSorting: [0, 'asc']
        };


        //get all team list
        $scope.GetAllTraining = function () {
            $http.get($rootScope.RoutePath + "pharmacytraining/get_pharmacy_training").then(function (data) {
                $scope.lstTraining = data.data.success;
            });
        }

        //delete team by id 
        $scope.DeleteTraining = function (_id, ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to delete this Training?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                $http.get($rootScope.RoutePath + "pharmacytraining/delete_pharmacy_training?id=" + _id).then(function (data) {
                    if (data.data.success) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                        $scope.init();
                    } else {
                        if (data.data.data == 'TOKEN') {
                            //$cookieStore.remove('UserName');
                            //$cookieStore.remove('token');
                            //window.location.href = '/app/login';
                            $rootScope.logout();
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(data.data.message)
                                    .position('top right')
                                    .hideDelay(3000)
                            );
                        }
                    }
                });
            }, function () { });

        }
        $scope.CreateVideOld = function (form, o) {
            // ShowLoader();
            var formData = new FormData();
            if ($scope.MediafilesVideo.length == 0 && o.id == 0) {
                alert("Please Upload the video file.")
                return false;
            }
            formData.append("id", o.id)
            formData.append("type", o.type)
            formData.append("name", o.name)
            formData.append("created_date", o.created_date)
            formData.append("created_by", o.created_by)
            if ($scope.MediafilesVideo.length > 0) {

                if ($scope.MediafilesVideo.length > 0) {
                    angular.forEach($scope.MediafilesVideo, function (obj) {
                        var AI = 'Videoname';
                        formData.append(AI, obj.lfFile);
                        formData.append("isFile", true);
                    });
                }
            } else {
                formData.append("isFile", false);
            }
            $http.post($rootScope.RoutePath + 'pharmacytraining/uploadVideo', formData, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            }).then(function (data) {
                if (data.data.success) {
                    // HideLoader();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    );
                    $scope.ResetData();
                    $scope.init();
                } else {
                    // HideLoader();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    )
                }

            })

        }
        $scope.CreateVideo = function () {
            $http.post($rootScope.RoutePath + 'pharmacytraining/saveTraining', $scope.model).then(function (data) {
                if (data.data.success) {
                    // HideLoader();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    );
                    $scope.ResetData();
                    $scope.init();
                } else {
                    // HideLoader();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    )
                }

            })
        }

        $scope.UpdateVideo = function (o) {
            // $scope.model.id = o._id;
            // $scope.model.name = o.name;
            // $scope.flag = true;
            // $scope.VideoFileName = o.video
            // if ($scope.VideoFileName != '') {
            //     $scope.FlgImage = true;
            // } else {
            //     $scope.FlgImage = false;
            // }
            $scope.model._id = o._id;
            $scope.model.name = o.name;
            $scope.model.video_url = o.video_url;
            $scope.model.is_active = o.is_active;
            $scope.model.type = o.type;
            $scope.flag = true;
            $scope.btn = "Update";
        }


        $scope.UpdateIsActive = function (_id, is_active) {
            var params = {
                id: _id,
                is_active: is_active,
            };
            $http.get($rootScope.RoutePath + 'pharmacytraining/UpdateAccount', { params: params })
                .then(function (data) {
                    if (data.data.success == true) {
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .textContent(data.data.message)
                                .position("top right")
                                .hideDelay(3000)
                        );
                        $scope.Cancel();
                        $scope.GetAllTraining();
                    } else {
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .textContent(data.data.message)
                                .position("top right")
                                .hideDelay(3000)
                        );
                    }
                });
        };
        $scope.RemoveImage = function () {

            $scope.VideoFileName = "";
            $scope.FlgImage = false;
            $scope.MediafilesVideo = [];
        }

        $scope.ResetTab = function () {
            if ($rootScope.FlgAddedAccess != true) {
                $scope.FlgAddedEditlocal = false;
            }
        }

        $scope.ResetEdit = function () {
            // $scope.FlgAddedEditlocal = true;
            // $scope.RestForm();
            // $scope.init();
            // $scope.apiMediaVideo.removeAll();
            // $scope.VideoFileName = "";
            // $scope.FlgImage = false;
            // $scope.MediafilesVideo = [];
            $scope.initModel();
            $scope.RestForm();
            $scope.flag = true;
        }

        $scope.RestForm = function () {
            $scope.formPharmacyTraining.$setPristine();
            $scope.formPharmacyTraining.$setUntouched();
        }

        $scope.ResetData = function () {
            // $scope.model = {
            //     id: '',
            //     name: '',
            //     video: '',
            //     IsActive: true,
            //     created_by: '',
            //     created_date: $rootScope.convertdatetimeformat(new Date()),
            // };
            // $scope.RestForm();
            // $scope.apiMediaVideo.removeAll();
            // $scope.VideoFileName = "";
            // $scope.FlgImage = false;
            // $scope.MediafilesVideo = [];
            // $scope.btn = "Save"

            $scope.initModel();
            $scope.RestForm();
        }

        //cancel btn
        $scope.Cancel = function () {
            // $scope.FlgAddedEditlocal = true;
            // $scope.RestForm();
            // $scope.init();
            // $scope.apiMediaVideo.removeAll();
            // $scope.VideoFileName = "";
            // $scope.FlgImage = false;
            // $scope.MediafilesVideo = [];
            $scope.flag = false;
            $scope.initModel();
            $scope.RestForm();

        }
        $rootScope.convertdatetimeformat = function (date1) {
            var date = new Date(date1);
            var firstdayDay = date.getDate();
            var firstdayMonth = date.getMonth() + 1;
            var firstdayYear = date.getFullYear();
            var hour = date.getHours();
            var minute = date.getMinutes();
            var sec = date.getSeconds();
            return ("00" + firstdayMonth.toString()).slice(-2) + "-" + ("00" + firstdayDay.toString()).slice(-2) + "-" + ("0000" + firstdayYear.toString()).slice(-4) + " " + ("00" + hour.toString()).slice(-2) + ":" + ("00" + minute.toString()).slice(-2) + ":" + ("00" + sec.toString()).slice(-2);
        }
        //back btn
        $scope.gotoOrderList = function () {
            $scope.init();
        }

        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
            $scope.init();
        })


    }
})();
(function() {
    'use strict';

    angular
        .module('app.Pharmacy')
        .controller('PharmacyController', PharmacyController);

    /** @ngInject */
    function PharmacyController($http, $scope, $rootScope, $cookieStore, $mdToast, $mdDialog, DTOptionsBuilder, DTColumnBuilder, $compile) {
        var vm = this;
        vm.Reset = function() {
            $scope.reloadTableData();
        }

        $scope.init = function() {
            $scope.modelData = {
                _id: null,
                billing_period_days: null,
                payment_period_days: null,
                token: null,
            }
            $scope.initModel();
        }

        $scope.initModel = function() {
            $scope.modelSearch = {
                search: '',
                zip_code: '',
                verified: '',
                Approved: '',
            }
            $scope.selected = [];
        }

        $rootScope.role_id = $cookieStore.get('role_id');

        //Dynamic Pagging
        // $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
        $scope.FilterStatus = 1;
        $scope.dtColumns = [
            DTColumnBuilder.newColumn('signup_at').renderWith(NumberHtml).notSortable().withOption('width', '4%').withOption('class', 'text-center'),
            // DTColumnBuilder.newColumn(null).notSortable().renderWith(ImageHtml).withOption('width', '4%'),
            DTColumnBuilder.newColumn('pharmacy_name'),
            DTColumnBuilder.newColumn('first_name').renderWith(NameHtml).withOption('width', '12%'),
            DTColumnBuilder.newColumn('email'),
            DTColumnBuilder.newColumn('mobile_number'),
            DTColumnBuilder.newColumn('address').renderWith(AddressHtml),
            DTColumnBuilder.newColumn('zip_code'),
            DTColumnBuilder.newColumn('signup_at').renderWith(dateFormat),
            DTColumnBuilder.newColumn('last_invoice_date').renderWith(dateHtml),
            DTColumnBuilder.newColumn('billing_period_days').withOption('class', 'text-center'),
            DTColumnBuilder.newColumn('payment_period_days').withOption('class', 'text-center'),
            DTColumnBuilder.newColumn('verified').renderWith(isverifiedHtml),
            DTColumnBuilder.newColumn('Approved').renderWith(IsActiveHtml),
            DTColumnBuilder.newColumn(null).notSortable().renderWith(ActionHtml).withOption('width', '5%').withOption('class', 'text-center')
        ]
        $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                url: $rootScope.RoutePath + "pharmacy/getAllDynamicPharmacy",
                data: function(d) {
                    d.search = $scope.modelSearch.search;
                    d.zip_code = $scope.modelSearch.zip_code;
                    d.verified = $scope.modelSearch.verified;
                    d.Approved = $scope.modelSearch.Approved;
                    return d;
                },
                type: "get",
                dataSrc: function(json) {
                    if (json.success != false) {
                        $scope.lstdata = json.data;
                        return json.data;
                    } else {
                        return [];
                    }
                },
            })
            .withOption('processing', true) //for show progress bar
            .withOption('serverSide', true) // for server side processing
            .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
            .withDisplayLength(25) // Page size
            .withOption('aaSorting', [0, 'desc'])
            .withOption('responsive', true)
            .withOption('createdRow', createdRow)
            .withOption('autoWidth', true)
            .withOption('initComplete', function() {
                $scope.AdjustColumn();
            })
            // .withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
            .withOption('scrollY', 'auto');
        // });



        vm.dtInstance = {};
        vm.dtInstance1 = {};
        $scope.dtInstance = {};
        $(window).resize(function() {
            $scope.AdjustColumn();
        });

        $scope.AdjustColumn = function() {
                vm.dtInstance.DataTable.columns.adjust();
            }
            //Reload Datatable
        $scope.reloadTableData = function(IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            vm.dtInstance.reloadData(callback, resetPaging);
            $('#pharmacyTable').dataTable()._fnPageChange(0);
            $('#pharmacyTable').dataTable()._fnAjaxUpdate();
        }

        $scope.reloadData = function() {}

        function callback(json) {}

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }

        function dateFormat(data, type, full, meta) {
            if (data != null && data != '') {
                return moment(data).format('MM-DD-YYYY hh:mm:ss a')
            } else {
                return "";
            }
        }

        function dateHtml(data, type, full, meta) {
            if (data != null && data != '') {
                var btns = '';
                btns += '<span><b> Last Invoice Date : </b>' + moment(full.last_invoice_date).format('MM-DD-YYYY hh:mm:ss a') + '</span><br>';
                btns += '<span><b> First Invoice Date : </b>' + moment(full.next_invoice_date).format('MM-DD-YYYY hh:mm:ss a') + '  </span><br>';
                return btns;
            } else {
                return "-";
            }
        }

        function IsActiveHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';

            if (full.Approved == 1) {
                var method = "approvePharmacyByAdmin('" + full._id + "',0)";
                btns += '<md-button style="font-size: 20px;color: green" ng-click="' + method + '"> &#x2714;' +
                    '<md-tooltip md-visible="" md-direction="">DeActive</md-tooltip>' +
                    '</md-button>';
            } else {
                var method = "approvePharmacyByAdmin('" + full._id + "',1)";
                btns += '<md-button  style="font-size: 20px;color: red" ng-click="' + method + '">&#x2716;' +
                    '<md-tooltip md-visible="" md-direction="">Active</md-tooltip>' +
                    '</md-button>';

            }
            btns += '<div>';
            return btns;
        };


        function isverifiedHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if (data == 1) {
                btns += '<span style="font-size: 20px;color: green;"> &#x2714; </span>'
            } else {
                btns += '<span style="font-size: 20px;color: red;">&#x2716;</span>';
            }
            btns += '<div>';
            return btns;
        };

        function NameHtml(data, type, full, meta) {

            var data = full.last_name + " " + full.first_name + " " + full.middle_name;
            return data;
        };

        function AddressHtml(data, type, full, meta) {
            var btns = '';
            if (full.address) {
                btns += full.address;
            }
            if (full.city) {
                btns += "," + full.city;
            }
            if (full.state) {
                btns += "," + full.state;
            }

            return btns;
        }

        function ActionHtml(data, type, full, meta) {
            // // var model = 'selected[' + full._id + '].isChecked';
            // var datavalue = '';
            // // datavalue = '<div layout="row" layout-align="center"><md-checkbox aria-label="assign"  ng-model="' + model + '"></md-checkbox></div>';
            // return datavalue;

            // var btns = '<div layout="row" layout-align="center">'; 
            var btns = '<div layout="row" layout-align="center" class="res-btn">';
            var method = "EditDays('" + full._id + "','" + full.billing_period_days + "','" + full.payment_period_days + "')";
            btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                '<md-icon md-font-icon="icon-calendar"  class="s22 orange-500-fg"></md-icon>' +
                '<md-tooltip md-visible="" md-direction="">Update Billing and Payment Days</md-tooltip>' +
                '</md-button>';


            var method1 = "callToPharmacy('" + full._id + "')";
            btns += '<md-button class="edit-button md-icon-button" ng-click="' + method1 + '">' +
                '<md-icon md-font-icon="icon-cast" class="s20 brown-500-fg"></md-icon>' +
                '<md-tooltip md-visible="" md-direction="">Support</md-tooltip>' +
                '</md-button>';

            btns += '<div>';
            return btns;
        }

        $scope.EditDays = function(id, data, data1) {
            // console.log(id, data, data1)
            $mdDialog.show({
                controller: 'pharmacyEditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Pharmacy/dialogs/pharmacyEdit/pharmacyEdit.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    _id: id,
                    billing_period_days: parseInt(data),
                    payment_period_days: parseInt(data1),
                    token: $cookieStore.get('token'),
                }
            })

        }

        $scope.callToPharmacy = function(pharmacyId) {
            // console.log("pharmacy  ===== ", pharmacyId);
            window.open($rootScope.VideoCallPath + "audio-call-admin/" + $rootScope.role_id + "/" + pharmacyId, '_blank');
        }

        $scope.ResetModel = function() {
            $scope.init();

            $scope.restForm();
        }

        $scope.restForm = function() {
            $scope.AddStatusForm.$setUntouched();
            $scope.AddStatusForm.$setPristine();
        }

        $scope.approvePharmacyByAdmin = function(id, Approved) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to approve this pharmacy?')
                .textContent('')
                .ariaLabel('Lucky day')
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function() {
                var obj = {
                    _id: id,
                    Approved: Approved
                }
                $http.post($rootScope.RoutePath + "pharmacy/approvePharmacyByAdmin", obj).then(function(data) {

                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                    if (data.data.success) {
                        $scope.reloadTableData(true)
                    }
                });
            })
        }

        $scope.toggle = function() {
            if (!$scope.flgforIcon) {
                $scope.flgforIcon = true;
            } else {
                $scope.flgforIcon = false;
            }

            $(function() {
                $(".showBtn").toggleClass("active");
                $(".ShowContentBox").slideToggle();
            });
        };

        $scope.init();

        $scope.ShowAnnouncementModel = function(ev) {
            $mdDialog.show({
                controller: 'pharmacyAnnouncementController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Pharmacy/dialogs/pharmacyAnnouncement/pharmacyAnnouncement.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    // id: driver_id
                }
            })
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('app.Patient')
        .controller('PatientController', PatientController);

    /** @ngInject */
    function PatientController($http, $scope, $mdDialog, $document, $mdToast, $cookieStore, DTOptionsBuilder, DTColumnDefBuilder, $rootScope, $timeout, DTColumnBuilder, $compile) {
        var vm = this;

        $scope.modelSearch = {
            search: ''
        }
        $scope.init = function() {
                $scope.flag = false;
            }
            //Dynamic Pagging
        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function(response) {

            $scope.dtColumns = [
                DTColumnBuilder.newColumn('signup_at').renderWith(NumberHtml).notSortable().withOption('width', '4%').withOption('class', 'text-center'),
                DTColumnBuilder.newColumn('first_name').renderWith(NameHtml),
                DTColumnBuilder.newColumn('signup_at').renderWith(dateFormat).withOption('class', 'text-center'),
                DTColumnBuilder.newColumn('prefferedpharmacy').renderWith(prefferedpharmacyHtml),
                DTColumnBuilder.newColumn('primaryCarePhysician').renderWith(columnNameHtml),
                DTColumnBuilder.newColumn('profile_status').renderWith(statusHtml),
                DTColumnBuilder.newColumn(null).notSortable().renderWith(actionsHtml).withOption('width', '5%').withOption('class', 'text-center')
            ]
            $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                    url: $rootScope.RoutePath + "patient/getAllpatient",
                    data: function(d) {
                        d.search = $scope.modelSearch.search;

                        return d;
                    },
                    type: "get",
                    dataSrc: function(json) {
                        if (json.success != false) {
                            $scope.lstdata = json.data;
                            // console.log($scope.lstdata)
                            return json.data;
                        } else {
                            return [];
                        }
                    },
                })
                .withOption('processing', true) //for show progress bar
                .withOption('serverSide', true) // for server side processing
                .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                .withDisplayLength(10) // Page size
                .withOption('aaSorting', [2, 'desc'])
                .withOption('responsive', true)
                .withOption('autoWidth', true)
                .withOption('initComplete', function() {})
                .withOption('createdRow', createdRow)
                .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
                .withOption('scrollY', 'auto');
        });



        vm.dtInstance = {};

        //Reload Datatable
        $scope.reloadTableData = function(IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            vm.dtInstance.reloadData(callback, resetPaging);
            $('#PatientTable').dataTable()._fnPageChange(0);
            $('#PatientTable').dataTable()._fnAjaxUpdate();
        }

        $scope.reloadData = function() {}

        function callback(json) {}

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }

        function dateFormat(data, type, full, meta) {
            if (data != null && data != '') {
                return moment(data).format('MM-DD-YYYY')
            } else {
                return "N/A";
            }

        }

        function statusHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';

            if (full.profile_status == 1) {
                btns += ' <span style="font-size: 20px;color: green">  &#x2714;</span>';
            } else {
                btns += ' <span style="font-size: 20px;color: red">&#x2716;</span>';
            }
            btns += '<div>';
            return btns;
        }

        function actionsHtml(data, type, full, meta) {
            var data = full.first_name + " " + full.middle_name + " " + full.last_name;
            var btns = '<div layout="row" layout-align="center">';
            var method = "OrderDetails('" + full._id + "'" + ',' + "'" + data + "')";
            btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                '<md-icon md-font-icon="icon-receipt"  class="orange-500-fg"></md-icon>' +
                '<md-tooltip md-visible="" md-direction="">Order Details</md-tooltip>' +
                '</md-button>';
            btns += '<div>';

            var method = "PrefferedPharmacy('" + full._id + "')";
            btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                '<md-icon md-font-icon="icon-note"  class="orange-500-fg"></md-icon>' +
                '<md-tooltip md-visible="" md-direction="">Preffered Pharmacy Detail</md-tooltip>' +
                '</md-button>';
            btns += '<div>';

            return btns;
        };

        function prefferedpharmacyHtml(data, type, full, meta) {
            var btns = '';
            if (full.prefferedpharmacy) {
                if (full.prefferedpharmacy.pharmacy_name != null) {
                    btns += '<span><b>  Name : </b>' + full.prefferedpharmacy.pharmacy_name + '</span> <br>';
                }
                if (full.prefferedpharmacy.pharmacy_address != null && full.prefferedpharmacy.pharmacy_address != undefined) {
                    btns += '<span><b> Address : </b>' + full.prefferedpharmacy.pharmacy_address + '</span><br>'
                }
                if (full.prefferedpharmacy.pharmacy_state != null && full.prefferedpharmacy.pharmacy_state != undefined) {
                    btns += '<span><b> State : </b>' + full.prefferedpharmacy.pharmacy_state + '  </span><br>';
                }
                if (full.prefferedpharmacy.pharmacy_city != null && full.prefferedpharmacy.pharmacy_city != undefined) {
                    btns += '<span><b> City : </b>' + full.prefferedpharmacy.pharmacy_city + '  </span><br>';
                }
                if (full.prefferedpharmacy.pharmacy_zip_code != null && full.prefferedpharmacy.pharmacy_zip_code != undefined) {
                    btns += '<span><b> Zip Code : </b>' + full.prefferedpharmacy.pharmacy_zip_code + '  </span><br>';
                }
                if (full.prefferedpharmacy.pharmacy_mobilenumber != null && full.prefferedpharmacy.pharmacy_mobilenumber != undefined) {
                    btns += '<span><b>  Mobile Number : </b>' + full.prefferedpharmacy.pharmacy_mobilenumber + '  </span><br>';
                }

                if ((full.prefferedpharmacy.pharmacy_name == null) && (full.prefferedpharmacy.pharmacy_address == null && full.prefferedpharmacy.pharmacy_address == undefined) && (full.prefferedpharmacy.pharmacy_mobilenumber == null && full.prefferedpharmacy.pharmacy_mobilenumber == undefined) && (full.prefferedpharmacy.pharmacy_state == null && full.prefferedpharmacy.pharmacy_state == undefined) && (full.prefferedpharmacy.pharmacy_city == null && full.prefferedpharmacy.pharmacy_city == undefined) && (full.prefferedpharmacy.pharmacy_zip_code == null && full.prefferedpharmacy.pharmacy_zip_code == undefined)) {
                    return 'N/A';
                }
            }

            return btns;
        }

        function NameHtml(data, type, full, meta) {
            var btns = '';
            if (full.first_name != null || full.middle_name != null || full.last_name != null) {
                btns += '<span><b>  Name : </b>' + full.first_name + '</span> <span>' + full.middle_name + '</span> <span>' + full.last_name + '<br>';
            }
            if(full.address.length > 0 && (full.address[0].address1 != null || full.address[0].address2 != null)) {
                btns += '<span><b>  Address : </b>'+ full.address[0].address1 +'</span> <span>' + full.address[0].address2 + ", " +  full.address[0].city + ", " + full.address[0].state + ", " + full.address[0].zip_code + '</span> <br>' ;         
              }
            if (full.email != null && full.email != undefined) {
                btns += '<span><b>  E-mail : </b>' + full.email + '</span> <br>';
            }
            if (full.dob != null && full.dob != undefined) {
                btns += '<span><b>  DOB : </b>' + full.dob + '  </span><br>';
            }
            if (full.gender != null && full.gender != undefined) {
                btns += '<span><b>  Gender : </b>' + full.gender + '  </span><br>';
            }
            if (full.mobile_number != null && full.mobile_number != undefined) {
                btns += '<span><b> Phone Number : </b>' + full.mobile_number + '  </span><br>';
            }
            if (full.zip_code != null && full.zip_code != undefined) {
                btns += '<span><b> Zip Code : </b>' + full.zip_code + '  </span><br>';
            }
            if (full.authorization != null && full.authorization != undefined) {
                if(full.authorization.addr1 != null){
                btns += '<span><b> Authorized Address : </b>' + full.authorization.addr1 + ", "  + ", " +  full.authorization.city  +  ", " +  full.authorization.state +  ", " + full.authorization.zip  + '  </span><br>';
            }else {
                btns += '<span><b> Authorized Address : </b> N/A  </span><br>';
            }
        }
            if ((full.first_name == null && full.middle_name == null && full.last_name == null) && (email == null && email == undefined) && (full.dob == null && full.dob == undefined) && (full.mobile_number == null && full.mobile_number == undefined) && (full.gender == null && full.gender == undefined) && (full.zip_code == null && full.zip_code == undefined)) {
                return 'N/A';
            }

            return btns;
        };

        function columnNameHtml(data, type, full, meta) {
            if (data) {
                return data;
            } else {
                return 'N/A';
            }
        }


        $scope.OrderDetails = function(id, data) {
            if (id != null && id != undefined && id != '') {
                $scope.patient_name = data;
                $scope.id = id;
                $scope.flag = true;
            }
            $scope.selectedTab();
        }

        $scope.PrefferedPharmacy = function(id) {
            $mdDialog.show({
                controller: 'PreferedPharmacyDetailInformationController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Patient/dialogs/PreferedPharmacyDetailInformation/PreferedPharmacyDetailInformation.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    data: id,
                }
            })
        }

        $scope.orderDetailRecord = function(id, value) {
            //Dynamic Pagging
            if ($scope.flag && value == 1) {
                $scope.dtColumns1 = [
                    DTColumnBuilder.newColumn('signup_at').renderWith(NumberHtml).notSortable().withOption('width', '4%').withOption('class', 'text-center'),
                    DTColumnBuilder.newColumn('order_id').renderWith(oneTimecolumnNameHtml).withOption('width', '12%'),
                    DTColumnBuilder.newColumn('patient_firstname').renderWith(patientDetailHtml).withOption('width', '13%'),
                    DTColumnBuilder.newColumn('pharmacy_name').renderWith(pharmacyDetailHtml),
                    DTColumnBuilder.newColumn('driver_name').renderWith(driverHtml),
                    DTColumnBuilder.newColumn('delivery_date').renderWith(DeliverdDateHtml),
                    DTColumnBuilder.newColumn('order_status').renderWith(StatusHtml),
                    DTColumnBuilder.newColumn(null).notSortable().renderWith(oneTimeactionsHtml).withOption('width', '5%').withOption('class', 'text-center')
                ]
                $scope.dtOptions1 = DTOptionsBuilder.newOptions().withOption('ajax', {
                        url: $rootScope.RoutePath + "patient/getPatientOneTimeOrdersById?patientId=" + id,
                        data: function(d) {
                            d.search = $scope.modelSearch.search;

                            return d;
                        },
                        type: "get",
                        dataSrc: function(json) {
                            if (json.success != false) {
                                $scope.lstOneTime = json.data;
                                return json.data;
                            } else {
                                return [];
                            }
                        },
                    })
                    .withOption('processing', true) //for show progress bar
                    .withOption('serverSide', true) // for server side processing
                    .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                    .withDisplayLength(10) // Page size
                    .withOption('aaSorting', [5, 'desc'])
                    .withOption('responsive', true)
                    .withOption('autoWidth', true)
                    .withOption('initComplete', function() {
                        // $scope.AdjustColumn();
                    })
                    .withOption('createdRow', createdRow)
                    .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
                    .withOption('scrollY', 'auto');



                vm.dtInstance1 = {};
                // $(window).resize(function() {
                // $scope.AdjustColumn();
                // });
                // $scope.AdjustColumn = function() {
                //     vm.dtInstance.DataTable.columns.adjust();
                // }

                //Reload Datatable
                $scope.reloadOneTimeTableData = function(IsUpdate) {
                    var resetPaging = false;
                    if (IsUpdate == true) {
                        resetPaging = true;
                    };
                    vm.dtInstance1.reloadData(callback, resetPaging);
                    $('#OneTimeTable').dataTable()._fnPageChange(0);
                    $('#OneTimeTable').dataTable()._fnAjaxUpdate();
                }

                $scope.reloadData = function() {}

                function callback(json) {}

                //compile Datatable And Apply Class
                function createdRow(row, data, dataIndex) {
                    // Recompiling so we can bind Angular directive to the DT
                    $compile(angular.element(row).contents())($scope);
                }

                function NumberHtml(data, type, full, meta) {
                    return (meta.row + 1);
                }

                function DeliverdDateHtml(data, type, full, meta) {
                    if (data != null && data != '') {
                        return moment(data).format('MM-DD-YYYY')
                    } else {
                        return "N/A";
                    }

                }

                function dateFormat(data, type, full, meta) {
                    if (data != null && data != '') {
                        return moment(data).format('MM-DD-YYYY')
                    } else {
                        return "N/A";
                    }

                }

                function patientDetailHtml(data, type, full, meta) {
                    var btns = '';
                    if (full.patients[0].first_name != null || full.patients[0].patient_lastname != null || full.patients[0].middle_name != null) {
                        btns += '<span><b>  Name : </b>' + full.patients[0].first_name + '</span> <span>' + full.patients[0].middle_name + '</span> <span>' + full.patients[0].last_name + '<br>';
                    }

                    if ((full.patient_address1 != null && full.patient_address1 != undefined) || (full.patient_state != null && full.patient_state != undefined) || (full.patient_zip_code != null && full.patient_zip_code != undefined)) {
                        btns += '<span><b>  Address : </b>' + full.patient_address1 + '</span> ,<span>' + full.patient_state + '</span> , <span>' + full.patient_zip_code + ' </span><br>';
                    }
                    if (full.patient_dob != null && full.patient_dob != undefined) {
                        btns += '<span><b>  DOB : </b>' + full.patient_dob + '  </span><br>';
                    }
                    if (full.patient_phone_number != null && full.patient_phone_number != undefined) {
                        btns += '<span><b> Phone Number : </b>' + full.patient_phone_number + '  </span><br>';
                    }
                    if ((full.patients[0].first_name == null && full.patients[0].patient_lastname == null && full.patients[0].middle_name == null)) {
                        return 'N/A';
                    }

                    return btns;
                }

                function pharmacyDetailHtml(data, type, full, meta) {
                    var btns = '';

                    if (full.pharmacy_name != null && full.pharmacy_name != undefined) {
                        btns += '<span><b>Pharmacy Name : </b>' + full.pharmacy_name + '</span><br>';
                    }
                    // if (full.pharmacy_charge != null && full.pharmacy_charge != undefined) {
                    //     btns += '<span><b> Charge ($): </b>' + full.pharmacy_charge + '  </span><br>';
                    // }
                    if (full.pharmacy_latitude != null && full.pharmacy_latitude != undefined) {
                        btns += '<span><b> Latitude : </b>' + full.pharmacy_latitude + '</span><br>';
                    }
                    if (full.pharmacy_longitude != null && full.pharmacy_longitude != undefined) {
                        btns += '<span><b> Logitude : </b>' + full.pharmacy_longitude + '</span><br>';
                    }
                    if (full.pharmacy_address != null && full.pharmacy_address != undefined) {
                        btns += '<span><b> Address : </b>' + full.pharmacy_address + '  </span><br>';
                    }
                    if (full.pharmacy_payment_status != null && full.pharmacy_payment_status != undefined) {
                        btns += '<span><b> Payment Status : </b>' + full.pharmacy_payment_status + '  </span><br>';
                    }
                    if ((full.pharmacy_name == null && full.pharmacy_name == undefined) && (full.pharmacy_charge == null && full.pharmacy_charge == undefined) &&
                        (full.pharmacy_latitude == null && full.pharmacy_latitude == undefined) && (full.pharmacy_longitude == null && full.pharmacy_longitude == undefined) &&
                        (full.pharmacy_address == null && full.pharmacy_address == undefined) && (full.pharmacy_payment_status == null && full.pharmacy_payment_status == undefined)) {
                        return 'N/A';
                    }
                    return btns;
                }

                function StatusHtml(data, type, full, meta) {
                    if (full.order_status != null && full.order_status != undefined && full.order_status != '') {
                        var btns = '<div layout="row" layout-align="center">';
                        if (full.order_status == -2) {
                            btns += '<span style="font-size: 15px;background-color:  #ff9790;color:white;padding:5px;" >Co-pay Verification</span>';
                        } else if (full.order_status == -1) {
                            btns += '<span style="font-size: 15px;background-color:  #ceb5f9;color:white;padding:5px;">Co-pay Approval</span>';
                        } else if (full.order_status == 1) {
                            btns += '<span style="font-size: 15px;background-color:#00bde3;color:white;padding:5px;">New</span>';
                        } else if (full.order_status == 2) {
                            btns += '<span style="font-size: 15px;background-color:#ff9790;color:white;padding:5px;">OnHold</span>';
                        } else if (full.order_status == 3) {
                            btns += '<span style="font-size: 15px;background-color: orange;color:white;padding:5px;">Ready to Pick</span>';
                        } else if (full.order_status == 4) {
                            btns += '<span style="font-size: 15px;background-color: green;color:white;padding:5px;">Driver Picked Up</span>';
                        } else if (full.order_status == 5) {
                            btns += '<span style="font-size: 15px;background-color: blue;color:white;padding:5px;">Completed</span>';
                        } else if (full.order_status == 6) {
                            btns += '<span style="font-size: 15px;background-color: red;color:white;padding:5px;">Canceled</span>';
                        } else if (full.order_status == 7) {
                            btns += '<span style="font-size: 15px;background-color:#abc343;color:white;padding:5px;">Co-pay Direct to Pharmacy</span>';
                        } else if (full.order_status == 8) {
                            btns += '<span style="font-size: 15px;background-color: lightgray;color:white;padding:5px;">Return Pending</span>';
                        } else if (full.order_status == 9) {
                            btns += '<span style="font-size: 15px;background-color:  #ceb5f9;color:white;padding:5px;">Return Completed</span>';
                        } else {
                            return 'N/A'
                        }
                        btns += '<div>';
                        return btns;

                    } else {
                        return 'N/A';
                    }
                }

                function driverHtml(data, type, full, meta) {
                    var btns = '';

                    if (full.driver_name != null && full.driver_name != undefined) {
                        btns += '<span><b>Driver Name : </b>' + full.driver_name + '</span><br>';
                    }
                    if (full.pharmacy_charge != null && full.pharmacy_charge != undefined) {
                        btns += '<span><b> Charge ($): </b>' + full.pharmacy_charge + '  </span><br>';
                    }
                    if (full.driver_status != null && full.driver_status != undefined) {
                        btns += '<span><b> Driver Status : </b>' + full.driver_status + '</span><br>';
                    }
                    if (full.driver_earnings != null && full.driver_earnings != undefined) {
                        btns += '<span><b> Driver Earnings : </b>' + full.driver_earnings + '</span><br>';
                    }
                    if (full.delivery_type != null && full.delivery_type != undefined) {
                        btns += '<span><b> Delivery Type : </b>' + full.delivery_type + '  </span><br>';
                    }
                    if (full.distance != null && full.distance != undefined) {
                        btns += '<span><b> Distance : </b>' + full.distance + '  </span><br>';
                    }
                    if ((full.driver_name == null && full.driver_name == undefined) && (full.pharmacy_charge == null && full.pharmacy_charge == undefined) &&
                        (full.driver_status == null && full.driver_status == undefined) && (full.driver_earnings == null && full.driver_earnings == undefined) &&
                        (full.delivery_type == null && full.delivery_type == undefined) && (full.distance == null && full.distance == undefined)) {
                        return 'N/A';
                    }
                    return btns;
                }

                function oneTimeactionsHtml(data, type, full, meta) {
                    var btns = '<div layout="row" layout-align="center">';
                    // if (full.approval != 0) {
                    var method = "OneTimeOrderDetails('" + full._id + "')";
                    btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                        '<md-icon md-font-icon="icon-receipt"  class="orange-500-fg"></md-icon>' +
                        '<md-tooltip md-visible="" md-direction="">One-Time Order Details</md-tooltip>' +
                        '</md-button>';
                    // }
                    btns += '<div>';
                    return btns;
                };

                function NameHtml(data, type, full, meta) {
                    var data = full.first_name + " " + full.last_name + " " + full.middle_name;
                    return data;
                };

                function oneTimecolumnNameHtml(data, type, full, meta) {
                    if (data) {
                        return data;
                    } else {
                        return 'N/A';
                    }
                }
            }

            if ($scope.flag && value == 2) {
                $scope.dtColumns2 = [
                    DTColumnBuilder.newColumn('signup_at').renderWith(NumberHtml).notSortable().withOption('width', '4%').withOption('class', 'text-center'),
                    DTColumnBuilder.newColumn('order_id').renderWith(refillcolumnNameHtml).withOption('width', '12%'),
                    DTColumnBuilder.newColumn('patient_firstname').renderWith(patientDetailsHtml).withOption('width', '13%'),
                    DTColumnBuilder.newColumn('pharmacy_name').renderWith(pharmacyDetailsHtml),
                    DTColumnBuilder.newColumn('no_of_prescriptions').renderWith(refillcolumnNameHtml),
                    DTColumnBuilder.newColumn('recurring_count').renderWith(refillcolumnNameHtml),
                    DTColumnBuilder.newColumn('recurring_due').renderWith(durationHtml),
                    DTColumnBuilder.newColumn('recurring_times').renderWith(refillcolumnNameHtml),
                    DTColumnBuilder.newColumn('created_on').renderWith(dateFormat),
                    DTColumnBuilder.newColumn('next_recurring').renderWith(dateFormat),
                    DTColumnBuilder.newColumn('recurring_active').renderWith(refillOrderReccurringActive),
                    DTColumnBuilder.newColumn('recurring_done').renderWith(refillOrderReccurringDone),
                    DTColumnBuilder.newColumn(null).notSortable().renderWith(refillactionsHtml).withOption('width', '5%').withOption('class', 'text-center')
                ]

                $scope.dtOptions2 = DTOptionsBuilder.newOptions().withOption('ajax', {
                        url: $rootScope.RoutePath + "patient/getPatientRefillOrdersById?patientId=" + id,
                        data: function(d) {
                            d.search = $scope.modelSearch.search;

                            return d;
                        },
                        type: "get",
                        dataSrc: function(json) {
                            if (json.success != false) {
                                $scope.lstRefill = json.data;
                                return json.data;
                            } else {
                                return [];
                            }
                        },
                    })
                    .withOption('processing', true) //for show progress bar
                    .withOption('serverSide', true) // for server side processing
                    .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                    .withDisplayLength(10) // Page size
                    .withOption('aaSorting', [8, 'desc'])
                    .withOption('responsive', true)
                    .withOption('autoWidth', true)
                    .withOption('initComplete', function() {
                        // $scope.AdjustColumn();
                    })
                    .withOption('createdRow', createdRow)
                    .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
                    .withOption('scrollY', 'auto');



                // $(window).resize(function() {
                // $scope.AdjustColumn();
                // });
                // $scope.AdjustColumn = function() {
                //     vm.dtInstance.DataTable.columns.adjust();
                // }
                vm.dtInstance2 = {};
                //Reload Datatable
                $scope.reloadRefillTableData = function(IsUpdate) {
                    var resetPaging = false;
                    if (IsUpdate == true) {
                        resetPaging = true;
                    };
                    vm.dtInstance2.reloadData(callback, resetPaging);
                    $('#RefillOrderTable').dataTable()._fnPageChange(0);
                    $('#RefillOrderTable').dataTable()._fnAjaxUpdate();
                }

                $scope.reloadData = function() {}

                function callback(json) {}

                //compile Datatable And Apply Class
                function createdRow(row, data, dataIndex) {
                    // Recompiling so we can bind Angular directive to the DT
                    $compile(angular.element(row).contents())($scope);
                }

                function NumberHtml(data, type, full, meta) {
                    return (meta.row + 1);
                }

                function dateFormat(data, type, full, meta) {
                    if (data != null && data != '') {
                        return moment(data).format('MM-DD-YYYY')
                    } else {
                        return "N/A";
                    }
                }

                function patientDetailsHtml(data, type, full, meta) {
                    var btns = '';
                    if (full.patients[0].first_name != null || full.patients[0].patient_lastname != null || full.patients[0].middle_name != null) {
                        btns += '<span><b>  Name : </b>' + full.patients[0].first_name + '</span> <span>' + full.patients[0].middle_name + '</span> <span>' + full.patients[0].last_name + '<br>';
                    }

                    if ((full.patient_address1 != null && full.patient_address1 != undefined) || (full.patient_state != null && full.patient_state != undefined) || (full.patient_zip_code != null && full.patient_zip_code != undefined)) {
                        btns += '<span><b>  Address : </b>' + full.patient_address1 + '</span> ,<span>' + full.patient_state + '</span> , <span>' + full.patient_zip_code + ' </span><br>';
                    }
                    if (full.patient_dob != null && full.patient_dob != undefined) {
                        btns += '<span><b>  DOB : </b>' + full.patient_dob + '  </span><br>';
                    }
                    if (full.patient_phone_number != null && full.patient_phone_number != undefined) {
                        btns += '<span><b> Phone Number : </b>' + full.patient_phone_number + '  </span><br>';
                    }
                    if ((full.patients[0].first_name == null && full.patients[0].patient_lastname == null && full.patients[0].middle_name == null)) {
                        return 'N/A';
                    }

                    return btns;
                }

                function pharmacyDetailsHtml(data, type, full, meta) {
                    var btns = '';

                    if (full.pharmacy_name != null && full.pharmacy_name != undefined) {
                        btns += '<span><b>Pharmacy Name : </b>' + full.pharmacy_name + '</span><br>';
                    }
                    // if (full.pharmacy_charge != null && full.pharmacy_charge != undefined) {
                    //     btns += '<span><b> Charge ($): </b>' + full.pharmacy_charge + '  </span><br>';
                    // }
                    if (full.pharmacy_latitude != null && full.pharmacy_latitude != undefined) {
                        btns += '<span><b> Latitude : </b>' + full.pharmacy_latitude + '</span><br>';
                    }
                    if (full.pharmacy_longitude != null && full.pharmacy_longitude != undefined) {
                        btns += '<span><b> Logitude : </b>' + full.pharmacy_longitude + '</span><br>';
                    }
                    if (full.pharmacy_address != null && full.pharmacy_address != undefined) {
                        btns += '<span><b> Address : </b>' + full.pharmacy_address + '  </span><br>';
                    }
                    if (full.pharmacy_payment_status != null && full.pharmacy_payment_status != undefined) {
                        btns += '<span><b> Payment Status : </b>' + full.pharmacy_payment_status + '  </span><br>';
                    }
                    if ((full.pharmacy_name == null && full.pharmacy_name == undefined) && (full.pharmacy_charge == null && full.pharmacy_charge == undefined) &&
                        (full.pharmacy_latitude == null && full.pharmacy_latitude == undefined) && (full.pharmacy_longitude == null && full.pharmacy_longitude == undefined) &&
                        (full.pharmacy_address == null && full.pharmacy_address == undefined) && (full.pharmacy_payment_status == null && full.pharmacy_payment_status == undefined)) {
                        return 'N/A';
                    }
                    return btns;
                }

                function durationHtml(data, type, full, meta) {
                    if (full.recurring_due != null && full.recurring_due != undefined && full.recurring_due != '') {
                        var btns = '<div layout="row" layout-align="center">';
                        if (full.recurring_due == '7') {
                            btns += '<span style="font-size: 15px;background-color:  #ff9790;color:white;padding:5px;" >1 Week</span>';
                        } else if (full.recurring_due == '10') {
                            btns += '<span style="font-size: 15px;background-color:  #ceb5f9;color:white;padding:5px;">10 Days</span>';
                        } else if (full.recurring_due == '14') {
                            btns += '<span style="font-size: 15px;background-color:#00bde3;color:white;padding:5px;">2 Weeks</span>';
                        } else if (full.recurring_due == '21') {
                            btns += '<span style="font-size: 15px;background-color:#ff9790;color:white;padding:5px;">3 Weeks</span>';
                        } else if (full.recurring_due == '28') {
                            btns += '<span style="font-size: 15px;background-color: orange;color:white;padding:5px;">4 Weeks</span>';
                        } else {
                            return 'N/A'
                        }
                        btns += '<div>';
                        return btns;

                    } else {
                        return 'N/A';
                    }
                }


                function refillOrderReccurringActive(data, type, full, meta) {
                    var btns = '<div layout="row" layout-align="center">';

                    if (full.recurring_active == true) {
                        btns += ' <span style="font-size: 20px;color: green">  &#x2714;</span>';
                    } else {
                        btns += ' <span style="font-size: 20px;color: red">&#x2716;</span>';
                    }
                    btns += '<div>';
                    return btns;
                };

                function refillOrderReccurringDone(data, type, full, meta) {
                    var btns = '<div layout="row" layout-align="center">';

                    if (full.recurring_done == true) {
                        btns += ' <span style="font-size: 20px;color: green">  &#x2714;</span>';
                    } else {
                        btns += ' <span style="font-size: 20px;color: red">&#x2716;</span>';
                    }
                    btns += '<div>';
                    return btns;
                };

                function refillactionsHtml(data, type, full, meta) {
                    var btns = '<div layout="row" layout-align="center">';

                    var method = "RefillOrderDetails('" + full._id + "')";
                    btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                        '<md-icon md-font-icon="icon-receipt"  class="orange-500-fg"></md-icon>' +
                        '<md-tooltip md-visible="" md-direction="">Re-Fill Order Details</md-tooltip>' +
                        '</md-button>';

                    btns += '<div>';
                    return btns;
                };

                function NameHtml(data, type, full, meta) {
                    var data = full.first_name + " " + full.last_name + " " + full.middle_name;
                    return data;
                };

                function refillcolumnNameHtml(data, type, full, meta) {
                    if (data) {
                        return data;
                    } else {
                        return 'N/A';
                    }
                }
            }
        }

        //back to list
        $scope.back = function() {
            $scope.flag = false;
            $scope.reloadTableData(true);
        }

        //selected tab manage
        $scope.selectedTab = function(value) {
            if (value == 'onetime') {
                $scope.tabFlag = 1
                $scope.orderDetailRecord($scope.id, $scope.tabFlag);
            } else if (value == 'refill') {
                $scope.tabFlag = 2
                $scope.orderDetailRecord($scope.id, $scope.tabFlag);
            } else {
                $scope.tabFlag = 1;
                $scope.orderDetailRecord($scope.id, $scope.tabFlag);
            }
        }

        //one time order details
        $scope.OneTimeOrderDetails = function(id) {
            var orderData = _.findWhere($scope.lstOneTime, {
                _id: id
            });
            $mdDialog.show({
                controller: 'OneTimeOrderDetailInformationController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Patient/dialogs/OneTimeOrderDetailInformation/OneTimeOrderDetailInformation.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    data: orderData,
                }
            })
        }

        //refill order details
        $scope.RefillOrderDetails = function(id) {
            var orderData = _.findWhere($scope.lstRefill, {
                _id: id
            });
            $mdDialog.show({
                controller: 'ReFillOrderDetailInformationController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Patient/dialogs/ReFillOrderDetailInformation/ReFillOrderDetailInformation.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    data: orderData,
                }
            })
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.OrderCharges', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.OrderCharges', {
                url: '/ordercharges',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/OrderCharges/OrderCharges.html',
                        controller: 'OrderChargesController as vm'
                    }
                },
                bodyClass: 'OrderCharges',
                ModuleName: 'OrderCharges'
            });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.OrderCharges')
        .controller('OrderChargesController', OrderChargesController)


    /** @ngInject */
    function OrderChargesController($http, $scope, $rootScope, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {

        // var vm = this;
        $scope.init = function () {
            $scope.model = {
                id: 0,
                order_id: '',
            }
            $scope.Search = '';
            $scope.flag = false;
            $scope.modelSearch = {
                Search: '',
            }
        }
        $scope.ExportOrderCharges = function () {
            window.location = $rootScope.RoutePath + "order/ExportExcelOrderCharges";
        }
        $scope.onSearchChange = function ($event) {
            $event.stopPropagation();
        }

        $scope.FilterStatus = 1;
        $scope.dtColumns = [
            DTColumnBuilder.newColumn('id').renderWith(NumberHtml).withOption('class', 'text-center'),

            DTColumnBuilder.newColumn('order_id').withOption('class', 'text-right'),

            DTColumnBuilder.newColumn('miles').withOption('class', 'text-right'),

            DTColumnBuilder.newColumn('prescription').withOption('class', 'text-right'),

            DTColumnBuilder.newColumn('patient').withOption('class', 'text-right'),

            DTColumnBuilder.newColumn('mini_charges').withOption('class', 'text-right'),

            DTColumnBuilder.newColumn('miles_charges').withOption('class', 'text-right'),

            DTColumnBuilder.newColumn('ETA_charges').withOption('class', 'text-right'),

            DTColumnBuilder.newColumn('prescription_charges').withOption('class', 'text-right'),

            DTColumnBuilder.newColumn('patient_charges').withOption('class', 'text-right'),

            DTColumnBuilder.newColumn('return_order_charges').withOption('class', 'text-right'),

            DTColumnBuilder.newColumn('total_charge').renderWith(AdditionHtml).withOption('class', 'text-right'),

        ]

        $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
            url: $rootScope.RoutePath + "order/getDynamicOrderCharges",
            data: function (d) {
                if ($scope.modelSearch.Search == '') {
                    d.search = '';
                } else {
                    d.search = $scope.modelSearch.Search;
                }
                return d;
            },
            type: "get",
            dataSrc: function (json) {
                if (json.success != false) {
                    $scope.lstdata = json.data;
                    return json.data;
                } else {
                    return [];
                }
            },
        })
            .withOption('processing', true) //for show progress bar
            .withOption('serverSide', true) // for server side processing
            .withPaginationType('simple') // for get full pagination options // first / last / prev / next and page numbers
            .withDisplayLength(10) // Page size
            .withOption('aaSorting', [0, 'desc'])
            .withOption('responsive', true)
            .withOption('createdRow', createdRow)
            
            .withOption('initComplete', function () {
                $scope.AdjustColumn();
            })
            .withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('scrollY', 'auto');

        $scope.dtInstance = {};
        $(window).resize(function () {
            $scope.AdjustColumn();
        });

        $scope.AdjustColumn = function () {
            $scope.dtInstance.DataTable.columns.adjust();
        }

        //Reload Datatable
        $scope.GetAllOrderCharge = function (IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            $scope.dtInstance.reloadData(callback, resetPaging);
            $('#OrderCharge').dataTable()._fnPageChange(0);
            $('#OrderCharge').dataTable()._fnAjaxUpdate();

        }

        function AdditionHtml(data, type, full, meta) {
            var data_display = parseFloat(full.return_order_charges) + parseFloat(full.total_charge);
            return data_display;
        }

        $scope.reloadData = function () { }

        function callback(json) { }

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }


        function NumberHtml(data, type, full, meta) {
            return parseInt((meta.settings._iDisplayStart) + (meta.row + 1));
        }

        //Dynamic Pagging End

        $scope.GetSerch = function (Search) {
            $scope.modelSearch.Search = Search;
            $scope.GetAllOrderCharge(true);
            // $scope.init();
        }
        $scope.modelSearch = {
            Search: ''
        }

        $scope.init();
    }

})();
(function () {
    'use strict';

    angular
        .module('app.OnePrice', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.OnePrice', {
                url: '/OnePrice',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/OnePrice/OnePrice.html',
                        controller: 'OnePriceController as vm'
                    }
                },
                bodyClass: 'OnePrice',
                ModuleName: 'OnePrice'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('SPI.Bank Deposit', {
        //     title: 'Bank Deposit',
        //     state: 'app.bankdeposit',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.OnePrice')
        .controller('OnePriceController', OnePriceController);

    /** @ngInject */
    function OnePriceController($http, $scope, $rootScope, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {
        var vm = this;
        $scope.init = function () {
            $scope.model = {
                Search: '',
                pharmacy_id: ''
            }

            // var date = new Date();
            // var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

            $scope.modelSearch = {
                search: '',
                order_status: '',
                pharmacy_name: '',
                hospital_name: '',
                patient_firstname: '',
                StartDate: '',
                EndDate: '',
                // Lyft
                lyft_order: ''
                // StartDate: firstDay,
                // EndDate: date
            }


            $scope.searchtype = 'one_price_charges';
            $scope.role = $cookieStore.get("UserRoles")
            $scope.getAllPharmacy();
            $scope.getAllPatient();
            $scope.getHospital();
            $scope.flaglink = 3;
           


        }

        $scope.GetSerch = function (Search) {
            $scope.model.Search = Search;
            $scope.GetAllDynamicHospital(true);
        }
        $scope.searchtype1 = function (type) {
            $scope.searchtype = type
            $scope.GetAllDynamicHospital(true);
        }
        $scope.onSearchChange = function ($event) {
            $event.stopPropagation();
        }
        $scope.getAllPharmacy = function () {

            $http.get($rootScope.RoutePath + "pharmacy/getAllPharmacy").then(function (data) {
                $scope.lstPharmacy = data.data.data;
            });
        };
        $scope.getHospital = function () {

            $http.get($rootScope.RoutePath + "hospital/getAllHospital").then(function (data) {
                $scope.lstHospitalname = data.data.data;
            });
        };
        $scope.getAllPatient = function () {

            $http.get($rootScope.RoutePath + "order/getAllPatient").then(function (data) {
                $scope.lstPatient = data.data.data;
                // console.log($scope.lstPatient)
            });
        };
        //Dynamic Pagging for Hospital
        //Reload Datatable
        $scope.FilterStatus = '';
        try {
            $scope.dtColumnsHospital = [
                DTColumnBuilder.newColumn('created_on').renderWith(NumberHtml).notSortable(),
                DTColumnBuilder.newColumn('pharmacy_name').renderWith(currentPharmacyHtml),
                DTColumnBuilder.newColumn('hospital_name').renderWith(HospitalInfoHtml),
                DTColumnBuilder.newColumn('patient_firstname').renderWith(patientInfoHtml),
                // DTColumnBuilder.newColumn('patient_lastname').renderWith(NAHtml),
                // DTColumnBuilder.newColumn('patient_dob').renderWith(NAHtml),
                DTColumnBuilder.newColumn('order_id').renderWith(orderHtml),
                DTColumnBuilder.newColumn('delivery_date').renderWith(DeliverdDateHtml),
                DTColumnBuilder.newColumn('created_on').renderWith(DateHtml),
                DTColumnBuilder.newColumn('pharmacy_charge').renderWith(NAHtml),
                DTColumnBuilder.newColumn('order_status').renderWith(StatusHtml).notSortable().withOption('class', 'dt-body-center'),
                DTColumnBuilder.newColumn(null).notSortable().renderWith(actionsHtml).withOption('width', '5%').withOption('class', 'text-center'),
                DTColumnBuilder.newColumn('lyft_order').renderWith(checkLyftOrderHtml).notSortable().withOption('class', 'dt-body-center')
    
            ]
        }
        catch (error) {
            console.log(error)
        }
       

        // console.log( $cookieStore.get("UserRoles"), $scope.dtColumnsHospital )
      
        $http.get($rootScope.RoutePath + "userpermission/CheckRightsbyPage", {
            params: {
                    tablename: "demand"                
            }
        }).then(function (data) {
            $scope.demandView = $rootScope.demandViewAccess
            if (data.data.success == true) {
                
                $scope.demandView = true
                var objpermission = data.data.data;
                $rootScope.FlgAddedAccess = objpermission.Added;
                $rootScope.FlgAddedEditlocal = objpermission.Added;
                $rootScope.FlgModifiedAccess = objpermission.Modified;
                $rootScope.FlgDeletedAccess = objpermission.Deleted;
            } else {
                $rootScope.FlgAddedAccess = false;
                $rootScope.FlgAddedEditlocal = false;
                $rootScope.FlgModifiedAccess = false;
                $rootScope.FlgDeletedAccess = false;
                $scope.demandView = false
            }
        })

        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {

            $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                url: $rootScope.RoutePath + "order/getAllOrder",
                data: function (d) {
                    d.type = $scope.searchtype;
                    d.order_status = $scope.modelSearch.order_status;
                    d.pharmacy_name = $scope.modelSearch.pharmacy_name;
                    d.hospital_name = $scope.modelSearch.hospital_name;
                    d.patient_firstname = $scope.modelSearch.patient_firstname;
                    d.Search = $scope.model.Search;
                    d.StartDate = $scope.modelSearch.StartDate;
                    d.EndDate = $scope.modelSearch.EndDate;
                    // For lyft
                    d.lyft_order = $scope.modelSearch.lyft_order
                    return d;
                },
                type: "get",
                dataSrc: function (json) {
                    if (json.success != false) {
                        $scope.lstHospital = json.data;
                        // console.log($scope.lstHospital)
                        return json.data;

                    } else {
                        return [];
                    }
                }
            })

                .withOption('processing', true) //for show progress bar
                .withOption('serverSide', true) // for server side processing
                .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                .withDisplayLength(10) // Page size
                .withOption('aaSorting', [0, 'desc'])
                .withOption('responsive', true)
                .withOption('createdRow', createdRow)
                .withOption('autoWidth', true)
                .withOption('initComplete', function () {
                    $scope.AdjustColumn();
                })
                .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
                .withOption('scrollY', 'auto');
        });

        // $scope.AdvanceSearch = function (o) {
        //     console.log(o)



        //     $scope.GetAllDynamicHospital(true)
        // }
        vm.dtInstanceHospital = {};
        $(window).resize(function () {
            // console.log("$$$$$$$$$$$$$")
            $scope.AdjustColumn();
        });
        $scope.AdjustColumn = function () {

            vm.dtInstanceHospital.DataTable.columns.adjust();
        }
        $scope.GetAllDynamicHospital = function (IsUpdate) {
            // $scope.searchtype = searchtype
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            vm.dtInstanceHospital.reloadData(callback, resetPaging);
            $('#Hospital').dataTable()._fnAjaxUpdate();

        }

        $(window).resize(function () {
            // console.log("$$$$$$$$$$$$$")
            $scope.AdjustColumn();
        });
        function currentPharmacyHtml(data, type, full, meta) {
            var btns = '';

            if (full.pharmacy_name != null && full.pharmacy_name != undefined) {
                btns += '<span><b>Pharmacy Name : </b>' + full.pharmacy_name + '</span><br>';
            }
            // if (full.pharmacy_charge != null && full.pharmacy_charge != undefined) {
            //     btns += '<span><b> Charge ($): </b>' + full.pharmacy_charge + '  </span><br>';
            // }
            if (full.pharmacy_latitude != null && full.pharmacy_latitude != undefined) {
                btns += '<span><b> Latitude : </b>' + full.pharmacy_latitude + '</span><br>';
            } if (full.pharmacy_longitude != null && full.pharmacy_longitude != undefined) {
                btns += '<span><b> Logitude : </b>' + full.pharmacy_longitude + '</span><br>';
            } if (full.pharmacy_address != null && full.pharmacy_address != undefined) {
                btns += '<span><b> Address : </b>' + full.pharmacy_address + '  </span><br>';
            } if (full.pharmacy_payment_status != null && full.pharmacy_payment_status != undefined) {
                btns += '<span><b> Payment Status : </b>' + full.pharmacy_payment_status + '  </span><br>';
            } if ((full.pharmacy_name == null && full.pharmacy_name == undefined) && (full.pharmacy_charge == null && full.pharmacy_charge == undefined) &&
                (full.pharmacy_latitude == null && full.pharmacy_latitude == undefined) && (full.pharmacy_longitude == null && full.pharmacy_longitude == undefined) &&
                (full.pharmacy_address == null && full.pharmacy_address == undefined) && (full.pharmacy_payment_status == null && full.pharmacy_payment_status == undefined)) {
                return 'N/A';
            }
            return btns;
        };

        function HospitalInfoHtml(data, type, full, meta) {
            var btns = '';
            if (full.hospital_name != null && full.hospital_name != undefined) {
                btns += '<span><b> Name : </b>' + full.hospital_name + '</span><br>';
            } if (full.hospital_number != null && full.hospital_number != undefined) {
                btns += '<span><b> Hospital Number : </b>' + full.hospital_number + '  </span><br>';
            } if (full.hospital_instructions != null && full.hospital_instructions != undefined && full.hospital_instructions != '') {
                btns += '<span><b> Hospital Instructions : </b>' + full.hospital_instructions + '</span><br>';
            } if ((full.hospital_name == null && full.hospital_name == undefined) && (full.hospital_number == null && full.hospital_number == undefined) && (full.hospital_instructions == null && full.hospital_instructions == undefined || full.hospital_instructions == '')) {
                btns += '-'
            }
            return btns;
        }
        function orderHtml(data, type, full, meta) {
            var btns = '';
            if (full.order_id != null && full.order_id != undefined) {
                btns += '<span><b> Order Id : </b>' + full.order_id + '</span><br>';
            } if (full.ordering_personnel != null && full.ordering_personnel != undefined) {
                btns += '<span><b> Order Person Name : </b>' + full.ordering_personnel + '  </span><br>';
            } if (full.ordering_personnel_role != null && full.ordering_personnel_role != undefined) {
                btns += '<span><b> Order Person Role : </b>' + full.ordering_personnel_role + '</span><br>';
            } if ((full.order_id == null && full.order_id == undefined) && (full.ordering_personnel == null && full.ordering_personnel == undefined) && (full.ordering_personnel_role == null && full.ordering_personnel_role == undefined)) {
                return 'N/A';
            }
            // btns += '<span><b> Order Status : </b>' + full.order_status + '</span><br>';

            return btns;

        }
        // by Afzan for lyft order 
        function checkLyftOrderHtml(data, type, full, meta) {
            var btns = '';
            if (full.order_id != null && full.order_id != undefined) {
                // btns += '<span>' + full. + '</span><br>';
                if (full.lyft_delivery_order_id != null && full.lyft_delivery_order_id != undefined) {
                    btns += "<span>" + '<br><b> Doordash Order id : </b>' + full.lyft_delivery_order_id + '  </span><br>';
                } else {
                    btns += "No"
                }
            }
            // btns += '<span><b> Order Status : </b>' + full.order_status + '</span><br>';

            return btns;

        }
        function patientInfoHtml(data, type, full, meta) {
            var btns = '';
            if (full.patients.length > 0) {
                if (full.patients[0].first_name != null || full.patients[0].patient_lastname != null || full.patients[0].middle_name != null) {
                    btns += '<span><b>  Name : </b>' + full.patients[0].first_name + '</span> <span>' + full.patients[0].middle_name + '</span> <span>' + full.patients[0].last_name + '<br>';
                }
            }
            else {
                return 'N/A';
            }
            if ((full.patient_address1 != null && full.patient_address1 != undefined) || (full.patient_state != null && full.patient_state != undefined) || (full.patient_zip_code != null && full.patient_zip_code != undefined)) {
                btns += '<span><b>  Address : </b>' + full.patient_address1 + '</span> ,<span>' + full.patient_state + '</span> , <span>' + full.patient_zip_code + ' </span><br>';
            } if (full.patient_dob != null && full.patient_dob != undefined) {
                btns += '<span><b>  DOB : </b>' + full.patient_dob + '  </span><br>';
            } if (full.patient_phone_number != null && full.patient_phone_number != undefined) {
                btns += '<span><b> Phone Number : </b>' + full.patient_phone_number + '  </span><br>';
            }
            if ((full.patients[0].first_name == null && full.patients[0].patient_lastname == null && full.patients[0].middle_name == null)) {
                return 'N/A';
            }


            return btns;
        }
        function actionsHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if (data != null) {
                var method = "ShowOrderDetailInformation('" + data.order_id + "')";
                btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                    '<md-icon md-font-icon="icon-note"  class="orange-500-fg"></md-icon>' +
                    '<md-tooltip md-visible="" md-direction="">Order Information</md-tooltip>' +
                    '</md-button>';
                btns += '<div>';
            }
            // if (data.order_charges.length > 0) {
            //     var method = "ShowOrderDetailsModal('" + data.order_id + "')";
            //     btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
            //         '<md-icon md-font-icon="icon-receipt"  class="orange-500-fg"></md-icon>' +
            //         '<md-tooltip md-visible="" md-direction="">Order Details</md-tooltip>' +
            //         '</md-button>';
            //     btns += '<div>';
            // }
            return btns;

            // var btns = '<div layout="row" layout-align="center center">';

            // if ($rootScope.FlgModifiedAccess) {
            //     btns += '<md-button class="edit-button md-icon-button"  ng-click="EditBankDepositeById(' + data.id + ',' + data.Status + ')" aria-label="Edit Location">' +
            //         '<md-icon md-font-icon="icon-pencil"  class="s18 green-500-fg"></md-icon>' +
            //         '<md-tooltip md-visible="" md-direction="">Edit</md-tooltip>' +
            //         '</md-button>';
            // }
            // if ($rootScope.FlgDeletedAccess) {
            //     btns += '<md-button class="edit-button md-icon-button" ng-click="DeleteBankDepositeById(' + data.id + ',' + data.Status + ',$event)" aria-label="Add Sub-Location">' +
            //         '<md-icon md-font-icon="icon-trash"  class="s18 red-600-fg"></md-icon>' +
            //         '<md-tooltip md-visible="" md-direction="">Delete</md-tooltip>' +
            //         '</md-button>';
            // }

            // btns += '</div>'
            // return btns;
        };

        function NAHtml(data, type, full, meta) {
            if($cookieStore.get("UserRoles") == "Admin" || $cookieStore.get("UserRoles")=="Owner"  ){
                if (data != null && data != undefined && data != '') {
                    return "<b>Balto : </b>" + data + ',&nbsp;&nbsp;<b>Doordash : </b>' + full.pharmacy_lyft_charge;
                } else {
                    return 'N/A';
                }
            }else {
                if (data != null && data != undefined && data != '') {
                    return "<b> - </b>"
                } else {
                    return 'N/A';
                }
            }
            
        }

        $scope.reloadData = function () { }

        function callback(json) { }

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

        function NumberHtml(data, type, full, meta) {
            return parseInt((meta.settings._iDisplayStart) + (meta.row + 1));
        }

        $rootScope.convertdatetimeformat = function (date1) {
            var date = new Date(date1);
            var firstdayDay = date.getDate();
            var firstdayMonth = date.getMonth() + 1;
            var firstdayYear = date.getFullYear();
            var hour = date.getHours();
            var minute = date.getMinutes();
            var sec = date.getSeconds();
            return ("00" + firstdayMonth.toString()).slice(-2) + "-" + ("00" + firstdayDay.toString()).slice(-2) + "-" + ("0000" + firstdayYear.toString()).slice(-4) + " " + ("00" + hour.toString()).slice(-2) + ":" + ("00" + minute.toString()).slice(-2) + ":" + ("00" + sec.toString()).slice(-2);
        }

        function DateHtml(data, type, full, meta) {
            if (full != null && full != undefined && full != '') {
                var date = new Date(full.created_on)
                return $rootScope.convertdatetimeformat(date);
                // return $rootScope.convertdatetimeformat(date + ' UTC');
            } else {
                return 'N/A';
            }
        }

        function DeliverdDateHtml(data, type, full, meta) {
            if (full != null && full != undefined && full != '') {
                var date = new Date(full.delivered_at)
                return $rootScope.convertdatetimeformat(date);
                // return $rootScope.convertdatetimeformat(date + ' UTC');
            } else {
                return 'N/A';
            }
        }

        function StatusHtml(data, type, full, meta) {
            if (full.order_status != null && full.order_status != undefined && full.order_status != '') {
                var btns = '<div layout-align="center">';
                if (full.order_status == -2) {
                    btns += '<span style="font-size: 15px;background-color:  #ff9790;color:white;padding:5px;" >Co-pay Verification</span>';
                }
                else if (full.order_status == -1) {
                    btns += '<span style="font-size: 15px;background-color:  #ceb5f9;color:white;padding:5px;">Co-pay Approval</span>';
                }
                else if (full.order_status == 1) {
                    btns += '<span style="font-size: 15px;background-color:#00bde3;color:white;padding:5px;">New</span>';
                }
                else if (full.order_status == 2) {
                    btns += '<span style="font-size: 15px;background-color:#ff9790;color:white;padding:5px;">OnHold</span>';
                }
                else if (full.order_status == 3) {
                    btns += '<span style="font-size: 15px;background-color: orange;color:white;padding:5px;">Ready to Pick</span>';
                }
                else if (full.order_status == 4) {
                    btns += '<span style="font-size: 15px;background-color: green;color:white;padding:5px;">Driver Picked Up</span>';
                }
                else if (full.order_status == 5) {
                    btns += '<span style="font-size: 15px;background-color: blue;color:white;padding:5px;">Completed</span>';
                }
                else if (full.order_status == 6) {
                    btns += '<span style="font-size: 15px;background-color: red;color:white;padding:5px;">Canceled</span>';
                }
                else if (full.order_status == 7) {
                    btns += '<span style="font-size: 15px;background-color:#abc343;color:white;padding:5px;">Co-pay Direct to Pharmacy</span>';
                }
                else if (full.order_status == 8) {
                    btns += '<span style="font-size: 15px;background-color: lightgray;color:white;padding:5px;">Return Pending</span>';
                }
                else if (full.order_status == 9) {
                    btns += '<span style="font-size: 15px;background-color:  #ceb5f9;color:white;padding:5px;">Return Completed</span><br>' +
                        '<br><span><b>  Return Reason : </b>' + full.return_order[0].reason + '  </span><br>' +
                        '<span><b>  Receiver Name : </b>' + full.return_order[0].recived_name + '  </span><br>';
                }
                else {
                    return 'N/A'
                }
                btns += '<div>';
                return btns;

            } else {
                return 'N/A';
            }
        }


        $(document).on('click', '#okbtn1', function () {
            $mdDialog.hide();
        });

        //Dynamic pagging End


        $scope.toggle = function () {
            if (!$scope.flgforIcon) {
                $scope.flgforIcon = true;
            } else {
                $scope.flgforIcon = false;
            }

            $(function () {
                $(".showBtn").toggleClass("active");
                $(".ShowContentBox").slideToggle();
            });
        };
        $scope.ShowOrderDetailsModal = function (Order_Id) {
            var orderData = _.findWhere($scope.lstHospital, {
                order_id: Order_Id
            });
            $scope.orderDetailData = orderData.order_charges;
            $mdDialog.show({
                controller: 'OrderDetailsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Order/dialogs/OrderDetails/OrderDetails.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    Order_Id: Order_Id,
                    OrderDetailData: $scope.orderDetailData
                }
            })
        }

        $scope.ShowOrderDetailInformation = function (Order_Id) {
            var orderData = _.findWhere($scope.lstHospital, {
                order_id: Order_Id
            });
            $scope.orderDetailData = orderData.order_charges;
            $mdDialog.show({
                controller: 'OrderDetailInformationController',
                controllerAs: 'vm',
                templateUrl: 'app/main/DemandOrder/dialogs/OrderDetailInformation/DemandOrderControllerDetailInformation.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    Order_Id: Order_Id,
                }
            })
        }

        $scope.ResetTab = function (type) {
            $scope.flag = false;

            $scope.flaglink = 0;
            $scope.searchtype1(type)

        }

        $scope.ResetModel1 = function (type) {
            $scope.flag = false;
            $scope.flaglink = 1;
            $scope.searchtype1(type)
        }
        $scope.ResetModel2 = function (type) {

            $scope.flag = false;
            $scope.flaglink = 2;
            $scope.searchtype1(type)
        }
        $scope.ResetModel3 = function (type) {

            $scope.flag = false;
            $scope.flaglink = 3;
            $scope.searchtype1(type)
        }

        $scope.dtInstance = {};
        $scope.init();
    }

})();
(function () {
    'use strict';

    angular
        .module('app.Order')
        .controller('OrderController', OrderController);

    /** @ngInject */
    function OrderController($http, $scope, $rootScope, $window, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {
        var vm = this;

        $('#loaderDiv').hide();
        $scope.init = function () {
            $scope.model = {
                Search: '',
                pharmacy_id: ''
            }

            // var date = new Date();
            // var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

            $scope.modelSearch = {
                search: '',
                order_status: '',
                pharmacy_name: '',
                hospital_name: '',
                patient_firstname: '',
                StartDate: '',
                EndDate: '',
                // Lyft
                lyft_order: ''
                // StartDate: firstDay,
                // EndDate: date
            }


            $scope.searchtype = 'hospital';
            $scope.getAllPharmacy();
            $scope.getAllPatient();
            $scope.getHospital();
            $scope.flaglink = 0;



        }

        $scope.GetSerch = function (Search) {
            $scope.model.Search = Search;
            $scope.GetAllDynamicHospital(true);
        }
        $scope.searchtype1 = function (type) {
            $scope.searchtype = type
            $scope.GetAllDynamicHospital(true);
        }
        $scope.onSearchChange = function ($event) {
            $event.stopPropagation();
        }
        $scope.getAllPharmacy = function () {

            $http.get($rootScope.RoutePath + "pharmacy/getAllPharmacy").then(function (data) {
                $scope.lstPharmacy = data.data.data;
            });
        };
        $scope.getHospital = function () {

            $http.get($rootScope.RoutePath + "hospital/getAllHospital").then(function (data) {
                $scope.lstHospitalname = data.data.data;
            });
        };
        $scope.getAllPatient = function () {

            $http.get($rootScope.RoutePath + "order/getAllPatient").then(function (data) {
                $scope.lstPatient = data.data.data;
                // console.log($scope.lstPatient)
            });
        };
        //Dynamic Pagging for Hospital
        //Reload Datatable
        $scope.FilterStatus = '';
        $scope.dtColumnsHospital = [
            DTColumnBuilder.newColumn('created_on').renderWith(NumberHtml).notSortable(),
            DTColumnBuilder.newColumn('pharmacy_name').renderWith(currentPharmacyHtml),
            DTColumnBuilder.newColumn('hospital_name').renderWith(HospitalInfoHtml),
            DTColumnBuilder.newColumn('patient_firstname').renderWith(patientInfoHtml),
            // DTColumnBuilder.newColumn('patient_lastname').renderWith(NAHtml),
            // DTColumnBuilder.newColumn('patient_dob').renderWith(NAHtml),
            DTColumnBuilder.newColumn('order_id').renderWith(orderHtml),
            DTColumnBuilder.newColumn('delivery_date').renderWith(DeliverdDateHtml),
            DTColumnBuilder.newColumn('created_on').renderWith(DateHtml),
            DTColumnBuilder.newColumn('pharmacy_charge').renderWith(NAHtml),
            DTColumnBuilder.newColumn('order_status').renderWith(StatusHtml).notSortable().withOption('class', 'dt-body-center').withOption('width', '4%').withOption('responsivePriority', 6), ,
            DTColumnBuilder.newColumn(null).notSortable().renderWith(actionsHtml).withOption('width', '5%').withOption('class', 'text-center'),
            DTColumnBuilder.newColumn('lyft_order').renderWith(checkLyftOrderHtml).notSortable().withOption('class', 'dt-body-center')

        ]


        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {

            $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                url: $rootScope.RoutePath + "order/getAllOrder",
                data: function (d) {
                    d.type = $scope.searchtype;
                    d.order_status = $scope.modelSearch.order_status;
                    d.pharmacy_name = $scope.modelSearch.pharmacy_name;
                    d.hospital_name = $scope.modelSearch.hospital_name;
                    d.patient_firstname = $scope.modelSearch.patient_firstname;
                    d.Search = $scope.model.Search;
                    d.StartDate = $scope.modelSearch.StartDate;
                    d.EndDate = $scope.modelSearch.EndDate;
                    // For lyft
                    d.lyft_order = $scope.modelSearch.lyft_order
                    return d;
                },
                type: "get",
                dataSrc: function (json) {
                    if (json.success != false) {
                        $scope.lstHospital = json.data;
                        // console.log($scope.lstHospital)
                        return json.data;

                    } else {
                        return [];
                    }
                },
            })

                .withOption('processing', true) //for show progress bar
                .withOption('serverSide', true) // for server side processing
                .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                .withDisplayLength(10) // Page size
                .withOption('aaSorting', [0, 'desc'])
                .withOption('responsive', true)
                .withOption('createdRow', createdRow)
                .withOption('autoWidth', true)
                .withOption('initComplete', function () {
                    $scope.AdjustColumn();
                })
                .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
                .withOption('scrollY', 'auto');
        });

        // $scope.AdvanceSearch = function (o) {
        //     console.log(o)



        //     $scope.GetAllDynamicHospital(true)
        // }
        vm.dtInstanceHospital = {};
        $(window).resize(function () {
            // console.log("$$$$$$$$$$$$$")
            $scope.AdjustColumn();
        });
        $scope.AdjustColumn = function () {

            vm.dtInstanceHospital.DataTable.columns.adjust();
        }
        $scope.GetAllDynamicHospital = function (IsUpdate) {
            // $scope.searchtype = searchtype
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            vm.dtInstanceHospital.reloadData(callback, resetPaging);
            $('#Hospital').dataTable()._fnAjaxUpdate();

        }

        $(window).resize(function () {
            // console.log("$$$$$$$$$$$$$")
            $scope.AdjustColumn();
        });
        function currentPharmacyHtml(data, type, full, meta) {
            var btns = '';

            if (full.pharmacy_name != null && full.pharmacy_name != undefined) {
                btns += '<span><b>Pharmacy Name : </b>' + full.pharmacy_name + '</span><br>';
            }
            // if (full.pharmacy_charge != null && full.pharmacy_charge != undefined) {
            //     btns += '<span><b> Charge ($): </b>' + full.pharmacy_charge + '  </span><br>';
            // }
            if (full.pharmacy_latitude != null && full.pharmacy_latitude != undefined) {
                btns += '<span><b> Latitude : </b>' + full.pharmacy_latitude + '</span><br>';
            } if (full.pharmacy_longitude != null && full.pharmacy_longitude != undefined) {
                btns += '<span><b> Logitude : </b>' + full.pharmacy_longitude + '</span><br>';
            } if (full.pharmacy_address != null && full.pharmacy_address != undefined) {
                btns += '<span><b> Address : </b>' + full.pharmacy_address + '  </span><br>';
            } if (full.pharmacy_payment_status != null && full.pharmacy_payment_status != undefined) {
                btns += '<span><b> Payment Status : </b>' + full.pharmacy_payment_status + '  </span><br>';
            } if ((full.pharmacy_name == null && full.pharmacy_name == undefined) && (full.pharmacy_charge == null && full.pharmacy_charge == undefined) &&
                (full.pharmacy_latitude == null && full.pharmacy_latitude == undefined) && (full.pharmacy_longitude == null && full.pharmacy_longitude == undefined) &&
                (full.pharmacy_address == null && full.pharmacy_address == undefined) && (full.pharmacy_payment_status == null && full.pharmacy_payment_status == undefined)) {
                return 'N/A';
            }
            return btns;
        };

        function HospitalInfoHtml(data, type, full, meta) {
            var btns = '';
            if (full.hospital_name != null && full.hospital_name != undefined) {
                btns += '<span><b> Name : </b>' + full.hospital_name + '</span><br>';
            } if (full.hospital_number != null && full.hospital_number != undefined) {
                btns += '<span><b> Hospital Number : </b>' + full.hospital_number + '  </span><br>';
            } if (full.hospital_instructions != null && full.hospital_instructions != undefined && full.hospital_instructions != '') {
                btns += '<span><b> Hospital Instructions : </b>' + full.hospital_instructions + '</span><br>';
            } if ((full.hospital_name == null && full.hospital_name == undefined) && (full.hospital_number == null && full.hospital_number == undefined) && (full.hospital_instructions == null && full.hospital_instructions == undefined || full.hospital_instructions == '')) {
                btns += '-'
            }
            return btns;
        }
        function orderHtml(data, type, full, meta) {
            var btns = '';
            if (full.order_id != null && full.order_id != undefined) {
                btns += '<span><b> Order Id : </b>' + full.order_id + '</span><br>';
            } if (full.ordering_personnel != null && full.ordering_personnel != undefined) {
                btns += '<span><b> Order Person Name : </b>' + full.ordering_personnel + '  </span><br>';
            } if (full.ordering_personnel_role != null && full.ordering_personnel_role != undefined) {
                btns += '<span><b> Order Person Role : </b>' + full.ordering_personnel_role + '</span><br>';
            } if (full.auto_approve_co_pay_amount != null && full.auto_approve_co_pay_amount != undefined) {
                btns += '<span><b> Pre-authorized Co-pay Amount : </b>' + full.auto_approve_co_pay_amount + '</span><br>';
            } 
            if (full.co_pay_amount != null && full.co_pay_amount != undefined) {
                btns += '<span><b> Actual Co-pay Amount : </b>' + full.co_pay_amount + '</span><br>';
            }
            if (full.co_pay_by != null && full.co_pay_by != undefined) {
                btns += '<span><b> Co-pay by : </b>' + full.co_pay_by + '</span><br>';
            }
            // if (full.co_pay_status != null && full.co_pay_status != undefined) {
            //     btns += '<span><b> Co-pay status : </b>' + full.co_pay_status + '</span><br>';
            // }
            if ((full.order_id == null && full.order_id == undefined) && (full.ordering_personnel == null && full.ordering_personnel == undefined) && (full.ordering_personnel_role == null && full.ordering_personnel_role == undefined)) {
                return 'N/A';
            }
            // btns += '<span><b> Order Status : </b>' + full.order_status + '</span><br>';

            return btns;

        }
        // by Afzan for lyft order 
        function checkLyftOrderHtml(data, type, full, meta) {
            var btns = '';
            if (full.order_id != null && full.order_id != undefined) {
                // btns += '<span>' + full. + '</span><br>';
                if (full.lyft_delivery_order_id != null && full.lyft_delivery_order_id != undefined) {
                    btns += "<span>" + '<br><b> Doordash Order id : </b>' + full.lyft_delivery_order_id + '  </span><br>';
                } else {
                    btns += "No"
                }
            }
            // btns += '<span><b> Order Status : </b>' + full.order_status + '</span><br>';

            return btns;

        }
        function patientInfoHtml(data, type, full, meta) {
            var btns = '';
            if (full.patients.length > 0) {
                if (full.patients[0].first_name != null || full.patients[0].patient_lastname != null || full.patients[0].middle_name != null) {
                    btns += '<span><b>  Name : </b>' + full.patients[0].first_name + '</span> <span>' + full.patients[0].middle_name + '</span> <span>' + full.patients[0].last_name + '<br>';
                }
            }
            else {
                return 'N/A';
            }
            if ((full.patient_address1 != null && full.patient_address1 != undefined) || (full.patient_state != null && full.patient_state != undefined) || (full.patient_zip_code != null && full.patient_zip_code != undefined)) {
                btns += '<span><b>  Address : </b>' + full.patient_address1 + '</span> ,<span>' + full.patient_state + '</span> , <span>' + full.patient_zip_code + ' </span><br>';
            } if (full.patient_dob != null && full.patient_dob != undefined) {
                btns += '<span><b>  DOB : </b>' + full.patient_dob + '  </span><br>';
            } if (full.patient_phone_number != null && full.patient_phone_number != undefined) {
                btns += '<span><b> Phone Number : </b>' + full.patient_phone_number + '  </span><br>';
            }
            if ((full.patients[0].first_name == null && full.patients[0].patient_lastname == null && full.patients[0].middle_name == null)) {
                return 'N/A';
            }


            return btns;
        }
        function actionsHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            var lyft_btn = '<div layout="row" layout-align="center">';
            if (data != null) {
                var method = "ShowOrderDetailInformation('" + data.order_id + "')";
                btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                    '<md-icon md-font-icon="icon-note"  class="orange-500-fg"></md-icon>' +
                    '<md-tooltip md-visible="" md-direction="">Order Information</md-tooltip>' +
                    '</md-button>';
                btns += '<div>';
            }
            // if (data.order_status == 3 || data.order_status == 1) {
            //     // if (!orderTransfertoLyft) {
            //     if (data.lyft_delivery_order_id == null || data.lyft_delivery_order_id == undefined || data.lyft_delivery_order_id == "") {

            //         var transfer_order_lyft = "baltoToLyftOrder('" + data.order_id + "')";
            //         btns += '<md-button class="edit-button md-icon-button" ng-click="' + transfer_order_lyft + '">' +
            //             '<md-icon md-font-icon="icon-transfer"  class="orange-500-fg"></md-icon>' +
            //             '<md-tooltip md-visible="" md-direction="">Transfer to lyft </md-tooltip>' +
            //             '</md-button>';
            //         btns += '<div>';

            //     }
            //     // }
            // }
            return btns + lyft_btn;

            // var btns = '<div layout="row" layout-align="center center">';

            // if ($rootScope.FlgModifiedAccess) {
            //     btns += '<md-button class="edit-button md-icon-button"  ng-click="EditBankDepositeById(' + data.id + ',' + data.Status + ')" aria-label="Edit Location">' +
            //         '<md-icon md-font-icon="icon-pencil"  class="s18 green-500-fg"></md-icon>' +
            //         '<md-tooltip md-visible="" md-direction="">Edit</md-tooltip>' +
            //         '</md-button>';
            // }
            // if ($rootScope.FlgDeletedAccess) {
            //     btns += '<md-button class="edit-button md-icon-button" ng-click="DeleteBankDepositeById(' + data.id + ',' + data.Status + ',$event)" aria-label="Add Sub-Location">' +
            //         '<md-icon md-font-icon="icon-trash"  class="s18 red-600-fg"></md-icon>' +
            //         '<md-tooltip md-visible="" md-direction="">Delete</md-tooltip>' +
            //         '</md-button>';
            // }

            // btns += '</div>'
            // return btns;
        }

        function NAHtml(data, type, full, meta) {
            if (data != null && data != undefined && data != '') {
                return "<b>Balto : </b>" + data + ',&nbsp;&nbsp;<b>Doordash : </b>' + full.pharmacy_lyft_charge;
            } else {
                return 'N/A';
            }
        }

        $scope.reloadData = function () { }

        function callback(json) { }

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

        function NumberHtml(data, type, full, meta) {
            return parseInt((meta.settings._iDisplayStart) + (meta.row + 1));
        }

        $rootScope.convertdatetimeformat = function (date1) {
            var date = new Date(date1);
            var firstdayDay = date.getDate();
            var firstdayMonth = date.getMonth() + 1;
            var firstdayYear = date.getFullYear();
            var hour = date.getHours();
            var minute = date.getMinutes();
            var sec = date.getSeconds();
            return ("00" + firstdayMonth.toString()).slice(-2) + "-" + ("00" + firstdayDay.toString()).slice(-2) + "-" + ("0000" + firstdayYear.toString()).slice(-4) + " " + ("00" + hour.toString()).slice(-2) + ":" + ("00" + minute.toString()).slice(-2) + ":" + ("00" + sec.toString()).slice(-2);
        }

        function DateHtml(data, type, full, meta) {
            if (full != null && full != undefined && full != '') {
                var date = new Date(full.created_on)
                return $rootScope.convertdatetimeformat(date);
                // return $rootScope.convertdatetimeformat(date + ' UTC');
            } else {
                return 'N/A';
            }
        }

        function DeliverdDateHtml(data, type, full, meta) {
            if (full != null && full != undefined && full != '') {
                if (full.delivered_at != null) {
                    var date = new Date(full.delivered_at)
                    return $rootScope.convertdatetimeformat(date)
                }
                if (full.delivered_at != null) return $rootScope.convertdatetimeformat(date)
                else return 'N/A';

                // return $rootScope.convertdatetimeformat(date + ' UTC');
            } else {
                return 'N/A';
            }
        }

        function StatusHtml(data, type, full, meta) {
            if (full.lyft_delivery_order_id != null || full.lyft_delivery_order_id != undefined) {
                var btns = '<div layout-align="center">';
                if (full.lyft_delivery_status != null) {
                    if (full.lyft_delivery_status == "pending") {
                        btns += ' <span style="font-size: 15px;background-color:yellow;color:white;padding:5px;" >' + 'Doordash status : ' + full.lyft_delivery_status + '</span>';
                        return btns
                    } else if (full.lyft_delivery_status === "DASHER_CONFIRMED") {
                        btns += ' <span style="font-size: 15px;background-color:#00bde3;color:white;padding:5px;" >' + 'Doordash status : ' + "DASHER ACCEPTED" + '</span>';
                        return btns
                    } else if (full.lyft_delivery_status === "DASHER_ENROUTE_TO_PICKUP") {
                        btns += ' <span style="font-size: 15px;background-color:orange;color:white;padding:5px;" >' + 'Doordash status : ' + "Dasher enroute to pickup" + '</span>';
                        return btns
                    } else if (full.lyft_delivery_status === "DASHER_CONFIRMED_PICKUP_ARRIVAL") {
                        btns += ' <span style="font-size: 15px;background-color:orange;color:white;padding:5px;" >' + 'Doordash status : ' + 'Dasher Arrived at Pickup' + '</span>';
                        return btns
                    } else if(full.lyft_delivery_status === "DASHER_PICKED_UP") {
                        btns += ' <span style="font-size: 15px;background-color:orange;color:white;padding:5px;" >' + 'Doordash status : ' + 'Delivery Picked Up' + '</span>';
                        return btns
                    } 
                    else if (full.lyft_delivery_status === "DASHER_ENROUTE_TO_DROPOFF") {
                        btns += ' <span style="font-size: 15px;background-color:#4dff4d;color:white;padding:5px;" >' + 'Doordash status : ' + 'Dasher Enroute to Dropoff' + '</span>';3
                        return btns
                    }
                    else if(full.lyft_delivery_status==="DASHER_CONFIRMED_DROPOFF_ARRIVAL") {
                        btns += ' <span style="font-size: 15px;background-color:#4dff4d;color:white;padding:5px;" >' + 'Doordash status : ' + 'Dasher Arrived at Dropoff' + '</span>';3
                        return btns
                    } 
                    
                    else if (full.lyft_delivery_status == "DASHER_DROPPED_OFF") {
                        btns += ' <span style="font-size: 15px;background-color:green;color:white;padding:5px;" >' + 'Doordash status : ' + 'Delivered' + '</span>';
                        return btns
                    } else if (full.lyft_delivery_status === "DELIVERY_CANCELLED") {
                        btns += ' <span style="font-size: 15px;background-color:red;color:white;padding:5px;" >' + 'Doordash status : ' + "Canceled" + '</span>';
                        return btns
                    } else if (full.lyft_delivery_status === "failed") {
                        if(full.order_status === 8 ) {
                        btns += ' <span style="font-size: 15px;background-color:red;color:white;padding:5px;" >' + 'Doordash status : ' + "Return Pending" + '</span>';
                        }
                        if(full.order_status === 9){
                        btns += ' <span style="font-size: 15px;background-color:red;color:white;padding:5px;" >' + 'Doordash status : ' + "Return Completed" + '</span>';

                        }
                        return btns
                    }
                    
                    else {
                        btns += ' <span style="font-size: 15px;background-color:red;color:white;padding:5px;" >' + 'Doordash status : ' + full.lyft_delivery_status + '</span>';
                        return btns
                    }
                } else {
                    btns += '<span style="font-size: 15px;background-color:red;color:white;padding:5px;" >' + 'Doordash status : Pending' + '</span>';
                    return btns
                }
            }
            if (full.order_status != null && full.order_status != undefined && full.order_status != '') {
                var btns = '<div layout-align="center">';
                if (full.order_status == -2) {
                    btns += '<span style="font-size: 15px;background-color:  #ff9790;color:white;padding:5px;" >Co-pay Verification</span>';
                }
                else if (full.order_status == -1) {
                    btns += '<span style="font-size: 15px;background-color:  #ceb5f9;color:white;padding:5px;">Co-pay Approval</span>';
                }
                else if (full.order_status == 1) {
                    btns += '<span style="font-size: 15px;background-color:#00bde3;color:white;padding:5px;">New</span>';
                }
                else if (full.order_status == 2) {
                    btns += '<span style="font-size: 15px;background-color:#ff9790;color:white;padding:5px;">OnHold</span>';
                }
                else if (full.order_status == 3) {
                    btns += '<span style="font-size: 15px;background-color: orange;color:white;padding:5px;">Ready to Pick</span>';
                }
                else if (full.order_status == 4) {
                    btns += '<span style="font-size: 15px;background-color: green;color:white;padding:5px;">Driver Picked Up</span>';
                }
                else if (full.order_status == 5) {
                    btns += '<span style="font-size: 15px;background-color: blue;color:white;padding:5px;">Completed</span>';
                }
                else if (full.order_status == 6) {
                    btns += '<span style="font-size: 15px;background-color: red;color:white;padding:5px;">Canceled</span>';
                }
                else if (full.order_status == 7) {
                    btns += '<span style="font-size: 15px;background-color:#abc343;color:white;padding:5px;">Co-pay Direct to Pharmacy</span>';
                }
                else if (full.order_status == 8) {
                    btns += '<span style="font-size: 15px;background-color: lightgray;color:white;padding:5px;">Return Pending</span>';
                }
                else if (full.order_status == 9) {
                    btns += '<span style="font-size: 15px;background-color:  #ceb5f9;color:white;padding:5px;">Return Completed</span><br>' +
                        '<br><span><b>  Return Reason : </b>' + full.return_order[0].reason + '  </span><br>' +
                        '<span><b>  Receiver Name : </b>' + full.return_order[0].recived_name + '  </span><br>';
                }
                else {
                    return 'N/A'
                }
                btns += '<div>';
                return btns;

            } else {
                return 'N/A';
            }
        }


        $(document).on('click', '#okbtn1', function () {
            $mdDialog.hide();
        });

        //Dynamic pagging End


        $scope.toggle = function () {
            if (!$scope.flgforIcon) {
                $scope.flgforIcon = true;
            } else {
                $scope.flgforIcon = false;
            }

            $(function () {
                $(".showBtn").toggleClass("active");
                $(".ShowContentBox").slideToggle();
            });
        };
        $scope.ShowOrderDetailsModal = function (Order_Id) {
            var orderData = _.findWhere($scope.lstHospital, {
                order_id: Order_Id
            });
            $scope.orderDetailData = orderData.order_charges;
            $mdDialog.show({
                controller: 'OrderDetailsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Order/dialogs/OrderDetails/OrderDetails.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    Order_Id: Order_Id,
                    OrderDetailData: $scope.orderDetailData
                }
            })
        }

        $scope.ShowOrderDetailInformation = function (Order_Id) {
            var orderData = _.findWhere($scope.lstHospital, {
                order_id: Order_Id
            });
            $scope.orderDetailData = orderData.order_charges;
            $mdDialog.show({
                controller: 'OrderDetailInformationController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Order/dialogs/OrderDetailInformation/OrderDetailInformation.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    Order_Id: Order_Id,
                }
            })
        }

        $scope.baltoToLyftOrder = function (order_id) {

            var confirm = $mdDialog.confirm()
                .title('Are you sure to transfer order to Lyft?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent(order_id)
                .ok('Yes')
                .cancel('No');


            $mdDialog.show(confirm).then(function () {
                $('#loaderDiv').show();
                if (order_id != undefined || order_id != null) {
                    var body = {
                        order_id: order_id
                    }
                    // console.log(body)
                    $http.post($rootScope.RoutePath + "v1/baltoToLyftByOrderId", body).then(function (data) {
                        $('#loaderDiv').hide();
                        // console.log(data)
                        if (data.data.message) {
                            $mdDialog.show(
                                $mdDialog.alert()
                                    .parent(angular.element(document.querySelector('#popupContainer')))
                                    .clickOutsideToClose(true)
                                    .title('Order transferred successfully.')
                                    .textContent(data.data.message)
                                    .ok('close')
                                    .targetEvent()
                            );
                            var resetPaging_for_lyft = true;
                            vm.dtInstanceHospital.reloadData(callback, resetPaging_for_lyft);
                            $('#Hospital').dataTable()._fnAjaxUpdate();
                        }
                        else if (data.data.error) {
                            return $mdDialog.show(
                                $mdDialog.alert()
                                    .parent(angular.element(document.querySelector('#popupContainer')))
                                    .clickOutsideToClose(true)
                                    .title('Order transferred failed.')
                                    .textContent(data.data.error)
                                    .ok('close')
                                    .targetEvent()
                            );
                        }
                    })
                        .catch(function (_error) {
                            // console.log(JSON.stringify(err))
                            $('#loaderDiv').hide();
                            if (_error.data.error_detail) {
                                for (var property in _error.data.error_detail[0]) {
                                    $mdDialog.show(
                                        $mdDialog.alert()
                                            .parent(angular.element(document.querySelector('#popupContainer')))
                                            .clickOutsideToClose(true)
                                            .title('Order transfer failed.')
                                            .textContent(_error.data.error_detail[0][property])
                                            .ok('close')
                                            .targetEvent()
                                    );
                                    return
                                }
                            }
                            else {
                                if (_error.data.error_description) {
                                    alert("Error", _error.data.error_description);
                                    $mdDialog.show(
                                        $mdDialog.alert()
                                            .parent(angular.element(document.querySelector('#popupContainer')))
                                            .clickOutsideToClose(true)
                                            .title('Order transfer failed.')
                                            .textContent(_error.data.error.error_description)
                                            .ok('close')
                                            .targetEvent()
                                    );
                                    return
                                } else {
                                    alert("Error", "OOPS ..!!! Error occurred ! ");
                                    return
                                }
                            }
                            // $mdDialog.show(
                            //     $mdDialog.alert()
                            //         .parent(angular.element(document.querySelector('#popupContainer')))
                            //         .clickOutsideToClose(true)
                            //         .title('Order transfer failed.')
                            //         .textContent(err.data.message)
                            //         .ok('close')
                            //         .targetEvent()
                            // );

                        })
                }
            }
            )
        }

        $scope.ResetTab = function (type) {
            $scope.flag = false;

            $scope.flaglink = 0;
            $scope.searchtype1(type)

        }

        $scope.ResetModel1 = function (type) {
            $scope.flag = false;
            $scope.flaglink = 1;
            $scope.searchtype1(type)
        }
        $scope.ResetModel2 = function (type) {

            $scope.flag = false;
            $scope.flaglink = 2;
            $scope.searchtype1(type)
        }
        $scope.ResetModel3 = function (type) {

            $scope.flag = false;
            $scope.flaglink = 3;
            $scope.searchtype1(type)
        }

        $scope.dtInstance = {};
        $scope.init();
    }

})();
(function() {
    'use strict';

    angular
        .module('app.ModuleMgmt', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.ModuleMgmt', {
                url: '/ModuleMgmt',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/ModuleMgmt/ModuleMgmt.html',
                        controller: 'ModuleMgmtController as vm'
                    }
                },
                bodyClass: 'Module Management',
                ModuleName: 'Module Management',
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Master.Banks', {
        //     title: 'Banks',
        //     state: 'app.Banks',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.ModuleMgmt')
        .controller('ModuleMgmtController', ModuleMgmtController);

    /** @ngInject */
    function ModuleMgmtController($http, $scope, $rootScope, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {
        var vm = this;
        // vm.getAllSIMInfo = getAllSIMInfo;
        $scope.init = function() {
            $scope.model = {
                id: 0,
                Module: '',
                IsActive: false,
                DisplayOrder: null,
            }
            $scope.Search = '';
            $scope.FlgAddedEditlocal = true;
            $scope.flag = false;
            getAllmodule();
        }


        function getAllmodule() {
            $http.get($rootScope.RoutePath + "module/GetAllModuleName").then(function(data) {
                $scope.lstModule = data.data;
            })
        }

        $scope.SaveModule = function(o) {
            var url = '';
            if (o.id == 0) {
                url = $rootScope.RoutePath + "module/CreateModule";
            } else {
                url = $rootScope.RoutePath + "module/UpdateModule";
            }
            $http.post(url, o).then(function(data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                    $scope.flag = false;
                    $scope.ResetModel();
                    getAllmodule();
                    // $scope.getAllSIMInfo();
                } else {
                    $mdToast.show(
                        $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                    );
                }

            })
        }
        $scope.editModuleById = function(o) {
            $scope.model.id = o.id;
            $scope.model.Module = o.Module;
            $scope.model.DisplayOrder = parseInt(o.DisplayOrder);
            if (o.IsActive == 1) {
                $scope.model.IsActive = true;
            } else {
                $scope.model.IsActive = false;
            }
            $scope.flag = true;
        }

        $scope.DeleteModule = function(Id) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to Delete this Module ?')
                .ok('Ok')
                .cancel('Cancel')
            $mdDialog.show(confirm).then(function() {
                var params = {
                    idModule: Id
                };
                $http.get($rootScope.RoutePath + "module/DeleteModule/" + Id).success(function(data) {
                    if (data.success == true) {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                        $scope.ResetModel();
                        getAllmodule();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                            .textContent(data.message)
                            .position('top right')
                            .hideDelay(3000)
                        );
                    }
                });
            });
        }

        $scope.resetForm = function() {
            $scope.formModule.$setUntouched();
            $scope.formModule.$setPristine();
        }

        $scope.Reset = function() {
            $scope.model = {
                id: 0,
                Module: '',
                IsActive: false,
                DisplayOrder: null,
            }
            $scope.Search = '';
            $rootScope.FlgAddedEditlocal = false;
            if ($rootScope.FlgAddedAccess == true) {
                $rootScope.FlgAddedEditlocal = true;
            }
            $scope.flag = true;
            $scope.resetForm();
        }

        $scope.ResetModel = function() {
            $scope.model = {
                id: 0,
                Module: '',
                IsActive: false,
                DisplayOrder: null,
            }
            $scope.Search = '';
            $scope.flag = false;
            $scope.resetForm();
        }

        $scope.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable().withOption('width', '4%').withOption('class', 'text-center'),
            DTColumnDefBuilder.newColumnDef(1),
            DTColumnDefBuilder.newColumnDef(2),
            DTColumnDefBuilder.newColumnDef(3),
            DTColumnDefBuilder.newColumnDef(4).notSortable().withOption('class', 'text-center'),
        ];

        $scope.dtInstance = {};
        $scope.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>',
            // dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [],
            initComplete: function() {
                var api = this.api(),
                    searchBox = angular.element('body').find('#modelsearch');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function(event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'full_numbers',
            lengthMenu: [25, 30, 50, 100],
            pageLength: 25,
            scrollY: 'auto',
            responsive: true
        };
        $scope.DownloadExcelTemplate = function() {
            window.location = $rootScope.RoutePath + "sim/DownloadTemplate";
        }

        $scope.ShowImportSimModal = function(ev) {
            $mdDialog.show({
                controller: 'ImportSIMController',
                controllerAs: 'vm',
                templateUrl: 'app/main/SIM/dialogs/ImportSIM/ImportSIM.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Tasks: [],
                    event: ev,
                    Obj: vm,
                }
            })
        }


        $scope.init();
        $scope.GetSerch = function(Search) {
            $scope.dtInstance.DataTable.search(Search);

            $scope.dtInstance.DataTable.search(Search).draw();
        };

    }

})();
(function() {
    'use strict';

    angular
        .module('app.Module', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.Module', {
                url: '/Module',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Module/Module.html',
                        controller: 'ModuleController as vm'
                    }
                },
                bodyClass: 'Manage Module',
                ModuleName: 'Manage Module'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/Module');

        // Navigation
        // msNavigationServiceProvider.saveItem('Module.Module', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Module.Module', {
        //     title: 'Manage Module',
        //     state: 'app.Module',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.Module')
        .controller('ModuleController', ModuleController);


    /** @ngInject */
    function ModuleController($http, $scope, $rootScope, $state, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;

        $scope.init = function () {
            $scope.model = {
                id: '',
                module_name: '',
                status: true,

            }
            $scope.Search = '';
            $scope.FlgAddedEditlocal = true;
            $scope.flag = false;
            $scope.GetAllModule();
            $scope.tab = { selectedIndex: 0 };
        }


        $scope.GetAllModule = function () {
            $http.get($rootScope.RoutePath + "module/getAllModule").then(function (data) {
                $scope.lstModules = data.data.data;
            });
        }
        $scope.editModuleById = function (o) {
            $scope.model.id = o._id;
            $scope.model.module_name = o.module_name;

            if (o.status == 1) {
                $scope.model.status = true;
            } else {
                $scope.model.status = false;
            }
            $scope.flag = true;
        }


        $scope.CreateModule = function (o, form) {
            $http.post($rootScope.RoutePath + "module/saveModule", o).then(function (data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    );
                    $rootScope.FlgAddedEditlocal = false;
                    if ($rootScope.FlgAddedAccess == true) {
                        $rootScope.FlgAddedEditlocal = true
                    }

                    $scope.init();
                } else {
                    if (data.data.data == 'TOKEN') {
                        //$cookieStore.remove('UserName');
                        //$cookieStore.remove('token');
                        //window.location.href = '/app/login';
                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                    }
                }
            });
        };
        $scope.FetchmoduleById = function (o) {
            o.IsUpdate = true;
        }

        $scope.ResetEdit = function (o) {
            o.IsUpdate = false;
            $scope.GetAllModule();
        }


        // $scope.Reset = function() {
        //     $scope.init();
        // }
        $scope.Reset = function () {
            $scope.model = {
                id: '',
                module_name: '',
                status: true,

            }
            $scope.Search = '';
            $rootScope.FlgAddedEditlocal = false;
            if ($rootScope.FlgAddedAccess == true) {
                $rootScope.FlgAddedEditlocal = true;
            }
            $scope.flag = true;
            $scope.resetForm();
        }
        $scope.ResetModel = function () {
            $scope.model = {
                id: 0,
                module_name: '',
                status: true,

            }
            $scope.Search = '';
            $scope.flag = false;
            $scope.resetForm();
        }
        $scope.resetForm = function () {
            $scope.formModule.$setUntouched();
            $scope.formModule.$setPristine();
        }
        $scope.DeleteModule = function (item) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to delete this Module?')

                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                $http.get($rootScope.RoutePath + "module/DeleteModule?id=" + item).then(function (data) {

                    if (data.data.success) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                        $scope.init();
                    } else {
                        if (data.data.data == 'TOKEN') {
                            //$cookieStore.remove('UserName');
                            //$cookieStore.remove('token');
                            //window.location.href = '/app/login';
                            $rootScope.logout();
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(data.data.message)
                                    .position('top right')
                                    .hideDelay(3000)
                            );
                        }
                    }
                });
            }, function () { });

        }


        $scope.dtCustomOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDisplayLength(100)
            .withOption('responsive', true)
            // .withOption('autoWidth', true)
            .withOption('aaSorting', [0, 'asc'])
            .withOption('deferRender', true)
            .withOption('paging', false)
            .withOption('language', {
                'zeroRecords': "No Record Found",
                'emptyTable': "No Record Found"
            })
            // .withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"info"i><"pagination"p>>>')
            .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
            .withOption('scrollY', 'auto'),

            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0).notSortable(),
                DTColumnDefBuilder.newColumnDef(1),
                DTColumnDefBuilder.newColumnDef(2),
                DTColumnDefBuilder.newColumnDef(3).notSortable().withOption('class', 'text-center'),
            ];
        $scope.dtInstance = {};

        $scope.GetSerch = function (Search) {
            $scope.dtInstance.DataTable.search(Search);

            $scope.dtInstance.DataTable.search(Search).draw();
        };
        $scope.init();
    }

})();
(function() {
    'use strict';

    angular
        .module('app.IssueReport', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.IssueReport', {
                url: '/IssueReport',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/IssueReport/IssueReport.html',
                        controller: 'IssueReportController as vm'
                    }
                },
                bodyClass: 'IssueReport',
                ModuleName: 'IssueReport'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.owneruser', {
        //     title: 'Owner Users',
        //     state: 'app.owneruser',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.IssueReport')
        .controller('IssueReportController', IssueReportController)


    /** @ngInject */
    function IssueReportController($http, $scope, $rootScope, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {

        var vm = this;
        $rootScope.appId = localStorage.getItem('appId');
        $rootScope.UserRoles = localStorage.getItem('UserRoles');
        $scope.init = function () {
            $scope.modelSearch = {
                search: '',
            }
        }


        //Dynamic Pagging
        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
            $scope.FilterStatus = 1;
            $scope.dtColumns = [
                DTColumnBuilder.newColumn('date').renderWith(NumberHtml).notSortable().withOption('width', '4%').withOption('class', 'text-center'),
                DTColumnBuilder.newColumn('pharmacy_name').renderWith(pharmacyInfoHtml),
                DTColumnBuilder.newColumn('first_name').renderWith(NameHtml).withOption('width', '12%'),
                DTColumnBuilder.newColumn('probleam_desription').renderWith(pharmacyInfoHtml),

                DTColumnBuilder.newColumn('status').renderWith(StatusHtml),
                DTColumnBuilder.newColumn('image').renderWith(urlHtml), ,
            ]
            $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                url: $rootScope.RoutePath + "reportissue/getAllDaynamicReportIssue",
                data: function (d) {
                    d.search = $scope.modelSearch.search;
                    return d;
                },
                type: "get",
                dataSrc: function (json) {
                    if (json.success != false) {
                        $scope.lstdata = json.data;
                        return json.data;
                    } else {
                        return [];
                    }
                },
            })
                .withOption('processing', true) //for show progress bar
                .withOption('serverSide', true) // for server side processing
                .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                .withDisplayLength(10) // Page size
                .withOption('aaSorting', [0, 'desc'])
                .withOption('responsive', true)
                .withOption('createdRow', createdRow)
                .withOption('autoWidth', true)
                .withOption('initComplete', function () {
                    $scope.AdjustColumn();
                })
                // .withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
                .withOption('scrollY', 'auto');
        });



        vm.dtInstance = {};
        vm.dtInstance1 = {};
        $(window).resize(function () {
            // console.log("$$$$$$$$$$$$$")
            $scope.AdjustColumn();
        });
        $scope.AdjustColumn = function () {

            vm.dtInstance.DataTable.columns.adjust();
        }
        //Reload Datatable
        $scope.reloadTable = function (IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            vm.dtInstance.reloadData(callback, resetPaging);
            $('#issueReportTable').dataTable()._fnPageChange(0);
            $('#issueReportTable').dataTable()._fnAjaxUpdate();
        }

        $scope.reloadData = function () { }

        function callback(json) { }

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }


        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }

        function dateFormat(data, type, full, meta) {
            if (data != null && data != '') {
                return moment(data).format('MM-DD-YYYY')
            } else {
                return "-";
            }

        }
        function pharmacyInfoHtml(data, type, full, meta) {
            if (data != null && data != '') {
                return data;
            } else {
                return "-";
            }
        }
        function actionsHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if (full.approval != 0) {
                var method = "ShowApplicationModal('" + full._id + "')";
                btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                    '<md-icon md-font-icon="icon-receipt"  class="orange-500-fg"></md-icon>' +
                    '<md-tooltip md-visible="" md-direction="">Driver Application</md-tooltip>' +
                    '</md-button>';
            }
            btns += '<div>';
            return btns;
        };

        function NameHtml(data, type, full, meta) {

            var data = full.first_name + " " + full.last_name;
            return data;
        };



        function StatusHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if (data == "Pending") {
                btns += '<span style="font-size: 15px;background-color: green;color:white;padding:5px;">Pending</span>';
            }
            btns += '<div>';
            return btns;
        }



        function urlHtml(data, type, full, meta) {
            var btns = '';
            if (data != "" && data != undefined && data != null) {
                btns += '<a href="' + data + '" target="_blank"> <img src="/assets/images/file.png" width="50px" /></a>';
            } else {
                btns += '-'
            }
            return btns;
        }


        $scope.init();
    }

})();
(function () {
    'use strict';

    angular
        .module('app.Invoice')
        .controller('InvoiceController', InvoiceController)


    /** @ngInject */
    function InvoiceController($http, $scope, $rootScope, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {

        var vm = this;
        $rootScope.appId = localStorage.getItem('appId');
        $rootScope.UserRoles = localStorage.getItem('UserRoles');
        $scope.lstclient = [];
        $scope.init = function () {
            $scope.modelSearch = {
                search: '',
                client_id: '',
                client_type: '',
                status: "",
            }
        }
        $scope.getAllClient = function () {
            $scope.lstclient = [];
            if ($scope.modelSearch.client_type == 'Pharmacy') {
                $http.get($rootScope.RoutePath + "pharmacy/getAllPharmacy").then(function (data) {
                    $scope.lstclient = data.data.data;
                });
            } else {
                $http.get($rootScope.RoutePath + "hospital/getAllHospital").then(function (data) {
                    $scope.lstclient = data.data.data;
                });
            }
        };

        //Dynamic Pagging
        // $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
        $scope.FilterStatus = 1;
        $scope.dtColumns = [
            DTColumnBuilder.newColumn('date').renderWith(NumberHtml).notSortable().withOption('width', '4%').withOption('class', 'text-center'),
            DTColumnBuilder.newColumn(null).renderWith(clientHtml).notSortable(),
            DTColumnBuilder.newColumn(null).withOption('width', '12%').renderWith(clientTypeHtml).notSortable(),
            DTColumnBuilder.newColumn('invoice_no'),
            DTColumnBuilder.newColumn('invoice_url').renderWith(urlHtml),
            DTColumnBuilder.newColumn('charged_amount').renderWith(AmountHtml).withOption('class', 'text-right'),
            DTColumnBuilder.newColumn('from_date').renderWith(InvoicePeroidHtml),
            DTColumnBuilder.newColumn('created_at').renderWith(dateFormat),
            DTColumnBuilder.newColumn('invoice_transactions').renderWith(PaymentType).notSortable(),
            DTColumnBuilder.newColumn('invoice_transactions[0].payment_id').notSortable(),
            DTColumnBuilder.newColumn('status').renderWith(StatusHtml),
            DTColumnBuilder.newColumn(null).renderWith(actionsHtml).notSortable(),
        ]
        $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
            url: $rootScope.RoutePath + "invoice/invoicePaymentVerificationRequest",
            data: function (d) {
                d.search = $scope.modelSearch.search;
                d.client_id = $scope.modelSearch.client_id;
                d.client_type = $scope.modelSearch.client_type;
                d.status = $scope.modelSearch.status;
                return d;
            },
            type: "get",
            dataSrc: function (json) {
                if (json.success != false) {
                    $scope.lstdata = json.data;
                    return json.data;
                } else {
                    return [];
                }
            },
        })
            .withOption('processing', true) //for show progress bar
            .withOption('serverSide', true) // for server side processing
            .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
            .withDisplayLength(10) // Page size
            .withOption('aaSorting', [7, 'desc'])
            .withOption('responsive', true)
            .withOption('createdRow', createdRow)
            .withOption('autoWidth', true)
                .withOption('initComplete', function () {
                    $scope.AdjustColumn();
                })
            // .withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
            .withOption('scrollY', 'auto');
        // });



        vm.dtInstance = {};
        vm.dtInstance1 = {};
        $(window).resize(function () {
            // console.log("$$$$$$$$$$$$$")
            $scope.AdjustColumn();
        });

        $scope.AdjustColumn = function () {

            vm.dtInstance.DataTable.columns.adjust();
        }
        //Reload Datatable
        $scope.reloadTable = function (IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            vm.dtInstance.reloadData(callback, resetPaging);
            $('#issueReportTable').dataTable()._fnPageChange(0);
            $('#issueReportTable').dataTable()._fnAjaxUpdate();
        }

        $scope.reloadData = function () { }

        function callback(json) { }

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }
        function AmountHtml(data, type, full, meta) {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(data);
        }

        function dateFormat(data, type, full, meta) {
            if (data != null && data != '') {
                return moment(data).format('MM-DD-YYYY')
            } else {
                return "";
            }

        }
        function PaymentType(data, type, full, meta) {
            var btns = '';
            if (data != null && data != '') {

                if (full.invoice_transactions.length > 0) {
                    if (full.invoice_transactions[0].payment_type === 'Bank') {
                        btns += '<span> <b>Type : </b> </span>' + full.invoice_transactions[0].payment_type + '</br>';
                        btns += '<span> <b>Bank Name : </b> </span>' + full.invoice_transactions[0].bank_name + '</br>';
                        btns += '<span> <b>Account Number : </b> </span>' + full.invoice_transactions[0].account_number + '</br>';
                        btns += '<span> <b>Routing Number : </b> </span>' + full.invoice_transactions[0].routing_number + '</br>';
                        return btns;
                    } else {
                        return full.invoice_transactions[0].payment_type;
                    }
                }
            } else {
                return "N/A";
            }

        }
        function InvoicePeroidHtml(data, type, full, meta) {
            if (data != null && data != '') {
                return moment(full.from_date).format('MM-DD-YYYY') + ' to ' + moment(full.to_date).format('MM-DD-YYYY')
            } else {
                return "";
            }

        }

        function clientHtml(data, type, full, meta) {
            var data = '';
            if (full.pharmacy[0]) {
                data = full.pharmacy[0].pharmacy_name;
            }
            if (full.hospital[0]) {
                data = full.hospital[0].hospitalName;
            }
            return data;
        }

        function clientTypeHtml(data, type, full, meta) {
            var data = '';
            if (full.pharmacy[0]) {
                data = "Pharmacy";
            }
            if (full.hospital[0]) {
                data = "Hospital";
            }
            return data;
        }

        function actionsHtml(data, type, full, meta) {           
            var btns = '<div layout="row" layout-align="center">';
            if (full.status == 'Verification') {
                var method = "verifiyInvoice('" + full.invoice_no + "')";
                btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                    '<md-icon md-font-icon="icon-check-circle"  class="green-500-fg"></md-icon>' +
                    '<md-tooltip md-visible="" md-direction="">Verify Payment</md-tooltip>' +
                    '</md-button>';
            }
            var method1 = "sendInvoiceEmail('" + full.invoice_no + "')";
            btns += '<md-button class="edit-button md-icon-button" ng-click="' + method1 + '">' +
                    '<md-icon md-font-icon="icon-email"  class="blue-500-fg"></md-icon>' +
                    '<md-tooltip md-visible="" md-direction="">Verify Payment</md-tooltip>' +
                    '</md-button>'
                    if (full.status == 'Pending') {
                    var method2 = "updatePayment('" + full.invoice_no + "')";
                    btns += '<md-button class="edit-button md-icon-button" ng-click="' + method2 + '">' +
                    '<md-icon md-font-icon="icon-pencil" class="blue-500-fg"></md-icon>' +
                    '<md-tooltip md-visible="" md-direction="">update Payment</md-tooltip>' +
                    '</md-button>'
                    }
                
            btns += '<div>';
            return btns;
        };

        function NameHtml(data, type, full, meta) {

            var data = full.last_name + " " + full.first_name;
            return data;
        };



        function StatusHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if (data == "Pending") {
                btns += '<span style="font-size: 15px;background-color: orange;color:white;padding:5px;">Pending</span>';
            } else if (data == "Verification") {
                btns += '<span style="font-size: 15px;background-color: Blue;color:white;padding:5px;">Verification</span>';
            } else if (data == "Completed") {
                btns += '<span style="font-size: 15px;background-color: green;color:white;padding:5px;">Completed</span>';
            }
            btns += '<div>';
            return btns;
        }



        function urlHtml(data, type, full, meta) {
            var btns = '';
            if (data != "" && data != undefined && data != null) {
                btns += '<a href="' + data + '" target="_blank"><img src="/assets/images/pdf.png" width="50px" /></a>'
                // btns += '<a href="' + data + '" target="_blank">' + data + '</a>';
            }
            return btns;
        }

        $scope.verifiyInvoice = function (invoice_no) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to verified invoice payment?')
                .textContent('')
                .ariaLabel('Lucky day')
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                var param = {
                    invoice_no: invoice_no
                }
                $http.post($rootScope.RoutePath + "invoice/ApprovePaymentRequest", param).then(function (data) {
                    if (data.data.success) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                        $scope.reloadTable();
                    } else {
                        if (data.data.data == 'TOKEN') {
                            //$cookieStore.remove('UserName');
                            //$cookieStore.remove('token');
                            //window.location.href = '/app/login';
                            $rootScope.logout();
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(data.data.message)
                                    .position('top right')
                                    .hideDelay(3000)
                            );
                        }
                    }
                });
            }, function () { });
        }

        $scope.sendInvoiceEmail = function (invoice_no) {
         
            var confirm = $mdDialog.confirm()
                .title('Are you sure to send invoice email?')
                .textContent('')
                .ariaLabel('Lucky day')
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {               
                $http.get($rootScope.RoutePath + "api/resendInvoiceMail?invoice_no="+invoice_no).then(function (data) {
                    if (data.data.success) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                        // $scope.reloadTable();
                    } else {
                        if (data.data.data == 'TOKEN') {                            
                            $rootScope.logout();
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(data.data.message)
                                    .position('top right')
                                    .hideDelay(3000)
                            );
                        }
                    }
                });
            }, function () { });
        }

        $scope.updatePayment = function (invoice_no) {
            $mdDialog.show({
                controller: 'invoiceUpdateController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Invoice/dialogs/invoiceUpdate/invoiceUpdate.html',
                // parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    invoice_no : invoice_no
                
                }
            }).then(function (response) {
                // This function will be called when the dialog is closed
                if (response && response.success) {
                    // Call your function here or perform any other actions
                    // For example: vm.myFunction();
                    $('#issueReportTable').dataTable()._fnAjaxUpdate();
        }})
            return
        }

        $scope.toggle = function () {
            if (!$scope.flgforIcon) {
                $scope.flgforIcon = true;
            } else {
                $scope.flgforIcon = false;
            }

            $(function () {
                $(".showBtn").toggleClass("active");
                $(".ShowContentBox").slideToggle();
            });
        };

        $scope.onSearchChange = function ($event) {
            $event.stopPropagation();
        }

        $scope.init();
    }

})();
(function () {
    'use strict';

    angular
        .module('app.Hospital')
        .controller('HospitalController', HospitalController);

    /** @ngInject */
    function HospitalController($http, $scope, $rootScope, $cookieStore, $mdToast, $mdDialog, DTOptionsBuilder, DTColumnBuilder, $compile) {
        var vm = this;
        $scope.init = function () {
            $scope.model = {
                Search: '',
            }

            $scope.modelSearch = {
                search: '',
                zipcode: null,
            }
            $scope.flag = false;
            $scope.modelData = {
                _id: null,
                billing_period_days: null,
                payment_period_days: null,
                token: null,
            }
        }
        $rootScope.role_id = $cookieStore.get('role_id');
        $scope.GetSearch = function (Search) {
            $scope.model.Search = Search;
            $scope.reloadTableData(true);
        }
        //Dynamic Pagging
        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
            $scope.FilterStatus = 1;
            $scope.dtColumns = [
                DTColumnBuilder.newColumn('signup_at').renderWith(NumberHtml).notSortable().withOption('width', '4%').withOption('class', 'text-center'),
                // DTColumnBuilder.newColumn(null).notSortable().renderWith(ImageHtml).withOption('width', '4%'),
                DTColumnBuilder.newColumn('hospitalName'),
                DTColumnBuilder.newColumn('firstName').renderWith(NameHtml).withOption('width', '12%'),
                DTColumnBuilder.newColumn('email'),
                DTColumnBuilder.newColumn('telephone'),
                DTColumnBuilder.newColumn('spocEmail'),
                DTColumnBuilder.newColumn('spocTelephone'),
                DTColumnBuilder.newColumn('address').renderWith(AddressHtml),
                DTColumnBuilder.newColumn('zip'),
                DTColumnBuilder.newColumn('last_invoice_date').renderWith(dateHtml),
                DTColumnBuilder.newColumn('billing_period_days').withOption('class', 'text-center'),
                DTColumnBuilder.newColumn('payment_period_days').withOption('class', 'text-center'),
                DTColumnBuilder.newColumn(null).notSortable().renderWith(ActionHtml).withOption('width', '5%').withOption('class', 'text-center')
            ]
            $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                url: $rootScope.RoutePath + "hospital/getAllDynamicHospital",
                data: function (d) {
                    d.search = $scope.model.Search;
                    d.zip = $scope.modelSearch.zipcode;
                    return d;
                },
                type: "get",
                dataSrc: function (json) {
                    if (json.success != false) {
                        $scope.lstdata = json.data;
                        return json.data;
                    } else {
                        return [];
                    }
                },
            })
                .withOption('processing', true) //for show progress bar
                .withOption('serverSide', true) // for server side processing
                .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                .withDisplayLength(10) // Page size
                .withOption('aaSorting', [0, 'desc'])
                .withOption('responsive', true)
                .withOption('createdRow', createdRow)
                .withOption('autoWidth', true)
                .withOption('initComplete', function () {
                    $scope.AdjustColumn();
                })
                // .withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
                .withOption('scrollY', 'auto');
        });

        //Reload Datatable
        $scope.reloadTableData = function (IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            vm.dtInstance.reloadData(callback, resetPaging);
            // $('#pharmacyTable').dataTable()._fnPageChange(0);
            $('#pharmacyTable').dataTable()._fnAjaxUpdate();
        }
        $scope.AdjustColumn = function () {

            vm.dtInstance.DataTable.columns.adjust();
        }
        $scope.onSearchChange = function ($event) {
            $event.stopPropagation();
        }
        vm.dtInstance = {};
        $(window).resize(function () {
            // console.log("$$$$$$$$$$$$$")
            $scope.AdjustColumn();
        });

        $scope.reloadData = function () { }

        function callback(json) { }

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }

        // function dateFormat(data, type, full, meta) {
        //     if (data != null && data != '') {
        //         return moment(data).format('MM-DD-YYYY')
        //     } else {
        //         return "";
        //     }

        // }
        function dateHtml(data, type, full, meta) {
            if (data != null && data != '') {
                var btns = '';
                btns += '<span><b> Last Invoice Date : </b>' + moment(full.last_invoice_date).format('MM-DD-YYYY hh:mm:ss a') + '</span><br>';
                btns += '<span><b> First Invoice Date : </b>' + moment(full.next_invoice_date).format('MM-DD-YYYY hh:mm:ss a') + '  </span><br>';
                return btns;
            } else {
                return "";
            }
        }


        function IsActiveHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';

            if (full.Approved == 1) {
                var method = "approvePharmacyByAdmin('" + full._id + "',0)";
                btns += '<md-button style="font-size: 20px;color: green" ng-click="' + method + '"> &#x2714;' +
                    '<md-tooltip md-visible="" md-direction="">DeActive</md-tooltip>' +
                    '</md-button>';
            } else {
                var method = "approvePharmacyByAdmin('" + full._id + "',1)";
                btns += '<md-button  style="font-size: 20px;color: red" ng-click="' + method + '">&#x2716;' +
                    '<md-tooltip md-visible="" md-direction="">Active</md-tooltip>' +
                    '</md-button>';

            }
            btns += '<div>';
            return btns;
        };


        function isverifiedHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if (data == 1) {
                btns += '<span style="font-size: 20px;color: green"> &#x2714; </span>'
            } else {
                btns += '<span style="font-size: 20px;color: red">&#x2716;</span>';
            }
            btns += '<div>';
            return btns;
        };

        function ActionHtml(data, type, full, meta) {
            var method = "EditDays('" + full._id + "','" + full.billing_period_days + "','" + full.payment_period_days + "')";
            var btns = '<div layout="row" layout-align="center">';

            btns += '<md-checkbox aria-label="assign" style="margin:0;" ng-disabled="devices[' + meta.row + '].isDisabled" ng-model="devices[' + meta.row + '].isChecked" ng-change="assignDevice(' + meta.row + ')"></md-checkbox>';

            btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                '<md-icon md-font-icon="icon-pencil"  class="orange-500-fg"></md-icon>' +
                '<md-tooltip md-visible="" md-direction="">Edit Billing Days</md-tooltip>' +
                '</md-button>';

            var method1 = "callToPharmacy('" + full._id + "')";
            btns += '<md-button class="edit-button md-icon-button" ng-click="' + method1 + '">' +
                '<md-icon md-font-icon="icon-cast" class="s20 brown-500-fg"></md-icon>' +
                '<md-tooltip md-visible="" md-direction="">Support</md-tooltip>' +
                '</md-button>';

            btns += '<div>';
            return btns;
            // var datavalue = '<div layout="row" layout-align="center"><md-checkbox aria-label="assign" ng-disabled="devices[' + meta.row + '].isDisabled" ng-model="devices[' + meta.row + '].isChecked" ng-change="assignDevice(' + meta.row + ')"></md-checkbox></div>';
            // return datavalue;

        }

        $scope.AddDays = function (modelData, form) {
            $http.post($rootScope.RoutePath + "hospital/updateBillingDaysAndPaymentDays", modelData).then(function (data) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent(data.data.message)
                        .position('top right')
                        .hideDelay(3000)
                );
                if (data.data.success) {
                    $scope.reloadTableData(true);
                    $scope.flag = false;
                }
            });
        }

        $scope.EditDays = function (id, data, data1) {
            $scope.flag = true;
            $scope.modelData = {
                _id: id,
                billing_period_days: parseInt(data),
                payment_period_days: parseInt(data1),
                token: $cookieStore.get('token'),
            }
        }
        $scope.ResetModel = function () {
            $scope.init();

            $scope.restForm();
        }

        $scope.restForm = function () {
            $scope.AddStatusForm.$setUntouched();
            $scope.AddStatusForm.$setPristine();
        }

        function NameHtml(data, type, full, meta) {

            var data = full.lastName + " " + full.firstName + " " + full.middleName;
            return data;
        };

        function SPOCNameHtml(data, type, full, meta) {

            var data = full.spoclastName + " " + full.spocfirstName + " " + full.spocmiddleName;
            return data;
        };

        function AddressHtml(data, type, full, meta) {
            var btns = '';
            if (full.address) {
                btns += full.address;
            }
            if (full.city) {
                btns += "," + full.city;
            }
            if (full.state) {
                btns += "," + full.state;
            }

            return btns;
        }

        $scope.toggle = function () {
            if (!$scope.flgforIcon) {
                $scope.flgforIcon = true;
            } else {
                $scope.flgforIcon = false;
            }

            $(function () {
                $(".showBtn").toggleClass("active");
                $(".ShowContentBox").slideToggle();
            });
        };

        $scope.init();

        $scope.ShowAnnouncementModel = function (ev) {
            $mdDialog.show({
                controller: 'HospitalAnnouncementController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Hospital/dialogs/HospitalAnnouncement/HospitalAnnouncement.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    // id: driver_id
                }
            })
        }

        $scope.callToPharmacy = function(hospitalId) {
            // console.log("hospital  ===== ", hospitalId);
            window.open($rootScope.VideoCallPath + "audio-call-admin/" + $rootScope.role_id + "/" + hospitalId, '_blank');
        }
    }


})();
(function () {
    'use strict';

    angular
        .module('app.Hospice', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.Hospice', {
                url: '/Hospice',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Hospice/Hospice.html',
                        controller: 'HospiceController as vm'
                    }
                },
                bodyClass: 'Hospice',
                ModuleName: 'Hospice'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/roles');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Roles',
        //     state: 'app.roles',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.Hospice')
        .controller('HospiceController', HospiceController);

    /** @ngInject */
    function HospiceController($http, $scope, $rootScope, $cookieStore, $mdToast, $mdDialog, DTOptionsBuilder, DTColumnBuilder, $compile) {
        var vm = this;
        vm.Reset = function () {
            $scope.reloadTableData();
        }

        $scope.init = function () {
            $scope.modelData = {
                _id: null,
                billing_period_days: null,
                payment_period_days: null,
                token: null,
            }
            $scope.initModel();
        }

        $scope.initModel = function () {
            $scope.modelSearch = {
                search: '',
                zip_code: '',
                verified: '',
                Approved: '',
            }
            $scope.selected = [];
        }

        $rootScope.role_id = $cookieStore.get('role_id');

        //Dynamic Pagging
        // $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
        $scope.FilterStatus = 1;
        $scope.dtColumns = [
            DTColumnBuilder.newColumn('signup_at').renderWith(NumberHtml).notSortable().withOption('width', '4%').withOption('class', 'text-center'),
            // DTColumnBuilder.newColumn(null).notSortable().renderWith(ImageHtml).withOption('width', '4%'),
            DTColumnBuilder.newColumn('hospiceName'),
            DTColumnBuilder.newColumn('first_name').renderWith(NameHtml).withOption('width', '12%'),
            DTColumnBuilder.newColumn('email'),
            DTColumnBuilder.newColumn('spocTelephone'),
            DTColumnBuilder.newColumn('address').renderWith(AddressHtml),
            DTColumnBuilder.newColumn('zip'),
            DTColumnBuilder.newColumn('signup_at').renderWith(dateFormat),
            DTColumnBuilder.newColumn('last_invoice_date').renderWith(dateHtml),
            DTColumnBuilder.newColumn('billing_period_days').withOption('class', 'text-center'),
            DTColumnBuilder.newColumn('payment_period_days').withOption('class', 'text-center'),
            DTColumnBuilder.newColumn('verified').renderWith(isverifiedHtml),
            DTColumnBuilder.newColumn('Approved').renderWith(IsActiveHtml),
            DTColumnBuilder.newColumn(null).notSortable().renderWith(ActionHtml).withOption('width', '5%').withOption('class', 'text-center')
        ]
        $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
            url: $rootScope.RoutePath + "hospice/getAllDynamicHospice",
            data: function (d) {
                d.search = $scope.modelSearch.search;
                d.zip_code = $scope.modelSearch.zip_code;
                d.verified = $scope.modelSearch.verified;
                d.Approved = $scope.modelSearch.Approved;
                return d;
            },
            type: "get",
            dataSrc: function (json) {
                if (json.success != false) {
                    $scope.lstdata = json.data;
                    return json.data;
                } else {
                    return [];
                }
            },
        })
            .withOption('processing', true) //for show progress bar
            .withOption('serverSide', true) // for server side processing
            .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
            .withDisplayLength(25) // Page size
            .withOption('aaSorting', [0, 'desc'])
            .withOption('responsive', true)
            .withOption('createdRow', createdRow)
            .withOption('autoWidth', true)
            .withOption('initComplete', function () {
                $scope.AdjustColumn();
            })
            // .withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
            .withOption('scrollY', 'auto');
        // });



        vm.dtInstance = {};
        vm.dtInstance1 = {};
        $scope.dtInstance = {};
        $(window).resize(function () {
            $scope.AdjustColumn();
        });

        $scope.AdjustColumn = function () {
            vm.dtInstance.DataTable.columns.adjust();
        }
        //Reload Datatable
        $scope.reloadTableData = function (IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            vm.dtInstance.reloadData(callback, resetPaging);
            $('#pharmacyTable').dataTable()._fnPageChange(0);
            $('#pharmacyTable').dataTable()._fnAjaxUpdate();
        }

        $scope.reloadData = function () { }

        function callback(json) { }

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }

        function dateFormat(data, type, full, meta) {
            if (data != null && data != '') {
                return moment(data).format('MM-DD-YYYY hh:mm:ss a')
            } else {
                return "";
            }
        }

        function dateHtml(data, type, full, meta) {
            if (data != null && data != '') {
                var btns = '';
                btns += '<span><b> Last Invoice Date : </b>' + moment(full.last_invoice_date).format('MM-DD-YYYY hh:mm:ss a') + '</span><br>';
                btns += '<span><b> First Invoice Date : </b>' + moment(full.next_invoice_date).format('MM-DD-YYYY hh:mm:ss a') + '  </span><br>';
                return btns;
            } else {
                return "-";
            }
        }

        function IsActiveHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';

            if (full.verified == 1) {
                var method = "approvePharmacyByAdmin('" + full._id + "',0)";
                btns += '<md-button style="font-size: 20px;color: green" ng-click="' + method + '"> &#x2714;' +
                    '<md-tooltip md-visible="" md-direction="">DeActive</md-tooltip>' +
                    '</md-button>';
            } else {
                var method = "approvePharmacyByAdmin('" + full._id + "',1)";
                btns += '<md-button  style="font-size: 20px;color: red" ng-click="' + method + '">&#x2716;' +
                    '<md-tooltip md-visible="" md-direction="">Active</md-tooltip>' +
                    '</md-button>';

            }
            btns += '<div>';
            return btns;
        };


        function isverifiedHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if (data == 1) {
                btns += '<span style="font-size: 20px;color: green;"> &#x2714; </span>'
            } else {
                btns += '<span style="font-size: 20px;color: red;">&#x2716;</span>';
            }
            btns += '<div>';
            return btns;
        };

        function NameHtml(data, type, full, meta) {
            console.log('full: ', full);

            var data = full.lastName + " " + full.firstName + " " + full.middleName;
            return data;
        };

        function AddressHtml(data, type, full, meta) {
            var btns = '';
            if (full.address) {
                btns += full.address;
            }
            if (full.city) {
                btns += "," + full.city;
            }
            if (full.state) {
                btns += "," + full.state;
            }

            return btns;
        }

        function ActionHtml(data, type, full, meta) {
            // // var model = 'selected[' + full._id + '].isChecked';
            // var datavalue = '';
            // // datavalue = '<div layout="row" layout-align="center"><md-checkbox aria-label="assign"  ng-model="' + model + '"></md-checkbox></div>';
            // return datavalue;

            // var btns = '<div layout="row" layout-align="center">'; 
            var btns = '<div layout="row" layout-align="center" class="res-btn">';
            var method = "EditDays('" + full._id + "','" + full.billing_period_days + "','" + full.payment_period_days + "')";
            btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                '<md-icon md-font-icon="icon-calendar"  class="s22 orange-500-fg"></md-icon>' +
                '<md-tooltip md-visible="" md-direction="">Update Billing and Payment Days</md-tooltip>' +
                '</md-button>';


            var method1 = "callToPharmacy('" + full._id + "')";
            btns += '<md-button class="edit-button md-icon-button" ng-click="' + method1 + '">' +
                '<md-icon md-font-icon="icon-cast" class="s20 brown-500-fg"></md-icon>' +
                '<md-tooltip md-visible="" md-direction="">Support</md-tooltip>' +
                '</md-button>';

            btns += '<div>';
            return btns;
        }

        $scope.EditDays = function (id, data, data1) {
            // console.log(id, data, data1)
            $mdDialog.show({
                controller: 'pharmacyEditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Pharmacy/dialogs/pharmacyEdit/pharmacyEdit.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    _id: id,
                    billing_period_days: parseInt(data),
                    payment_period_days: parseInt(data1),
                    token: $cookieStore.get('token'),
                }
            })

        }

        $scope.callToPharmacy = function (pharmacyId) {
            // console.log("pharmacy  ===== ", pharmacyId);
            window.open($rootScope.VideoCallPath + "audio-call-admin/" + $rootScope.role_id + "/" + pharmacyId, '_blank');
        }

        $scope.ResetModel = function () {
            $scope.init();

            $scope.restForm();
        }

        $scope.restForm = function () {
            $scope.AddStatusForm.$setUntouched();
            $scope.AddStatusForm.$setPristine();
        }

        $scope.approvePharmacyByAdmin = function (id, Approved) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to approve this pharmacy?')
                .textContent('')
                .ariaLabel('Lucky day')
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                var obj = {
                    _id: id,
                    Approved: Approved
                }
                $http.post($rootScope.RoutePath + "pharmacy/approvePharmacyByAdmin", obj).then(function (data) {

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    );
                    if (data.data.success) {
                        $scope.reloadTableData(true)
                    }
                });
            })
        }

        $scope.toggle = function () {
            if (!$scope.flgforIcon) {
                $scope.flgforIcon = true;
            } else {
                $scope.flgforIcon = false;
            }

            $(function () {
                $(".showBtn").toggleClass("active");
                $(".ShowContentBox").slideToggle();
            });
        };

        $scope.init();

        $scope.ShowAnnouncementModel = function (ev) {
            $mdDialog.show({
                controller: 'pharmacyAnnouncementController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Pharmacy/dialogs/pharmacyAnnouncement/pharmacyAnnouncement.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    // id: driver_id
                }
            })
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('app.Forgotpassword', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.Forgotpassword', {
            url: '/app/Forgotpassword',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.Forgotpassword': {
                    templateUrl: 'app/main/Forgotpassword/Forgotpassword.html',
                    controller: 'ForgotpasswordController as vm'
                }
            },
            bodyClass: 'Forgotpassword',
            ModuleName: 'Forgotpassword'
        });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/Forgotpassword');

        // Navigation
        // msNavigationServiceProvider.saveItem('Demo.login', {
        //     title : 'Authentication',
        //     icon  : 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Demo.Forgotpassword', {
        //     title: 'Login',
        //     state: 'app.Forgotpassword',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.Forgotpassword')
        .controller('ForgotpasswordController', ForgotpasswordController);

    /** @ngInject */
    function ForgotpasswordController($scope, $state, $rootScope, $http, $cookieStore, $mdDialog, $document, $mdToast, $timeout) {
        $('.logo').css('background-image', 'url(./assets/images/final-logo.png)');

        // $('.logo').css('background-image', 'url(' + localStorage.getItem('Logo') + ')');
        $scope.init = function () {
            $scope.model = {
                email: '',
            }
        }
        $scope.ResetPassword = function () {
            var params = {
                email: $scope.model.email
            }
            $http.post($rootScope.RoutePath + "account/forgot_password", params).then(function (response) {
                if (response.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(response.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    );
                    $scope.email = '';
                    $timeout(function () {
                        $state.go('app.login', {
                            cache: false
                        });
                    }, 1500);

                } else {
                    if (response.data.data == 'TOKEN') {
                        $cookieStore.remove('UserName');
                        $cookieStore.remove('token');
                        $state.go('app.login', {
                            cache: false
                        });
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(response.data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                    }
                }
            });
        }

        $scope.init();
    }
})();


(function () {
    'use strict';

    angular
        .module('app.DriverApplication')
        .controller('DriverApplicationController', DriverApplicationController)


    /** @ngInject */
    function DriverApplicationController($http, $scope, $rootScope, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {

        var vm = this;
        $rootScope.appId = localStorage.getItem('appId');
        $rootScope.UserRoles = localStorage.getItem('UserRoles');
        $scope.init = function () {
            $scope.modelSearch = {
                search: ''
            }
            $scope.advanceSearch = {
                status: null,
            }
        }


        //Dynamic Pagging
        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
            $scope.FilterStatus = 1;
            $scope.dtColumns = [
                DTColumnBuilder.newColumn('signup_at').renderWith(NumberHtml).notSortable().withOption('width', '4%').withOption('class', 'text-center'),
                // DTColumnBuilder.newColumn(null).notSortable().renderWith(ImageHtml).withOption('width', '4%'),
                DTColumnBuilder.newColumn('first_name').notSortable().renderWith(NameHtml).withOption('width', '12%'),
                DTColumnBuilder.newColumn('dob').renderWith(dateFormat),
                DTColumnBuilder.newColumn('Social_security_no').notSortable(),
                DTColumnBuilder.newColumn('current_address').notSortable().renderWith(addressHtml),
                DTColumnBuilder.newColumn('previous_address').notSortable().renderWith(preaddressHtml),
                DTColumnBuilder.newColumn('Education').notSortable(),
                DTColumnBuilder.newColumn('front_side').renderWith(LicenseImageHtml),
                DTColumnBuilder.newColumn('applicant_name').renderWith(columnNameHtml).notSortable(),
                DTColumnBuilder.newColumn('applicant_email').notSortable(),
                DTColumnBuilder.newColumn('applicant_signature').renderWith(ImageHtml).withOption('class', 'text-center').notSortable(),
                DTColumnBuilder.newColumn('drivers[0].email'),
                DTColumnBuilder.newColumn('drivers[0].mobile_number'),
                DTColumnBuilder.newColumn('drivers[0].approval').renderWith(driverStatusHtml).notSortable(),
                DTColumnBuilder.newColumn(null).notSortable().renderWith(actionsHtml).withOption('width', '5%').withOption('class', 'text-center')
            ]
            $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                url: $rootScope.RoutePath + "driverapplication/getAllDynamicDriverApplication",
                data: function (d) {
                    d.search = $scope.modelSearch.search;
                    d.status = $scope.advanceSearch.status;
                    return d;
                },
                type: "get",
                dataSrc: function (json) {
                    if (json.success != false) {
                        $scope.lstdata = json.data;
                        return json.data;
                    } else {
                        return [];
                    }
                },
            })
                .withOption('processing', true) //for show progress bar
                .withOption('serverSide', true) // for server side processing
                .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                .withDisplayLength(10) // Page size
                .withOption('aaSorting', [0, 'desc'])
                .withOption('responsive', true)
                .withOption('autoWidth', true)
                .withOption('initComplete', function () {
                    $scope.AdjustColumn();
                })
                .withOption('createdRow', createdRow)
                // .withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
                .withOption('scrollY', 'auto');
        });



        vm.dtInstance = {};
        vm.dtInstance1 = {};
        vm.dtInstance = {};
        $(window).resize(function () {
            $scope.AdjustColumn();
        });
        $scope.AdjustColumn = function () {

            vm.dtInstance.DataTable.columns.adjust();
        }
        //Reload Datatable
        $scope.reloadTableData = function (IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            vm.dtInstance.reloadData(callback, resetPaging);
            $('#driverApplicationTable').dataTable()._fnPageChange(0);
            $('#driverApplicationTable').dataTable()._fnAjaxUpdate();
        }

        $scope.reloadData = function () { }

        function callback(json) { }

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }

        function dateFormat(data, type, full, meta) {
            if (data != null && data != '') {
                return moment(data).format('MM-DD-YYYY')
            } else {
                return "";
            }

        }

        function addressHtml(data, type, full, meta) {
            if (data != null && data != '') {
                return data;
            } else {
                var btns = '';
                if (full.street != null) {
                    btns += '<span>' + full.street;
                }
                if (full.city != null) {
                    btns += ' , ' + full.city;
                }
                if (full.state != null) {
                    btns += ' , ' + full.state;
                }
                if (full.zip != null) {
                    btns += ' , ' + full.zip + '</span><br>';
                }
                return btns;
            }

        }

        function preaddressHtml(data, type, full, meta) {
            if (data != null && data != '') {
                return data;
            } else {
                var btns = '';
                if (full.street1 != null) {
                    btns += '<span>' + full.street1;
                }
                if (full.city1 != null) {
                    btns += ' , ' + full.city1;
                }
                if (full.state1 != null) {
                    btns += ' , ' + full.state1;
                }
                if (full.zip1 != null) {
                    btns += ' , ' + full.zip1 + '</span><br>';
                }
                else {
                    btns += ' - ';
                }
                return btns;
            }
        }

        function actionsHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if (full.drivers != [] && full.drivers != null && full.drivers.length != 0) {
                if (full.drivers[0].approval == 1) {
                    var method = "approveDriverApplication('" + full.driver_id + "')";
                    btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                        '<md-icon md-font-icon="icon-checkbox-marked-circle"  class="green-500-fg"></md-icon>' +
                        '<md-tooltip md-visible="" md-direction="">Approve Application</md-tooltip>' +
                        '</md-button>';
                }
                // if (full.drivers[0].approval == 1 || full.drivers[0].approval == 2) {
                var method = "ShowApplicationModal('" + full.driver_id + "','" + full.current_address + "','" + full.previous_address + "')";
                btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                    '<md-icon md-font-icon="icon-receipt"  class="orange-500-fg"></md-icon>' +
                    '<md-tooltip md-visible="" md-direction="">Driver Application</md-tooltip>' +
                    '</md-button>';
                // }
            } else {
                return '-';
            }
            btns += '<div>';
            return btns;
        };

        function NameHtml(data, type, full, meta) {

            var data = full.last_name + " " + full.first_name + " " + full.middle_name;
            return data;
        };



        function driverStatusHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if (data == 0) {
                btns += '<span style="font-size: 15px;background-color: green;color:white;padding:5px;">Pending</span>';
            } else if (data == 1) {
                btns += '<span  style="font-size: 15px;background-color: orange;color:white;padding:5px;">Submitted</span>';
            } else if (data == 2) {
                btns += '<span  style="font-size: 15px;background-color: blue;color:white;padding:5px;">Approved</span>';
            }
            btns += '<div>';
            return btns;
        }

        function columnNameHtml(data, type, full, meta) {
            if (data) {
                return data;
            } else {
                return '';
            }
        }

        function ImageHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if (data != "") {
                btns += '<a href="' + data + '" target="_blank"><img ng-src="' + data + '" err-src="assets/images/no-image.png" height="50px" width="50px"></a>';
            } else if (data == "") {
                btns += '<img ng-src="assets/images/no-image.png" height="50px" width="50px">';
            }
            btns += '</div>';
            return btns;
        }

        function LicenseImageHtml(data, type, full, meta) {

            var btns = '<div layout="row" layout-align="center">';
            if (full.front_side != null) {
                btns += '<a href="' + full.front_side + '" target="_blank"><img ng-src="' + full.front_side + '" err-src="assets/images/no-image.png" height="50px" width="50px" style="padding:2px"></a>';
            } else {
                btns += '<img ng-src="' + full.front_side + '" err-src="assets/images/no-image.png" height="50px" width="50px" style="padding:2px">';
            }
            if (full.back_side != null) {
                btns += '<a href="' + full.back_side + '" target="_blank"><img ng-src="' + full.back_side + '" err-src="assets/images/no-image.png" height="50px" width="50px"  style="padding:2px"></a>';
            } else {
                btns += '<img ng-src="' + full.back_side + '" err-src="assets/images/no-image.png" height="50px" width="50px"  style="padding:2px">';
            }
            btns += '</div>';
            return btns;
        }

        $scope.ShowApplicationModal = function (driver_id, current_address, previous_address) {
            var obj = _.findWhere($scope.lstdata, { driver_id: driver_id });
            $mdDialog.show({
                controller: 'ApplicationDetailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/DriverApplication/dialogs/ApplicationDetail.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    id: driver_id,
                    current_address: current_address,
                    previous_address: previous_address,
                    objData: obj
                }
            })
        }

        $scope.approveDriverApplication = function (id) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to Approve this driver application?')
                .textContent('')
                .ariaLabel('Lucky day')
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                var obj = {
                    _id: id,
                    approval: 2
                }
                $http.post($rootScope.RoutePath + "driverapplication/approveDriverApplication", obj).then(function (data) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    );
                    if (data.data.success) {
                        $scope.reloadTableData();
                    }
                });
            })
        }
        $scope.toggle = function () {
            if (!$scope.flgforIcon) {
                $scope.flgforIcon = true;
            } else {
                $scope.flgforIcon = false;
            }

            $(function () {
                $(".showBtn").toggleClass("active");
                $(".ShowContentBox").slideToggle();
            });
        };

        $scope.init();
    }

})();
(function() {
    'use strict';

    angular
        .module('app.Driver')
        .controller('DriverController', DriverController)


    /** @ngInject */
    function DriverController($http, $scope, $rootScope, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {

        var vm = this;
        $rootScope.appId = localStorage.getItem('appId');
        $rootScope.UserRoles = localStorage.getItem('UserRoles');
        $scope.init = function() {
            $scope.modelSearch = {
                search: ''
            }
            $scope.advanceSearch = {
                status: null,
            }
        }


        //Dynamic Pagging
        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function(response) {
            $scope.FilterStatus = 1;
            $scope.dtColumns = [
                DTColumnBuilder.newColumn('signup_at').renderWith(NumberHtml).notSortable().withOption('width', '4%').withOption('class', 'text-center'),
                // DTColumnBuilder.newColumn(null).notSortable().renderWith(ImageHtml).withOption('width', '4%'),
                DTColumnBuilder.newColumn('first_name').renderWith(NameHtml).withOption('width', '12%'),
                DTColumnBuilder.newColumn('email').withOption('width', '13%'),
                DTColumnBuilder.newColumn('gender').renderWith(columnNameHtml),
                DTColumnBuilder.newColumn('dob').renderWith(dateFormat),
                DTColumnBuilder.newColumn('mobile_number').renderWith(columnNameHtml),
                DTColumnBuilder.newColumn('address').renderWith(addressHtml).withOption('width', '20%'),
                DTColumnBuilder.newColumn('vehicle_license').renderWith(columnNameHtml),
                DTColumnBuilder.newColumn('vehicle_make').renderWith(columnNameHtml),
                DTColumnBuilder.newColumn('vehicle_year').renderWith(columnNameHtml),
                DTColumnBuilder.newColumn('vehicle_color').renderWith(columnNameHtml),
                DTColumnBuilder.newColumn('vehicle_ownorrent').renderWith(vehicleOwnorrentHtml),
                DTColumnBuilder.newColumn('driving_license').renderWith(columnNameHtml),
                DTColumnBuilder.newColumn('dlexpiry_date').renderWith(dateFormat),
                DTColumnBuilder.newColumn('payment_mode').renderWith(paymentModeHtml),
                DTColumnBuilder.newColumn('registration_id').renderWith(paymentRegIdHtml),
                DTColumnBuilder.newColumn('account_number').renderWith(accountNumberHtml),
                DTColumnBuilder.newColumn('routing_number').renderWith(routingNumberHtml),
                DTColumnBuilder.newColumn('verified').renderWith(verifiedHtml),
                DTColumnBuilder.newColumn('profile_status').renderWith(profileStatusHtml),
                DTColumnBuilder.newColumn('approval').renderWith(driverStatusHtml),
                DTColumnBuilder.newColumn(null).notSortable().renderWith(actionsHtml).withOption('width', '5%').withOption('class', 'text-center')
            ]
            $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                    url: $rootScope.RoutePath + "driver/getAllDynamicDriver",
                    data: function(d) {
                        d.search = $scope.modelSearch.search;
                        d.status = $scope.advanceSearch.status;
                        return d;
                    },
                    type: "get",
                    dataSrc: function(json) {
                        if (json.success != false) {
                            $scope.lstdata = json.data;
                            return json.data;
                        } else {
                            return [];
                        }
                    },
                })
                .withOption('processing', true) //for show progress bar
                .withOption('serverSide', true) // for server side processing
                .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                .withDisplayLength(10) // Page size
                .withOption('aaSorting', [0, 'desc'])
                .withOption('responsive', true)
                .withOption('autoWidth', true)
                .withOption('initComplete', function() {
                    $scope.AdjustColumn();
                })
                .withOption('createdRow', createdRow)
                // .withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
                .withOption('scrollY', 'auto');
        });



        vm.dtInstance = {};
        vm.dtInstance1 = {};
        vm.dtInstance = {};
        $(window).resize(function() {
            $scope.AdjustColumn();
        });
        $scope.AdjustColumn = function() {

                vm.dtInstance.DataTable.columns.adjust();
            }
            //Reload Datatable
        $scope.reloadTableData = function(IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            vm.dtInstance.reloadData(callback, resetPaging);
            $('#Drivertable').dataTable()._fnPageChange(0);
            $('#Drivertable').dataTable()._fnAjaxUpdate();
        }

        $scope.reloadData = function() {}

        function callback(json) {}

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }

        function dateFormat(data, type, full, meta) {
            if (data != null && data != '') {
                return moment(data).format('MM-DD-YYYY')
            } else {
                return "";
            }

        }

        function actionsHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            // if (full.approval != 0) {
            var method = "ShowApplicationModal('" + full._id + "','" + full.address + "')";
            btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                '<md-icon md-font-icon="icon-receipt"  class="orange-500-fg"></md-icon>' +
                '<md-tooltip md-visible="" md-direction="">Driver Application</md-tooltip>' +
                '</md-button>';
            // }
            btns += '<div>';
            return btns;
        };

        function addressHtml(data, type, full, meta) {
            var btns = '';
            if (full.address != null && full.address != undefined) {
                btns += full.address + ' , '
            }
            if (full.state != null && full.state != undefined) {
                btns += full.state + ' , ';
            }
            if (full.city != null && full.city != undefined) {
                btns += full.city + ' , ';
            }
            if (full.zip_code != null && full.zip_code != undefined) {
                btns += full.zip_code;
            }

            if ((full.address == null && full.address == undefined) && (full.state == null && full.state == undefined) && (full.city == null && full.city == undefined) && (full.zip_code == null && full.zip_code == undefined)) {
                return 'N/A';
            }

            return btns;
        }

        function NameHtml(data, type, full, meta) {
            var middle_name_ = full.middle_name?full.middle_name:""
            var data = full.last_name + " " + full.first_name + " " + middle_name_ ;
            return data;
        };

        function verifiedHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if (data == 1) {
                btns += '<md-button style="font-size: 10px;background-color: green;color:white;padding:5px;"> &#x2714;' +
                    '</md-button>';
            } else {
                btns += '<md-button style="font-size: 10px;background-color: red;color:white;padding:5px;" >&#x2716;' +
                    '</md-button>';
            }
            btns += '<div>';
            return btns;
        }


        function profileStatusHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if (data == 1) {
                btns += '<md-button  style="font-size: 15px;background-color: green;color:white;padding:5px;">Pending' +
                    '</md-button>';
            } else {
                btns += '<md-button  style="font-size: 15px;background-color: blue;color:white;padding:5px;" >Approve' +
                    '</md-button>';
            }

            btns += '<div>';
            return btns;
        }

        function profileStatusHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if (data == 1) {
                btns += '<span style="font-size: 15px;background-color: green;color:white;padding:5px;">Approve</span>';
            } else {
                btns += '<span  style="font-size: 15px;background-color: blue;color:white;padding:5px;" >Pending</span>';
            }
            btns += '<div>';
            return btns;
        }

        function driverStatusHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if (data == 0) {
                btns += '<span style="font-size: 15px;background-color: green;color:white;padding:5px;">Pending</span>';
            } else if (data == 1) {
                btns += '<span  style="font-size: 15px;background-color: orange;color:white;padding:5px;">Submitted</span>';
            } else if (data == 2) {
                btns += '<span  style="font-size: 15px;background-color: blue;color:white;padding:5px;">Approved</span>';
            }
            btns += '<div>';
            return btns;
        }

        function vehicleOwnorrentHtml(data, type, full, meta) {
            if (data) {
                return 'Own';
            } else {
                return 'Rent';
            }
        }

        function paymentModeHtml(data, type, full, meta) {
            if (data) {
                return data;
            } else {
                return 'N/A';
            }
        }

        function paymentRegIdHtml(data, type, full, meta) {
            if (data) {
                return data;
            } else {
                return 'N/A';
            }
        }
        function routingNumberHtml(data, type, full, meta) {
            if (data) {
                return data;
            } else {
                return 'N/A';
            }
        }

        function accountNumberHtml(data, type, full, meta) {
            if (data) {
                return data;
            } else {
                return 'N/A';
            }
        }
        

        function columnNameHtml(data, type, full, meta) {
            if (data) {
                return data;
            } else {
                return 'N/A';
            }
        }

        $scope.ShowApplicationModal = function(driver_id, current_address) {
            $mdDialog.show({
                controller: 'DriverApplicationDetailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Driver/dialogs/DriverApplicationDetail/DriverApplicationDetail.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    id: driver_id,
                    current_address: current_address,
                }
            })
        }
        $scope.toggle = function() {
            if (!$scope.flgforIcon) {
                $scope.flgforIcon = true;
            } else {
                $scope.flgforIcon = false;
            }

            $(function() {
                $(".showBtn").toggleClass("active");
                $(".ShowContentBox").slideToggle();
            });
        };

        $scope.init();
    }

})();
(function () {
    'use strict';

    angular
        .module('app.DemandOrder')
        .controller('DemandOrderController', DemandOrderController);

    /** @ngInject */
    function DemandOrderController($http, $scope, $rootScope, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {
        var vm = this;
        $scope.init = function () {
            $scope.model = {
                Search: '',
                pharmacy_id: ''
            }

            // var date = new Date();
            // var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

            $scope.modelSearch = {
                search: '',
                order_status: '',
                pharmacy_name: '',
                hospital_name: '',
                patient_firstname: '',
                StartDate: '',
                EndDate: '',
                // Lyft
                lyft_order: ''
                // StartDate: firstDay,
                // EndDate: date
            }


            $scope.searchtype = 'demand';
            $scope.role = $cookieStore.get("UserRoles")
            $scope.getAllPharmacy();
            $scope.getAllPatient();
            $scope.getHospital();
            $scope.flaglink = 3;
           


        }

        $scope.GetSerch = function (Search) {
            $scope.model.Search = Search;
            $scope.GetAllDynamicHospital(true);
        }
        $scope.searchtype1 = function (type) {
            $scope.searchtype = type
            $scope.GetAllDynamicHospital(true);
        }
        $scope.onSearchChange = function ($event) {
            $event.stopPropagation();
        }
        $scope.getAllPharmacy = function () {

            $http.get($rootScope.RoutePath + "pharmacy/getAllPharmacy").then(function (data) {
                $scope.lstPharmacy = data.data.data;
            });
        };
        $scope.getHospital = function () {

            $http.get($rootScope.RoutePath + "hospital/getAllHospital").then(function (data) {
                $scope.lstHospitalname = data.data.data;
            });
        };
        $scope.getAllPatient = function () {

            $http.get($rootScope.RoutePath + "order/getAllPatient").then(function (data) {
                $scope.lstPatient = data.data.data;
                // console.log($scope.lstPatient)
            });
        };
        //Dynamic Pagging for Hospital
        //Reload Datatable
        $scope.FilterStatus = '';
        try {
            $scope.dtColumnsHospital = [
                DTColumnBuilder.newColumn('created_on').renderWith(NumberHtml).notSortable(),
                DTColumnBuilder.newColumn('pharmacy_name').renderWith(currentPharmacyHtml),
                DTColumnBuilder.newColumn('hospital_name').renderWith(HospitalInfoHtml),
                DTColumnBuilder.newColumn('patient_firstname').renderWith(patientInfoHtml),
                // DTColumnBuilder.newColumn('patient_lastname').renderWith(NAHtml),
                // DTColumnBuilder.newColumn('patient_dob').renderWith(NAHtml),
                DTColumnBuilder.newColumn('order_id').renderWith(orderHtml),
                DTColumnBuilder.newColumn('delivery_date').renderWith(DeliverdDateHtml),
                DTColumnBuilder.newColumn('created_on').renderWith(DateHtml),
                DTColumnBuilder.newColumn('pharmacy_charge').renderWith(NAHtml),
                DTColumnBuilder.newColumn('order_status').renderWith(StatusHtml).notSortable().withOption('class', 'dt-body-center'),
                DTColumnBuilder.newColumn(null).notSortable().renderWith(actionsHtml).withOption('width', '5%').withOption('class', 'text-center'),
                DTColumnBuilder.newColumn('lyft_order').renderWith(checkLyftOrderHtml).notSortable().withOption('class', 'dt-body-center')
    
            ]
        }
        catch (error) {
            console.log(error)
        }
       

        // console.log( $cookieStore.get("UserRoles"), $scope.dtColumnsHospital )
      
        $http.get($rootScope.RoutePath + "userpermission/CheckRightsbyPage", {
            params: {
                    tablename: "demand"                
            }
        }).then(function (data) {
            $scope.demandView = $rootScope.demandViewAccess
            if (data.data.success == true) {
                
                $scope.demandView = true
                var objpermission = data.data.data;
                $rootScope.FlgAddedAccess = objpermission.Added;
                $rootScope.FlgAddedEditlocal = objpermission.Added;
                $rootScope.FlgModifiedAccess = objpermission.Modified;
                $rootScope.FlgDeletedAccess = objpermission.Deleted;
            } else {
                $rootScope.FlgAddedAccess = false;
                $rootScope.FlgAddedEditlocal = false;
                $rootScope.FlgModifiedAccess = false;
                $rootScope.FlgDeletedAccess = false;
                $scope.demandView = false
            }
        })

        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {

            $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                url: $rootScope.RoutePath + "order/getAllOrder",
                data: function (d) {
                    d.type = $scope.searchtype;
                    d.order_status = $scope.modelSearch.order_status;
                    d.pharmacy_name = $scope.modelSearch.pharmacy_name;
                    d.hospital_name = $scope.modelSearch.hospital_name;
                    d.patient_firstname = $scope.modelSearch.patient_firstname;
                    d.Search = $scope.model.Search;
                    d.StartDate = $scope.modelSearch.StartDate;
                    d.EndDate = $scope.modelSearch.EndDate;
                    // For lyft
                    d.lyft_order = $scope.modelSearch.lyft_order
                    return d;
                },
                type: "get",
                dataSrc: function (json) {
                    if (json.success != false) {
                        $scope.lstHospital = json.data;
                        // console.log($scope.lstHospital)
                        return json.data;

                    } else {
                        return [];
                    }
                }
            })

                .withOption('processing', true) //for show progress bar
                .withOption('serverSide', true) // for server side processing
                .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                .withDisplayLength(10) // Page size
                .withOption('aaSorting', [0, 'desc'])
                .withOption('responsive', true)
                .withOption('createdRow', createdRow)
                .withOption('autoWidth', true)
                .withOption('initComplete', function () {
                    $scope.AdjustColumn();
                })
                .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
                .withOption('scrollY', 'auto');
        });

        // $scope.AdvanceSearch = function (o) {
        //     console.log(o)



        //     $scope.GetAllDynamicHospital(true)
        // }
        vm.dtInstanceHospital = {};
        $(window).resize(function () {
            // console.log("$$$$$$$$$$$$$")
            $scope.AdjustColumn();
        });
        $scope.AdjustColumn = function () {

            vm.dtInstanceHospital.DataTable.columns.adjust();
        }
        $scope.GetAllDynamicHospital = function (IsUpdate) {
            // $scope.searchtype = searchtype
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            vm.dtInstanceHospital.reloadData(callback, resetPaging);
            $('#Hospital').dataTable()._fnAjaxUpdate();

        }

        $(window).resize(function () {
            // console.log("$$$$$$$$$$$$$")
            $scope.AdjustColumn();
        });
        function currentPharmacyHtml(data, type, full, meta) {
            var btns = '';

            if (full.pharmacy_name != null && full.pharmacy_name != undefined) {
                btns += '<span><b>Pharmacy Name : </b>' + full.pharmacy_name + '</span><br>';
            }
            // if (full.pharmacy_charge != null && full.pharmacy_charge != undefined) {
            //     btns += '<span><b> Charge ($): </b>' + full.pharmacy_charge + '  </span><br>';
            // }
            if (full.pharmacy_latitude != null && full.pharmacy_latitude != undefined) {
                btns += '<span><b> Latitude : </b>' + full.pharmacy_latitude + '</span><br>';
            } if (full.pharmacy_longitude != null && full.pharmacy_longitude != undefined) {
                btns += '<span><b> Logitude : </b>' + full.pharmacy_longitude + '</span><br>';
            } if (full.pharmacy_address != null && full.pharmacy_address != undefined) {
                btns += '<span><b> Address : </b>' + full.pharmacy_address + '  </span><br>';
            } if (full.pharmacy_payment_status != null && full.pharmacy_payment_status != undefined) {
                btns += '<span><b> Payment Status : </b>' + full.pharmacy_payment_status + '  </span><br>';
            } if ((full.pharmacy_name == null && full.pharmacy_name == undefined) && (full.pharmacy_charge == null && full.pharmacy_charge == undefined) &&
                (full.pharmacy_latitude == null && full.pharmacy_latitude == undefined) && (full.pharmacy_longitude == null && full.pharmacy_longitude == undefined) &&
                (full.pharmacy_address == null && full.pharmacy_address == undefined) && (full.pharmacy_payment_status == null && full.pharmacy_payment_status == undefined)) {
                return 'N/A';
            }
            return btns;
        };

        function HospitalInfoHtml(data, type, full, meta) {
            var btns = '';
            if (full.hospital_name != null && full.hospital_name != undefined) {
                btns += '<span><b> Name : </b>' + full.hospital_name + '</span><br>';
            } if (full.hospital_number != null && full.hospital_number != undefined) {
                btns += '<span><b> Hospital Number : </b>' + full.hospital_number + '  </span><br>';
            } if (full.hospital_instructions != null && full.hospital_instructions != undefined && full.hospital_instructions != '') {
                btns += '<span><b> Hospital Instructions : </b>' + full.hospital_instructions + '</span><br>';
            } if ((full.hospital_name == null && full.hospital_name == undefined) && (full.hospital_number == null && full.hospital_number == undefined) && (full.hospital_instructions == null && full.hospital_instructions == undefined || full.hospital_instructions == '')) {
                btns += '-'
            }
            return btns;
        }
        function orderHtml(data, type, full, meta) {
            var btns = '';
            if (full.order_id != null && full.order_id != undefined) {
                btns += '<span><b> Order Id : </b>' + full.order_id + '</span><br>';
            } if (full.ordering_personnel != null && full.ordering_personnel != undefined) {
                btns += '<span><b> Order Person Name : </b>' + full.ordering_personnel + '  </span><br>';
            } if (full.ordering_personnel_role != null && full.ordering_personnel_role != undefined) {
                btns += '<span><b> Order Person Role : </b>' + full.ordering_personnel_role + '</span><br>';
            } if ((full.order_id == null && full.order_id == undefined) && (full.ordering_personnel == null && full.ordering_personnel == undefined) && (full.ordering_personnel_role == null && full.ordering_personnel_role == undefined)) {
                return 'N/A';
            }
            // btns += '<span><b> Order Status : </b>' + full.order_status + '</span><br>';

            return btns;

        }
        // by Afzan for lyft order 
        function checkLyftOrderHtml(data, type, full, meta) {
            var btns = '';
            if (full.order_id != null && full.order_id != undefined) {
                // btns += '<span>' + full. + '</span><br>';
                if (full.lyft_delivery_order_id != null && full.lyft_delivery_order_id != undefined) {
                    btns += "<span>" + '<br><b> Doordash Order id : </b>' + full.lyft_delivery_order_id + '  </span><br>';
                } else {
                    btns += "No"
                }
            }
            // btns += '<span><b> Order Status : </b>' + full.order_status + '</span><br>';

            return btns;

        }
        function patientInfoHtml(data, type, full, meta) {
            var btns = '';
            if (full.patients.length > 0) {
                if (full.patients[0].first_name != null || full.patients[0].patient_lastname != null || full.patients[0].middle_name != null) {
                    btns += '<span><b>  Name : </b>' + full.patients[0].first_name + '</span> <span>' + full.patients[0].middle_name + '</span> <span>' + full.patients[0].last_name + '<br>';
                }
            }
            else {
                return 'N/A';
            }
            if ((full.patient_address1 != null && full.patient_address1 != undefined) || (full.patient_state != null && full.patient_state != undefined) || (full.patient_zip_code != null && full.patient_zip_code != undefined)) {
                btns += '<span><b>  Address : </b>' + full.patient_address1 + '</span> ,<span>' + full.patient_state + '</span> , <span>' + full.patient_zip_code + ' </span><br>';
            } if (full.patient_dob != null && full.patient_dob != undefined) {
                btns += '<span><b>  DOB : </b>' + full.patient_dob + '  </span><br>';
            } if (full.patient_phone_number != null && full.patient_phone_number != undefined) {
                btns += '<span><b> Phone Number : </b>' + full.patient_phone_number + '  </span><br>';
            }
            if ((full.patients[0].first_name == null && full.patients[0].patient_lastname == null && full.patients[0].middle_name == null)) {
                return 'N/A';
            }


            return btns;
        }
        function actionsHtml(data, type, full, meta) {
            var btns = '<div layout="row" layout-align="center">';
            if (data != null) {
                var method = "ShowOrderDetailInformation('" + data.order_id + "')";
                btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
                    '<md-icon md-font-icon="icon-note"  class="orange-500-fg"></md-icon>' +
                    '<md-tooltip md-visible="" md-direction="">Order Information</md-tooltip>' +
                    '</md-button>';
                btns += '<div>';
            }
            // if (data.order_charges.length > 0) {
            //     var method = "ShowOrderDetailsModal('" + data.order_id + "')";
            //     btns += '<md-button class="edit-button md-icon-button" ng-click="' + method + '">' +
            //         '<md-icon md-font-icon="icon-receipt"  class="orange-500-fg"></md-icon>' +
            //         '<md-tooltip md-visible="" md-direction="">Order Details</md-tooltip>' +
            //         '</md-button>';
            //     btns += '<div>';
            // }
            return btns;

            // var btns = '<div layout="row" layout-align="center center">';

            // if ($rootScope.FlgModifiedAccess) {
            //     btns += '<md-button class="edit-button md-icon-button"  ng-click="EditBankDepositeById(' + data.id + ',' + data.Status + ')" aria-label="Edit Location">' +
            //         '<md-icon md-font-icon="icon-pencil"  class="s18 green-500-fg"></md-icon>' +
            //         '<md-tooltip md-visible="" md-direction="">Edit</md-tooltip>' +
            //         '</md-button>';
            // }
            // if ($rootScope.FlgDeletedAccess) {
            //     btns += '<md-button class="edit-button md-icon-button" ng-click="DeleteBankDepositeById(' + data.id + ',' + data.Status + ',$event)" aria-label="Add Sub-Location">' +
            //         '<md-icon md-font-icon="icon-trash"  class="s18 red-600-fg"></md-icon>' +
            //         '<md-tooltip md-visible="" md-direction="">Delete</md-tooltip>' +
            //         '</md-button>';
            // }

            // btns += '</div>'
            // return btns;
        };

        function NAHtml(data, type, full, meta) {
            if($cookieStore.get("UserRoles") == "Admin" || $cookieStore.get("UserRoles")=="Owner"  ){
                if (data != null && data != undefined && data != '') {
                    return "<b>Balto : </b>" + data + ',&nbsp;&nbsp;<b>Doordash : </b>' + full.pharmacy_lyft_charge;
                } else {
                    return 'N/A';
                }
            }else {
                if (data != null && data != undefined && data != '') {
                    return "<b> - </b>"
                } else {
                    return 'N/A';
                }
            }
            
        }

        $scope.reloadData = function () { }

        function callback(json) { }

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

        function NumberHtml(data, type, full, meta) {
            return parseInt((meta.settings._iDisplayStart) + (meta.row + 1));
        }

        $rootScope.convertdatetimeformat = function (date1) {
            var date = new Date(date1);
            var firstdayDay = date.getDate();
            var firstdayMonth = date.getMonth() + 1;
            var firstdayYear = date.getFullYear();
            var hour = date.getHours();
            var minute = date.getMinutes();
            var sec = date.getSeconds();
            return ("00" + firstdayMonth.toString()).slice(-2) + "-" + ("00" + firstdayDay.toString()).slice(-2) + "-" + ("0000" + firstdayYear.toString()).slice(-4) + " " + ("00" + hour.toString()).slice(-2) + ":" + ("00" + minute.toString()).slice(-2) + ":" + ("00" + sec.toString()).slice(-2);
        }

        function DateHtml(data, type, full, meta) {
            if (full != null && full != undefined && full != '') {
                var date = new Date(full.created_on)
                return $rootScope.convertdatetimeformat(date);
                // return $rootScope.convertdatetimeformat(date + ' UTC');
            } else {
                return 'N/A';
            }
        }

        function DeliverdDateHtml(data, type, full, meta) {
            if (full != null && full != undefined && full != '') {
                var date = new Date(full.delivered_at)
                return $rootScope.convertdatetimeformat(date);
                // return $rootScope.convertdatetimeformat(date + ' UTC');
            } else {
                return 'N/A';
            }
        }

        function StatusHtml(data, type, full, meta) {
            if (full.order_status != null && full.order_status != undefined && full.order_status != '') {
                var btns = '<div layout-align="center">';
                if (full.order_status == -2) {
                    btns += '<span style="font-size: 15px;background-color:  #ff9790;color:white;padding:5px;" >Co-pay Verification</span>';
                }
                else if (full.order_status == -1) {
                    btns += '<span style="font-size: 15px;background-color:  #ceb5f9;color:white;padding:5px;">Co-pay Approval</span>';
                }
                else if (full.order_status == 1) {
                    btns += '<span style="font-size: 15px;background-color:#00bde3;color:white;padding:5px;">New</span>';
                }
                else if (full.order_status == 2) {
                    btns += '<span style="font-size: 15px;background-color:#ff9790;color:white;padding:5px;">OnHold</span>';
                }
                else if (full.order_status == 3) {
                    btns += '<span style="font-size: 15px;background-color: orange;color:white;padding:5px;">Ready to Pick</span>';
                }
                else if (full.order_status == 4) {
                    btns += '<span style="font-size: 15px;background-color: green;color:white;padding:5px;">Driver Picked Up</span>';
                }
                else if (full.order_status == 5) {
                    btns += '<span style="font-size: 15px;background-color: blue;color:white;padding:5px;">Completed</span>';
                }
                else if (full.order_status == 6) {
                    btns += '<span style="font-size: 15px;background-color: red;color:white;padding:5px;">Canceled</span>';
                }
                else if (full.order_status == 7) {
                    btns += '<span style="font-size: 15px;background-color:#abc343;color:white;padding:5px;">Co-pay Direct to Pharmacy</span>';
                }
                else if (full.order_status == 8) {
                    btns += '<span style="font-size: 15px;background-color: lightgray;color:white;padding:5px;">Return Pending</span>';
                }
                // else if (full.order_status == 9) {
                //     btns += '<span style="font-size: 15px;background-color:  #ceb5f9;color:white;padding:5px;">Return Completed</span><br>' +
                //         '<br><span><b>  Return Reason : </b>' + full.return_order[0].reason + '  </span><br>' +
                //         '<span><b>  Receiver Name : </b>' + full.return_order[0].recived_name + '  </span><br>';
                // }
                else if (full.order_status == 9) {
                    btns += '<span style="font-size: 15px;background-color:  #ceb5f9;color:white;padding:5px;">Return Completed</span><br>' +
                        '<br><span><b>  Return Reason : </b>' + 'N/A' + '  </span><br>' +
                        '<span><b>  Receiver Name : </b>' + 'N/A' + '  </span><br>';
                }
                else {
                    return 'N/A'
                }
                btns += '<div>';
                return btns;

            } else {
                return 'N/A';
            }
        }


        $(document).on('click', '#okbtn1', function () {
            $mdDialog.hide();
        });

        //Dynamic pagging End


        $scope.toggle = function () {
            if (!$scope.flgforIcon) {
                $scope.flgforIcon = true;
            } else {
                $scope.flgforIcon = false;
            }

            $(function () {
                $(".showBtn").toggleClass("active");
                $(".ShowContentBox").slideToggle();
            });
        };
        $scope.ShowOrderDetailsModal = function (Order_Id) {
            var orderData = _.findWhere($scope.lstHospital, {
                order_id: Order_Id
            });
            $scope.orderDetailData = orderData.order_charges;
            $mdDialog.show({
                controller: 'OrderDetailsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/Order/dialogs/OrderDetails/OrderDetails.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    Order_Id: Order_Id,
                    OrderDetailData: $scope.orderDetailData
                }
            })
        }

        $scope.ShowOrderDetailInformation = function (Order_Id) {
            var orderData = _.findWhere($scope.lstHospital, {
                order_id: Order_Id
            });
            $scope.orderDetailData = orderData.order_charges;
            $mdDialog.show({
                controller: 'OrderDetailInformationController',
                controllerAs: 'vm',
                templateUrl: 'app/main/DemandOrder/dialogs/OrderDetailInformation/DemandOrderControllerDetailInformation.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                locals: {
                    VM: vm,
                    Order_Id: Order_Id,
                }
            })
        }

        $scope.ResetTab = function (type) {
            $scope.flag = false;

            $scope.flaglink = 0;
            $scope.searchtype1(type)

        }

        $scope.ResetModel1 = function (type) {
            $scope.flag = false;
            $scope.flaglink = 1;
            $scope.searchtype1(type)
        }
        $scope.ResetModel2 = function (type) {

            $scope.flag = false;
            $scope.flaglink = 2;
            $scope.searchtype1(type)
        }
        $scope.ResetModel3 = function (type) {

            $scope.flag = false;
            $scope.flaglink = 3;
            $scope.searchtype1(type)
        }

        $scope.dtInstance = {};
        $scope.init();
    }

})();
(function () {
    'use strict';

    angular
        .module('app.DefaultChargesSetting', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.DefaultChargesSetting', {
                url: '/DefaultChargesSetting',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/DefaultChargesSetting/DefaultChargesSetting.html',
                        controller: 'DefaultChargesSettingController as vm'
                    }
                },
                bodyClass: 'Default Charges Setting',
                ModuleName: 'Default Charges Setting'
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.DefaultChargesSetting')
        .controller('DefaultChargesSettingController', DefaultChargesSettingController);

    /** @ngInject */
    function DefaultChargesSettingController($http, $scope, $mdDialog, $document, $mdToast, $cookieStore, DTOptionsBuilder, DTColumnDefBuilder, $rootScope, $timeout) {
        var vm = this;
        $scope.init = function () {
            $scope.initModel();
            $scope.btn = "Save";
            $scope.modelSearch = { Search: '' };
            $scope.geAllChargesSetting();
            $scope.flag = false;
        }

        $scope.initModel = function () {
            $scope.model = {
                _id: null,
                type: null,
                mini_charges: null,
                defualt_miles: null,
                per_miles_charge: null,
                defualt_ETA: null,
                per_ETA_charge: null,
                defualt_prescription: null,
                per_prescription_charge: null,
                defualt_patient: null,
                per_patient_charge: null,
                miles_limit: null,
                above_limit_per_miles_charge: null,
                above_limit_per_ETA_charge: null,
                defualt_prescription_night : null,
                mini_charges_night:null
            };
        }

        vm.dtInstance = {};
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [],
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#modelsearch');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            lengthMenu: [10, 20, 30, 50, 100],
            pageLength: 20,
            scrollY: 'auto',
            responsive: true
        };


        //get all team list
        $scope.geAllChargesSetting = function () {
            $http.get($rootScope.RoutePath + "charges_setting/geAllChargesSetting").then(function (data) {
                $scope.lst_charges_setting = data.data;
            });
        }

        $scope.FetchData = function (item) {
            $scope.model = item;
            $scope.flag = true;
        }

        $scope.SaveData = function () {
            $http.post($rootScope.RoutePath + 'charges_setting/saveDfaultCharges', $scope.model).then(function (data) {
                if (data.data.success) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    );
                    $scope.ResetData();
                    $scope.init();
                } else {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    )
                }

            })
        }

        $scope.ResetEdit = function () {
            $scope.initModel();
            $scope.RestForm();
            $scope.flag = true;
        }

        $scope.RestForm = function () {
            $scope.chargesSettingFrom.$setPristine();
            $scope.chargesSettingFrom.$setUntouched();
        }

        $scope.ResetData = function () {
            $scope.initModel();
            $scope.RestForm();
        }

        //cancel btn
        $scope.Cancel = function () {
            $scope.flag = false;
            $scope.initModel();
            $scope.RestForm();

        }
        $rootScope.convertdatetimeformat = function (date1) {
            var date = new Date(date1);
            var firstdayDay = date.getDate();
            var firstdayMonth = date.getMonth() + 1;
            var firstdayYear = date.getFullYear();
            var hour = date.getHours();
            var minute = date.getMinutes();
            var sec = date.getSeconds();
            return ("00" + firstdayDay.toString()).slice(-2) + "-" + ("00" + firstdayMonth.toString()).slice(-2) + "-" + ("0000" + firstdayYear.toString()).slice(-4) + " " + ("00" + hour.toString()).slice(-2) + ":" + ("00" + minute.toString()).slice(-2) + ":" + ("00" + sec.toString()).slice(-2);
        }
        //back btn
        $scope.gotoOrderList = function () {
            $scope.init();
        }

        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
            $scope.init();
        })


    }
})();
(function() {
    'use strict';

    angular
        .module('app.Dashboard', ['nvd3'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.Dashboard', {
                url: '/Dashboard',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Dashboard/Dashboard.html',
                        controller: 'DashboardController'
                    }
                },
                bodyClass: 'Dashboard',
                ModuleName: 'Dashboard'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/Dashboard');

        // msNavigationServiceProvider.saveItem('Dashboard', {
        //     title: 'Authentication',
        //     icon: 'icon-television',
        //     weight: 1
        // });


        // msNavigationServiceProvider.saveItem('Dashboard', {
        //     title: 'Dashboard',
        //     state: 'app.Dashboard',
        //     // icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.Dashboard')
        .controller('DashboardController', DashboardController);

    function DashboardController($http, $scope, $mdDialog, $document, $mdToast, $cookieStore, DTOptionsBuilder, DTColumnDefBuilder, $rootScope, $timeout, $filter) {

        var vm = this;
        var map;
        var SimpleMarker;
        var socket = io($rootScope.Socket_URL, {
            'forceNew': true
        });

        $rootScope.UserRoles = $cookieStore.get('UserRoles');
        $rootScope.appId = localStorage.getItem('appId');
        $scope.AppName = localStorage.getItem('appName');

        //for map icon
        if ($scope.AppName != "Tracking") {
            $scope.OnlineImage = "/assets/images/icon-map-car-on2.png";
            $scope.OfflineImage = "/assets/images/icon-map-car--off2.png";
            $scope.ActiveImage = "/assets/images/icon-map-car-active2.png";
            $scope.SimpleMarkerIcon = "/assets/images/locate-active-blue.png";
        } else {
            $scope.OnlineImage = "/assets/images/locate-live.png";
            $scope.OfflineImage = "/assets/images/locate-disconnect.png";
            $scope.ActiveImage = "/assets/images/locate-active.png";
            $scope.SimpleMarkerIcon = "/assets/images/locate-active.png";
        }
        //endicon
        $scope.selectAppName = $scope.AppName;

        $scope.GetAllInfoList = function () {
            $http.get($rootScope.RoutePath + "appinfo/GetAllInfoList").then(function (data) {
                $scope.lstAppInfo = data.data;
            })
        }
        $scope.GetAllInfoList();
        $scope.selectedAppName = function (o) {
            if (o != 'All') {
                $scope.selectAppName = o.AppName;
                $rootScope.appId = o.id;
                $scope.AppName = o.AppName;
            } else {
                $scope.selectAppName = 'All';
                $rootScope.appId = '';
                $scope.AppName = '';
            }

            $scope.init();
            $scope.getCurrentLocation(false);
        }

        function callDeviceStatus() {
            for (var t = 0; t < $scope.lstActiveVehicle.length; t++) {
                socket.on($scope.lstActiveVehicle[t].deviceid + 'BikeDeviceStatus', function (msg) {
                    var obj = JSON.parse(msg);
                    $scope.$apply(function () {
                        // if ($scope.lstDevices != undefined) {
                        if ($scope.lstActiveVehicle != null && $scope.lstActiveVehicle != undefined) {
                            for (var t = 0; t < $scope.lstActiveVehicle.length; t++) {
                                if ($scope.lstActiveVehicle[t].deviceid == obj.DeviceId) {
                                    if (obj.Status == true) {
                                        obj.Status = 1;
                                    } else {
                                        obj.Status = 0;
                                    }
                                    $scope.lstActiveVehicle[t].IsOnline = obj.Status;
                                    // $scope.ActiveDevice = _.filter($scope.lstActiveVehicle, function(item) {
                                    //         if (item.IsOnline == 1 || item.IsOnline == true) {
                                    //             return item
                                    //         }
                                    //     })
                                    //     //  _.where($scope.lstActiveVehicle, { IsOnline: true });
                                    // $scope.NotActiveDevice = _.filter($scope.lstActiveVehicle, function(item) {
                                    //         if (item.id != null && (item.IsOnline == 0 || item.IsOnline == false)) {
                                    //             return item;
                                    //         }
                                    //     })
                                    //     // console.log("A....", $scope.ActiveDevice.length)
                                    //     // console.log($scope.NotActiveDevice.length)
                                    // $scope.NotSaleDevice = _.where($scope.lstActiveVehicle, { IsOnline: 0, id: null });

                                    var VehicleID = $scope.lstActiveVehicle[t].Name;
                                    if (VehicleID == null || VehicleID == undefined || VehicleID == '') {
                                        VehicleID = $scope.lstActiveVehicle[t].deviceid;
                                    }
                                    //new CustomMarker(new google.maps.LatLng($scope.lstActiveVehicle[t].Latitude, $scope.lstActiveVehicle[t].Longitude), map, VehicleID, $scope.lstActiveVehicle[t])
                                    // SimpleMarker = new google.maps.Marker({
                                    //     map: map,
                                    //     position: new google.maps.LatLng($scope.lstActiveVehicle[t].Latitude, $scope.lstActiveVehicle[t].Longitude),
                                    //     icon: $scope.SimpleMarkerIcon
                                    // });
                                    // var infowindow = new google.maps.InfoWindow();
                                    if ($scope.lstActiveVehicle[t].marker) {
                                        $scope.lstActiveVehicle[t].marker.setLatLng([$scope.lstActiveVehicle[t].Latitude, $scope.lstActiveVehicle[t].Longitude]);
                                    }
                                    var EngineStatus = $scope.lstActiveVehicle[t].IsEngine == true ? "Engine On" : "Engine Off";
                                    var DeviceDatetime = moment(moment.utc(new Date($scope.lstActiveVehicle[t].Date * 1000)).toDate()).format('MM - DD - YYYY hh: mm: ss a');
                                    // var content = '<div class="SimpleMarker MapMarkerLable"><h3>' + VehicleID + '</h3><div class="content"><div class="col2"><i class="ion-ios-clock" style="color:green;"></i><span class="localDate ' + $scope.lstActiveVehicle[t].deviceid + '">' + DeviceDatetime + '</span></div><div class="col2"><i class="ion-ios-speedometer localSpeedSymbol" style="color:green;"></i><span class="localSpeed ' + $scope.lstActiveVehicle[t].deviceid + '">' + parseFloat($scope.lstActiveVehicle[t].Speed).toFixed(2) + ' km/h</span></div><div class="col2"><i class="ion-gear-b localEngineSymbol" style="color:green;"></i><span class="localEngine ' + $scope.lstActiveVehicle[t].deviceid + '"> ' + EngineStatus + ' </span></div></div></div>';
                                    var content = '<div class="CustomInfoWindow">' +
                                        '    <h3>' + VehicleID + '</h3>' +
                                        '    <ul>' +
                                        '        <li>' +
                                        '            <i class="ion-ios-clock" style="color:green;"></i>' +
                                        '            <span>' + DeviceDatetime + '</span>' +
                                        '        </li>' +
                                        '        <li>' +
                                        '            <i class="ion-ios-speedometer localSpeedSymbol" style="color:green;"></i>' +
                                        '            <span>' + parseFloat($scope.lstActiveVehicle[t].Speed).toFixed(2) + ' km/h </span>' +
                                        '        </li>' +
                                        '        <li>' +
                                        '            <i class="ion-gear-b localEngineSymbol" style="color:green;"></i>' +
                                        '            <span> ' + EngineStatus + ' </span>' +
                                        '        </li>' +
                                        '    </ul>' +
                                        '</div>';
                                    // google.maps.event.addListener(SimpleMarker, 'click', (function(SimpleMarker, content, infowindow) {
                                    //     return function() {
                                    //         infowindow.setContent(content);
                                    //         infowindow.open(map, SimpleMarker);
                                    //     };
                                    // })(SimpleMarker, content, infowindow));
                                    $scope.lstActiveVehicle[t].popup = content;
                                    $scope.ManageDashBoardCount();
                                }
                            }

                        }
                        // }
                    });
                });

                // socket.on($scope.lstActiveVehicle[t].deviceid + 'BikeRoute', function(msg) {
                //     var obj = JSON.parse(msg);
                //     $scope.$apply(function() {
                //         if ($scope.lstActiveVehicle) {
                //             var lstVehicle = _.filter($scope.lstActiveVehicle, { deviceid: obj.Deviceid });
                //             if (lstVehicle != null && lstVehicle != undefined && lstVehicle != '' && lstVehicle.length > 0) {
                //                 var objVehicle = lstVehicle[0];
                //                 objVehicle.Date = obj.Date;
                //                 objVehicle.IsEngine = obj.IsEngine;
                //                 objVehicle.Speed = parseFloat(obj.Speed).toFixed(2);
                //                 objVehicle.Direction = obj.Direction;
                //                 objVehicle.Latitude = obj.Latitude;
                //                 objVehicle.Longitude = obj.Longitude;
                //                 var VehicleID = objVehicle.Name;
                //                 // new CustomMarker(new google.maps.LatLng(objVehicle.Latitude, objVehicle.Longitude), map, VehicleID, objVehicle)
                //                 SimpleMarker = new google.maps.Marker({
                //                     map: map,
                //                     position: new google.maps.LatLng(objVehicle.Latitude, objVehicle.Longitude),
                //                     icon: $scope.SimpleMarkerIcon
                //                 });
                //                 var infowindow = new google.maps.InfoWindow();
                //                 var EngineStatus = objVehicle.IsEngine == true ? "Engine On" : "Engine Off";
                //                 var DeviceDatetime = moment(moment.utc(new Date(objVehicle.Date * 1000)).toDate()).format('DD-MM-YYYY hh:mm:ss a');
                //                 // var content = '<div class="SimpleMarker MapMarkerLable"><h3>' + VehicleID + '</h3><div class="content"><div class="col2"><i class="ion-ios-clock" style="color:green;"></i><span class="localDate ' + objVehicle.deviceid + '">' + DeviceDatetime + '</span></div><div class="col2"><i class="ion-ios-speedometer localSpeedSymbol" style="color:green;"></i><span class="localSpeed ' + objVehicle.deviceid + '">' + parseFloat(objVehicle.Speed).toFixed(2) + ' km/h</span></div><div class="col2"><i class="ion-gear-b localEngineSymbol" style="color:green;"></i><span class="localEngine ' + objVehicle.deviceid + '"> ' + EngineStatus + ' </span></div></div></div>';
                //                 var content = '<div class="CustomInfoWindow">' +
                //                     '    <h3>' + VehicleID + '</h3>' +
                //                     '    <ul>' +
                //                     '        <li>' +
                //                     '            <i class="ion-ios-clock" style="color:green;"></i>' +
                //                     '            <span>' + DeviceDatetime + '</span>' +
                //                     '        </li>' +
                //                     '        <li>' +
                //                     '            <i class="ion-ios-speedometer localSpeedSymbol" style="color:green;"></i>' +
                //                     '            <span>' + objVehicle.Speed + ' km/h </span>' +
                //                     '        </li>' +
                //                     '        <li>' +
                //                     '            <i class="ion-gear-b localEngineSymbol" style="color:green;"></i>' +
                //                     '            <span> ' + EngineStatus + ' </span>' +
                //                     '        </li>' +
                //                     '    </ul>' +
                //                     '</div>';
                //                 google.maps.event.addListener(SimpleMarker, 'click', (function(SimpleMarker, content, infowindow) {
                //                     return function() {
                //                         infowindow.setContent(content);
                //                         infowindow.open(map, SimpleMarker);
                //                     };
                //                 })(SimpleMarker, content, infowindow));


                //             };
                //         }
                //     });
                // });
            }
        }

        $scope.$on('$stateChangeStart', function (e, to) {
            socket.disconnect();
        });

        $scope.init = function () {
            $scope.model = {
                Year: '',
                MonthId: '',
                CountryName: 'All',
                YearAcc: '',
                MonthIdAcc: '',
                CountryNameAcc: 'All',
            }
            $scope.flgshow = 0;
            $scope.FlgSuperAdmin = false;
            $rootScope.UserRoles = $cookieStore.get('UserRoles');
            if ($rootScope.UserRoles.length > 0) {
                for (var i = 0; i < $rootScope.UserRoles.length; i++) {
                    if ($rootScope.UserRoles[i] == "Super Admin") {
                        $scope.FlgSuperAdmin = true;
                    }
                }
            }

            $scope.GetDashboardCount();
            $scope.ManageGraph();
            $scope.GetCustomer();
            $scope.TotalCustomerbyCountry();
            // $scope.GetAllDevice();
            $scope.GetAllMontName();
            $scope.GetAllYearName();
            $scope.TotalShopperCustomer = 0;
            $scope.TotalOwnerCustomer = 0;
            $scope.GetAllExpiredDevice();
        }
        $scope.GetAllMontName = function () {
            $scope.listMonthName = [
                { id: 1, name: "Jan" },
                { id: 2, name: "Feb" },
                { id: 3, name: "Mar" },
                { id: 4, name: "Apr" },
                { id: 5, name: "May" },
                { id: 6, name: "Jun" },
                { id: 7, name: "Jul" },
                { id: 8, name: "Aug" },
                { id: 9, name: "Sep" },
                { id: 10, name: "Oct" },
                { id: 11, name: "Nov" },
                { id: 12, name: "Dec" }
            ];
        }
        $scope.GetAllYearName = function () {
            $scope.listYear = [];
            for (var j = 2015; j <= new Date().getFullYear(); j++) {
                var obj = new Object();
                obj.YearName = j;
                $scope.listYear.push(obj);
            }
        }

        //google map start
        $scope.IntializeGoogleMap = function (Redirectflag) {

            var myOptions;

            var CurrentLat = 0;
            var CurrentLang = 0;
            // myOptions = {
            //     center: new google.maps.LatLng(CurrentLat, CurrentLang),
            //     zoom: 3,
            //     mapTypeId: google.maps.MapTypeId.TERRAIN
            // };

            myOptions = {
                center: [CurrentLat, CurrentLang],
                zoom: 5,
                fullscreenControl: false,
                zoomControl: false,
                streetViewControl: false,
                mapTypeControl: false,
                preferCanvas: true
            };


            // var CurrentLatLang = new google.maps.LatLng(CurrentLat, CurrentLang);

            setTimeout(function () {
                // map = new google.maps.Map(document.getElementById("map123"),
                //     myOptions);
                if (map) {
                    map.remove();
                }
                map = L.map(document.getElementById("map123"), myOptions);
                L.tileLayer($rootScope.MapTile_URL + 'styles/klokantech-basic/{z}/{x}/{y}.png').addTo(map);
                // var MethodCallFlag = true;

                var FoundLocation = 0;
                $http.get($rootScope.RoutePath + 'dashboard/GetAllWorkingBikeNew?AppName=' + $scope.AppName).success(function (data) {
                    $scope.lstActiveVehicle = data.data;
                    callDeviceStatus();
                    for (var i = 0; i < $scope.lstActiveVehicle.length; i++) {
                        if ($scope.lstActiveVehicle[i].IsOnline == null) {
                            $scope.lstActiveVehicle[i].IsOnline = 0;
                        }
                    }
                    $scope.ManageDashBoardCount();
                    var bounds = [];

                    function setActiveVehicle(i) {
                        if (i < $scope.lstActiveVehicle.length) {
                            var ImageURL = '';
                            // var IsWireCut = $scope.lstActiveVehicle[i].IsWireCut;
                            var VehicleID = $scope.lstActiveVehicle[i].Name;
                            if (VehicleID == null || VehicleID == undefined || VehicleID == '') {
                                VehicleID = $scope.lstActiveVehicle[i].deviceid;
                            }
                            var objVehicle = $scope.lstActiveVehicle[i];
                            if ($scope.lstActiveVehicle[i].Latitude != null && $scope.lstActiveVehicle[i].Longitude != null) {
                                // new CustomMarker(new google.maps.LatLng($scope.lstActiveVehicle[i].Latitude, $scope.lstActiveVehicle[i].Longitude), map, VehicleID, objVehicle)
                                // SimpleMarker = new google.maps.Marker({
                                //     map: map,
                                //     position: new google.maps.LatLng($scope.lstActiveVehicle[i].Latitude, $scope.lstActiveVehicle[i].Longitude),
                                //     icon: $scope.SimpleMarkerIcon
                                // });
                                // var infowindow = new google.maps.InfoWindow();
                                var EngineStatus = $scope.lstActiveVehicle[i].IsEngine == true ? "Engine On" : "Engine Off";
                                var DeviceDatetime = moment(moment.utc(new Date($scope.lstActiveVehicle[i].Date * 1000)).toDate()).format('DD-MM-YYYY hh:mm:ss a');
                                // // var content = '<div class="SimpleMarker MapMarkerLable"><h3>' + VehicleID + '</h3><div class="content"><div class="col2"><i class="ion-ios-clock" style="color:green;"></i><span class="localDate ' + $scope.lstActiveVehicle[i].deviceid + '">' + DeviceDatetime + '</span></div><div class="col2"><i class="ion-ios-speedometer localSpeedSymbol" style="color:green;"></i><span class="localSpeed ' + $scope.lstActiveVehicle[i].deviceid + '">' + parseFloat($scope.lstActiveVehicle[i].Speed).toFixed(2) + ' km/h</span></div><div class="col2"><i class="ion-gear-b localEngineSymbol" style="color:green;"></i><span class="localEngine ' + $scope.lstActiveVehicle[i].deviceid + '"> ' + EngineStatus + ' </span></div></div></div>';

                                var content = '<div class="CustomInfoWindow">' +
                                    '    <h3>' + VehicleID + '</h3>' +
                                    '    <ul>' +
                                    '        <li>' +
                                    '            <i class="ion-ios-clock" style="color:green;"></i>' +
                                    '            <span>' + DeviceDatetime + '</span>' +
                                    '        </li>' +
                                    '        <li>' +
                                    '            <i class="ion-ios-speedometer localSpeedSymbol" style="color:green;"></i>' +
                                    '            <span>' + parseFloat($scope.lstActiveVehicle[i].Speed).toFixed(2) + ' km/h </span>' +
                                    '        </li>' +
                                    '        <li>' +
                                    '            <i class="ion-gear-b localEngineSymbol" style="color:green;"></i>' +
                                    '            <span> ' + EngineStatus + ' </span>' +
                                    '        </li>' +
                                    '    </ul>' +
                                    '</div>';
                                // google.maps.event.addListener(SimpleMarker, 'click', (function(SimpleMarker, content, infowindow) {
                                //     return function() {
                                //         infowindow.setContent(content);
                                //         infowindow.open(map, SimpleMarker);
                                //     };
                                // })(SimpleMarker, content, infowindow));

                                var MapIcon = L.icon({
                                    iconUrl: $scope.SimpleMarkerIcon,
                                    iconAnchor: [28, 48], // point of the icon which will correspond to marker's location
                                    popupAnchor: [-3, -45] // point from which the popup should open relative to the iconAnchor
                                });
                                $scope.lstActiveVehicle[i].marker = L.marker([$scope.lstActiveVehicle[i].Latitude, $scope.lstActiveVehicle[i].Longitude], { icon: MapIcon, title: $scope.lstActiveVehicle[i].Name }).addTo(map);
                                $scope.lstActiveVehicle[i].popup = content;
                                $scope.lstActiveVehicle[i].marker.on('mouseover', function () {
                                    $scope.lstActiveVehicle[i].marker.bindPopup($scope.lstActiveVehicle[i].popup).openPopup();
                                });
                                $scope.lstActiveVehicle[i].marker.on('mouseout ', function () {
                                    $scope.lstActiveVehicle[i].marker.bindPopup($scope.lstActiveVehicle[i].popup).closePopup()
                                });
                                bounds.push([$scope.lstActiveVehicle[i].Latitude, $scope.lstActiveVehicle[i].Longitude])

                            }
                            setActiveVehicle(i + 1);
                        } else {
                            if (bounds.length > 0) {
                                map.fitBounds(bounds, { maxZoom: 13 });
                            }
                        }
                    }
                    setActiveVehicle(0);
                });
                //     };
                // });

                if ($scope.CurrentLatitude != '' && $scope.CurrentLongitude != '') { } else {
                    if (Redirectflag) {
                        MethodCallFlag = true;
                    } else {
                        $scope.getCurrentLocation(true);
                    }
                }
            })
        }

        $scope.ManageDashBoardCount = function () {
            $scope.ActiveDevice = _.where($scope.lstActiveVehicle, { IsOnline: 1 });
            // $scope.NotActiveDevice = _.where($scope.lstActiveVehicle, { IsOnline: 0 });
            $scope.NotActiveDevice = _.filter($scope.lstActiveVehicle, function (item) {
                if (item.id != null && item.IsOnline == 0) {
                    return item;
                }
            })
            $scope.NotSaleDevice = _.where($scope.lstActiveVehicle, { IsOnline: 0, id: null });
        }

        $scope.getCurrentLocation = function (flag) {
            var posOptions = { timeout: 7000, enableHighAccuracy: false };
            try {
                $cordovaGeolocation.getCurrentPosition(posOptions).then(function (position) {
                    $scope.CurrentLatitude = position.coords.latitude;
                    $scope.CurrentLongitude = position.coords.longitude;
                    $scope.IntializeGoogleMap(flag);
                }, function (err) {
                    $scope.IntializeGoogleMap(flag);
                });
            } catch (ex) {
                $scope.IntializeGoogleMap(flag);
            }
        }

        $scope.getCurrentLocation(false);


        // function CustomMarker(latlng, map, VehicleID, objVehicle) {
        //     this.latlng_ = latlng;
        //     // this.imageSrc = imageSrc;
        //     this.VehicleID = VehicleID;
        //     this.objVehicle = objVehicle;
        //     // this.IsOnline = objVehicle.IsOnline;
        //     // this.IsEngine = objVehicle.IsEngine;
        //     // this.Authorised = Authorised;

        //     // Once the LatLng and text are set, add the overlay to the map.  This will
        //     // trigger a call to panes_changed which should in turn call draw.
        //     this.setMap(map);
        // }




        // CustomMarker.prototype = new google.maps.OverlayView();
        // CustomMarker.prototype.draw = function() {
        //     var div = null;
        //     var animatediv = null;

        //     var CustomeInfoWindowdiv = null;
        //     var animatCustomeInfoWindowdiv = null;

        //     var EngineStatus = 'Engine OFF';

        //     if (this.objVehicle.IsEngine == true) {
        //         EngineStatus = 'Engine ON';
        //     }

        //     var DeviceDatetime = moment(moment.utc(new Date(this.objVehicle.Date * 1000)).toDate()).format('DD-MM-YYYY hh:mm:ss a');


        //     div = this.div_ = $('.customMarkercar.' + this.objVehicle.deviceid)[0];
        //     animatediv = $('.customMarkercar.' + this.objVehicle.deviceid);

        //     CustomeInfoWindowdiv = this.CustomeInfoWindowdiv_ = $('.custom-infowinow.' + this.objVehicle.deviceid)[0];
        //     animatCustomeInfoWindowdiv = $('.custom-infowinow.' + this.objVehicle.deviceid);

        //     if (!div) {
        //         div = this.div_ = document.createElement('div');
        //         // var TextDiv = document.createElement("div");
        //         // TextDiv.innerHTML = this.objVehicle.Name;


        //         CustomeInfoWindowdiv = this.CustomeInfoWindowdiv_ = document.createElement('div');

        //         CustomeInfoWindowdiv.className = 'custom-infowinow ' + this.objVehicle.deviceid;

        //         if (this.objVehicle.IsOnline == false) {
        //             div.className = "customMarkercar offline " + this.objVehicle.deviceid;
        //             // $(TextDiv).addClass('my-text-shadow offline');
        //         } else {
        //             if (this.objVehicle.IsEngine == false) {
        //                 div.className = "customMarkercar active " + this.objVehicle.deviceid;
        //                 // $(TextDiv).addClass('my-text-shadow active');
        //             } else {
        //                 div.className = "customMarkercar online " + this.objVehicle.deviceid;
        //                 // $(TextDiv).addClass('my-text-shadow online');
        //             }
        //         }

        //         var BikeNameP = document.createElement("div");
        //         var leftDiv = document.createElement("div");
        //         var RightDiv = document.createElement("div");
        //         var closeBtn = document.createElement("div");

        //         BikeNameP.innerHTML = '<div class="MapMarkerLable"><h3>' + this.objVehicle.Name + '</h3><div class="content"><div class="col2"><i class="ion-ios-clock" style="color:green;"></i><span class="localDate ' + this.objVehicle.deviceid + '">' + DeviceDatetime + '</span></div><div class="col2"><i class="ion-ios-speedometer localSpeedSymbol" style="color:green;"></i><span class="localSpeed ' + this.objVehicle.deviceid + '">' + parseFloat(this.objVehicle.Speed).toFixed(2) + ' km/h</span></div><div class="col2"><i class="ion-gear-b localEngineSymbol" style="color:green;"></i><span class="localEngine ' + this.objVehicle.deviceid + '"> ' + EngineStatus + ' </span></div></div></div>';

        //         $(leftDiv).addClass('leftside');
        //         leftDiv.innerHTML = '<span> </span>';
        //         $(RightDiv).addClass('rightside');
        //         RightDiv.innerHTML = '<span> </span>';
        //         $(closeBtn).addClass('closeBtn ' + this.objVehicle.deviceid);

        //         CustomeInfoWindowdiv.appendChild(BikeNameP);
        //         CustomeInfoWindowdiv.appendChild(leftDiv);
        //         CustomeInfoWindowdiv.appendChild(RightDiv);
        //         CustomeInfoWindowdiv.appendChild(closeBtn);

        //         CustomeInfoWindowdiv.style.visibility = "hidden";

        //         // $(TextDiv).addClass('my-text-shadow');
        //         // div.appendChild(TextDiv);

        //         google.maps.event.addDomListener(div, "click", function(event) {

        //             var lstclassName = event.srcElement.className.split(' ')
        //             var DeviceID = "";
        //             for (var t = 0; t < lstclassName.length; t++) {
        //                 if (lstclassName[t] != "customMarkercar" && lstclassName[t] != "active" && lstclassName[t] != "online" && lstclassName[t] != "offline") {
        //                     DeviceID = lstclassName[t];
        //                 }
        //             }
        //             $(".custom-infowinow." + DeviceID).css("visibility", "visible");

        //         });

        //         var panes = this.getPanes();
        //         panes.overlayImage.appendChild(div);
        //         panes.overlayImage.appendChild(CustomeInfoWindowdiv);
        //         // panes.overlayImage.appendChild(DrivingDataDiv);

        //         // $(".custom-driving-infowinow").css("visibility", "hidden");

        //         $(".closeBtn." + this.objVehicle.deviceid).click(function(event) {

        //             var lstclassName = event.currentTarget.className.split(' ');
        //             var DeviceID = "";
        //             for (var t = 0; t < lstclassName.length; t++) {
        //                 if (lstclassName[t] != "customMarkercar" && lstclassName[t] != "active" && lstclassName[t] != "online" && lstclassName[t] != "offline") {
        //                     DeviceID = lstclassName[t];
        //                 }
        //             }
        //             $(".custom-infowinow." + DeviceID).css("visibility", "hidden");
        //         });

        //         if (this.objVehicle.IsOnline == false) {
        //             animatediv = $('.customMarkercar.' + this.objVehicle.deviceid);
        //         } else {
        //             if (this.objVehicle.IsEngine == false) {
        //                 animatediv = $('.customMarkercar.' + this.objVehicle.deviceid);
        //             } else {
        //                 animatediv = $('.customMarkercar.' + this.objVehicle.deviceid);
        //             }
        //         }
        //     } else {
        //         if (this.objVehicle.IsOnline == false) {
        //             $('.customMarkercar.' + this.objVehicle.deviceid).removeClass("online");
        //             $('.customMarkercar.' + this.objVehicle.deviceid).removeClass("active");
        //             $('.customMarkercar.' + this.objVehicle.deviceid).addClass("offline");

        //             // $('.customMarkercar.' + this.objVehicle.deviceid + ' .my-text-shadow').removeClass("online");
        //             // $('.customMarkercar.' + this.objVehicle.deviceid + ' .my-text-shadow').removeClass("active");
        //             // $('.customMarkercar.' + this.objVehicle.deviceid + ' .my-text-shadow').addClass("offline");

        //         } else {
        //             if (this.objVehicle.IsEngine == false) {
        //                 $('.customMarkercar.' + this.objVehicle.deviceid).removeClass("online");
        //                 $('.customMarkercar.' + this.objVehicle.deviceid).addClass("active");
        //                 $('.customMarkercar.' + this.objVehicle.deviceid).removeClass("offline");

        //                 // $('.customMarkercar.' + this.objVehicle.deviceid + ' .my-text-shadow').removeClass("online");
        //                 // $('.customMarkercar.' + this.objVehicle.deviceid + ' .my-text-shadow').addClass("active");
        //                 // $('.customMarkercar.' + this.objVehicle.deviceid + ' .my-text-shadow').removeClass("offline");
        //             } else {
        //                 $('.customMarkercar.' + this.objVehicle.deviceid).addClass("online");
        //                 $('.customMarkercar.' + this.objVehicle.deviceid).removeClass("active");
        //                 $('.customMarkercar.' + this.objVehicle.deviceid).removeClass("offline");

        //                 // $('.customMarkercar.' + this.objVehicle.deviceid + ' .my-text-shadow').addClass("online");
        //                 // $('.customMarkercar.' + this.objVehicle.deviceid + ' .my-text-shadow').removeClass("active");
        //                 // $('.customMarkercar.' + this.objVehicle.deviceid + ' .my-text-shadow').removeClass("offline");
        //             }
        //         }
        //     }

        //     $(".localDate." + this.objVehicle.deviceid).text(DeviceDatetime);
        //     $(".localEngin." + this.objVehicle.deviceid).text(EngineStatus);
        //     $(".localSpeed." + this.objVehicle.deviceid).text(parseFloat(this.objVehicle.Speed).toFixed(2) + " km/h");


        //     var point = this.getProjection().fromLatLngToDivPixel(this.latlng_);

        //     if (point) {
        //         div.style.left = point.x + 'px';
        //         div.style.top = point.y + 'px';

        //         CustomeInfoWindowdiv.style.left = (point.x - 125) + 'px';
        //         CustomeInfoWindowdiv.style.top = (point.y - 180) + 'px';


        //         if ($scope.AppName == "Tracking") {

        //             if (this.objVehicle.IsOnline == 1 && this.objVehicle.IsEngine == true) {

        //                 var heading = parseFloat(this.objVehicle.Direction) + 90;
        //                 div.style.transform = 'rotate(' + heading + 'deg)';
        //                 animatediv.css('-webkit-transform', 'rotate(' + heading + 'deg)');
        //             } else {
        //                 div.style.transform = 'rotate(0deg)';
        //                 animatediv.css('-webkit-transform', 'rotate(0deg)');
        //             }
        //         } else {
        //             var heading = parseFloat(this.objVehicle.Direction) + 90;
        //             div.style.transform = 'rotate(' + heading + 'deg)';
        //             animatediv.css('-webkit-transform', 'rotate(' + heading + 'deg)');
        //         }
        //     }
        // };

        // CustomMarker.prototype.remove = function() {
        //     if (this.div_) {
        //         this.div_.parentNode.removeChild(this.div_);
        //         this.div_ = null;
        //     }
        // };

        // CustomMarker.prototype.getPosition = function() {
        //     return this.latlng_;
        // };

        $scope.ManageCustomerGraph = function () {
            var params = {
                // countryName: null,
                // CountryList: $rootScope.CountryList,
                // IsSuperAdmin: $scope.FlgSuperAdmin,
                idApp: $rootScope.appId,
            }
            $http.get($rootScope.RoutePath + "dashboard/GetGraphCustomer", { params: params }).then(function (data) {
                $scope.lstCustomerGraph = data.data.UserData;

                $scope.lstCountry = [];
                for (var i = 0; i < $scope.lstCustomerGraph.length; i++) {
                    if ($scope.lstCustomerGraph[i].country == '' || $scope.lstCustomerGraph[i].country == null) {
                        $scope.lstCustomerGraph[i].country = 'Other';
                    }
                    if ($scope.lstCountry.length != 0) {
                        var obj = _.findWhere($scope.lstCountry, { Country: $scope.lstCustomerGraph[i].country });
                        if (obj != null && obj != undefined && obj != "") {

                        } else {
                            var obj1 = new Object();
                            obj1.Country = $scope.lstCustomerGraph[i].country;
                            $scope.lstCountry.push(obj1);
                        }
                    } else {
                        var obj1 = new Object();
                        obj1.Country = $scope.lstCustomerGraph[i].country;
                        $scope.lstCountry.push(obj1);
                    }
                }

                $timeout(function () {
                    $scope.CustomerAndUser(false);
                    $scope.CustomerAndUserAcc(false);
                    $scope.CustomerGraph();
                }, 300);

            });
        }
        $scope.CustomerAndUser = function (flag) {
            $scope.weekDays = '';
            $scope.weekMonths = '';
            var currentDate = moment();
            var weekStart = currentDate.clone().startOf('days');
            $scope.days = [];
            $scope.months = [];
            $scope.lstUser = [];
            $scope.lstCustomer = [];
            for (var i = 0; i <= 30; i++) {
                $scope.days.push(moment(weekStart).subtract(i, 'days').format("Do"));
                $scope.months.push(moment(weekStart).subtract(i, 'month').format("M"));
            };

            var custDate = new Date(),
                locale = "en-us",
                stingmonth = custDate.toLocaleString(locale, { month: "long" });
            $scope.custCurrentYear = custDate.getFullYear();
            $scope.custCurrentMonth = custDate.getMonth() + 1;
            $scope.custCurrentDay = custDate.getDate();
            var daywiseuserlist = [];
            var labelsday = [];
            $scope.model.Year = "0";
            $scope.model.MonthId = "0";
            if (flag == false) {
                $scope.model.CountryName = 'All';
            }
            for (var i = 0; i < 30; i++) {

                var date = $scope.custCurrentDay + '-' + $scope.listMonthbyName[$scope.custCurrentMonth - 1] + '-' + $scope.custCurrentYear;
                var objCustomer = new Object();
                objCustomer.x = moment($filter('date')(new Date(date), "MM/dd/yyyy")).valueOf();

                if ($scope.model.CountryName == 'All') {
                    var Customer = _.filter($scope.lstCustomerGraph, function (item) {
                        if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay)) {
                            return item;
                        }
                    });
                    // var ShopCustomer = _.filter($scope.lstCustomerGraph, function(item) {
                    //     if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.Type == 'Shop' || item.Type == 'Both')) {
                    //         return item;
                    //     }
                    // });
                } else if ($scope.model.CountryName == '' || $scope.model.CountryName == null) {
                    var Customer = _.filter($scope.lstCustomerGraph, function (item) {
                        if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.country == '' || item.country == null)) {
                            return item;
                        }
                    });
                    // var ShopCustomer = _.filter($scope.lstCustomerGraph, function(item) {
                    //     if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.Type == 'Shop' || item.Type == 'Both') && (item.country == '' || item.country == null)) {
                    //         return item;
                    //     }
                    // });
                } else {
                    var Customer = _.filter($scope.lstCustomerGraph, function (item) {
                        if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.country == $scope.model.CountryName)) {
                            return item;
                        }
                    });
                    // var ShopCustomer = _.filter($scope.lstCustomerGraph, function(item) {
                    //     if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.Type == 'Shop' || item.Type == 'Both') && (item.country == $scope.model.CountryName)) {
                    //         return item;
                    //     }
                    // });
                }


                objCustomer.y = Customer.length;
                $scope.lstCustomer.push(objCustomer);

                // var objOwnerCustomer = new Object();
                // objOwnerCustomer.x = moment($filter('date')(new Date(date), "MM/dd/yyyy")).valueOf();
                // if ($scope.model.CountryName == 'All') {
                //     var OwnerCustomer = _.filter($scope.lstCustomerGraph, function(item) {
                //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.Type == 'Owner' || item.Type == 'Both')) {
                //             return item;
                //         }
                //     });
                // } else if ($scope.model.CountryName == '' || $scope.model.CountryName == null) {
                //     var OwnerCustomer = _.filter($scope.lstCustomerGraph, function(item) {
                //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.Type == 'Owner' || item.Type == 'Both') && (item.country == '' || item.country == null)) {
                //             return item;
                //         }
                //     });
                // } else {
                //     var OwnerCustomer = _.filter($scope.lstCustomerGraph, function(item) {
                //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.Type == 'Owner' || item.Type == 'Both') && (item.country == $scope.model.CountryName)) {
                //             return item;
                //         }
                //     });
                // }
                // objOwnerCustomer.y = OwnerCustomer.length;
                // $scope.lstOwnerCustomer.push(objOwnerCustomer);


                var objUser = new Object();
                objUser.x = moment($filter('date')(new Date(date), "MM/dd/yyyy")).valueOf();
                if ($scope.model.CountryName == 'All') {
                    var User = _.filter($scope.userslist, function (item) {
                        if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay)) {
                            return item;
                        }
                    });
                    // var ShopUser = _.filter($scope.userslist, function(item) {
                    //     if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.Type == 'Shop' || item.Type == 'Both')) {
                    //         return item;
                    //     }
                    // });
                } else if ($scope.model.CountryName == '' || $scope.model.CountryName == null) {
                    var User = _.filter($scope.userslist, function (item) {
                        if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.country == '' || item.country == null)) {
                            return item;
                        }
                    });
                    // var ShopUser = _.filter($scope.userslist, function(item) {
                    //     if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.Type == 'Shop' || item.Type == 'Both') && (item.country == '' || item.country == null)) {
                    //         return item;
                    //     }
                    // });
                } else {
                    var User = _.filter($scope.userslist, function (item) {
                        if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.country == $scope.model.CountryName)) {
                            return item;
                        }
                    });
                    // var ShopUser = _.filter($scope.userslist, function(item) {
                    //     if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.Type == 'Shop' || item.Type == 'Both') && (item.country == $scope.model.CountryName)) {
                    //         return item;
                    //     }
                    // });
                }

                if (User.length > 0) {
                    var sum = 0;
                    angular.forEach(User, function (value, key) {
                        sum = sum + parseInt(value.Total);
                    })
                    objUser.y = sum;
                } else {
                    objUser.y = 0;
                }
                $scope.lstUser.push(objUser);

                // var objOwnerUser = new Object();
                // objOwnerUser.x = moment($filter('date')(new Date(date), "MM/dd/yyyy")).valueOf();
                // if ($scope.model.CountryName == 'All') {
                //     var ownerUser = _.filter($scope.userslist, function(item) {
                //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.Type == 'Owner' || item.Type == 'Both')) {
                //             return item;
                //         }
                //     });
                // } else if ($scope.model.CountryName == '' || $scope.model.CountryName == null) {
                //     var ownerUser = _.filter($scope.userslist, function(item) {
                //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.Type == 'Owner' || item.Type == 'Both') && (item.country == '' || item.country == null)) {
                //             return item;
                //         }
                //     });
                // } else {
                //     var ownerUser = _.filter($scope.userslist, function(item) {
                //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.Type == 'Owner' || item.Type == 'Both') && (item.country == $scope.model.CountryName)) {
                //             return item;
                //         }
                //     });
                // }
                // if (ownerUser.length > 0) {
                //     var sum1 = 0;
                //     angular.forEach(ownerUser, function(value, key) {
                //         sum1 = sum1 + parseInt(value.Total);
                //     })
                //     objOwnerUser.y = sum1;
                // } else {
                //     objOwnerUser.y = 0;
                // }
                // $scope.lstOwnerUser.push(objOwnerUser);


                if ($scope.custCurrentDay == 1) {
                    if ($scope.custCurrentMonth == 1) {
                        $scope.custCurrentMonth = 12;
                        $scope.custCurrentYear = $scope.custCurrentYear - 1;
                        var lastDay = new Date($scope.custCurrentYear, $scope.custCurrentMonth, 0);
                        $scope.custCurrentDay = lastDay.getDate();
                    } else {
                        $scope.custCurrentMonth = $scope.custCurrentMonth - 1;
                        var lastDay = new Date($scope.custCurrentYear, $scope.custCurrentMonth, 0);
                        $scope.custCurrentDay = lastDay.getDate();
                    }
                } else {
                    $scope.custCurrentDay = $scope.custCurrentDay - 1;
                }
            }
            $scope.dashboardData = [{
                "key": "User",
                "values": $scope.lstUser.reverse()
            },
            {
                "key": "Customer",
                "values": $scope.lstCustomer.reverse()
            }
            ];
            CallGraphData();
        }

        $scope.SearchData = function (o) {
            if (o.Year != 0 && o.MonthId == 0) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent("Please Select Month..")
                        .position('top right')
                        .hideDelay(3000)
                );
                // o.MonthId = 1;
            } else {
                if (o.Year != "0" && o.MonthId != "0") {
                    var oneDay = 24 * 60 * 60 * 1000;
                    var firstDate = new Date(parseInt(o.Year), parseInt(o.MonthId) - 1, 1);
                    var secondDate = new Date(parseInt(o.Year), parseInt(o.MonthId), 0);
                    var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay))) + 1;
                    // $scope.lstShopUserSearch = [];
                    // $scope.lstShopCustomerSearch = [];
                    // $scope.lstOwnerUserSearch = [];
                    // $scope.lstOwnerCustomerSearch = [];

                    $scope.lstUserSearch = [];
                    $scope.lstCustomerSearch = [];

                    var custDate = firstDate,
                        locale = "en-us",
                        stingmonth = custDate.toLocaleString(locale, { month: "long" });
                    $scope.custCurrentYear = parseInt(o.Year);
                    $scope.custCurrentMonth = parseInt(o.MonthId);
                    $scope.custCurrentDay = parseInt(custDate.getDate());
                    for (var k = 0; k < diffDays; k++) {
                        var date1 = k + 1 + '-' + $scope.listMonthbyName[$scope.custCurrentMonth - 1] + '-' + $scope.custCurrentYear;
                        //1
                        var objCustomer = new Object();
                        objCustomer.x = moment($filter('date')(new Date(date1), "MM/dd/yyyy")).valueOf();
                        if (o.CountryName == 'All') {
                            var Customer = _.filter($scope.lstCustomerGraph, function (item) {
                                if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1)) {
                                    return item;
                                }
                            });
                        } else if (o.CountryName == '' || o.CountryName == null) {
                            var Customer = _.filter($scope.lstCustomerGraph, function (item) {
                                if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.country == '' || item.country == null)) {
                                    return item;
                                }
                            });
                        } else {
                            var Customer = _.filter($scope.lstCustomerGraph, function (item) {
                                if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.country == o.CountryName)) {
                                    return item;
                                }
                            });
                        }
                        objCustomer.y = Customer.length;
                        $scope.lstCustomerSearch.push(objCustomer);
                        // //2
                        // var objOwnerCustomer = new Object();
                        // objOwnerCustomer.x = moment($filter('date')(new Date(date1), "MM/dd/yyyy")).valueOf();
                        // if (o.CountryName == 'All') {
                        //     var OwnerCustomer = _.filter($scope.lstCustomerGraph, function(item) {
                        //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.Type == 'Owner' || item.Type == 'Both')) {
                        //             return item;
                        //         }
                        //     });
                        // } else if (o.CountryName == '' || o.CountryName == null) {
                        //     var OwnerCustomer = _.filter($scope.lstCustomerGraph, function(item) {
                        //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.Type == 'Owner' || item.Type == 'Both') && (item.country == '' || item.country == null)) {
                        //             return item;
                        //         }
                        //     });
                        // } else {
                        //     var OwnerCustomer = _.filter($scope.lstCustomerGraph, function(item) {
                        //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.Type == 'Owner' || item.Type == 'Both') && (item.country == o.CountryName)) {
                        //             return item;
                        //         }
                        //     });
                        // }
                        // objOwnerCustomer.y = OwnerCustomer.length;
                        // $scope.lstOwnerCustomerSearch.push(objOwnerCustomer);
                        //3
                        var objUser = new Object();
                        objUser.x = moment($filter('date')(new Date(date1), "MM/dd/yyyy")).valueOf();
                        if (o.CountryName == 'All') {
                            var User = _.filter($scope.userslist, function (item) {
                                if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1)) {
                                    return item;
                                }
                            });
                        } else if (o.CountryName == '' || o.CountryName == null) {
                            var User = _.filter($scope.userslist, function (item) {
                                if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.country == '' || item.country == null)) {
                                    return item;
                                }
                            });
                        } else {
                            var User = _.filter($scope.userslist, function (item) {
                                if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.country == o.CountryName)) {
                                    return item;
                                }
                            });
                        }
                        if (User.length > 0) {
                            var sum = 0;
                            angular.forEach(User, function (value, key) {
                                sum = sum + parseInt(value.Total);
                            })
                            objUser.y = sum;
                        } else {
                            objUser.y = 0;
                        }
                        $scope.lstUserSearch.push(objUser);
                        //4
                        // var objOwnerUser = new Object();
                        // if (o.CountryName == 'All') {
                        //     var ownerUser = _.filter($scope.userslist, function(item) {
                        //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.Type == 'Owner' || item.Type == 'Both')) {
                        //             return item;
                        //         }
                        //     });
                        // } else if (o.CountryName == '' || o.CountryName == null) {
                        //     var ownerUser = _.filter($scope.userslist, function(item) {
                        //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.Type == 'Owner' || item.Type == 'Both') && (item.country == '' || item.country == null)) {
                        //             return item;
                        //         }
                        //     });
                        // } else {
                        //     var ownerUser = _.filter($scope.userslist, function(item) {
                        //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.Type == 'Owner' || item.Type == 'Both') && (item.country == o.CountryName)) {
                        //             return item;
                        //         }
                        //     });
                        // }
                        // objOwnerUser.x = moment($filter('date')(new Date(date1), "MM/dd/yyyy")).valueOf();
                        // if (ownerUser.length > 0) {
                        //     var sum1 = 0;
                        //     angular.forEach(ownerUser, function(value, key) {
                        //         sum1 = sum1 + parseInt(value.Total);
                        //     })
                        //     objOwnerUser.y = sum1;
                        // } else {
                        //     objOwnerUser.y = 0;
                        // }
                        // $scope.lstOwnerUserSearch.push(objOwnerUser);
                    }
                    $scope.dashboardData = [{
                        "key": "User",
                        "values": $scope.lstUserSearch
                    },
                    {
                        "key": "Customer",
                        "values": $scope.lstCustomerSearch
                    }
                    ];
                    CallGraphData();
                } else {
                    $scope.CustomerAndUser(true);
                }
            }
        }

        function CallGraphData() {
            $scope.TotalCustomerUser = {
                title: 'Total Customer and User',
                chart: {
                    options: {
                        chart: {
                            type: 'lineChart',
                            color: [ /*'#4caf50',*/ '#2196F3', /*'#ff5722',*/ '#1a237e'],
                            height: 320,
                            margin: {
                                top: 32,
                                right: 32,
                                bottom: 32,
                                left: 48
                            },
                            useInteractiveGuideline: true,
                            clipVoronoi: false,
                            interpolate: 'monotone',
                            x: function (d) {
                                return d.x;
                            },
                            y: function (d) {
                                return d.y;
                            },
                            //xScale = d3.time.scale();
                            xAxis: {
                                tickFormat: function (d) {
                                    return moment(d).format("D-MMM-YYYY");
                                },
                                showMaxMin: false
                            },
                            yAxis: {
                                tickFormat: function (d) {
                                    return d;
                                }
                            },
                            interactiveLayer: {
                                tooltip: {
                                    gravity: 's',
                                    classes: 'gravity-s'
                                }
                            },
                            legend: {
                                margin: {
                                    top: 8,
                                    right: 0,
                                    bottom: 32,
                                    left: 0
                                },
                                rightAlign: false
                            }
                        }
                    },
                    data: $scope.dashboardData
                }
            };
        }

        $scope.CustomerAndUserAcc = function (flag) {
            $scope.weekDays = '';
            $scope.weekMonths = '';
            var currentDate = moment();
            var weekStart = currentDate.clone().startOf('days');
            $scope.days = [];
            $scope.months = [];
            $scope.lstUserAcc = [];
            $scope.lstCustomerAcc = [];
            for (var i = 0; i <= 30; i++) {
                $scope.days.push(moment(weekStart).subtract(i, 'days').format("Do"));
                $scope.months.push(moment(weekStart).subtract(i, 'month').format("M"));
            };

            var custDate1 = new Date();
            var date = custDate1.setDate(custDate1.getDate() - parseInt(29));
            var date1 = new Date(moment(date).format("D-MMM-YYYY"));
            $scope.custCurrentYear = date1.getFullYear();
            $scope.custCurrentMonth = date1.getMonth() + 1;
            $scope.custCurrentDay = date1.getDate();
            var daywiseuserlist = [];
            var labelsday = [];
            $scope.model.YearAcc = "0";
            $scope.model.MonthIdAcc = "0";
            if (flag == false) {
                $scope.model.CountryNameAcc = 'All';
            }
            var sum1 = 0;
            var sum2 = 0;
            var sum3 = 0;
            var sum4 = 0;
            var objcurrentDate = new Date($scope.custCurrentYear.toString() + "-" + $scope.custCurrentMonth.toString() + "-" + $scope.custCurrentDay.toString());

            var lstInitialCustomerdata = [];
            if ($scope.model.CountryNameAcc == 'All') {
                lstInitialCustomerdata = _.filter($scope.lstCustomerGraph, function (obj) {
                    var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
                    if ((objdate < objcurrentDate)) {
                        return obj;
                    };
                })
            } else if ($scope.model.CountryNameAcc == '' || $scope.model.CountryNameAcc == null) {
                lstInitialCustomerdata = _.filter($scope.lstCustomerGraph, function (obj) {
                    var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
                    if ((objdate < objcurrentDate && obj.country == null)) {
                        return obj;
                    };
                })
            } else {
                lstInitialCustomerdata = _.filter($scope.lstCustomerGraph, function (obj) {
                    var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
                    if ((objdate < objcurrentDate && obj.country == $scope.model.CountryNameAcc)) {
                        return obj;
                    };
                })
            }
            sum1 = lstInitialCustomerdata.length;

            // var lstInitialOwnerCustomerdata = [];
            // if ($scope.model.CountryNameAcc == 'All') {
            //     lstInitialOwnerCustomerdata = _.filter($scope.lstCustomerGraph, function(obj) {
            //         var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
            //         if ((objdate < objcurrentDate) && (obj.Type == 'Owner' || obj.Type == 'Both')) {
            //             return obj;
            //         };
            //     })
            // } else if ($scope.model.CountryNameAcc == '' || $scope.model.CountryNameAcc == null) {
            //     lstInitialOwnerCustomerdata = _.filter($scope.lstCustomerGraph, function(obj) {
            //         var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
            //         if ((objdate < objcurrentDate && obj.country == null) && (obj.Type == 'Owner' || obj.Type == 'Both')) {
            //             return obj;
            //         };
            //     })
            // } else {
            //     lstInitialOwnerCustomerdata = _.filter($scope.lstCustomerGraph, function(obj) {
            //         var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
            //         if ((objdate < objcurrentDate && obj.country == $scope.model.CountryNameAcc) && (obj.Type == 'Owner' || obj.Type == 'Both')) {
            //             return obj;
            //         };
            //     })
            // }
            // sum2 = lstInitialOwnerCustomerdata.length;

            var lstInitialUserdata = [];
            if ($scope.model.CountryNameAcc == 'All') {
                lstInitialUserdata = _.filter($scope.userslist, function (obj) {
                    var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
                    if ((objdate < objcurrentDate)) {
                        return obj;
                    };
                })
            } else if ($scope.model.CountryNameAcc == '' || $scope.model.CountryNameAcc == null) {
                lstInitialUserdata = _.filter($scope.userslist, function (obj) {
                    var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
                    if ((objdate < objcurrentDate && obj.country == null)) {
                        return obj;
                    };
                })
            } else {
                lstInitialUserdata = _.filter($scope.userslist, function (obj) {
                    var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
                    if ((objdate < objcurrentDate && obj.country == $scope.model.CountryNameAcc)) {
                        return obj;
                    };
                })
            }
            var TempUsersum = 0;
            angular.forEach(lstInitialUserdata, function (value, key) {
                TempUsersum = TempUsersum + parseInt(value.Total);
            })
            sum3 = TempUsersum;

            // var lstInitialOwnerUserdata = [];
            // if ($scope.model.CountryNameAcc == 'All') {
            //     lstInitialOwnerUserdata = _.filter($scope.userslist, function(obj) {
            //         var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
            //         if ((objdate < objcurrentDate) && (obj.Type == 'Owner' || obj.Type == 'Both')) {
            //             return obj;
            //         };
            //     })
            // } else if ($scope.model.CountryNameAcc == '' || $scope.model.CountryNameAcc == null) {
            //     lstInitialOwnerUserdata = _.filter($scope.userslist, function(obj) {
            //         var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
            //         if ((objdate < objcurrentDate && obj.country == null) && (obj.Type == 'Owner' || obj.Type == 'Both')) {
            //             return obj;
            //         };
            //     })
            // } else {
            //     lstInitialOwnerUserdata = _.filter($scope.userslist, function(obj) {
            //         var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
            //         if ((objdate < objcurrentDate && obj.country == $scope.model.CountryNameAcc) && (obj.Type == 'Owner' || obj.Type == 'Both')) {
            //             return obj;
            //         };
            //     })
            // }
            // var TempOwnerUsersum = 0;
            // angular.forEach(lstInitialOwnerUserdata, function(value, key) {
            //     TempOwnerUsersum = TempOwnerUsersum + parseInt(value.Total);
            // })
            // sum4 = TempOwnerUsersum;

            for (var i = 0; i < 30; i++) {
                var date = $scope.custCurrentDay + '-' + $scope.listMonthbyName[$scope.custCurrentMonth - 1] + '-' + $scope.custCurrentYear;
                //1                
                var objCustomer = new Object();
                objCustomer.x = moment($filter('date')(new Date(date), "MM/dd/yyyy")).valueOf();
                if ($scope.model.CountryNameAcc == 'All') {
                    var Customer = _.filter($scope.lstCustomerGraph, function (item) {
                        if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay)) {
                            return item;
                        }
                    });
                } else if ($scope.model.CountryNameAcc == '' || $scope.model.CountryNameAcc == null) {
                    var Customer = _.filter($scope.lstCustomerGraph, function (item) {
                        if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.country == '' || item.country == null)) {
                            return item;
                        }
                    });
                } else {
                    var Customer = _.filter($scope.lstCustomerGraph, function (item) {
                        if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.country == $scope.model.CountryNameAcc)) {
                            return item;
                        }
                    });
                }
                sum1 = sum1 + Customer.length
                objCustomer.y = sum1;
                $scope.lstCustomerAcc.push(objCustomer);
                //2
                // var objOwnerCustomer = new Object();
                // objOwnerCustomer.x = moment($filter('date')(new Date(date), "MM/dd/yyyy")).valueOf();
                // if ($scope.model.CountryNameAcc == 'All') {
                //     var OwnerCustomer = _.filter($scope.lstCustomerGraph, function(item) {
                //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay)) {
                //             return item;
                //         }
                //     });
                // } else if ($scope.model.CountryNameAcc == '' || $scope.model.CountryNameAcc == null) {
                //     var OwnerCustomer = _.filter($scope.lstCustomerGraph, function(item) {
                //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.country == '' || item.country == null)) {
                //             return item;
                //         }
                //     });
                // } else {
                //     var OwnerCustomer = _.filter($scope.lstCustomerGraph, function(item) {
                //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.country == $scope.model.CountryNameAcc)) {
                //             return item;
                //         }
                //     });
                // }
                // sum2 = sum2 + OwnerCustomer.length
                // objOwnerCustomer.y = sum2;
                // $scope.lstOwnerCustomerAcc.push(objOwnerCustomer);
                //3
                var objUser = new Object();
                objUser.x = moment($filter('date')(new Date(date), "MM/dd/yyyy")).valueOf();
                if ($scope.model.CountryNameAcc == 'All') {
                    var User = _.filter($scope.userslist, function (item) {
                        if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay)) {
                            return item;
                        }
                    });
                } else if ($scope.model.CountryNameAcc == '' || $scope.model.CountryNameAcc == null) {
                    var User = _.filter($scope.userslist, function (item) {
                        if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.country == '' || item.country == null)) {
                            return item;
                        }
                    });
                } else {
                    var User = _.filter($scope.userslist, function (item) {
                        if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.country == $scope.model.CountryNameAcc)) {
                            return item;
                        }
                    });
                }
                if (User.length > 0) {
                    var sum = 0;
                    angular.forEach(User, function (value, key) {
                        sum = sum + parseInt(value.Total);
                    })
                    sum3 = sum3 + sum;
                    objUser.y = sum3;
                } else {
                    objUser.y = sum3;
                }
                $scope.lstUserAcc.push(objUser);
                //4
                // var objOwnerUser = new Object();
                // objOwnerUser.x = moment($filter('date')(new Date(date), "MM/dd/yyyy")).valueOf();
                // if ($scope.model.CountryNameAcc == 'All') {
                //     var ownerUser = _.filter($scope.userslist, function(item) {
                //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.Type == 'Owner' || item.Type == 'Both')) {
                //             return item;
                //         }
                //     });
                // } else if ($scope.model.CountryNameAcc == '' || $scope.model.CountryNameAcc == null) {
                //     var ownerUser = _.filter($scope.userslist, function(item) {
                //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.Type == 'Owner' || item.Type == 'Both') && (item.country == '' || item.country == null)) {
                //             return item;
                //         }
                //     });
                // } else {
                //     var ownerUser = _.filter($scope.userslist, function(item) {
                //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == $scope.custCurrentDay) && (item.Type == 'Owner' || item.Type == 'Both') && (item.country == $scope.model.CountryNameAcc)) {
                //             return item;
                //         }
                //     });
                // }
                // if (ownerUser.length > 0) {
                //     var sumowneruser = 0;
                //     angular.forEach(ownerUser, function(value, key) {
                //         sumowneruser = sumowneruser + parseInt(value.Total);
                //     })
                //     sum4 = sum4 + sumowneruser;
                //     objOwnerUser.y = sum4;
                // } else {
                //     objOwnerUser.y = sum4;
                // }
                // $scope.lstOwnerUserAcc.push(objOwnerUser);

                var MonthLast = new Date();
                var LastDateMs = MonthLast.setDate(MonthLast.getDate() - parseInt(29));
                var ConvertLastDate = new Date(moment(LastDateMs).format("D-MMM-YYYY"));
                var MonthLastDate = new Date(parseInt(ConvertLastDate.getFullYear()), parseInt(ConvertLastDate.getMonth() + 1), 0);
                if (MonthLastDate.getDate() == $scope.custCurrentDay) {
                    if ($scope.custCurrentMonth == 12) {
                        $scope.custCurrentDay = 1
                        $scope.custCurrentMonth = 1;
                        $scope.custCurrentYear = $scope.custCurrentYear + 1;
                    } else {
                        $scope.custCurrentDay = 1
                        $scope.custCurrentMonth = $scope.custCurrentMonth + 1;
                    }
                } else {
                    $scope.custCurrentDay = $scope.custCurrentDay + 1;
                }
            }
            $scope.dashboardData1 = [{
                "key": "User",
                "values": $scope.lstUserAcc
            },
            {
                "key": "Customer",
                "values": $scope.lstCustomerAcc
            }
            ];
            CallGraphDataAcc();
        }

        $scope.SearchDataAcc = function (o) {
            if (o.YearAcc != 0 && o.MonthIdAcc == 0) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent("Please Select Month..")
                        .position('top right')
                        .hideDelay(3000)
                );
            } else {
                if (o.YearAcc != "0" && o.MonthIdAcc != "0") {
                    var oneDay = 24 * 60 * 60 * 1000;
                    var firstDate = new Date(parseInt(o.YearAcc), parseInt(o.MonthIdAcc) - 1, 1);
                    var secondDate = new Date(parseInt(o.YearAcc), parseInt(o.MonthIdAcc), 0);
                    var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay))) + 1;


                    $scope.weekDays = '';
                    $scope.weekMonths = '';
                    $scope.lstUserAccSearch = [];
                    $scope.lstCustomerAccSearch = [];

                    var custDate = firstDate,
                        locale = "en-us",
                        stingmonth = custDate.toLocaleString(locale, { month: "long" });
                    $scope.custCurrentYear = parseInt(o.YearAcc);
                    $scope.custCurrentMonth = parseInt(o.MonthIdAcc);
                    $scope.custCurrentDay = parseInt(custDate.getDate());
                    var sum1Acc = 0;
                    var sum2Acc = 0;
                    var sum3Acc = 0;
                    var sum4Acc = 0;
                    var objcurrentDate = new Date($scope.custCurrentYear.toString() + "-" + $scope.custCurrentMonth.toString() + "-" + $scope.custCurrentDay.toString());

                    var lstInitialCustomerdata = [];
                    if ($scope.model.CountryNameAcc == 'All') {
                        lstInitialCustomerdata = _.filter($scope.lstCustomerGraph, function (obj) {
                            var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
                            if ((objdate < objcurrentDate)) {
                                return obj;
                            };
                        })
                    } else if ($scope.model.CountryNameAcc == '' || $scope.model.CountryNameAcc == null) {
                        lstInitialCustomerdata = _.filter($scope.lstCustomerGraph, function (obj) {
                            var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
                            if ((objdate < objcurrentDate && obj.country == null)) {
                                return obj;
                            };
                        })
                    } else {
                        lstInitialCustomerdata = _.filter($scope.lstCustomerGraph, function (obj) {
                            var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
                            if ((objdate < objcurrentDate && obj.country == $scope.model.CountryNameAcc)) {
                                return obj;
                            };
                        })
                    }
                    sum1Acc = lstInitialCustomerdata.length;

                    // var lstInitialOwnerCustomerdata = [];
                    // if ($scope.model.CountryNameAcc == 'All') {
                    //     lstInitialOwnerCustomerdata = _.filter($scope.lstCustomerGraph, function(obj) {
                    //         var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
                    //         if ((objdate < objcurrentDate) && (obj.Type == 'Owner' || obj.Type == 'Both')) {
                    //             return obj;
                    //         };
                    //     })
                    // } else if ($scope.model.CountryNameAcc == '' || $scope.model.CountryNameAcc == null) {
                    //     lstInitialOwnerCustomerdata = _.filter($scope.lstCustomerGraph, function(obj) {
                    //         var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
                    //         if ((objdate < objcurrentDate && obj.country == null) && (obj.Type == 'Owner' || obj.Type == 'Both')) {
                    //             return obj;
                    //         };
                    //     })
                    // } else {
                    //     lstInitialOwnerCustomerdata = _.filter($scope.lstCustomerGraph, function(obj) {
                    //         var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
                    //         if ((objdate < objcurrentDate && obj.country == $scope.model.CountryNameAcc) && (obj.Type == 'Owner' || obj.Type == 'Both')) {
                    //             return obj;
                    //         };
                    //     })
                    // }
                    // sum2Acc = lstInitialOwnerCustomerdata.length;

                    var lstInitialUserdata = [];
                    if ($scope.model.CountryNameAcc == 'All') {
                        lstInitialUserdata = _.filter($scope.userslist, function (obj) {
                            var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
                            if ((objdate < objcurrentDate)) {
                                return obj;
                            };
                        })
                    } else if ($scope.model.CountryNameAcc == '' || $scope.model.CountryNameAcc == null) {
                        lstInitialUserdata = _.filter($scope.userslist, function (obj) {
                            var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
                            if ((objdate < objcurrentDate && obj.country == null)) {
                                return obj;
                            };
                        })
                    } else {
                        lstInitialUserdata = _.filter($scope.userslist, function (obj) {
                            var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
                            if ((objdate < objcurrentDate && obj.country == $scope.model.CountryNameAcc)) {
                                return obj;
                            };
                        })
                    }
                    var TempUsersum = 0;
                    angular.forEach(lstInitialUserdata, function (value, key) {
                        TempUsersum = TempUsersum + parseInt(value.Total);
                    })
                    sum3Acc = TempUsersum;

                    // var lstInitialOwnerUserdata = [];
                    // if ($scope.model.CountryNameAcc == 'All') {
                    //     lstInitialOwnerUserdata = _.filter($scope.userslist, function(obj) {
                    //         var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
                    //         if ((objdate < objcurrentDate) && (obj.Type == 'Owner' || obj.Type == 'Both')) {
                    //             return obj;
                    //         };
                    //     })
                    // } else if ($scope.model.CountryNameAcc == '' || $scope.model.CountryNameAcc == null) {
                    //     lstInitialOwnerUserdata = _.filter($scope.userslist, function(obj) {
                    //         var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
                    //         if ((objdate < objcurrentDate && obj.country == null) && (obj.Type == 'Owner' || obj.Type == 'Both')) {
                    //             return obj;
                    //         };
                    //     })
                    // } else {
                    //     lstInitialOwnerUserdata = _.filter($scope.userslist, function(obj) {
                    //         var objdate = new Date(obj.year.toString() + "-" + obj.month.toString() + "-" + obj.day.toString());
                    //         if ((objdate < objcurrentDate && obj.country == $scope.model.CountryNameAcc) && (obj.Type == 'Owner' || obj.Type == 'Both')) {
                    //             return obj;
                    //         };
                    //     })
                    // }
                    // var TempOwnerUsersum = 0;
                    // angular.forEach(lstInitialOwnerUserdata, function(value, key) {
                    //     TempOwnerUsersum = TempOwnerUsersum + parseInt(value.Total);
                    // })
                    // sum4Acc = TempOwnerUsersum;




                    for (var k = 0; k < diffDays; k++) {
                        var date = k + 1 + '-' + $scope.listMonthbyName[$scope.custCurrentMonth - 1] + '-' + $scope.custCurrentYear;
                        //1                
                        var objCustomer = new Object();
                        objCustomer.x = moment($filter('date')(new Date(date), "MM/dd/yyyy")).valueOf();
                        if (o.CountryName == 'All') {
                            var Customer = _.filter($scope.lstCustomerGraph, function (item) {
                                if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1)) {
                                    return item;
                                }
                            });
                        } else if (o.CountryNameAcc == '' || o.CountryNameAcc == null) {
                            var Customer = _.filter($scope.lstCustomerGraph, function (item) {
                                if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.country == '' || item.country == null)) {
                                    return item;
                                }
                            });
                        } else {
                            var Customer = _.filter($scope.lstCustomerGraph, function (item) {
                                if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.country == o.CountryNameAcc)) {
                                    return item;
                                }
                            });
                        }
                        sum1Acc = sum1Acc + Customer.length
                        objCustomer.y = sum1Acc;
                        $scope.lstCustomerAccSearch.push(objCustomer);
                        //2
                        // var objCustomer = new Object();
                        // objCustomer.x = moment($filter('date')(new Date(date), "MM/dd/yyyy")).valueOf();
                        // if (o.CountryName == 'All') {
                        //     var OwnerCustomer = _.filter($scope.lstCustomerGraph, function(item) {
                        //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.Type == 'Owner' || item.Type == 'Both')) {
                        //             return item;
                        //         }
                        //     });
                        // } else if (o.CountryNameAcc == '' || o.CountryNameAcc == null) {
                        //     var OwnerCustomer = _.filter($scope.lstCustomerGraph, function(item) {
                        //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.Type == 'Owner' || item.Type == 'Both') && (item.country == '' || item.country == null)) {
                        //             return item;
                        //         }
                        //     });
                        // } else {
                        //     var OwnerCustomer = _.filter($scope.lstCustomerGraph, function(item) {
                        //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.Type == 'Owner' || item.Type == 'Both') && (item.country == o.CountryNameAcc)) {
                        //             return item;
                        //         }
                        //     });
                        // }
                        // sum2Acc = sum2Acc + OwnerCustomer.length
                        // objOwnerCustomer.y = sum2Acc;
                        // $scope.lstOwnerCustomerAccSearch.push(objOwnerCustomer);
                        //3
                        var objUser = new Object();
                        if (o.CountryName == 'All') {
                            var User = _.filter($scope.userslist, function (item) {
                                if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1)) {
                                    return item;
                                }
                            });
                        } else if (o.CountryNameAcc == '' || o.CountryNameAcc == null) {
                            var User = _.filter($scope.userslist, function (item) {
                                if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.country == '' || item.country == null)) {
                                    return item;
                                }
                            });
                        } else {
                            var User = _.filter($scope.userslist, function (item) {
                                if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.country == o.CountryNameAcc)) {
                                    return item;
                                }
                            });
                        }
                        objUser.x = moment($filter('date')(new Date(date), "MM/dd/yyyy")).valueOf();
                        if (User.length > 0) {
                            var sum = 0;
                            angular.forEach(User, function (value, key) {
                                sum = sum + parseInt(value.Total);
                            })
                            sum3Acc = sum3Acc + sum;
                            objUser.y = sum3Acc;
                        } else {
                            objUser.y = sum3Acc;
                        }
                        $scope.lstUserAccSearch.push(objUser);
                        //4
                        // var objOwnerUser = new Object();
                        // if (o.CountryName == 'All') {
                        //     var ownerUser = _.filter($scope.userslist, function(item) {
                        //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.Type == 'Owner' || item.Type == 'Both')) {
                        //             return item;
                        //         }
                        //     });
                        // } else if (o.CountryNameAcc == '' || o.CountryNameAcc == null) {
                        //     var ownerUser = _.filter($scope.userslist, function(item) {
                        //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.Type == 'Owner' || item.Type == 'Both') && (item.country == '' || item.country == null)) {
                        //             return item;
                        //         }
                        //     });
                        // } else {
                        //     var ownerUser = _.filter($scope.userslist, function(item) {
                        //         if ((item.year == $scope.custCurrentYear && item.month == $scope.custCurrentMonth && item.day == k + 1) && (item.Type == 'Owner' || item.Type == 'Both') && (item.country == o.CountryNameAcc)) {
                        //             return item;
                        //         }
                        //     });
                        // }
                        // objOwnerUser.x = moment($filter('date')(new Date(date), "MM/dd/yyyy")).valueOf();
                        // if (ownerUser.length > 0) {
                        //     var sumowneruser = 0;
                        //     angular.forEach(ownerUser, function(value, key) {
                        //         sumowneruser = sumowneruser + parseInt(value.Total);
                        //     })
                        //     sum4Acc = sum4Acc + sumowneruser;
                        //     objOwnerUser.y = sum4Acc;
                        // } else {
                        //     objOwnerUser.y = sum4Acc;
                        // }
                        // $scope.lstOwnerUserAccSearch.push(objOwnerUser);
                    }
                    $scope.dashboardData1 = [{
                        "key": "User",
                        "values": $scope.lstUserAccSearch
                    },
                    {
                        "key": "Customer",
                        "values": $scope.lstCustomerAccSearch
                    }
                    ];
                    CallGraphDataAcc();
                } else {
                    $scope.CustomerAndUserAcc(true);
                }
            }
        }

        function CallGraphDataAcc() {
            $scope.TotalCustomerUserAcc = {
                title: 'Total Accumulate Customer and User',
                chart: {
                    options: {
                        chart: {
                            type: 'lineChart',
                            color: [ /*'#4caf50',*/ '#2196F3', /*'#ff5722',*/ '#1a237e'],
                            height: 320,
                            margin: {
                                top: 32,
                                right: 32,
                                bottom: 32,
                                left: 48
                            },
                            useInteractiveGuideline: true,
                            clipVoronoi: false,
                            interpolate: 'linear',
                            x: function (d) {
                                return d.x;
                            },
                            y: function (d) {

                                return d.y;
                            },
                            //xScale = d3.time.scale();
                            xAxis: {
                                tickFormat: function (d) {

                                    return moment(d).format("D-MMM-YYYY");;
                                },
                                showMaxMin: false
                            },
                            yAxis: {
                                tickFormat: function (d) {
                                    return d;
                                }
                            },
                            interactiveLayer: {
                                tooltip: {
                                    gravity: 's',
                                    classes: 'gravity-s'
                                }
                            },
                            legend: {
                                margin: {
                                    top: 8,
                                    right: 0,
                                    bottom: 32,
                                    left: 0
                                },
                                rightAlign: false
                            }
                        }
                    },
                    data: $scope.dashboardData1
                }
            };
        }



        $scope.CustomerGraph = function () {
            $scope.weekDays = '';
            $scope.weekMonths = '';
            var currentDate = moment();
            var weekStart = currentDate.clone().startOf('days');
            $scope.days = [];
            $scope.months = [];
            for (var i = 0; i <= 30; i++) {
                $scope.days.push(moment(weekStart).subtract(i, 'days').format("Do"));
                $scope.months.push(moment(weekStart).subtract(i, 'month').format("M"));
            };

            var custDate = new Date(),
                locale = "en-us",
                stingmonth = custDate.toLocaleString(locale, { month: "long" });
            $scope.custCurrentYear = custDate.getFullYear();
            $scope.custCurrentMonth = custDate.getMonth() + 1;
            $scope.custCurrentDay = custDate.getDate();
            var daywiseuserlist = [];
            var labelsday = [];

            for (var i = 0; i < 30; i++) {
                var objUser = _.where($scope.lstCustomerGraph, { day: $scope.custCurrentDay, month: $scope.custCurrentMonth });
                daywiseuserlist.push(objUser.length);

                //Add Label for graph
                var d = $scope.custCurrentDay + ' - ' + $scope.listMonthbyName[$scope.custCurrentMonth - 1] + ' - ' + $scope.custCurrentYear;
                labelsday.push(d);

                if ($scope.custCurrentDay == 1) {
                    if ($scope.custCurrentMonth == 1) {
                        $scope.custCurrentMonth = 12;
                        $scope.custCurrentYear = $scope.custCurrentYear - 1;
                    }

                    $scope.custCurrentMonth = $scope.custCurrentMonth - 1;
                    var lastDay = new Date($scope.custCurrentYear, $scope.custCurrentMonth, 0);
                    $scope.custCurrentDay = lastDay.getDate();

                } else {
                    $scope.custCurrentDay = $scope.custCurrentDay - 1;
                }
            };
            $scope.weekDays = labelsday.reverse();
            daywiseuserlist = daywiseuserlist.reverse();

            $scope.lineChart = {
                // labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                series: ['Total Number of Customer'],
                data: [daywiseuserlist]
            }
        }


        $scope.GetDashboardCount = function () {
            if (!$scope.FlgSuperAdmin) {
                var params = {
                    // countryName: $rootScope.UserCountry,
                    // CountryList: $rootScope.CountryList,
                    // IsSuperAdmin: $scope.FlgSuperAdmin,
                    idApp: $rootScope.appId,
                }
            } else {
                var params = {
                    // countryName: null,
                    // CountryList: [],
                    // IsSuperAdmin: $scope.FlgSuperAdmin,
                    idApp: $rootScope.appId,
                }
            }

            $http.get($rootScope.RoutePath + "dashboard/GetDashboardData", { params: params }).then(function (data) {

                $scope.lstDashBoardInfo = data.data;
                //Today
                if (data.data.sumTodayCancelled == null) {
                    $scope.lstDashBoardInfo.sumTodayCancelled = 0;
                } else {
                    $scope.lstDashBoardInfo.sumTodayCancelled = data.data.sumTodayCancelled;
                }
                if (data.data.sumTodayProcessing == null) {
                    $scope.lstDashBoardInfo.sumTodayProcessing = 0;
                } else {
                    $scope.lstDashBoardInfo.sumTodayProcessing = data.data.sumTodayProcessing;
                }
                if (data.data.sumTodayPending == null) {
                    $scope.lstDashBoardInfo.sumTodayPending = 0;
                } else {
                    $scope.lstDashBoardInfo.sumTodayPending = data.data.sumTodayPending;
                }
                if (data.data.sumTodayCompleted == null) {
                    $scope.lstDashBoardInfo.sumTodayCompleted = 0;
                } else {
                    $scope.lstDashBoardInfo.sumTodayCompleted = data.data.sumTodayCompleted;
                }
                //This year
                if (data.data.sumThisYearCancelled == null) {
                    $scope.lstDashBoardInfo.sumThisYearCancelled = 0;
                } else {
                    $scope.lstDashBoardInfo.sumThisYearCancelled = data.data.sumThisYearCancelled;
                }
                if (data.data.sumThisYearCompleted == null) {
                    $scope.lstDashBoardInfo.sumThisYearCompleted = 0;
                } else {
                    $scope.lstDashBoardInfo.sumThisYearCompleted = data.data.sumThisYearCompleted;
                }
                if (data.data.sumThisYearPending == null) {
                    $scope.lstDashBoardInfo.sumThisYearPending = 0;
                } else {
                    $scope.lstDashBoardInfo.sumThisYearPending = data.data.sumThisYearPending;
                }
                if (data.data.sumThisYearProcessing == null) {
                    $scope.lstDashBoardInfo.sumThisYearProcessing = 0;
                } else {
                    $scope.lstDashBoardInfo.sumThisYearProcessing = data.data.sumThisYearProcessing;
                }
                //This Months
                if (data.data.sumThisMonthProcessing == null) {
                    $scope.lstDashBoardInfo.sumThisMonthProcessing = 0;
                } else {
                    $scope.lstDashBoardInfo.sumThisMonthProcessing = data.data.sumThisMonthProcessing;
                }
                if (data.data.sumThisMonthPending == null) {
                    $scope.lstDashBoardInfo.sumThisMonthPending = 0;
                } else {
                    $scope.lstDashBoardInfo.sumThisMonthPending = data.data.sumThisMonthPending;
                }
                if (data.data.sumThisMonthCompleted == null) {
                    $scope.lstDashBoardInfo.sumThisMonthCompleted = 0;
                } else {
                    $scope.lstDashBoardInfo.sumThisMonthCompleted = data.data.sumThisMonthCompleted;
                }
                if (data.data.sumThisMonthCancelled == null) {
                    $scope.lstDashBoardInfo.sumThisMonthCancelled = 0;
                } else {
                    $scope.lstDashBoardInfo.sumThisMonthCancelled = data.data.sumThisMonthCancelled;
                }
                //This Week
                if (data.data.sumLastWeekProcessing == null) {
                    $scope.lstDashBoardInfo.sumLastWeekProcessing = 0;
                } else {
                    $scope.lstDashBoardInfo.sumLastWeekProcessing = data.data.sumLastWeekProcessing;
                }
                if (data.data.sumLastWeekPending == null) {
                    $scope.lstDashBoardInfo.sumLastWeekPending = 0;
                } else {
                    $scope.lstDashBoardInfo.sumLastWeekPending = data.data.sumLastWeekPending;
                }
                if (data.data.sumLastWeekCompleted == null) {
                    $scope.lstDashBoardInfo.sumLastWeekCompleted = 0;
                } else {
                    $scope.lstDashBoardInfo.sumLastWeekCompleted = data.data.sumLastWeekCompleted;
                }
                if (data.data.sumLastWeekCancelled == null) {
                    $scope.lstDashBoardInfo.sumLastWeekCancelled = 0;
                } else {
                    $scope.lstDashBoardInfo.sumLastWeekCancelled = data.data.sumLastWeekCancelled;
                }
                //All Time
                if (data.data.sumAllTimePending == null) {
                    $scope.lstDashBoardInfo.sumAllTimePending = 0;
                } else {
                    $scope.lstDashBoardInfo.sumAllTimePending = data.data.sumAllTimePending;
                }
                if (data.data.sumAllTimeCancelled == null) {
                    $scope.lstDashBoardInfo.sumAllTimeCancelled = 0;
                } else {
                    $scope.lstDashBoardInfo.sumAllTimeCancelled = data.data.sumAllTimeCancelled;
                }
                if (data.data.sumAllTimeCompleted == null) {
                    $scope.lstDashBoardInfo.sumAllTimeCompleted = 0;
                } else {
                    $scope.lstDashBoardInfo.sumAllTimeCompleted = data.data.sumAllTimeCompleted;
                }
                if (data.data.sumAllTimeProcessing == null) {
                    $scope.lstDashBoardInfo.sumAllTimeProcessing = 0;
                } else {
                    $scope.lstDashBoardInfo.sumAllTimeProcessing = data.data.sumAllTimeProcessing;
                }
                $timeout(function () {
                    $scope.ManageGraphOrderTotalByDuration('All');
                }, 600);
            });
        }

        $scope.ManageGraph = function () {

            if (!$scope.FlgSuperAdmin) {
                var params = {
                    // countryName: $rootScope.UserCountry,
                    // CountryList: $rootScope.CountryList,
                    // IsSuperAdmin: $scope.FlgSuperAdmin,
                    idApp: $rootScope.appId,
                }
            } else {
                var params = {
                    // countryName: null,
                    // CountryList: $rootScope.CountryList,
                    // IsSuperAdmin: $scope.FlgSuperAdmin,
                    idApp: $rootScope.appId,
                }
            }

            $http.get($rootScope.RoutePath + "dashboard/GetGraphData", { params: params }).then(function (data) {

                $scope.userslist = data.data.UserData;
                $scope.uploader();

            });
        }

        $scope.GetCustomer = function () {
            var params = {
                // countryName: $rootScope.UserCountry,
                // CountryList: $rootScope.CountryList,
                // IsSuperAdmin: $scope.FlgSuperAdmin,
                idApp: $rootScope.appId,
            }


            $http.get($rootScope.RoutePath + "dashboard/GetTotalCustomer", { params: params }).then(function (data) {
                $scope.lstTotalCustomer = data.data[0].Count;
            });
        }

        $scope.uploader = function () {
            var objDate = new Date(),
                locale = "en-us",
                stingmonth = objDate.toLocaleString(locale, { month: "long" });
            $scope.CurrentYear = objDate.getFullYear();
            $scope.CurrentMonth = objDate.getMonth() + 1;

            var monthname = "";
            var monthlist = [];
            var monthwiselist = [];
            // var monthwiseOwnerlist = [];
            // var monthwiseorderlist = [];
            $scope.listMonthbyName = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            $scope.dataUsresbgcolor = [{
                fillColor: 'rgba(33, 150, 243, 0.6)',
                strokeColor: 'rgba(33, 150, 243, 1)',
                highlightFill: 'rgba(33, 150, 243, 1)',
                highlightStroke: 'rgba(33, 150, 243, 1)'
            }];
            $scope.labelsMonth = [];
            $scope.Bardata = [];
            for (var i = 0; i < 12; i++) {
                var objbar = new Object();
                var objUser = _.where($scope.userslist, { month: $scope.CurrentMonth, year: $scope.CurrentYear });
                if (objUser.length > 0) {

                    var newobjUser = _.each(objUser, function (item) {
                        $scope.sum = function (items, prop) {
                            return items.reduce(function (a, b) {
                                return a + b[prop];
                            }, 0);
                        };
                    });
                    objbar.y = $scope.sum(newobjUser, 'Total');
                    objbar.x = $scope.listMonthbyName[$scope.CurrentMonth - 1] + ' - ' + $scope.CurrentYear;
                    monthwiselist.push($scope.sum(newobjUser, 'Total'))
                    objbar.series = 1;
                    $scope.Bardata.push(objbar);
                } else {
                    monthwiselist.push(0)
                    objbar.y = 0;
                    objbar.x = $scope.listMonthbyName[$scope.CurrentMonth - 1] + ' - ' + $scope.CurrentYear;
                    objbar.series = 1;
                    $scope.Bardata.push(objbar);
                }


                //Add Label for graph
                var monthName = $scope.listMonthbyName[$scope.CurrentMonth - 1] + ' - ' + $scope.CurrentYear;
                $scope.labelsMonth.push(monthName);

                $scope.CurrentMonth = $scope.CurrentMonth - 1;
                if ($scope.CurrentMonth == 0) {
                    $scope.CurrentMonth = 12;
                    $scope.CurrentYear = $scope.CurrentYear - 1;
                };
            };

            $scope.labelsMonth = $scope.labelsMonth.reverse();
            monthwiselist = monthwiselist.reverse();

            $scope.series = ['User'];

            $scope.dataUsresOrders = [
                monthwiselist,
            ];

            $scope.dashboardData3 = [{
                "key": "User",
                "values": $scope.Bardata.reverse(),
            }];
            DrowChart();
            $scope.lstTotalUser = monthwiselist.reduce(function (total, item) {
                return total + item;
            }, 0);
            $scope.ManageCustomerGraph();
            $timeout(function () {
                $scope.CustomerAndUser(false);
                $scope.CustomerAndUserAcc(false);
                // $scope.CustomerGraph();
            }, 300);
        }

        $scope.ManageGraphOrderTotalByDuration = function (Duration) {
            $scope.OrderDuration = Duration;
            $scope.labels = ["Processing", "Pending", "Cancelled", "Complete",];
            if (Duration == "Today") {

                if ($scope.lstDashBoardInfo.sumTodayProcessing == 0 && $scope.lstDashBoardInfo.sumTodayPending == 0 && $scope.lstDashBoardInfo.sumTodayCancelled == 0 && $scope.lstDashBoardInfo.sumTodayCompleted == 0) {
                    $scope.flgshow = 1;

                } else {
                    $scope.data = [$scope.lstDashBoardInfo.sumTodayProcessing, $scope.lstDashBoardInfo.sumTodayPending, $scope.lstDashBoardInfo.sumTodayCancelled, $scope.lstDashBoardInfo.sumTodayCompleted];
                    $scope.OrderDuration = "Today";
                    $scope.flgshow = 0;
                }
            } else if (Duration == "This Week") {
                if ($scope.lstDashBoardInfo.sumLastWeekProcessing == 0 && $scope.lstDashBoardInfo.sumLastWeekPending == 0 && $scope.lstDashBoardInfo.sumLastWeekCancelled == 0 && $scope.lstDashBoardInfo.sumLastWeekCompleted == 0) {
                    $scope.flgshow = 1;

                } else {

                    $scope.data = [$scope.lstDashBoardInfo.sumLastWeekProcessing, $scope.lstDashBoardInfo.sumLastWeekPending, $scope.lstDashBoardInfo.sumLastWeekCancelled, $scope.lstDashBoardInfo.sumLastWeekCompleted];
                    $scope.OrderDuration = "This Week";
                    $scope.flgshow = 0;
                }
            } else if (Duration == "This Month") {
                if ($scope.lstDashBoardInfo.sumThisMonthProcessing == 0 && $scope.lstDashBoardInfo.sumThisMonthPending == 0 && $scope.lstDashBoardInfo.sumThisMonthCancelled == 0 && $scope.lstDashBoardInfo.sumThisMonthCompleted == 0) {
                    $scope.flgshow = 1;


                } else {
                    $scope.data = [$scope.lstDashBoardInfo.sumThisMonthProcessing, $scope.lstDashBoardInfo.sumThisMonthPending, $scope.lstDashBoardInfo.sumThisMonthCancelled, $scope.lstDashBoardInfo.sumThisMonthCompleted];
                    $scope.OrderDuration = "This Month";
                    $scope.flgshow = 0;
                }
            } else if (Duration == "This Year") {
                if ($scope.lstDashBoardInfo.sumThisYearProcessing == 0 && $scope.lstDashBoardInfo.sumThisYearPending == 0 && $scope.lstDashBoardInfo.sumThisYearCancelled == 0 && $scope.lstDashBoardInfo.sumThisYearCompleted == 0) {

                    $scope.flgshow = 1;

                } else {
                    $scope.data = [$scope.lstDashBoardInfo.sumThisYearProcessing, $scope.lstDashBoardInfo.sumThisYearPending, $scope.lstDashBoardInfo.sumThisYearCancelled, $scope.lstDashBoardInfo.sumThisYearCompleted];
                    $scope.OrderDuration = "This Year";
                    $scope.flgshow = 0;
                }
            } else if (Duration == "All") {
                if ($scope.lstDashBoardInfo.sumAllTimeProcessing == 0 && $scope.lstDashBoardInfo.sumAllTimePending == 0 && $scope.lstDashBoardInfo.sumAllTimeCancelled == 0 && $scope.lstDashBoardInfo.sumAllTimeCompleted == 0) {
                    $scope.flgshow = 1;

                } else {
                    $scope.data = [$scope.lstDashBoardInfo.sumAllTimeProcessing, $scope.lstDashBoardInfo.sumAllTimePending, $scope.lstDashBoardInfo.sumAllTimeCancelled, $scope.lstDashBoardInfo.sumAllTimeCompleted];
                    $scope.OrderDuration = "All";
                    $scope.flgshow = 0;

                }
            }

        }

        $scope.dtOptionstable = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDisplayLength(5)
            .withOption('autoWidth', true)
            .withOption('deferRender', true)
            .withOption('aaSorting', [0, 'asc'])
            .withOption('aLengthMenu', [5, 10, 25, 50, 100])
            .withOption('language', {
                'zeroRecords': "No Record Found",
                'emptyTable': "No Record Found"
            })
            .withOption('dom', '<"top"<"left"<"length"l>>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>');

        $scope.dtColumnDefsQ = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).notSortable(),
            DTColumnDefBuilder.newColumnDef(2).notSortable(),
            DTColumnDefBuilder.newColumnDef(3).notSortable().notSortable().withOption('class', 'text-center'),
        ];

        $scope.dtColumnDefsA = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).notSortable(),
            DTColumnDefBuilder.newColumnDef(2).notSortable(),
            DTColumnDefBuilder.newColumnDef(3).notSortable().notSortable().withOption('class', 'text-center'),
        ];


        $scope.TotalCustomerbyCountry = function () {
            $http.get($rootScope.RoutePath + "dashboard/GetTotalCustomerByCountry?idApp=" + $rootScope.appId).then(function (data) {
                if (data.data.success == true) {
                    $scope.lstTotalCustomerbyCountry = data.data.data;
                    $scope.lst = [];
                    $timeout(function () {
                        for (var i = 0; i < $scope.lstTotalCustomerbyCountry.length; i++) {
                            $scope.lst.push($scope.lstTotalCustomerbyCountry[i].tbluserinformation);
                        }

                        $scope.lstFinalTotalCustomerByCountry = [];

                        for (var i = 0; i < $scope.lst.length; i++) {
                            if ($scope.lst[i].country == '' || $scope.lst[i].country == null) {
                                $scope.lst[i].country = 'Other';
                            }
                            if ($scope.lstFinalTotalCustomerByCountry.length == 0) {
                                var obj = new Object();
                                obj.Country = $scope.lst[i].country;
                                obj.Customer = $scope.lst[i].Total;
                                $scope.lstFinalTotalCustomerByCountry.push(obj);
                            } else {
                                var getdata = _.findWhere($scope.lstFinalTotalCustomerByCountry, { Country: $scope.lst[i].country });
                                if (getdata != null && getdata != undefined) {
                                    getdata.Customer += $scope.lst[i].Total;
                                } else {
                                    var obj = new Object();
                                    obj.Country = $scope.lst[i].country;
                                    obj.Customer = $scope.lst[i].Total;
                                    $scope.lstFinalTotalCustomerByCountry.push(obj);
                                }
                            }
                        };
                    }, 600);
                }
            });
        }
        $scope.dtColumnDefsC = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1).notSortable(),
            DTColumnDefBuilder.newColumnDef(2).notSortable().notSortable().withOption('class', 'text-center'),
            /*DTColumnDefBuilder.newColumnDef(3).notSortable(),*/
        ];


        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
            $scope.init();
        });

        function DrowChart() {
            $scope.TotalUser = {
                title: 'Total User Data',
                mainChart: {
                    config: {
                        refreshDataOnly: true,
                        deepWatchData: true
                    },
                    options: {
                        chart: {
                            type: 'multiBarChart',
                            color: ['#03a9f4'],
                            height: 420,
                            margin: {
                                top: 8,
                                right: 16,
                                bottom: 32,
                                left: 32
                            },
                            useInteractiveGuideline: false,
                            clipEdge: true,
                            // groupSpacing: 0.3,
                            reduceXTicks: false,
                            // stacked: true,
                            duration: 250,
                            showControls: false,
                            x: function (d) {
                                return d.x;
                            },
                            y: function (d) {
                                return d.y;
                            },
                            xAxis: {
                                tickFormat: function (d) {
                                    return d;
                                },
                                showMaxMin: true
                            },
                            yAxis: {
                                tickFormat: function (d) {
                                    return d;
                                }
                            },
                            legend: {
                                margin: {
                                    top: 8,
                                    bottom: 32
                                }
                            },
                            controls: {
                                margin: {
                                    top: 8,
                                    bottom: 32
                                }
                            },
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s',
                            },
                        }
                    },
                    data: $scope.dashboardData3
                }

            };
        }
        $scope.GetAllExpiredDevice = function () {
            $scope.ExpiryDevicelist = [];
            var params = {
                AppName: $scope.AppName
            }
            // if ($scope.selectAppName != null && $scope.selectAppName != '' && $scope.selectAppName != undefined) {
            //     params.AppName = $scope.selectAppName;
            // }
            $http.get($rootScope.RoutePath + "bike/GetAllExpireDevice", { params: params }).then(function (data) {
                for (var i = 0; i < data.data.length; i++) {
                    if (data.data[i].renewaldate != null && data.data[i].renewaldate != '' && data.data[i].renewaldate != undefined) {
                        data.data[i].diff = timeDifference(moment(data.data[i].renewaldate).format('MM-DD-YYYY hh:mm:ss a'));
                        // if (data.data[i].diff < 0) {
                        //     data.data[i].diff = 'Expired';
                        // }
                    }
                }
                $timeout(function () {
                    $scope.ExpiryDevicelist = data.data;
                }, 600);
            });
        }
        $scope.dtColumnDefsC1 = [
            DTColumnDefBuilder.newColumnDef(0).notSortable(),
            DTColumnDefBuilder.newColumnDef(1),
            DTColumnDefBuilder.newColumnDef(2),
            DTColumnDefBuilder.newColumnDef(3).notSortable().withOption('class', 'text-center'),
        ];

        // function timeDifference(Start) {

        //     var one_day = 1000 * 60 * 60 * 24;
        //     var date2 = new Date(Start);

        //     var date1 = new Date();

        //     date1.setHours(0);
        //     date1.setMinutes(0);
        //     date1.setSeconds(0);
        //     // console.log(date2)
        //     // console.log(date1)


        //     var date1_ms = date1.getTime();
        //     var date2_ms = date2.getTime();
        //     var difference_ms = date2_ms - date1_ms;
        //     difference_ms = difference_ms / 1000;
        //     var seconds = Math.floor(difference_ms % 60);
        //     difference_ms = difference_ms / 60;
        //     var minutes = Math.floor(difference_ms % 60);
        //     difference_ms = difference_ms / 60;
        //     var hours = Math.floor(difference_ms % 24);
        //     var days = Math.floor(difference_ms / 24);


        //     var displaydata = "";
        //     if (days > 0) {
        //         displaydata = days + ' days';
        //     }
        //     // return displaydata;
        //     var x = days;
        //     var y = 365;
        //     var y2 = 31;
        //     var remainder = x % y;
        //     var casio = remainder % y2;
        //     var year = (x - remainder) / y;
        //     var month = (remainder - casio) / y2;
        //     var result = '';
        //     if (year != 0) {
        //         result = year + " year  ";
        //     }
        //     if (month != 0 && year == 0) {
        //         result += month + " month  ";
        //     }
        //     if (casio != 0 && month == 0) {
        //         result += casio + " days  ";
        //     }
        //     // console.log(year, " ", month, " ", casio, " ")
        //     if (year <= 0 && month < 0 && casio < 0) {
        //         result = 'Expired';
        //     }


        //     // var a = moment(date2);
        //     // var b = moment(date1);
        //     // console.log(a)
        //     // console.log(b)
        //     // var D = a.diff(b, 'days');
        //     // var M = a.diff(b, 'month');
        //     // var Y = a.diff(b, 'years');
        //     // console.log(D, "- ", M, "- ", Y);
        //     var diff = a.from(b, true);
        //     console.log("Diiff=", diff);
        //     // var result = displaydata + "@--- Year ---" + year + "--- Month ---" + month + "--- Day ---" + casio;

        //     return result;
        // }

        function timeDifference(date_2) {
            var date_2 = new Date(date_2);
            var date_1 = new Date();
            date_2.setHours(0);
            date_2.setMinutes(0);
            date_2.setSeconds(0);
            date_1.setHours(0);
            date_1.setMinutes(0);
            date_1.setSeconds(0);
            //convert to UTC
            var date2_UTC = new Date(Date.UTC(date_2.getUTCFullYear(), date_2.getUTCMonth(), date_2.getUTCDate()));
            var date1_UTC = new Date(Date.UTC(date_1.getUTCFullYear(), date_1.getUTCMonth(), date_1.getUTCDate()));


            var yAppendix, mAppendix, dAppendix;


            //--------------------------------------------------------------
            var days = date2_UTC.getDate() - date1_UTC.getDate();
            if (days < 0) {

                date2_UTC.setMonth(date2_UTC.getMonth() - 1);
                days += DaysInMonth(date2_UTC);
            }
            //--------------------------------------------------------------
            var months = date2_UTC.getMonth() - date1_UTC.getMonth();
            if (months < 0) {
                date2_UTC.setFullYear(date2_UTC.getFullYear() - 1);
                months += 12;
            }
            //--------------------------------------------------------------
            var years = date2_UTC.getFullYear() - date1_UTC.getFullYear();


            var result = '';

            if (years > 1) yAppendix = " years";
            else yAppendix = " year";
            if (months > 1) mAppendix = " months";
            else mAppendix = " month";
            if (days > 1) dAppendix = " days";
            else dAppendix = " day";

            if (years != 0) {
                result = years + yAppendix;
            } else if (years == 0 && months != 0) {
                result = months + mAppendix;
            } else if (years == 0 & months == 0) {
                result = days + dAppendix;
            }
            return result;
        }


        function DaysInMonth(date2_UTC) {
            var monthStart = new Date(date2_UTC.getFullYear(), date2_UTC.getMonth(), 1);
            var monthEnd = new Date(date2_UTC.getFullYear(), date2_UTC.getMonth() + 1, 1);
            var monthLength = (monthEnd - monthStart) / (1000 * 60 * 60 * 24);
            return monthLength;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.Coupon', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.Coupon', {
                url: '/Coupon',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Coupon/Coupon.html',
                        controller: 'CouponController'
                    }
                },
                bodyClass: 'Coupon',
                ModuleName: 'Coupon'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/Coupon');

        // msNavigationServiceProvider.saveItem('Settings.Setting', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.ChangePassword', {
        //     title: 'Change Password',
        //     state: 'app.ChangePassword',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.Coupon')
        .controller('CouponController', CouponController);

    /** @ngInject */
    function CouponController($http, $window, $scope, $rootScope, $state, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTColumnBuilder, DTOptionsBuilder, DTColumnDefBuilder, $compile) {
        var vm = this;
        vm.SearchBrand

        $('#loaderDiv').hide();
        $scope.init = function () {
            $scope.model = {


            };

            $scope.modelSearch = {

            };
            $scope.GetAllCouponCode();
            $scope.flag = false;
        }

        vm.dtInstanceHospital = {};


        $scope.clearSearchTerm = function () {
            vm.SearchBrand = '';
        };

        $scope.onSearchChange = function ($event) {
            $event.stopPropagation();
        }


        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }


        $scope.ResetEdit = function () {

            $scope.flag = true;

        }


        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
            $scope.init();
        })

        $scope.GetAllCouponCode = function () {
            try {
                $scope.dtColumnsHospital = [
                    DTColumnBuilder.newColumn('number').renderWith(NumberHtml).notSortable().withOption('width', '5%').withOption('class', 'text-center'),
                    DTColumnBuilder.newColumn('coupon').renderWith(CouponHtml).withOption('width', '5%').withOption('class', 'text-center'),
                    DTColumnBuilder.newColumn('discount').renderWith(discountHtml).withOption('width', '5%').withOption('class', 'text-center'),
                    DTColumnBuilder.newColumn('expiring').renderWith(expiringHtml).withOption('width', '5%').withOption('class', 'text-center'),
                    DTColumnBuilder.newColumn(null).notSortable().renderWith(actionsHtml).withOption('width', '5%').withOption('class', 'text-center')
                ]
            }
            catch (error) {
                console.log(error)
            }

            $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
                $('#loaderDiv').show();
                $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                    url: $rootScope.RoutePath + "getAllCouponsAdmin",
                    data: function (d) {
                        return d;
                    },
                    type: "get",
                    dataSrc: function (json) {
                  
                        console.log(json.data)
                        if (json.success != false) {
                            $scope.lstdata = json;
                            return json.data;
                        } else {
                            return [];
                        }
                    }
                })
                    .withOption('processing', true) //for show progress bar
                    .withOption('serverSide', true) // for server side processing
                    .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                    .withDisplayLength(10) // Page size
                    .withOption('aaSorting', [0, 'desc'])
                    .withOption('responsive', true)
                    .withOption('createdRow', createdRow)
                    .withOption('autoWidth', true)
                    // .withOption('initComplete', function () {
                    //     $scope.AdjustColumn();
                    // })
                    .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
                    .withOption('scrollY', 'auto');

                    $('#loaderDiv').hide();

            });

        }

        $scope.cancel = function () {
            $scope.flag = false
        }

        $scope.AdjustColumn = function () {

            vm.dtInstanceHospital.DataTable.columns.adjust();
        }

        function NumberHtml(data, type, full, meta) {
            return parseInt((meta.settings._iDisplayStart) + (meta.row + 1));
        }

        function CouponHtml(data, type, full, meta) {
            if (full.coupon_code != null || full.coupon_code != undefined) {
                return full.coupon_code
            }
        }


        function discountHtml(data, type, full, meta) {
            if (full.coupon_discount_percent != null || full.coupon_discount_percent != undefined) {
                return full.coupon_discount_percent + "%"
            }
        }

        function expiringHtml(data, type, full, meta) {
            if (full.coupon_expireson != null || full.coupon_expireson != undefined) {
                var temp_exp_date = new Date(full.coupon_expireson);
                var exp_day = ('0' + temp_exp_date.getDate()).slice(-2); // Use getDate() instead of getDay()
                var exp_month = ('0' + (temp_exp_date.getMonth() + 1)).slice(-2); // Use getMonth() + 1 to get the correct month
                var exp_year = temp_exp_date.getFullYear(); // No need to modify the year
                temp_exp_date = exp_day + "-" + exp_month + "-" + exp_year;
                return temp_exp_date;
            }
            
        }

        function actionsHtml(data, type, full, meta) {
            if (full._id != undefined || full._id != null) {
                var btns = '<div layout="row" layout-align="center">';
                var method = "deleteCouponCode('" + full._id + "')";

                btns += '<b><md-button ng-click="' + method + '"> <md-icon md-font-icon="icon-trash" class="s18 red-500-fg"></md-icon><md-tooltip md-visible="" md-direction="">Delete coupon code</md-tooltip></md-button></b>'

                return btns
            }
        }


        $scope.reloadData = function () { }

        function callback(json) { }

        $scope.createCoupon = function (o, form) {
            var exp_date = document.getElementsByName('expiringDate')[0].value;
            var obj = {
                "coupon_name": o.name,
                "coupon_code": o.code,
                "coupon_discount_percent": o.discount,
                "coupon_description": o.descriptions,
                "coupon_createdon": new Date(),
                "coupon_expireson": exp_date
            }

            if (angular.isDefined(o.name) && o.name !== null && o.name !== "") {

                if (angular.isDefined(o.code) && o.code !== null && o.code !== "") {

                    if (angular.isDefined(o.discount) && o.discount !== null && o.discount !== "") {

                        if (parseInt(o.discount) < 100) {

                            if (angular.isDefined(exp_date) && exp_date !== null && exp_date !== "") {


                                $('#loaderDiv').show();

                                $http.post($rootScope.RoutePath + "generate_coupon_code", obj, {
                                    // transformRequest: angular.identity,
                                    // headers: { 'Content-Type': undefined },

                                }).success(function (res) {
                                    console.log(res);
                                    $('#loaderDiv').hide();
                                    if (res.success) {
                                        $mdToast.show(
                                            $mdToast.simple()
                                                .textContent(res.data)
                                                .position('top right')
                                                .hideDelay(3000)
                                        );
                                        $('#Hospital').dataTable()._fnAjaxUpdate();
                                        $scope.flag = false
                                    }

                                }).error(function () {
                                    $('#loaderDiv').hide();
                                    console.log('err')
                                    $mdToast.show(
                                        $mdToast.simple()
                                            .textContent('Error occurred  please try again')
                                            .position('top right')
                                            .hideDelay(3000)
                                    );
                                })
                            }
                            else {
                                return alert("Coupon expiry date cannot  be empty")

                            }

                        } else {
                            return alert('please enter discount  percentage less than 100%')
                        }

                    } else {
                        return alert("Please enter discount percentage on coupon")

                    }
                }
                else {
                    return alert("Please enter coupon code")
                }
            }
            else {
                return alert("Please enter coupon name")
            }


        }



        $scope.deleteCouponCode = function (data) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to delete this coupon?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent(data)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                if (data != undefined || data != null) {

                    $http.delete($rootScope.RoutePath + "removeCoupon/" + data).then(function (data) {
                        console.log(data)

                        if (data.data.success) {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(data.data.message)
                                    .position('top right')
                                    .hideDelay(3000)
                            );
                            // $scope.init();
                            $scope.backToAllCoupon();
                            
                        } else {
                            if (data.data.data == 'TOKEN') {
                                //$cookieStore.remove('UserName');
                                //$cookieStore.remove('token');
                                //window.location.href = '/app/login';
                                $rootScope.logout();
                            } else {
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent(data.data.message)
                                        .position('top right')
                                        .hideDelay(3000)
                                );
                            }
                        }
                    });
                }
            }, function () { });

        }

        $scope.backToAllCoupon = function () {
            $scope.GetAllCouponCode();
            // vm.dtInstanceHospital.reloadData(callback, true);
            $('#Hospital').dataTable()._fnAjaxUpdate();
            $scope.flag = false

        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.ChangePassword', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.ChangePassword', {
                url: '/ChangePassword',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/ChangePassword/ChangePassword.html',
                        controller: 'ChangePasswordController'
                    }
                },
                bodyClass: 'Change Password',
                ModuleName: 'Change Password'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/ChangePassword');

        // msNavigationServiceProvider.saveItem('Settings.Setting', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.ChangePassword', {
        //     title: 'Change Password',
        //     state: 'app.ChangePassword',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.ChangePassword')
        .controller('ChangePasswordController', ChangePasswordController);

    /** @ngInject */
    function ChangePasswordController($http, $scope, $mdDialog, $document, $mdToast, $cookieStore, DTOptionsBuilder, DTColumnDefBuilder, $rootScope) {
        var vm = this;
        $scope.init = function () {
            $scope.model = {
                email: $cookieStore.get('email'),
                oldpassword: '',
                password: '',
                confirmpassword: '',
            };
        }

        $scope.ChangePassword = function (o) {
            $scope.obj = {
                email: o.email,
                password: o.password,
                oldpassword: o.oldpassword,
                confirmpassword: o.confirmpassword
            }
            $http.put($rootScope.RoutePath + "account/change__password", $scope.obj).then(function (response) {
                if (response.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(response.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    );
                    // $scope.GetAllBanner();
                    $rootScope.FlgAddedEditlocal = false;
                    $scope.Reset();
                } else {
                    if (response.data.data == 'TOKEN') {
                        //$cookieStore.remove('UserName');
                        //$cookieStore.remove('token');
                        //window.location.href = '/app/login';
                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(response.data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                    }
                }
            });
        }

        $scope.Reset = function () {

            $scope.model = {
                email: '',
                oldpassword: '',
                password: '',
                confirmpassword: '',
            };
            $scope.FormChangePassword.$setUntouched();
            $scope.FormChangePassword.$setPristine();

        }

        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
            $scope.init();
        })
    }
})();
(function () {
    'use strict';

    angular
        .module('app.BagType', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.BagType', {
                url: '/BagType',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/BagType/BagType.html',
                        controller: 'BagTypeController as vm'
                    }
                },
                bodyClass: 'Bag Type',
                ModuleName: 'Bag Type'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/roles');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Roles',
        //     state: 'app.roles',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.BagType')
        .controller('BagTypeController', BagTypeController);

    /** @ngInject */
    function BagTypeController($http, $scope, $rootScope, $state, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;
        vm.SearchBrand
        $scope.init = function () {
            $scope.model = {
                id: '',
                name: '',
                price: '',
                is_active: true,
                date: new Date(),

            };
            $scope.modelSearch = { Search: '' };
            $scope.GetAllBagType();
            $scope.tab = {
                selectedIndex: 0
            };
            $scope.flag = false;
        }

        $scope.clearSearchTerm = function () {
            vm.SearchBrand = '';
        };

        $scope.onSearchChange = function ($event) {
            $event.stopPropagation();
        }
        vm.dtInstance = {};
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [],
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#modelsearch');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            lengthMenu: [10, 20, 30, 50, 100],
            pageLength: 20,
            scrollY: 'auto',
            responsive: true,
            aaSorting: [0, 'asc'],
        };

        $scope.GetAllBagType = function () {
            $http.get($rootScope.RoutePath + "bagtype/getAllBagType").then(function (data) {
                $scope.lstBagtype = data.data.data;
            });
        }

        $scope.DeleteBagType = function (_id, ev) {
            var confirm = $mdDialog.confirm()
                .title('Are you sure to delete this Bag Type?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent(ev)
                .ok('Yes')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                $http.get($rootScope.RoutePath + "bagtype/delete_Bag_Type?id=" + _id).then(function (data) {
                    if (data.data.success) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                        $scope.init();
                    } else {
                        if (data.data.data == 'TOKEN') {
                            //$cookieStore.remove('UserName');
                            //$cookieStore.remove('token');
                            //window.location.href = '/app/login';
                            $rootScope.logout();
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(data.data.message)
                                    .position('top right')
                                    .hideDelay(3000)
                            );
                        }
                    }
                });
            }, function () { });

        }

        $scope.FetchRoleById = function (o) {
            $rootScope.FlgAddedEditlocal = true;
            $scope.model.id = o._id;
            $scope.model.name = o.name;
            $scope.model.price = o.price;
            $scope.model.date = o.date;
            $scope.model.is_active = o.is_active;
            $scope.flag = true;

        }

        $scope.CreateBagType = function (o, form) {
            o.date = new Date()
            $http.post($rootScope.RoutePath + "bagtype/saveBagType", o).then(function (data) {
                if (data.data.success == true) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(data.data.message)
                            .position('top right')
                            .hideDelay(3000)
                    );
                    $scope.init();
                } else {
                    if (data.data.data == 'TOKEN') {
                        $rootScope.logout();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                    }
                }
            });
        };

        $scope.UpdateIsActive = function (_id, flg) {
            var params = {
                id: _id,
                is_active: flg,
            };
            $http.get($rootScope.RoutePath + 'bagtype/UpdateIsActive', { params: params })
                .then(function (data) {
                    if (data.data.success == true) {
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .textContent(data.data.message)
                                .position("top right")
                                .hideDelay(3000)
                        );
                        $scope.ResetData();
                        $scope.init();
                    } else {
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .textContent(data.data.message)
                                .position("top right")
                                .hideDelay(3000)
                        );
                    }
                });
        };

        $scope.ResetData = function () {
            $scope.model = {
                id: '',
                name: '',
                price: '',
                is_active: true,
                date: new Date(),
            };
            $scope.RestForm();
        }


        $scope.RestForm = function () {
            // $scope.form.$setPristine();
            // $scope.form.$setUntouched();
        }

        $scope.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0),
            DTColumnDefBuilder.newColumnDef(1),
            DTColumnDefBuilder.newColumnDef(2),
            DTColumnDefBuilder.newColumnDef(3),
            DTColumnDefBuilder.newColumnDef(4).notSortable(),
        ];


        $scope.ResetTab = function () {
            // if ($rootScope.FlgAddedAccess != true) {
            $scope.FlgAddedEditlocal = false;
            // }
        }

        $scope.ResetEdit = function () {

            $scope.flag = true;
            $scope.FormManageBrand.$setUntouched();
            $scope.FormManageBrand.$setPristine();
            $scope.model = {
                id: '',
                Name: '',
                price: '',
                is_active: true,
                date: '',

            };
        }
        $scope.Reset = function () {
            $scope.FormManageBrand.$setUntouched();
            $scope.FormManageBrand.$setPristine();
            $rootScope.FlgAddedEditlocal = false;
            $rootScope.FlgAddedEditlocal = true

            $scope.init();
        }


        $scope.GetSerch = function (Search) {
            vm.dtInstance.DataTable.search(Search);
            vm.dtInstance.DataTable.search(Search).draw();
        };
        $scope.gotoBrandList = function () {
            $scope.init();
        }

        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
            $scope.init();
        })
    }

})();
(function () {
    'use strict';

    angular
        .module('app.CashOutRequest', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.CashOutRequest', {
                url: '/CashOutRequest',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/CashOutRequest/CashOutRequest.html',
                        controller: 'CashOutRequestController as vm'
                    }
                },
                bodyClass: 'CashOut Request',
                ModuleName: 'CashOut Request'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/roles');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Roles',
        //     state: 'app.roles',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.CashOutRequest')
        .controller('CashOutRequestController', CashOutRequestController);

    /** @ngInject */
    function CashOutRequestController($http, $scope, $rootScope, $state, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder) {
        var vm = this;
        vm.SearchBrand
        $scope.init = function () {
            $scope.model = {
                id: '',
                name: '',
                price: '',
                is_active: true,
                date: new Date(),

            };
            $scope.modelSearch = { Search: '' };
            $scope.GetAllDriver();            
            $scope.tab = {
                selectedIndex: 0
            };
            $scope.flag = false;
        }

        $scope.clearSearchTerm = function () {
            vm.SearchBrand = '';
        };

        $scope.onSearchChange = function ($event) {
            $event.stopPropagation();
        }
        vm.dtInstance = {};
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [],
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#modelsearch');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keyup', function (event) {
                        api.search(event.target.value).draw();
                    });
                }
            },
            pagingType: 'simple',
            lengthMenu: [10, 20, 30, 50, 100],
            pageLength: 20,
            scrollY: 'auto',
            responsive: true,
            aaSorting: [0, 'asc'],
        };

        $scope.GetAllDriver = function () {
            $http.get($rootScope.RoutePath + "driver/driverlist").then(function (data) {
                $scope.lstDriver = data.data.data;                
            });
        }      

        $scope.GetDriverCashoutList = function(_id) {            
            $http.get($rootScope.RoutePath + "driver/driverCaseOutListing?id="+_id).then(function(data) {
                $scope.lstDriverCashoutRequest = data.data.data;                
            })
        } 

        $scope.ResetTab = function () {
            // if ($rootScope.FlgAddedAccess != true) {
            $scope.FlgAddedEditlocal = false;
            // }
        }
        
        $scope.GetSerch = function (Search) {
            vm.dtInstance.DataTable.search(Search);
            vm.dtInstance.DataTable.search(Search).draw();
        };
        $scope.gotoBrandList = function () {
            $scope.init();
        }

        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
            $scope.init();
        })
    }

})();
(function () {
    'use strict';

    angular
        .module('app.AutoPayAccount', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.AutoPayAccount', {
                url: '/AutoPayAccount',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/AutoPayAccount/AutoPayAccount.html',
                        controller: 'AutoPayAccountController as vm'
                    }
                },
                bodyClass: 'AutoPayAccount',
                ModuleName: 'AutoPayAccount'
            });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/roles');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.roles', {
        //     title: 'Roles',
        //     state: 'app.roles',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.AutoPayAccount')
        .controller('AutoPayAccountController', AutoPayAccountController);

    /** @ngInject */
    function AutoPayAccountController($http, $scope, $rootScope, $cookieStore, $mdToast, $mdDialog, DTOptionsBuilder, DTColumnBuilder, $compile) {
        var vm = this;

        vm.Reset = function() {
            $scope.reloadTableData();
        }

        $scope.init = function() {
            $scope.modelData = {
                _id: null,
                billing_period_days: null,
                payment_period_days: null
                // token: null,
            }
            $scope.initModel();
        }

        $scope.initModel = function() {

            $scope.modelSearch = {
                search: '',
                zip_code: '',
                verified: '',
                Approved: '',
            }
            $scope.selected = [];
        }
        $rootScope.role_id = $cookieStore.get('role_id');

        //Dynamic Pagging
        // $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
        $scope.FilterStatus = 1;

        $scope.dtColumns = [
            DTColumnBuilder.newColumn('signup_at').renderWith(NumberHtml).notSortable().withOption('width', '4%').withOption('class', 'text-center'),
            DTColumnBuilder.newColumn('pharmacy_name').renderWith(PharmacyHtml),
            DTColumnBuilder.newColumn('address').renderWith(AddressHtml),
            DTColumnBuilder.newColumn('acceptance').renderWith(AcceptanceHtml),
            DTColumnBuilder.newColumn('email').renderWith(EmailHtml),
            // DTColumnBuilder.newColumn('mobile_number').renderWith(PhoneHtml),                
            DTColumnBuilder.newColumn('created_at').renderWith(DateHtml),                
            DTColumnBuilder.newColumn(null).notSortable().renderWith(ActionHtml).withOption('width', '5%').withOption('class', 'text-center')
        ]
        $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                url: $rootScope.RoutePath + "getAllAutoPayAccounts",
                data: function(d) {
                    d.search = $scope.modelSearch.search;
                    d.zip_code = $scope.modelSearch.zip_code;
                    d.verified = $scope.modelSearch.verified;
                    d.Approved = $scope.modelSearch.Approved;
                    return d;
                },
                type: "get",
                dataSrc: function(json) {
                  
                    if (json.success != false) {
                        $scope.lstdata = json.data;
                        return json.data;
                    } else {
                        return [];
                    }
                },
            })
            .withOption('processing', true) //for show progress bar
            .withOption('serverSide', true) // for server side processing
            .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
            .withDisplayLength(25) // Page size
            .withOption('aaSorting', [0, 'desc'])
            .withOption('responsive', true)
            .withOption('createdRow', createdRow)
            .withOption('autoWidth', true)
            .withOption('initComplete', function() {
                $scope.AdjustColumn();
            })
            // .withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
            .withOption('scrollY', 'auto');
        // });


        vm.dtInstance = {};
        vm.dtInstance1 = {};
        $scope.dtInstance = {};
        // $(window).resize(function() {
        //     $scope.AdjustColumn();
        // });

        $scope.AdjustColumn = function() {
   
                vm.dtInstance.DataTable.columns.adjust();
            }
            //Reload Datatable
        $scope.reloadTableData = function(IsUpdate) {
            
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            }
            vm.dtInstance.reloadData(callback, resetPaging);
            $('#autoPayPharmacyTable').dataTable()._fnPageChange(0);
            $('#autoPayPharmacyTable').dataTable()._fnAjaxUpdate();
        }

        $scope.reloadData = function() {}

        function callback(json) {}

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }

        function dateFormat(data, type, full, meta) {
            if (full.autopay_data.created_at != null && full.autopay_data.created_at != '') {
                return moment(full.autopay_data.created_at).format('MM-DD-YYYY hh:mm:ss a')
            } else {
                return "";
            }
        }
        function AddressHtml(data, type, full, meta) {
            var btns = '';
            if (full.pharmacy_data && full.pharmacy_data.address) {
                btns += full.pharmacy_data.address;
            }
            if (full.pharmacy_data && full.pharmacy_data.city) {
                btns += "," + full.pharmacy_data.city;
            }
            if (full.pharmacy_data && full.pharmacy_data.state) {
                btns += "," + full.pharmacy_data.state;
            }

            return btns;
        }

       function AcceptanceHtml(data, type , full , meta) {
        var btns = ""
        if(full.pharmacy_data) {
        var accepatance_key = full.pharmacy_data.consent_acceptance_autopay == 'yes'? 'Accept':'Decline'
        var name =   full.pharmacy_data.pharmacy_name_autopay? full.pharmacy_data.pharmacy_name_autopay:'-'    
        var designation =   full.pharmacy_data.pharmacy_owner_autopay? full.pharmacy_data.pharmacy_owner_autopay:'-'    
         btns = '<div  layout-align="center"><p>Acceptance status : <b>' + accepatance_key + '</b></p><p>Name : <b>'+ name +   '</b></p><p>' + 'Designation : <b>'+ designation + '</b></p>';
        }    
        btns += ''
            return btns;
        }

        function PharmacyHtml(data, type , full , meta) {
            var btns = '';

            if (full.pharmacy_data && full.pharmacy_data.pharmacy_name) {
                btns += full.pharmacy_data.pharmacy_name;
            }
            return btns;
        }

        function EmailHtml(data, type , full , meta) {
            var btns = '';
            if (full.pharmacy_data && full.pharmacy_data.email) {
                btns += full.pharmacy_data.email;
            }
            return btns;
        }
        function PhoneHtml(data, type , full , meta) {
            var btns = '';
            if (full.pharmacy_data && full.pharmacy_data.mobile_number) {
                btns += full.pharmacy_data.mobile_number;
            }
            return btns;
        }

        function DateHtml(data, type , full , meta) {
            var btns = '';
            if (full.autopay_data && full.autopay_data.created_at) {
                btns += moment(full.autopay_data.created_at).format('MM-DD-YYYY hh:mm:ss a')
            }
            return btns;
        }

        function ActionHtml(data, type, full, meta) {
            var cur_status = null
            if(full.pharmacy_data && full.pharmacy_data.stope_order == false){
                cur_status = "Active"
            }else {
                cur_status = "Hold"
            }
            // // var model = 'selected[' + full._id + '].isChecked';
            // var datavalue = '';
            // // datavalue = '<div layout="row" layout-align="center"><md-checkbox aria-label="assign"  ng-model="' + model + '"></md-checkbox></div>';
            // return datavalue;

            // var btns = '<div layout="row" layout-align="center">'; 
            var btns = ''
            if(full.pharmacy_data && full.pharmacy_data.stope_order == false){
            btns = '<div layout="row" layout-align="center">';
            var method = "change_status('" + full.pharmacy_data.stope_order + "','" + full.pharmacy_data._id + "')";
            
            btns += '<md-button ng-style="{\'background-color\': ' + (full.pharmacy_data.stope_order ? '\'red\'' : '\'rgb(3,155,229)\'') +  ', \'color\': \'white\'}"  ng-click="' + method + '">' + cur_status +
                    '<md-tooltip md-visible="" md-direction="">Change status    </md-tooltip>' +
                    '</md-button>';
            btns += '</div>';
        }
            
            return btns;
        }

      

     

        $scope.ResetModel = function() {
            $scope.init();

            $scope.restForm();
        }

        $scope.restForm = function() {
            $scope.AddStatusForm.$setUntouched();
            $scope.AddStatusForm.$setPristine();
        }

       
        $scope.change_status = function( stope, pharmacy_id ) {
            var  stope_order = null
            if(stope === "true") {
                stope_order = false
                var confirm = $mdDialog.confirm()
            .title('Are you sure to ACTIVE an account?')
            .textContent('')
            .ariaLabel('Lucky day')
            .ok('Yes')
            .cancel('No');
            }
             else {
                stope_order = true;
                var confirm = $mdDialog.confirm()
                .title('Are you sure to HOLD an account?')
                .textContent('')
                .ariaLabel('Lucky day')
                .ok('Yes')
                .cancel('No');
            }

            $mdDialog.show(confirm).then(function () {
                var param = {
                    pharmacy_id : pharmacy_id,
                    stope_order  : stope_order
                  }
                $http.post($rootScope.RoutePath + "updateStopOrderStatus", param).then(function (data) {
                    if (data.data.success) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(data.data.message)
                                .position('top right')
                                .hideDelay(3000)
                        );
                        $scope.reloadTableData();
                    } else {
                        if (data.data.data == 'TOKEN') {
                            //$cookieStore.remove('UserName');
                            //$cookieStore.remove('token');
                            //window.location.href = '/app/login';
                            $rootScope.logout();
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent(data.data.message)
                                    .position('top right')
                                    .hideDelay(3000)
                            );
                        }
                    }
                });
            }, function () { });



        }
      //Reload Datatable
        $scope.reloadTableData = function(IsUpdate) {
            
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            }
            vm.dtInstance.reloadData(callback, resetPaging);
            $('#autoPayPharmacyTable').dataTable()._fnPageChange(0);
            $('#autoPayPharmacyTable').dataTable()._fnAjaxUpdate();
        }

        $scope.reloadData = function() {}

        $scope.init();

    }



})();
(function () {
    'use strict';

    angular
        .module('app.Announcement', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.Announcement', {
                url: '/Announcement',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/Announcement/Announcement.html',
                        controller: 'AnnouncementController as vm'
                    }
                },
                bodyClass: 'Announcement',
                ModuleName: 'Announcement'
            });

        // Translation
        // $translatePartialLoaderProvider.addPart('app/main/user');

        // Navigation
        // msNavigationServiceProvider.saveItem('Users.user', {
        //     title: 'Authentication',
        //     icon: 'icon-lock',
        //     weight: 1
        // });

        // msNavigationServiceProvider.saveItem('Users.owneruser', {
        //     title: 'Owner Users',
        //     state: 'app.owneruser',
        //     icon: 'icon-lock',
        //     weight: 1
        // });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.Announcement')
        .controller('AnnouncementController', AnnouncementController)


    /** @ngInject */
    function AnnouncementController($http, $scope, $rootScope, $state, $q, $timeout, $mdToast, $document, $mdDialog, $cookieStore, $stateParams, DTOptionsBuilder, DTColumnDefBuilder, DTColumnBuilder, $compile) {

        var vm = this;
        $rootScope.appId = localStorage.getItem('appId');
        $rootScope.UserRoles = localStorage.getItem('UserRoles');
        $scope.init = function () {
            $scope.initModel();
            $scope.flag = false;
        }
        $scope.initModel = function () {
            $scope.modelSearch = {
                search: '',
            }
            $scope.model = {
                _id: null,
                type: null,
                title: null,
                message: null,
            };
            $scope.resetForm();
        }

        $scope.resetData = function () {
            $scope.initModel();
            $scope.flag = true;
        }

        $scope.resetForm = function () {
            if ($scope.formAnnouncement) {
                $scope.formAnnouncement.$setPristine();
                $scope.formAnnouncement.$setUntouched();
            }
        }

        $scope.goToList = function () {
            $scope.flag = false;
            $scope.initModel();
        }


        //Dynamic Pagging
        $rootScope.CheckPageRights(($rootScope.state.current.ModuleName), function (response) {
            $scope.FilterStatus = 1;
            $scope.dtColumns = [
                DTColumnBuilder.newColumn('created_on').renderWith(NumberHtml).notSortable().withOption('width', '4%').withOption('class', 'text-center'),
                DTColumnBuilder.newColumn('type'),
                DTColumnBuilder.newColumn('title'),
                DTColumnBuilder.newColumn('message'),
                DTColumnBuilder.newColumn('created_on').renderWith(dateFormat),
            ]
            $scope.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                url: $rootScope.RoutePath + "announcement/getAllDynamicAnnouncement",
                data: function (d) {
                    d.search = $scope.modelSearch.search;
                    return d;
                },
                type: "get",
                dataSrc: function (json) {
                    if (json.success != false) {
                        $scope.lstdata = json.data;
                        return json.data;
                    } else {
                        return [];
                    }
                },
            })
                .withOption('processing', true) //for show progress bar
                .withOption('serverSide', true) // for server side processing
                .withPaginationType('full_numbers') // for get full pagination options // first / last / prev / next and page numbers
                .withDisplayLength(10) // Page size
                .withOption('aaSorting', [0, 'desc'])
                .withOption('responsive', true)
                .withOption('createdRow', createdRow)
                // .withOption('dom', 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                .withOption('autoWidth', true)
                .withOption('initComplete', function () {
                    $scope.AdjustColumn();
                })
                .withOption('initComplete', function () {
                    $scope.AdjustColumn();
                })
                .withOption('dom', 'rt<"bottom"<"left"<"length"l><"info"i>><"right"<"pagination"p>>>')
                .withOption('scrollY', 'auto');
        });



        vm.dtInstance = {};
        vm.dtInstance1 = {};
        vm.dtInstance = {};
        $(window).resize(function () {
            $scope.AdjustColumn();
        });
        $scope.AdjustColumn = function () {

            vm.dtInstance.DataTable.columns.adjust();
        }
        //Reload Datatable
        $scope.reloadTable = function (IsUpdate) {
            var resetPaging = false;
            if (IsUpdate == true) {
                resetPaging = true;
            };
            vm.dtInstance.reloadData(callback, resetPaging);
            $('#announcementTable').dataTable()._fnPageChange(0);
            $('#announcementTable').dataTable()._fnAjaxUpdate();
        }

        $scope.reloadData = function () { }

        function callback(json) { }

        //compile Datatable And Apply Class
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT
            $compile(angular.element(row).contents())($scope);
        }

        function NumberHtml(data, type, full, meta) {
            return (meta.row + 1);
        }

        function dateFormat(data, type, full, meta) {
            if (data != null && data != '') {
                return moment(data).format('MM-DD-YYYY hh:mm a')
            } else {
                return "";
            }
        }

        $scope.Announcement = function () {
            $http.post($rootScope.RoutePath + 'announcement/setAnnouncement', $scope.model)
                .then(function (data) {
                    if (data.data.success == true) {
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .textContent(data.data.message)
                                .position("top right")
                                .hideDelay(3000)
                        );
                        $scope.goToList();
                        $scope.reloadTable(true);
                    } else {
                        $mdToast.show(
                            $mdToast
                                .simple()
                                .textContent(data.data.message)
                                .position("top right")
                                .hideDelay(3000)
                        );
                    }
                });
        }

        $scope.init();
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  : {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0, color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '=?'
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject required services
        var $log = angular.injector(['ng']).get('$log'),
            $resource = angular.injector(['ngResource']).get('$resource');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Prepare the resource object
            var resourceObj = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };

            // Assign the resource
            api[key] = $resource(resourceObj.url, resourceObj.paramDefaults, resourceObj.actions, resourceObj.options);
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app.core').filter('ellipsis', function() {
            return function(text, length) {
                if (text.length > length) {
                    return text.substr(0, length) + "...";
                }
                return text;
            }
        });


})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($scope, $rootScope, $mdSidenav, $translate, $mdToast, $cookieStore, $state, $http, $window, $timeout) {
        var vm = this;
        $rootScope.UserName = localStorage.getItem('UserName');
        $rootScope.UserImage = $cookieStore.get('UserImage');

        // Data
        $rootScope.global = {
            search: ''
        };
        $('.logo-image').css('background-image', 'url(' + $rootScope.Logo + ')');

        $rootScope.logout = function () {
            $cookieStore.remove('UserName');
            $cookieStore.remove('token');
            $cookieStore.remove('UserImage');
            $cookieStore.remove('DistributorId');
            // $cookieStore.remove('AppName');
            // localStorage.setItem('AppName', '');
            // localStorage.setItem('appId', '');
            // $cookieStore.remove('appId');
            $rootScope.UserImage = '';
            $http.defaults.headers.common.Authorization = '';
            // $state.go('app.login');
            // $window.location.reload();
            // $window.location.href = "/#/app/login";
            $window.location.href = "/#/app/login";
            $cookieStore.put('FlagLogout', true);
            // $timeout(function() {
            //     $window.location.reload();
            // });
            // console.log($cookieStore.get('appId'));
        }

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [{
            'title': 'Online',
            'icon': 'icon-checkbox-marked-circle',
            'color': '#4CAF50'
        }, {
            'title': 'Away',
            'icon': 'icon-clock',
            'color': '#FFC107'
        }, {
            'title': 'Do not Disturb',
            'icon': 'icon-minus-circle',
            'color': '#F44336'
        }, {
            'title': 'Invisible',
            'icon': 'icon-checkbox-blank-circle-outline',
            'color': '#BDBDBD'
        }, {
            'title': 'Offline',
            'icon': 'icon-checkbox-blank-circle-outline',
            'color': '#616161'
        }];
        vm.languages = {
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            },
            es: {
                'title': 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es',
                'flag': 'es'
            },
            tr: {
                'title': 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code': 'tr',
                'flag': 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            // Do logout here..
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if (lang.code !== 'en') {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        $scope.ChangePssword = function () {
            window.location.href = '/#/ChangePassword';
        }
        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function () {
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, $rootScope, $cookieStore) {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // $('.logo-image').css('background-image', 'url(' + localStorage.getItem('Logo') + ')');
        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded() {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function () {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function () {
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',
            'app.navigation',
            'app.toolbar',
            // 'app.quick-panel',
            // 'app.Dashboard',
            'app.login',
            // 'app.Module',
            'app.roles',
            'app.UserPermission',
            'app.ChangePassword',
            'app.Forgotpassword',
            'app.user',
            'app.Order',
            'app.PharmacyTraining',
            'app.PharmacyUserManual',
            'app.BagType',
            'app.Pharmacy',
            'app.Hospice',
            'app.Driver',
            'app.DriverApplication',
            'app.IssueReport',
            'app.Announcement',
            // 'app.PharmacyAnnouncement',
            'app.TransferPharamcy',
            'app.Hospital',
            'app.Invoice',
            'app.DefaultChargesSetting',
            'app.ScheduleDelivery',
            'app.Testimonial',
            'app.Module',
            'app.UserPermission',
            'app.user',
            'app.OrderCharges',
            'app.Patient',
            'app.CashOutRequest',
            'app.DemandOrder',
            'app.Zipcode',
            'app.OnePrice',
            'app.Coupon',
            'app.SuggestPharmacy',
            'app.AutoPayAccount',
            'app.PickupOrder'
        ]);
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, DTOptionsBuilder, $cookieStore, $http, $window) {

        // $rootScope.RoutePath = "http://localhost:3030/";
        //////////
        $rootScope.editorOptions = {
            language: 'en',
            extraPlugins: 'colorbutton'
            // uiColor: '#000000'
        };


        $rootScope.convertdateformat = function (date1, flg) {
            var date = new Date(date1);
            var firstdayDay = date.getDate();
            var firstdayMonth = date.getMonth() + 1;
            var firstdayYear = date.getFullYear();
            var firstdayHours = date.getHours();
            var firstdayMinutes = date.getMinutes();
            var firstdaySeconds = date.getSeconds();
            var ampm = firstdayHours >= 12 ? 'pm' : 'am';
            if (flg == 1) {
                return ("00" + firstdayDay.toString()).slice(-2) + "-" + ("00" + firstdayMonth.toString()).slice(-2) + "-" + ("0000" + firstdayYear.toString()).slice(-4) + ' ' + ("00" + firstdayHours.toString()).slice(-2) + ":" + ("00" + firstdayMinutes.toString()).slice(-2) + ":" + ("00" + firstdaySeconds.toString()).slice(-2);
            }
            if (flg == 2) {
                return ("00" + firstdayDay.toString()).slice(-2) + "-" + ("00" + firstdayMonth.toString()).slice(-2) + "-" + ("0000" + firstdayYear.toString()).slice(-4) + ' ' + ("00" + firstdayHours.toString()).slice(-2) + ":" + ("00" + firstdayMinutes.toString()).slice(-2) + ":" + ("00" + firstdaySeconds.toString()).slice(-2) + " " + ampm;
            } else {
                return ("00" + firstdayDay.toString()).slice(-2) + "-" + ("00" + firstdayMonth.toString()).slice(-2) + "-" + ("0000" + firstdayYear.toString()).slice(-4);
            }
        }

        $rootScope.dtOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withDisplayLength(10)
            .withOption('responsive', true)
            .withOption('autoWidth', false)
            // .withOption('paging', false)
            .withOption('deferRender', true)
            .withOption('language', {
                'zeroRecords': "No Record Found",
                'emptyTable': "No Record Found"
            })
            .withOption('dom', '<"top"<"left"<"length"l>>f>rt<"bottom"<"left"<"info"i>><"right"<"pagination"p>>>');


        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider) {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars': false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile': true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $location, $state, $http, $cookieStore, msNavigationService, $window) {
        var token = $cookieStore.get('token');
        var datatoken = $http.defaults.headers.common['Authorization'];
        // if (token != null && token != undefined) {
        if (datatoken == null || datatoken == undefined) {
            $http.defaults.headers.common['Authorization'] = token;
        }
        // }

        // $rootScope.RoutePath = "http://localhost:28000/api/";
        // $rootScope.RoutePath = "http://192.168.1.55:28000/";
        // $rootScope.RoutePath ="https://api.delivermyrx.com/";
        // $rootScope.RoutePath = "https://uat.delivermyrx.com/api/"
        $rootScope.RoutePath = "https://iosapi1.delivermyrx.com/api/";


        $rootScope.UserId = $cookieStore.get('UserId');
        // $rootScope.demand ="demand";

        $rootScope.CheckPageRights = function (ModuleName, callback) {
            $rootScope.UserRoles = $cookieStore.get('UserRoles');
            $rootScope.FlgAddedAccess = false;
            $rootScope.FlgModifiedAccess = false;
            $rootScope.FlgDeletedAccess = false;
            // for (var i = 0; i < $rootScope.UserRoles.length; i++) {
            //     if ($rootScope.UserRoles[i] == 'Super Admin') {
            //         var params = {
            //             tablename: ModuleName,
            //         }
            //         break;
            //     } else {
            //         var params = {
            //             tablename: ModuleName,
            //         }
            //     }
            // }
            var params = {
                tablename: ModuleName,
            }
            $http.get($rootScope.RoutePath + "userpermission/CheckRightsbyPage", {
                params: params
            }).then(function (data) {
                // console.log(data)
                if (data.data.success == true) {
                    var objpermission = data.data.data;
                    $rootScope.FlgAddedAccess = objpermission.Added;
                    $rootScope.FlgAddedEditlocal = objpermission.Added;
                    $rootScope.FlgModifiedAccess = objpermission.Modified;
                    $rootScope.FlgDeletedAccess = objpermission.Deleted;
                } else {
                    $rootScope.FlgAddedAccess = false;
                    $rootScope.FlgAddedEditlocal = false;
                    $rootScope.FlgModifiedAccess = false;
                    $rootScope.FlgDeletedAccess = false;
                }

                return callback(1);
            })
        }

        $rootScope.MenuSet = function () {

            var token1 = $cookieStore.get('token');
            var RoleName = $cookieStore.get('UserRoles');
            $http.get($rootScope.RoutePath + "role/getAllRoleByid?RoleName=" + RoleName).then(function (data1) {
                if (data1.data.data != null) {
                    var role_id = data1.data.data._id;
                    $http.get($rootScope.RoutePath + "userPermission/GetAllPageRights?RoleId=" + role_id).then(function (data) {
                        // console.log(data.data)
                        if (data.data.success == true) {
                            var lstAllPages = data.data.data;

                            //User
                            var lstUser = _.filter(lstAllPages, function (obj) {
                                // console.log(obj.module[0].module_name)
                                return obj.module[0].module_name == 'Users';
                            });
                            if (lstUser.length > 0) {
                                msNavigationService.saveItem('User Management.User', {
                                    title: 'User',
                                    state: 'app.user',
                                    icon: 'icon-account',
                                    order: 1,
                                    weight: 1
                                });
                            }


                            //Roles
                            var lstRoles = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'Role';
                            });
                            if (lstRoles.length > 0) {
                                msNavigationService.saveItem('User Management.Roles', {
                                    title: 'Roles',
                                    state: 'app.roles',
                                    icon: 'icon-cube-outline',
                                    order: 1,
                                    weight: 1
                                });
                            }

                            //module
                            var lstModule = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'Module';
                            });
                            if (lstModule.length > 0) {
                                msNavigationService.saveItem('User Management.Module', {
                                    title: 'module',
                                    state: 'app.Module',
                                    icon: 'icon-account-network',
                                    order: 1,
                                    weight: 1
                                });
                            }

                            //userpermission
                            var lstUserPermission = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'UserPermission';
                            });
                            if (lstUserPermission.length > 0) {
                                msNavigationService.saveItem('User Management.UserPermission', {
                                    title: 'UserPermission',
                                    state: 'app.UserPermission',
                                    icon: 'icon-lock',
                                    order: 1,
                                    weight: 1
                                });
                            }

                            var lstOrder = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'Order';
                            });
                            if (lstOrder.length > 0) {
                                msNavigationService.saveItem('Order', {
                                    title: 'Order',
                                    state: 'app.Order',
                                    icon: 'icon-bank',
                                    order: 1,
                                    weight: 1
                                });
                            }

                            // Added by Afzan

                            var lstOrder = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'demand';
                            });
                            if (lstOrder.length > 0) {
                                msNavigationService.saveItem('DemandOrder', {
                                    title: 'Demand Order',
                                    state: 'app.DemandOrder',
                                    icon: 'icon-bank',
                                    order: 1,
                                    weight: 1
                                });
                            }

                            var lstOrder = _.filter(lstAllPages, function (obj) {

                                return obj.module[0].module_name == 'Pickup';
                            });
                            if (lstOrder.length > 0) {
                                msNavigationService.saveItem('PickupOrder', {
                                    title: 'Pickup Order',
                                    state: 'app.PickupOrder',
                                    icon: 'icon-bank',
                                    order: 1,
                                    weight: 1
                                });
                            }

                            var lstPharmacyTraining = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'PharmacyTraining';
                            });
                            if (lstPharmacyTraining.length > 0) {
                                msNavigationService.saveItem('Pharmacy Training', {
                                    title: 'Pharmacy Training',
                                    state: 'app.PharmacyTraining',
                                    icon: 'icon-pill',
                                    order: 2,
                                    weight: 1
                                });
                            }

                            var lstPharmacyUserManual = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'PharmacyUserManual';
                            });
                            if (lstPharmacyUserManual.length > 0) {
                                msNavigationService.saveItem('PharmacyUserManual', {
                                    title: 'Pharmacy User Manual',
                                    state: 'app.PharmacyUserManual',
                                    icon: 'icon-library-plus',
                                    order: 2,
                                    weight: 1
                                });
                            }

                            var lstBagType = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'BagType';
                            });
                            if (lstBagType.length > 0) {
                                msNavigationService.saveItem('BagType', {
                                    title: 'Bag Type',
                                    state: 'app.BagType',
                                    icon: 'icon-drawing-box',
                                    order: 2,
                                    weight: 1
                                });
                            }

                            var lstPharmacy = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'Pharmacy';
                            });
                            if (lstPharmacy.length > 0) {
                                msNavigationService.saveItem('Pharmacy', {
                                    title: 'Pharmacy',
                                    state: 'app.Pharmacy',
                                    icon: 'icon-pharmacy',
                                    order: 2,
                                    weight: 1
                                });
                            }

                            var lstPharmacy = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'Pharmacy';
                            });
                            if (lstPharmacy.length > 0) {
                                msNavigationService.saveItem('Hospice', {
                                    title: 'Hospice',
                                    state: 'app.Hospice',
                                    icon: 'icon-pharmacy',
                                    order: 2,
                                    weight: 1
                                });
                            }

                            var lstDriver = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'Driver';
                            });
                            if (lstDriver.length > 0) {
                                msNavigationService.saveItem('Driver', {
                                    title: 'Driver',
                                    state: 'app.Driver',
                                    icon: 'icon-account-network',
                                    order: 2,
                                    weight: 1
                                });
                            }

                            var lstDriverApplication = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'DriverApplication';
                            });
                            if (lstDriverApplication.length > 0) {
                                msNavigationService.saveItem('Driver Application', {
                                    title: 'Driver Application',
                                    state: 'app.DriverApplication',
                                    icon: 'icon-open-in-app',
                                    order: 2,
                                    weight: 1
                                });
                            }

                            var lstIssueReport = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'IssueReport';
                            });
                            if (lstIssueReport.length > 0) {
                                msNavigationService.saveItem('Issue Report', {
                                    title: 'Issue Report',
                                    state: 'app.IssueReport',
                                    order: 2,
                                    icon: 'icon-alert-box',
                                    weight: 1
                                });
                            }

                            var lstAnnouncement = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'Announcement';
                            });
                            if (lstAnnouncement.length > 0) {
                                msNavigationService.saveItem('Announcement', {
                                    title: 'Announcement',
                                    state: 'app.Announcement',
                                    icon: 'icon-microphone',
                                    order: 2,
                                    weight: 1
                                });
                            }

                            var lstScheduleDelivery = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'ScheduleDelivery';
                            });
                            if (lstScheduleDelivery.length > 0) {
                                msNavigationService.saveItem('Schedule Delivery', {
                                    title: 'Schedule Delivery',
                                    state: 'app.ScheduleDelivery',
                                    icon: 'icon-calendar-clock',
                                    order: 2,
                                    weight: 1
                                });
                            }

                            var lstTestimonial = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'Testimonial';
                            });
                            if (lstTestimonial.length > 0) {
                                msNavigationService.saveItem('Testimonial', {
                                    title: 'Testimonial',
                                    state: 'app.Testimonial',
                                    icon: 'icon-format-quote',
                                    order: 2,
                                    weight: 1
                                });
                            }

                            var lstTransferPharamcy = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'TransferPharamcy';
                            });
                            if (lstTransferPharamcy.length > 0) {
                                msNavigationService.saveItem('Transfer Pharamcy', {
                                    title: 'Transfer Pharamcy Request',
                                    state: 'app.TransferPharamcy',
                                    icon: 'icon-account-switch',
                                    order: 2,
                                    weight: 1
                                });
                            }

                            var lstHospital = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'Hospital';
                            });
                            if (lstHospital.length > 0) {
                                msNavigationService.saveItem('Hospital', {
                                    title: 'Hospital',
                                    state: 'app.Hospital',
                                    icon: 'icon-hospital',
                                    order: 2,
                                    weight: 1
                                });

                            }

                            var lstOrderCharges = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'OrderCharges';
                            });
                            if (lstOrderCharges.length > 0) {
                                msNavigationService.saveItem('OrderCharges', {
                                    title: 'Order Charges',
                                    state: 'app.OrderCharges',
                                    icon: 'icon-cash-usd',
                                    order: 2,
                                    weight: 1
                                });

                            }

                            var lstInvoice = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'Invoice';
                            });
                            if (lstInvoice.length > 0) {
                                msNavigationService.saveItem('Invoice', {
                                    title: 'Invoice',
                                    state: 'app.Invoice',
                                    icon: 'icon-coin',
                                    order: 2,
                                    weight: 1
                                });

                            }

                            var lstDefaultChargesSetting = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'DefaultChargesSetting';
                            });
                            if (lstDefaultChargesSetting.length > 0) {
                                msNavigationService.saveItem('DefaultChargesSetting', {
                                    title: 'Default Charges Setting',
                                    state: 'app.DefaultChargesSetting',
                                    icon: 'icon-cog',
                                    order: 2,
                                    weight: 1
                                });
                            }

                            var lstPatient = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'Patient';
                            });
                            if (lstPatient.length > 0) {
                                msNavigationService.saveItem('Patient', {
                                    title: 'Patient',
                                    state: 'app.Patient',
                                    icon: 'icon-account',
                                    order: 2,
                                    weight: 1
                                });
                            }
                            //cashout request
                            var lstRoles = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'CashOut Request';
                            });
                            if (lstRoles.length > 0) {
                                msNavigationService.saveItem('CashOut Request', {
                                    title: 'CashOut Request',
                                    state: 'app.CashOutRequest',
                                    icon: 'icon-cube-outline',
                                    order: 1,
                                    weight: 1
                                });
                            }

                            if (lstUser.length != 0 || lstRoles != 0 || lstModule != 0 || lstUserPermission != 0) {
                                msNavigationService.saveItem('User Management', {
                                    title: 'User Management',
                                    // state: 'app.user',
                                    icon: 'icon-account-multiple',
                                    // order: 1,
                                    weight: 1
                                });
                            }

                            var lstZipcode = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'zipcode';
                            });
                            if (lstZipcode.length > 0) {
                                msNavigationService.saveItem('Zipcode', {
                                    title: 'Zipcode',
                                    state: 'app.Zipcode',
                                    icon: 'icon-drawing-box',
                                    order: 2,
                                    weight: 1
                                });
                            }

                            var lstOnePrice = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'one_price_charges';
                            });
                            if (lstOnePrice.length > 0) {
                                msNavigationService.saveItem('OnePrice', {
                                    title: 'OnePrice',
                                    state: 'app.OnePrice',
                                    icon: 'icon-drawing-box',
                                    order: 2,
                                    weight: 1
                                });
                            }

                            var Coupon = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'coupon';
                            });
                            if (Coupon.length > 0) {
                                msNavigationService.saveItem('Coupon', {
                                    title: 'Coupon',
                                    state: 'app.Coupon',
                                    icon: 'icon-drawing-box',
                                    order: 2,
                                    weight: 1
                                });
                            }

                            var SuggestPharmacy = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'SuggestPharmacy';
                            });
                            if (SuggestPharmacy.length > 0) {
                                msNavigationService.saveItem('SuggestPharmacy', {
                                    title: 'SuggestPharmacy',
                                    state: 'app.SuggestPharmacy',
                                    icon: 'icon-drawing-box',
                                    order: 2,
                                    weight: 1
                                });
                            }

                            var AutoPayAccount = _.filter(lstAllPages, function (obj) {
                                return obj.module[0].module_name == 'AutoPayAccount';
                            });
                            if (AutoPayAccount.length > 0) {
                                msNavigationService.saveItem('AutoPayAccount', {
                                    title: 'AutoPayAccount',
                                    state: 'app.AutoPayAccount',
                                    icon: 'icon-drawing-box',
                                    order: 2,
                                    weight: 1
                                });
                            }

                        }
                    });
                } else {
                    // $rootScope.logout();
                    $window.location.href = "/#/app/login";

                }
            })


            // msNavigationService.saveItem('User Management.Roles', {
            //     title: 'Roles',
            //     state: 'app.roles',
            //     order: 1,
            //     weight: 1
            // });

            // msNavigationService.saveItem('User Management.Module', {
            //     title: 'module',
            //     state: 'app.Module',
            //     order: 1,
            //     weight: 1
            // });

            // msNavigationService.saveItem('User Management.UserPermission', {
            //     title: 'UserPermission',
            //     state: 'app.UserPermission',
            //     order: 1,
            //     weight: 1
            // });

            // msNavigationService.saveItem('User Management.User', {
            //     title: 'User',
            //     state: 'app.user',
            //     order: 1,
            //     weight: 1
            // });

            // msNavigationService.saveItem('Order', {
            //     title: 'Order',
            //     state: 'app.Order',
            //     order: 1,
            //     weight: 1
            // });

            // msNavigationService.saveItem('Pharmacy Training', {
            //     title: 'Pharmacy Training',
            //     state: 'app.PharmacyTraining',
            //     order: 2,
            //     weight: 1
            // });

            // msNavigationService.saveItem('PharmacyUserManual', {
            //     title: 'PharmacyUserManual',
            //     state: 'app.PharmacyUserManual',
            //     order: 2,
            //     weight: 1
            // });

            // msNavigationService.saveItem('BagType', {
            //     title: 'Bag Type',
            //     state: 'app.BagType',
            //     order: 2,
            //     weight: 1
            // });

            // msNavigationService.saveItem('Pharmacy', {
            //     title: 'Pharmacy',
            //     state: 'app.Pharmacy',
            //     order: 2,
            //     weight: 1
            // });

            // msNavigationService.saveItem('Driver', {
            //     title: 'Driver',
            //     state: 'app.Driver',
            //     order: 2,
            //     weight: 1
            // });


            // msNavigationService.saveItem('Driver Application', {
            //     title: 'Driver Application',
            //     state: 'app.DriverApplication',
            //     order: 2,
            //     weight: 1
            // });


            // msNavigationService.saveItem('Issue Report', {
            //     title: 'Issue Report',
            //     state: 'app.IssueReport',
            //     order: 2,
            //     weight: 1
            // });

            // msNavigationService.saveItem('Announcement', {
            //     title: 'Announcement',
            //     state: 'app.Announcement',
            //     order: 2,
            //     weight: 1
            // });
            // msNavigationService.saveItem('Schedule Delivery', {
            //     title: 'Schedule Delivery',
            //     state: 'app.ScheduleDelivery',
            //     order: 2,
            //     weight: 1
            // });

            // // msNavigationService.saveItem('Pharmacy Announcement', {
            // //     title: 'Pharmacy Announcement',
            // //     state: 'app.PharmacyAnnouncement',
            // //     order: 2,
            // //     weight: 1
            // // });

            // msNavigationService.saveItem('Transfer Pharamcy', {
            //     title: 'Transfer Pharamcy Request',
            //     state: 'app.TransferPharamcy',
            //     order: 2,
            //     weight: 1
            // });

            // msNavigationService.saveItem('Hospital', {
            //     title: 'Hospital',
            //     state: 'app.Hospital',
            //     order: 2,
            //     weight: 1
            // });

            // msNavigationService.saveItem('Invoice', {
            //     title: 'Invoice',
            //     state: 'app.Invoice',
            //     order: 2,
            //     weight: 1
            // });

            // msNavigationService.saveItem('DefaultChargesSetting', {
            //     title: 'Default Charges Setting',
            //     state: 'app.DefaultChargesSetting',
            //     order: 2,
            //     weight: 1
            // });



            //                 }
            //             }
            //         });
            //     }
        }
        $rootScope.MenuSet();

        //Predefine data
        $rootScope.$on('$stateChangeStart', function (e, to) {
            // $rootScope.CheckPageRights(to);

            $rootScope.Callfuntion = function () {

                //check User Login
                $rootScope.UserName = $cookieStore.get('UserName');
                $rootScope.UserName = localStorage.getItem('UserName');
                if ($rootScope.UserName == null || $rootScope.UserName == undefined) {
                    if (window.location.href.indexOf('app/login') == -1 && window.location.href.indexOf('Forgotpassword') == -1 && window.location.href.indexOf('Register') == -1) {
                        // window.location.href = '/#/app/login';
                    }
                }

                //check Permission
                $rootScope.UserRoles = $cookieStore.get('UserRoles');
                if (to.ModuleName != 'Setting' && to.ModuleName != 'Manage Module') {


                    if ($rootScope.UserRoles) {
                        for (var i = 0; i < $rootScope.UserRoles.length; i++) {
                            if ($rootScope.UserRoles[i] == 'Super Admin') {

                                var params = {
                                    tablename: to.ModuleName,
                                    permission: "Show"
                                }
                                break;
                            } else {
                                var params = {
                                    tablename: to.ModuleName,
                                    permission: "Show",
                                    idApp: localStorage.getItem('appId'),
                                }
                            }
                        }
                        // $http.get($rootScope.RoutePath + "userpermission/CheckRights", {
                        //     params: params
                        // }).then(function (data) {
                        //     if (data.data.success == false) {
                        //         e.preventDefault();
                        //         if (window.location.href.indexOf('app/login') == -1 && window.location.href.indexOf('Forgotpassword') == -1 && window.location.href.indexOf('Register') == -1) {
                        //             //$state.go("app.login");
                        //             window.location.href = '/#/app/login';
                        //         }
                        //     };
                        // })
                    }
                }
            }
            $rootScope.Callfuntion();


        });
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function () {
            $rootScope.loadingProgress = true;

        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
            $timeout(function () {
                delete $http.defaults.headers.common['X-Requested-With'];
                $http.defaults.headers.common['X-Requested-With'] = $state.current.ModuleName;
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        //$locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/app/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation: {
                main: 'app/core/layouts/vertical-navigation.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            horizontalNavigation: {
                main: 'app/core/layouts/horizontal-navigation.html',
                toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly: {
                main: 'app/core/layouts/content-only.html',
                toolbar: '',
                navigation: ''
            },
            contentWithToolbar: {
                main: 'app/core/layouts/content-with-toolbar.html',
                toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: layouts[layoutStyle].main,
                        controller: 'MainController as vm'
                    },
                    'toolbar@app': {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller: 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller: 'NavigationController as vm'
                    },
                    // 'quickPanel@app': {
                    //     templateUrl: 'app/quick-panel/quick-panel.html',
                    //     controller: 'QuickPanelController as vm'
                    // }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function() {
    'use strict';

    angular
        .module('fuse')
        .config(config).config(override_mdMaxlength);

    /** @ngInject */
    function config() {
        // Put your custom configurations here
    }

    function override_mdMaxlength($provide) {
        $provide.decorator(
            'mdMaxlengthDirective',
            function($delegate) {
                var mdMaxlength = $delegate[0];
                var link = mdMaxlength.link;
                mdMaxlength.compile = function() {
                    //Line 18 to 64: Code of md-maxlength directive. Change in line 62
                    return function(scope, element, attr, ctrls) {
                        var maxlength;
                        var ngModelCtrl = ctrls[0];
                        var containerCtrl = ctrls[1];
                        var charCountEl = angular.element('<div class="md-char-counter">');

                        attr.$set('ngTrim', 'false');
                        containerCtrl.element.append(charCountEl);

                        ngModelCtrl.$formatters.push(renderCharCount);
                        ngModelCtrl.$viewChangeListeners.push(renderCharCount);
                        element.on(
                            'input keydown',
                            function() {
                                renderCharCount(); //make sure it's called with no args
                            }
                        );

                        scope.$watch(attr.mdMaxlength, function(value) {
                            maxlength = value;
                            if (angular.isNumber(value) && value > 0) {
                                if (!charCountEl.parent().length) {
                                    $animate.enter(
                                        charCountEl,
                                        containerCtrl.element,
                                        angular.element(containerCtrl.element[0].lastElementChild)
                                    );
                                }
                                renderCharCount();
                            } else {
                                $animate.leave(charCountEl);
                            }
                        });

                        ngModelCtrl.$validators['md-maxlength'] = function(modelValue, viewValue) {
                            if (!angular.isNumber(maxlength) || maxlength < 0) {
                                return true;
                            }
                            return (modelValue || element.val() || viewValue || '').length <= maxlength;
                        };

                        function renderCharCount(value) {
                            //Original code commented
                            //charCountEl.text( ( element.val() || value || '' ).length + '/' + maxlength );
                            //CHANGE PROPOSED BY @breeze4 (MATT BAILEY): http://tinyurl.com/pxnnvxb
                            charCountEl.text((ngModelCtrl.$modelValue || '').length + '/' + maxlength);
                            return value;
                        }
                    };
                };
                return $delegate;
            }
        );
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
var Base64 = {
 
        keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
 
        encode: function (input) {
            var output = "";
            var chr1, chr2, chr3 = "";
            var enc1, enc2, enc3, enc4 = "";
            var i = 0;
 
            do {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);
 
                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;
 
                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }
 
                output = output +
                    this.keyStr.charAt(enc1) +
                    this.keyStr.charAt(enc2) +
                    this.keyStr.charAt(enc3) +
                    this.keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = "";
                enc1 = enc2 = enc3 = enc4 = "";
            } while (i < input.length);
 
            return output;
        },
 
        decode: function (input) {
            var output = "";
            var chr1, chr2, chr3 = "";
            var enc1, enc2, enc3, enc4 = "";
            var i = 0;
 
            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            var base64test = /[^A-Za-z0-9\+\/\=]/g;
            if (base64test.exec(input)) {
                window.alert("There were invalid base64 characters in the input text.\n" +
                    "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
                    "Expect errors in decoding.");
            }
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
 
            do {
                enc1 = this.keyStr.indexOf(input.charAt(i++));
                enc2 = this.keyStr.indexOf(input.charAt(i++));
                enc3 = this.keyStr.indexOf(input.charAt(i++));
                enc4 = this.keyStr.indexOf(input.charAt(i++));
 
                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;
 
                output = output + String.fromCharCode(chr1);
 
                if (enc3 != 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 != 64) {
                    output = output + String.fromCharCode(chr3);
                }
 
                chr1 = chr2 = chr3 = "";
                enc1 = enc2 = enc3 = enc4 = "";
 
            } while (i < input.length);
 
            return output;
        }
    };
 

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.TODAY\">TODAY</md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.CHAT\">CHAT</md-tab-label><md-tab-body><md-content class=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" ng-controller=\"ChatTabController as vm\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label translate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</md-tab-label><md-tab-body>\n<md-content class=\"activity-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" \nui-view=\"navigation\"></div><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div \nclass=\"option-title\">Layout Style:</div><md-radio-group layout=\"column\" ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button value=\"verticalNavigation\">Vertical Navigation</md-radio-button>\n<md-radio-button value=\"horizontalNavigation\">Horizontal Navigation</md-radio-button><md-radio-button \nvalue=\"contentOnly\">Content Only</md-radio-button><md-radio-button value=\"contentWithToolbar\">Content with Toolbar\n</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">\nLayout Mode:</div><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" \nng-change=\"vm.updateLayoutMode()\"><md-radio-button value=\"boxed\">Boxed</md-radio-button><md-radio-button value=\"wide\">\nWide</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div \nclass=\"option-title\">Color Palette:</div><md-menu-item ng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\">\n<md-button class=\"md-raised theme-button\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"themeName\"><span><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\">\n</md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>");
$templateCache.put("app/main/Announcement/Announcement.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-microphone\"></md-icon><span translate=\"Announcement\">Announcement</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\" flex-gt-sm=\"33\" align=\"center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" \nng-model=\"modelSearch.search\" ng-change=\"reloadTable(true)\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \ntranslate translate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" \nlayout-align=\"end center\"><div><md-button class=\"md-icon-button md-raised md-hue-2\" ng-click=\"resetData()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Send Announcement</md-tooltip></md-button>\n</div></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><table id=\"announcementTable\" class=\"dataTable cell-border row-border hover\" datatable=\"\" \ndt-instance=\"vm.dtInstance\" dt-columns=\"dtColumns\" dt-options=\"dtOptions\" width=\"100%\"><thead><tr><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">User Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Title</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Message</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Date</span></div></th></tr></thead></table></div></div></div></div><div\n class=\"page-layout simple tabbed\" layout=\"column\" ng-show=\"flag\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"goToList()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"subtitle secondary-text\"><span translate=\"Add Announcement\">\nAdd Announcement</span></div></div></div></div><div></div></div><div class=\"content\" layout-margin><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"formAnnouncement\" novalidate \nclass=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><div layout=\"row\" layout-wrap><md-input-container \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><label>User Type</label><md-select name=\"type\" ng-model=\"model.type\" \nrequired><md-option value=\"Pharmacy\">Pharmacy</md-option><md-option value=\"Hospital\">Hospital</md-option><md-option \nvalue=\"Driver\">Driver</md-option><md-option value=\"Patient\">Patient</md-option><div \nng-messages=\"formAnnouncement.type.$error\" ng-if=\"formAnnouncement.type.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>User Type field is required</span></div></div></md-select></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><label>Title</label><input \ntype=\"text\" name=\"title\" ng-model=\"model.title\" required maxlength=\"100\" md-maxlength=\"100\"><div \nng-messages=\"formAnnouncement.title.$error\" ng-if=\"formAnnouncement.title.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Title field is required</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><label>Announcement Message</label>\n<textarea ng-model=\"model.message\" md-select-on-focus></textarea><div ng-messages=\"formAnnouncement.message.$error\" \nng-if=\"formAnnouncement.message.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nAnnouncement message field is required</span></div></div></md-input-container></div><div align=\"center\"><md-button \nclass=\"md-raised md-primary\" ng-disabled=\"!formAnnouncement.$valid\" ng-click=\"Announcement()\">Send</md-button>\n<md-button class=\"md-accent md-raised\" ng-click=\"resetData()\">Reset</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"goToList()\">Cancel</md-button></div></form></div></div></div>");
$templateCache.put("app/main/BagType/BagType.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-drawing-box\"></md-icon><span translate=\"BagType\">BagType</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"modelsearch\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" \nlayout-align=\"end center\"><div><md-button class=\"md-icon-button md-raised md-hue-2\" ng-click=\"ResetEdit()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Add New BagType</md-tooltip></md-button>\n</div></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border cell-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Price ($)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Is Active</span></div></th><th class=\"all\">\n<div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in lstBagtype \"><td style=\"width: 4%; text-align: center\">{{$index+1}}</td><td>{{item.name}}</td><td>\n{{item.price}}</td><td>{{item.date |date : \"MM-dd-yyyy HH:mm:ss\"}}</td><td ng-if=\"item.is_active==1\" \nstyle=\"width: 10%; text-align: center\"><span style=\"font-size: 20px;color: green\">&#x2714;</span></td><td \nng-if=\"item.is_active!=1\" style=\"width: 10%; text-align: center\"><span style=\"font-size: 20px;color: red\">&#x2716;\n</span></td><td style=\"text-align: center\"><md-button class=\"edit-button md-icon-button\" \nng-click=\"FetchRoleById(item)\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18 green-500-fg\"></md-icon><md-tooltip \nmd-visible=\"\" md-direction=\"\">Edit</md-tooltip></md-button><md-button class=\"edit-button md-icon-button\" \nng-click=\"DeleteBagType(item._id)\"><md-icon md-font-icon=\"icon-trash\" class=\"s18 red-500-fg\"></md-icon><md-tooltip \nmd-visible=\"\" md-direction=\"\">Delete</md-tooltip></md-button><md-button ng-if=\"!item.is_active\" \nclass=\"edit-button md-icon-button\" ng-click=\"UpdateIsActive(item._id,1)\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"s20 green-500-fg\"></md-icon><md-tooltip md-visible=\"\" \nmd-direction=\"\">Activate BagType</md-tooltip></md-button><md-button ng-if=\"item.is_active\" \nclass=\"edit-button md-icon-button\" ng-click=\"UpdateIsActive(item._id,0)\" aria-label=\"\"><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"s20 red-500-fg\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">\nInactive BagType</md-tooltip></md-button></td></tr></tbody></table></div></div></div></div><div \nclass=\"page-layout simple tabbed\" layout=\"column\" ng-show=\"flag\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"Go to Brand\" ng-click=\"gotoBrandList()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"subtitle secondary-text\"><span translate=\"Add Bag Type\">\nAdd Bag Type</span></div></div></div></div><div></div></div><div class=\"content\" layout-margin><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"FormManageBrand\" novalidate \nclass=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><div layout=\"row\" layout-wrap><md-input-container \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>Name</label><input type=\"text\" name=\"name\" ng-model=\"model.name\" \nrequired maxlength=\"255\" md-maxlength=\"255\"><div ng-messages=\"FormManageBrand.name.$error\" \nng-if=\"FormManageBrand.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Name field is required</span></div>\n</div></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><label>Price</label><input type=\"number\" name=\"price\" ng-model=\"model.price\" required><div \nng-messages=\"FormManageBrand.price.$error\" ng-if=\"FormManageBrand.price.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>price field is required</span></div></div></md-input-container></div><div><md-button \nclass=\"md-raised md-primary\" ng-click=\"CreateBagType(model)\">save</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"Reset()\">cancel</md-button></div></form></div></div></div>");
$templateCache.put("app/main/AutoPayAccount/AutoPayAccount.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-wrap \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" layout-gt-sm=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-pharmacy\"></md-icon><span translate=\"AutoPay Account\">AutoPay Account</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" ng-model=\"modelSearch.search\" \nng-change=\"reloadTableData(true)\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button md-raised md-hue-2\" ng-click=\"toggle()\" aria-label=\"Search\">\n<md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Advance Search\n</md-tooltip></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"ShowContentBox\"><i \nng-show=\"flgforIcon\" ng-click=\"toggle()\" class=\"icon-close-circle-outline right closeIcon\"></i><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"25\" flex-gt-md=\"15\"><label>\nEmail Verified</label><md-select name=\"type\" ng-model=\"model.verified\" required><md-option value=\"1\">Yes</md-option>\n<md-option value=\"0\">No</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-sm=\"25\" flex-gt-md=\"15\"><label>IsActive</label><md-select name=\"type\" \nng-model=\"model.Approved\" required><md-option value=\"1\">Yes</md-option><md-option value=\"0\">No</md-option></md-select>\n</md-input-container><div align=\"left\"><md-button class=\"md-icon-button md-accent md-raised md-hue-2\" \nng-click=\"reloadTableData(true)\" aria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip \nmd-visible=\"\" md-direction=\"\">Search</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-warn md-raised md-hue-2\" ng-click=\"initModel();reloadTableData(true);\" \naria-label=\"Reset Search\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">\nReset Search</md-tooltip></md-button></div></div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table id=\"autoPayPharmacyTable\" class=\"dataTable cell-border row-border hover\" datatable=\"\" \ndt-instance=\"vm.dtInstance\" dt-columns=\"dtColumns\" dt-options=\"dtOptions\" width=\"100%\"><thead><tr><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Pharmacy Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Address</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Autopay Acceptance</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Email</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Created Date</span></div></th><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\">Status</span></div></th></tr></thead></table></div></div></div></div>");
$templateCache.put("app/main/ChangePassword/ChangePassword.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-wrap \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" layout-gt-sm=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-cube-outline\"></md-icon><span translate=\"Change Password\">Change Password</span></div></div></div>\n<div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nclass=\"product-detail-form-container md-background-bg\"><form name=\"FormChangePassword\" novalidate class=\"ms-stepper\" \naria-invalid=\"false\" style=\"padding: 24px\"><md-content class=\"content\" ms-scroll><md-input-container class=\"md-block\" \nflex-gt-sm=\"50\"><label>Old Password</label><input name=\"oldpassword\" type=\"password\" ng-model=\"model.oldpassword\" \nng-required=\"true\" md-maxlength=\"100\"><div ng-messages=\"FormChangePassword.oldpassword.$error\" \nng-if=\"FormChangePassword.oldpassword.$touched\"><div ng-message=\"required\"><span>Old Password is required</span></div>\n<div ng-message=\"md-maxlength\"><span>Old Password is 100 char long</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>Password</label><input name=\"password\" type=\"password\" \nng-model=\"model.password\" ng-required=\"true\" md-maxlength=\"100\"><div ng-messages=\"FormChangePassword.password.$error\" \nng-if=\"FormChangePassword.password.$touched\"><div ng-message=\"required\"><span>Password is required</span></div><div \nng-message=\"md-maxlength\"><span>Password is 100 char long</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm=\"50\"><label>Confirm Password</label><input name=\"confirmpassword\" type=\"password\" \nng-model=\"model.confirmpassword\" ng-required=\"true\" md-maxlength=\"100\"><div \nng-messages=\"FormChangePassword.confirmpassword.$error\" ng-if=\"FormChangePassword.confirmpassword.$touched\"><div \nng-message=\"required\"><span>Confirm Password is required</span></div><div ng-message=\"md-maxlength\"><span>\nConfirm Password is 100 char long</span></div></div></md-input-container><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-raised md-accent\" ng-disabled=\"FormChangePassword.$invalid\" ng-click=\"ChangePassword(model)\">\nChange Password</md-button><md-button class=\"md-raised md-default\" ng-click=\"Reset()\">Cancel</md-button></div><br>\n</md-content></form></div></div></div></div></div>");
$templateCache.put("app/main/Coupon/Coupon.html","<div id=\"loaderDiv\"><div class=\"loading-spiner\"><img src=\"../../../assets/images/loader.gif\" \nstyle=\"margin-left: 35rem;height: 150px;\r\n                width: 150px\"></div></div><div id=\"e-commerce-products\" \nclass=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-wrap layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" layout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-drawing-box\"></md-icon><span translate=\"Coupons\">\nCoupon</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex></div><div flex=\"40\" \nflex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" layout-align=\"end center\"><div><md-button \nclass=\"md-icon-button md-raised md-hue-2\" ng-click=\"ResetEdit()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip md-visible=\"\" md-direction=\"\">Add New Coupon</md-tooltip></md-button></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nid=\"Hospital\" class=\"dataTable row-border cell-border hover\" datatable=\"\" dt-instance=\"vm.dtInstanceHospital\" \ndt-columns=\"dtColumnsHospital\" dt-options=\"dtOptions\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Coupon\n</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Discount</span></div></th><th \nclass=\"all\"><div class=\"table-header\"><span class=\"column-title\">Expires on</span></div></th><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead></table></div></div></div></div>\n<div class=\"page-layout simple tabbed\" layout=\"column\" ng-show=\"flag\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"Go to Brand\" ng-click=\"backToAllCoupon()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"subtitle secondary-text\"><span translate=\"Add Coupon code\">\nAdd New Coupon</span></div></div></div></div><div></div></div><div class=\"content\" layout-margin><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"FormManageBrand\" novalidate \nclass=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><div layout=\"row\" layout-wrap><md-input-container \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>Coupon name</label><input type=\"text\" name=\"zip\" \nng-model=\"model.name\" required maxlength=\"20\" md-maxlength=\"20\"><div ng-messages=\"FormManageBrand.name.$error\" \nng-if=\"FormManageBrand.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Coupon name field is required\n</span></div></div></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"50\"><label>Coupon code</label><input type=\"text\" name=\"zip\" ng-model=\"model.code\" required \nmaxlength=\"10\" md-maxlength=\"10\"><div ng-messages=\"FormManageBrand.name.$error\" ng-if=\"FormManageBrand.name.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Coupon code field is required</span></div></div></md-input-container>\n</div><div layout=\"row\" layout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>\nCoupon discount percent (%)</label><input type=\"text\" name=\"zip\" ng-model=\"model.discount\" required maxlength=\"6\" \nmd-maxlength=\"6\"><div ng-messages=\"FormManageBrand.name.$error\" ng-if=\"FormManageBrand.name.$touched\" role=\"alert\"><div\n ng-message=\"required\"><span>Coupon discount percent field is required</span></div></div></md-input-container></div>\n<div layout=\"row\" layout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>Coupon descriptions\n</label><input type=\"text\" name=\"zip\" ng-model=\"model.descriptions\" required maxlength=\"60\" md-maxlength=\"60\"><div \nng-messages=\"FormManageBrand.name.$error\" ng-if=\"FormManageBrand.name.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Coupon descriptions field is required</span></div></div></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>Coupon Expiring Date\n</label><input type=\"date\" name=\"expiringDate\" ng-model=\"model.expiring\" required maxlength=\"10\" \nplaceholder=\"YYYY-MM-DD\"><div ng-messages=\"FormManageBrand.expiringDate.$error\" \nng-if=\"FormManageBrand.expiringDate.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Coupon exp date is required\n</span></div></div></md-input-container></div><div><md-button class=\"md-raised md-primary\" \nng-click=\"createCoupon(model)\">save</md-button><md-button class=\"md-raised md-warn\" ng-click=\"cancel()\">cancel\n</md-button></div></form></div></div></div>");
$templateCache.put("app/main/CashOutRequest/CashOutRequest.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-drawing-box\"></md-icon><span translate=\"CashOutRequest\">CashOutRequest</span></div></div><div \nflex=\"40\" flex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" layout-align=\"end center\"></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><div class=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Driver</label><md-select ng-model=\"model.driver_id\" md-on-close=\"clearSearchTerm()\" \nng-change=\"GetDriverCashoutList(model.driver_id)\" data-md-container-class=\"selectdemoSelectHeader\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.search\" type=\"search\" placeholder=\"Search for a Driver..\" \nclass=\"demo-header-searchbox md-text\" ng-keydown=\"onSearchChange($event)\"></md-select-header><md-option \nvalue=\"{{o._id}}\" ng-repeat=\"o in lstDriver| orderBy: \'first_name\' |  filter:vm.search\">\n{{o.first_name}} {{o.middle_name}} {{o.last_name}} - {{o.mobile_number}}</md-option></md-select></md-input-container>\n</div><table class=\"dataTable row-border cell-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Number Of Delivery</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Amount Credited ($)</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"item in lstDriverCashoutRequest.payments\"><td style=\"width: 4%; text-align: center\">\n{{$index+1}}</td><td style=\"text-align: center\">{{item.number_of_deliveries}}</td><td style=\"text-align: right\">\n{{item.amount_credited | number : 2}}</td><td style=\"text-align: center\">\n{{item.credited_date | date : \"MM-dd-yyyy HH:mm:ss\"}}</td></tr></tbody></table></div></div></div></div><div \nclass=\"page-layout simple tabbed\" layout=\"column\" ng-show=\"flag\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"Go to Brand\" ng-click=\"gotoBrandList()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"subtitle secondary-text\"><span translate=\"Add CashOut Request\">\nAdd CashOut Request</span></div></div></div></div><div></div></div><div class=\"content\" layout-margin><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"FormManageBrand\" novalidate \nclass=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><div layout=\"row\" layout-wrap><md-input-container \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>Name</label><input type=\"text\" name=\"name\" ng-model=\"model.name\" \nrequired maxlength=\"255\" md-maxlength=\"255\"><div ng-messages=\"FormManageBrand.name.$error\" \nng-if=\"FormManageBrand.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Name field is required</span></div>\n</div></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"50\" \nflex-gt-md=\"50\"><label>Price</label><input type=\"number\" name=\"price\" ng-model=\"model.price\" required><div \nng-messages=\"FormManageBrand.price.$error\" ng-if=\"FormManageBrand.price.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>price field is required</span></div></div></md-input-container></div><div><md-button \nclass=\"md-raised md-primary\" ng-click=\"CreateBagType(model)\">save</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"Reset()\">cancel</md-button></div></form></div></div></div>");
$templateCache.put("app/main/Dashboard/Dashboard.html","<md-content><div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">Dashboard</span></div></div><div \nlayout=\"row\" ng-if=\"UserRoles==\'Super Admin\'\"><div layout=\"column\" layout-align=\"center center\" flex></div><div \nclass=\"selected-project\">{{selectAppName}}</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button \nclass=\"md-icon-button project-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin \nmd-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" \nclass=\"md-background-bg\"><md-menu-item><md-button ng-click=\"selectedAppName(\'All\')\"><span \nng-class=\"{\'secondary-text\': selectAppName == All}\">All</span></md-button></md-menu-item><md-menu-item \nng-repeat=\"o in lstAppInfo\"><md-button ng-click=\"selectedAppName(o)\" aria-label=\"o.AppName\"><span \nng-class=\"{\'secondary-text\': selectAppName == o}\">{{o.AppName}}</span></md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div><div class=\"content\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget layout=\"column\" flex=\"auto\"><ms-widget-front class=\"p-16 blue-bg white-fg\" layout=\"row\" flex><div \nlayout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-3 pb-8\"><span \nng-if=\"lstDashBoardInfo.TotalUser==null\" class=\"s70\">0</span> <span ng-if=\"lstDashBoardInfo.TotalUser!=null\" \nclass=\"s70\">{{lstDashBoardInfo.TotalUser}}</span></div><div class=\"h3 font-weight-500\">Total Users</div></div><div \nclass=\"background-image-center\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s256 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"auto\"><ms-widget-front \nclass=\"p-16 indigo-400-bg white-fg\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-3 pb-8\"><span ng-if=\"lstTotalCustomer==null\" class=\"s70\">0</span> <span \nng-if=\"lstTotalCustomer!=null\" class=\"s70\">{{lstTotalCustomer}}</span></div><div class=\"h3 font-weight-500\">\nTotal Customer (s)</div></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-account-multiple\" \nclass=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"auto\">\n<ms-widget-front class=\"p-16 deep-orange-800-bg white-fg\" layout=\"row\" flex><div layout=\"column\" \nlayout-align=\"center center\" flex><div class=\"md-display-3 pb-8\"><span \nng-if=\"ActiveDevice==null && NotActiveDevice==null\">0</span> <span ng-if=\"ActiveDevice!=null && NotActiveDevice!=null\">\n{{ActiveDevice.length + NotActiveDevice.length+NotSaleDevice.length}}</span></div><div class=\"h3 font-weight-500\">\nTotal Device</div></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-album\" \nclass=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"auto\">\n<ms-widget-front class=\"p-16 green-900-bg white-fg\" layout=\"row\" flex><div layout=\"column\" \nlayout-align=\"center center\" flex><div class=\"md-display-3 pb-8\"><span ng-if=\"ActiveDevice==null\">0</span> <span \nng-if=\"ActiveDevice!=null\">{{ActiveDevice.length}}</span></div><div class=\"h3 font-weight-500\">Online Device</div>\n</div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-link-variant\" class=\"s256 faint-text\"></md-icon>\n</div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"auto\"><ms-widget-front \nclass=\"p-16 grey-700-bg white-fg\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-3 pb-8\"><span ng-if=\"NotActiveDevice==null\">0</span> <span ng-if=\"NotActiveDevice!=null\">\n{{NotActiveDevice.length}}</span></div><div class=\"h3 font-weight-500\">Customer Offline Device</div></div><div \nclass=\"background-image-center\"><md-icon md-font-icon=\"icon-link-variant-off\" class=\"s256 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"auto\"><ms-widget-front \nclass=\"p-16 grey-700-bg white-fg\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-3 pb-8\"><span ng-if=\"NotSaleDevice==null\">0</span> <span ng-if=\"NotSaleDevice!=null\">\n{{NotSaleDevice.length}}</span></div><div class=\"h3 font-weight-500\">Not Sale Device</div></div><div \nclass=\"background-image-center\"><md-icon md-font-icon=\"icon-link-variant-off\" class=\"s256 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget></div><div class=\"content\" layout-gt-sm=\"row\" layout=\"row\"><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"content\" \nlayout-gt-sm=\"row\" layout=\"row\"><div class=\"widget-group text-left\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\" \nflex-gt-xs=\"100\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><md-content \nclass=\"text-right\"><div><div layout-gt-sm=\"row\"><div style=\"width: 100%\"><div id=\"map123\" style=\"height: 500px\"></div>\n</div></div></div></md-content></ms-widget></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-md=\"100\" flex-xs=\"100\" flex-sm=\"100\">\n<ms-widget-front class=\"white-bg\"><md-toolbar class=\"md-primary md-hue-2\"><h2 class=\"md-toolbar-tools\"><span>\nThis Year Users</span></h2></md-toolbar><br><div><ms-widget-front class=\"p-16 white-bg\"><nvd3 \nclass=\"h-420 remove-x-lines\" config=\"TotalUser.mainChart.config\" options=\"TotalUser.mainChart.options\" \ndata=\"TotalUser.mainChart.data\"></nvd3></ms-widget-front></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"p-16 white-bg\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3\">{{TotalCustomerUser.title}}</div><md-input-container flex=\"10\" flex-gt-sm=\"10\"><label>Year</label><md-select\n name=\"OperatingWeeks1\" ng-model=\"model.Year\"><md-option value=\"0\">Select</md-option><md-option value=\"{{o.YearName}}\" \nng-repeat=\"o in listYear\">{{o.YearName}}</md-option></md-select></md-input-container><md-input-container flex=\"10\" \nflex-gt-sm=\"10\"><label>Month</label><md-select name=\"OperatingWeeks1\" ng-model=\"model.MonthId\"><md-option value=\"0\">\nSelect</md-option><md-option ng-repeat=\"o in listMonthName\" value=\"{{o.id}}\">{{o.name}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"10\" flex-gt-sm=\"10\"><label>Country</label><md-select name=\"CountryName\" \nng-model=\"model.CountryName\"><md-option value=\"All\">All</md-option><md-option \nng-repeat=\"i in lstCountry | orderBy : \'Country\' \" value=\"{{i.Country}}\">{{i.Country}}</md-option></md-select>\n</md-input-container><md-button class=\"md-raised md-primary\" ng-click=\"SearchData(model)\">Search</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"CustomerAndUser(false)\">Reset</md-button><md-menu><md-button aria-label=\"more\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"CustomerAndUser(false)\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div><nvd3 class=\"h-320\" class=\"remove-x-lines\" \noptions=\"TotalCustomerUser.chart.options\" data=\"TotalCustomerUser.chart.data\"></nvd3></div></ms-widget-front>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\"><div class=\"pb-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{TotalCustomerUserAcc.title}}</div><md-input-container flex=\"10\" \nflex-gt-sm=\"10\"><label>Year</label><md-select name=\"OperatingWeeks1\" ng-model=\"model.YearAcc\"><md-option value=\"0\">\nSelect</md-option><md-option value=\"{{o.YearName}}\" ng-repeat=\"o in listYear\">{{o.YearName}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"10\" flex-gt-sm=\"10\"><label>Month</label><md-select \nname=\"OperatingWeeks1\" ng-model=\"model.MonthIdAcc\"><md-option value=\"0\">Select</md-option><md-option \nng-repeat=\"o in listMonthName\" value=\"{{o.id}}\">{{o.name}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"10\" flex-gt-sm=\"10\"><label>Country</label><md-select name=\"CountryName\" \nng-model=\"model.CountryNameAcc\"><md-option value=\"All\">All</md-option><md-option \nng-repeat=\"i in lstCountry | orderBy : \'Country\' \" value=\"{{i.Country}}\">{{i.Country}}</md-option></md-select>\n</md-input-container><md-button class=\"md-raised md-primary\" ng-click=\"SearchDataAcc(model)\">Search</md-button>\n<md-button class=\"md-raised md-warn\" ng-click=\"CustomerAndUserAcc(false)\">Reset</md-button><md-menu><md-button \naria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"CustomerAndUserAcc(false)\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div><nvd3 \nclass=\"h-320\" class=\"remove-x-lines\" options=\"TotalCustomerUserAcc.chart.options\" \ndata=\"TotalCustomerUserAcc.chart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" layout-wrap ng-if=\"!FlgSuperAdmin\"><ms-widget layout=\"column\" flex=\"100\" flex-md=\"100\" flex-xs=\"100\" \nflex-sm=\"100\"><ms-widget-front class=\"white-bg\"><md-toolbar class=\"md-primary md-hue-2\"><div class=\"md-toolbar-tools\">\n<h2 class=\"md-flex\">Total Customer by Country</h2><span flex></span><md-button \nclass=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"icon-refresh\" ng-click=\"TotalCustomerbyCountry()\" \nclass=\"s16\"></md-icon></md-button></div></md-toolbar><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"dtOptionstable\" dt-column-defs=\"dtColumnDefsC\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\">No</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nCountry</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"o in lstFinalTotalCustomerByCountry\"><td class=\"\" \nstyle=\"width: 4%; text-align: center\">{{$index+1}}</td><td class=\"\" ng-if=\"o.Country!=null\">{{o.Country}}</td><td \nclass=\"\" ng-if=\"o.Country==null\">Other</td><td class=\"\">{{o.Customer}}</td></tr></tbody></table></ms-widget-front>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" layout-wrap ng-if=\"FlgSuperAdmin\"><ms-widget layout=\"column\" \nflex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><md-toolbar class=\"md-primary md-hue-2\"><div \nclass=\"md-toolbar-tools\"><h2 class=\"md-flex\">Total Customer by Country</h2><span flex></span><md-button \nclass=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"icon-refresh\" ng-click=\"TotalCustomerbyCountry()\" \nclass=\"s16\"></md-icon></md-button></div></md-toolbar><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"dtOptionstable\" dt-column-defs=\"dtColumnDefsC\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\">No</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nCountry</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Customer\n</span></div></th></tr></thead><tbody><tr ng-repeat=\"o in lstFinalTotalCustomerByCountry\"><td class=\"\" \nstyle=\"width: 4%; text-align: center\">{{$index+1}}</td><td class=\"\" ng-if=\"o.Country!=null\">{{o.Country}}</td><td \nclass=\"\" ng-if=\"o.Country==null\">Other</td><td class=\"\">{{o.Customer}}</td></tr></tbody></table></ms-widget-front>\n</ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><md-toolbar \nclass=\"md-primary md-hue-2\"><div class=\"md-toolbar-tools\"><h2 class=\"md-flex\">Expire Device</h2><span flex></span>\n<md-button class=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"icon-refresh\" \nng-click=\"GetAllExpiredDevice()\" class=\"s16\"></md-icon></md-button></div></md-toolbar><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptionstable\" dt-column-defs=\"dtColumnDefsC1\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\">No</div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Device ID</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">SIM Number</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Expire After</span></div></th></tr></thead><tbody><tr \nng-repeat=\"o in ExpiryDevicelist\"><td class=\"\" style=\"width: 4%; text-align: center\">{{$index+1}}</td><td class=\"\">\n{{o.deviceid}}</td><td class=\"\">{{o.SerialNum}}</td><td class=\"\">{{o.diff}}</td></tr></tbody></table></ms-widget-front>\n</ms-widget></div></div></div></md-content><style>\n.customMarker1 {\r\n        height: 20px;\r\n        /* background-image: url(img/icon-map-car-on2.png); */\r\n        width: 46px;\r\n        background-size: contain;\r\n        background-repeat: no-repeat;\r\n        position: absolute;\r\n        margin-left: -25px;\r\n        margin-top: -13px;\r\n        cursor: pointer;\r\n    }\r\n    \r\n    .customMarkercar {\r\n        height: 30px;\r\n        /* background-image: url(img/icon-map-car-on2.png); */\r\n        width: 30px;\r\n        background-size: contain;\r\n        background-repeat: no-repeat;\r\n        position: absolute;\r\n        margin-left: -13px;\r\n        margin-top: -13px;\r\n        cursor: pointer;\r\n        /* animation: pulseNew 1s infinite;\r\n        border-radius: 50%; */\r\n    }\r\n    \r\n    .customMarkercar.online {\r\n        background-image: url({{OnlineImage}});\r\n    }\r\n    \r\n    .customMarkercar.offline {\r\n        background-image: url({{OfflineImage}});\r\n    }\r\n    \r\n    .customMarkercar.active {\r\n        background-image: url({{ActiveImage}});\r\n    }\r\n    \r\n    .customMarkercar .my-text-shadow {\r\n        color: white;\r\n        position: absolute;\r\n        left: -25px;\r\n        top: -15px;\r\n        /* text-shadow: -2px -2px 0 #0cad00, -2px -1px 0 #0cad00, -2px 0px 0 #0cad00, -2px 1px 0 #0cad00, -2px 2px 0 #0cad00, -1px -2px 0 #0cad00, -1px -1px 0 #0cad00, -1px 0px 0 #0cad00, -1px 1px 0 #0cad00, -1px 2px 0 #0cad00, 0px -2px 0 #0cad00, 0px -1px 0 #0cad00, 0px 0px 0 #0cad00, 0px 1px 0 #0cad00, 0px 2px 0 #0cad00, 1px -2px 0 #0cad00, 1px -1px 0 #0cad00, 1px 0px 0 #0cad00, 1px 1px 0 #0cad00, 1px 2px 0 #0cad00, 2px -2px 0 #0cad00, 2px -1px 0 #0cad00, 2px 0px 0 #0cad00, 2px 1px 0 #0cad00, 2px 2px 0 #0cad00; */\r\n        font-size: 14px;\r\n        width: 100px;\r\n        text-align: center;\r\n    }\r\n    \r\n    .customMarkercar .my-text-shadow.online {\r\n        text-shadow: -2px -2px 0 #007f00, -2px -1px 0 #007f00, -2px 0px 0 #007f00, -2px 1px 0 #007f00, -2px 2px 0 #007f00, -1px -2px 0 #007f00, -1px -1px 0 #007f00, -1px 0px 0 #007f00, -1px 1px 0 #007f00, -1px 2px 0 #007f00, 0px -2px 0 #007f00, 0px -1px 0 #007f00, 0px 0px 0 #007f00, 0px 1px 0 #007f00, 0px 2px 0 #007f00, 1px -2px 0 #007f00, 1px -1px 0 #007f00, 1px 0px 0 #007f00, 1px 1px 0 #007f00, 1px 2px 0 #007f00, 2px -2px 0 #007f00, 2px -1px 0 #007f00, 2px 0px 0 #007f00, 2px 1px 0 #007f00, 2px 2px 0 #007f00;\r\n    }\r\n    \r\n    .customMarkercar .my-text-shadow.offline {\r\n        text-shadow: -2px -2px 0 #7f7f7f, -2px -1px 0 #7f7f7f, -2px 0px 0 #7f7f7f, -2px 1px 0 #7f7f7f, -2px 2px 0 #7f7f7f, -1px -2px 0 #7f7f7f, -1px -1px 0 #7f7f7f, -1px 0px 0 #7f7f7f, -1px 1px 0 #7f7f7f, -1px 2px 0 #7f7f7f, 0px -2px 0 #7f7f7f, 0px -1px 0 #7f7f7f, 0px 0px 0 #7f7f7f, 0px 1px 0 #7f7f7f, 0px 2px 0 #7f7f7f, 1px -2px 0 #7f7f7f, 1px -1px 0 #7f7f7f, 1px 0px 0 #7f7f7f, 1px 1px 0 #7f7f7f, 1px 2px 0 #7f7f7f, 2px -2px 0 #7f7f7f, 2px -1px 0 #7f7f7f, 2px 0px 0 #7f7f7f, 2px 1px 0 #7f7f7f, 2px 2px 0 #7f7f7f;\r\n    }\r\n    \r\n    .customMarkercar .my-text-shadow.active {\r\n        text-shadow: -2px -2px 0 #ff9900, -2px -1px 0 #ff9900, -2px 0px 0 #ff9900, -2px 1px 0 #ff9900, -2px 2px 0 #ff9900, -1px -2px 0 #ff9900, -1px -1px 0 #ff9900, -1px 0px 0 #ff9900, -1px 1px 0 #ff9900, -1px 2px 0 #ff9900, 0px -2px 0 #ff9900, 0px -1px 0 #ff9900, 0px 0px 0 #ff9900, 0px 1px 0 #ff9900, 0px 2px 0 #ff9900, 1px -2px 0 #ff9900, 1px -1px 0 #ff9900, 1px 0px 0 #ff9900, 1px 1px 0 #ff9900, 1px 2px 0 #ff9900, 2px -2px 0 #ff9900, 2px -1px 0 #ff9900, 2px 0px 0 #ff9900, 2px 1px 0 #ff9900, 2px 2px 0 #ff9900;\r\n    }\r\n    \r\n    .nvtooltip {\r\n        color: #fff;\r\n        border: none;\r\n    }\r\n    \r\n    .nvtooltip table {\r\n        margin: 0;\r\n        border-radius: 0;\r\n    }\r\n    \r\n    .nvtooltip.gravity-s:after {\r\n        display: block;\r\n        position: absolute;\r\n        content: \'\';\r\n        width: 0;\r\n        height: 0;\r\n        top: 99%;\r\n        left: 50%;\r\n        margin-left: -5px;\r\n        border: 10px solid transparent;\r\n        border-top-color: rgba(0, 0, 0, 0.87);\r\n        transform: translateX(-20%);\r\n    }\r\n    \r\n    .custom-infowinow {\r\n        color: black;\r\n        background-color: white;\r\n        position: absolute;\r\n        width: 250px;\r\n        padding: 0px;\r\n        font-weight: bold;\r\n        font-size: 12px;\r\n        border: none;\r\n        border-radius: 7px;\r\n        -webkit-border-radius: 7px;\r\n        -moz-border-radius: 7px;\r\n        box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.2);\r\n        background: #fff;\r\n        cursor: default;\r\n        color: rgba(255, 255, 255, 0.9);\r\n        text-align: left;\r\n        z-index: 1;\r\n    }\r\n    \r\n    .custom-infowinow h3 {\r\n        background: #000;\r\n        color: #fff;\r\n        padding: 5px;\r\n        border-bottom: 1px solid #ccc;\r\n        border-top-left-radius: 7px;\r\n        border-top-right-radius: 7px;\r\n        padding-left: 12px;\r\n        font-size: 1.2em;\r\n        margin-bottom: 0;\r\n        margin-top: 0;\r\n    }\r\n    \r\n    .custom-infowinow .content {\r\n        padding: 10px;\r\n        display: block;\r\n        color: #000;\r\n    }\r\n    \r\n    .custom-infowinow i {\r\n        color: rgba(255, 255, 255, 0.8) !important;\r\n    }\r\n    \r\n    .custom-infowinow .leftside {\r\n        position: absolute;\r\n        overflow: hidden;\r\n        left: 50%;\r\n        transform: translateX(-100%);\r\n        -webkit-transform: translateX(-100%);\r\n        bottom: -30px;\r\n        width: 16px;\r\n        height: 30px;\r\n    }\r\n    \r\n    .custom-infowinow .leftside span {\r\n        position: absolute;\r\n        left: 6px;\r\n        background-color: #fff;\r\n        transform: skewX(22.6deg);\r\n        -webkit-transform: skewX(22.6deg);\r\n        transform-origin: 0px 0px 0px;\r\n        -webkit-transform-origin: 0px 0px 0px;\r\n        height: 24px;\r\n        width: 10px;\r\n        box-shadow: rgba(0, 0, 0, 0.6) 0px 1px 6px;\r\n    }\r\n    \r\n    .custom-infowinow .rightside {\r\n        position: absolute;\r\n        overflow: hidden;\r\n        left: 50%;\r\n        transform: translateX(0%);\r\n        -webkit-transform: translateX(0%);\r\n        bottom: -30px;\r\n        width: 16px;\r\n        height: 30px;\r\n    }\r\n    \r\n    .custom-infowinow .rightside span {\r\n        position: absolute;\r\n        right: 6px;\r\n        background-color: #fff;\r\n        transform: skewX(-22.6deg);\r\n        -webkit-transform: skewX(-22.6deg);\r\n        transform-origin: 10px 0px 0px;\r\n        -webkit-transform-origin: 10px 0px 0px;\r\n        height: 24px;\r\n        width: 10px;\r\n        box-shadow: rgba(0, 0, 0, 0.6) 0px 1px 6px;\r\n    }\r\n    \r\n    .closeBtn {\r\n        background: url(\'assets/images/closeMapLabel.png\') no-repeat center center;\r\n        width: 13px;\r\n        height: 13px;\r\n        position: absolute;\r\n        top: 8px;\r\n        right: 8px;\r\n        cursor: pointer;\r\n    }\r\n    \r\n    @-webkit-keyframes pulseNew {\r\n        0% {\r\n            -webkit-box-shadow: 0 0 0 0 rgba(41, 144, 241, 0.4);\r\n        }\r\n        70% {\r\n            -webkit-box-shadow: 0 0 0 10px rgba(41, 144, 241, 0);\r\n        }\r\n        100% {\r\n            -webkit-box-shadow: 0 0 0 0 rgba(41, 144, 241, 0);\r\n        }\r\n    }\r\n    \r\n    @keyframes pulseNew {\r\n        0% {\r\n            -moz-box-shadow: 0 0 0 0 rgba(41, 144, 241, 0.4);\r\n            box-shadow: 0 0 0 0 rgba(41, 144, 241, 0.4);\r\n        }\r\n        70% {\r\n            -moz-box-shadow: 0 0 0 10px rgba(41, 144, 241, 0);\r\n            box-shadow: 0 0 0 10px rgba(41, 144, 241, 0);\r\n        }\r\n        100% {\r\n            -moz-box-shadow: 0 0 0 0 rgba(41, 144, 241, 0);\r\n            box-shadow: 0 0 0 0 rgba(41, 144, 241, 0);\r\n        }\r\n    }\n</style>");
$templateCache.put("app/main/DefaultChargesSetting/DefaultChargesSetting.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon><span translate=\"Default Charges Setting\">Default Charges Setting</span></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" \nflex-gt-sm=\"33\" layout=\"row\" layout-align=\"end center\"><div><md-button class=\"md-icon-button md-raised md-hue-2\" \nng-click=\"ResetEdit()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">\nAdd Training</md-tooltip></md-button></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border cell-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"all\"><div \nclass=\"table-header\" style=\"width: 4%\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Minimum Charge</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Defualt Miles</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Per Mile Charge</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Miles limit</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Above Limit Per Mile Charge</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Defualt ETA</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Per ETA Charge</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Above Limit Per ETA Charge</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Defualt Prescription</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Per Prescription Charge</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Defualt Patient</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Per Patient Charge</span></div>\n</th><th class=\"all\" data-orderable=\"false\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"item in lst_charges_setting | orderBy: \'name\'\"><td \nstyle=\"width: 4%; text-align: center\">{{$index+1}}</td><td>{{item.type}}</td><td>{{item.mini_charges}}</td><td>\n{{item.defualt_miles}}</td><td>{{item.per_miles_charge}}</td><td>{{item.miles_limit}}</td><td>\n{{item.above_limit_per_miles_charge}}</td><td>{{item.defualt_ETA}}</td><td>{{item.per_ETA_charge}}</td><td>\n{{item.above_limit_per_ETA_charge}}</td><td>{{item.defualt_prescription}}</td><td>{{item.per_prescription_charge}}</td>\n<td>{{item.defualt_patient}}</td><td>{{item.per_patient_charge}}</td><td style=\"width: 12%; text-align: center\">\n<md-button class=\"edit-button md-icon-button\" ng-click=\"FetchData(item)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s18 green-500-fg\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Edit</md-tooltip></md-button></td></tr>\n</tbody></table></div></div></div></div><div class=\"page-layout simple tabbed\" layout=\"column\" ng-show=\"flag\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" \nng-click=\"gotoOrderList()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"subtitle secondary-text\"><span \ntranslate=\"Default Charges Setting\">Default Charges Setting</span></div></div></div></div><div></div></div><div \nclass=\"content\" layout-margin><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form \nname=\"chargesSettingFrom\" novalidate class=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><div layout=\"row\" \nlayout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"25\"><label>Type</label><md-select \ndisabled=\"disabled\" name=\"type\" ng-model=\"model.type\" required><md-option value=\"Pharmacy\">Pharmacy</md-option>\n<md-option value=\"Hospital\">Hospital</md-option><md-option value=\"Patient\">Patient</md-option><md-option \nvalue=\"Driver\">Driver</md-option><md-option value=\"demand_pharmacy\">demand_pharmacy</md-option><md-option \nvalue=\"demand_driver\">demand_driver</md-option><md-option value=\"one_price_charges\">one_price_charges</md-option>\n<md-option value=\"one_price_driver\">one_price_driver</md-option><div ng-messages=\"chargesSettingFrom.type.$error\" \nng-if=\"chargesSettingFrom.type.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Type field is required</span>\n</div></div></md-select></md-input-container><md-input-container flex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"25\"><label>\nMinimum Charges</label><input type=\"number\" name=\"mini_charges\" ng-model=\"model.mini_charges\" required><div \nng-messages=\"chargesSettingFrom.mini_charges.$error\" ng-if=\"chargesSettingFrom.mini_charges.$touched\" role=\"alert\"><div\n ng-message=\"required\"><span>Minimum charges field is required</span></div></div></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"25\"><label>Defualt Miles</label>\n<input type=\"number\" name=\"defualt_miles\" ng-model=\"model.defualt_miles\" required><div \nng-messages=\"chargesSettingFrom.defualt_miles.$error\" ng-if=\"chargesSettingFrom.defualt_miles.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span>Defualt Miles field is required</span></div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"25\"><label>Per Mile Charge</label><input type=\"number\" \nname=\"per_miles_charge\" ng-model=\"model.per_miles_charge\" required><div \nng-messages=\"chargesSettingFrom.per_miles_charge.$error\" ng-if=\"chargesSettingFrom.per_miles_charge.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Per Mile Charge field is required</span></div></div></md-input-container>\n</div><div layout=\"row\" layout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"25\"><label>Miles Limit\n</label><input type=\"number\" name=\"miles_limit\" ng-model=\"model.miles_limit\" required><div \nng-messages=\"chargesSettingFrom.miles_limit.$error\" ng-if=\"chargesSettingFrom.miles_limit.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Miles Limit field is required</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"25\"><label>Above Limit Per Mile Charge</label><input type=\"number\" \nname=\"above_limit_per_miles_charge\" ng-model=\"model.above_limit_per_miles_charge\" required><div \nng-messages=\"chargesSettingFrom.above_limit_per_miles_charge.$error\" \nng-if=\"chargesSettingFrom.above_limit_per_miles_charge.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nAbove Limit Per Mile Charge field is required</span></div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-sm=\"25\" flex-gt-md=\"25\"><label>Above Limit Per ETA Charge</label><input type=\"number\" \nname=\"above_limit_per_ETA_charge\" ng-model=\"model.above_limit_per_ETA_charge\" required><div \nng-messages=\"chargesSettingFrom.above_limit_per_ETA_charge.$error\" \nng-if=\"chargesSettingFrom.above_limit_per_ETA_charge.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nAbove Limit Per ETA Charge field is required</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"25\"><label>Defualt ETA</label><input \ntype=\"number\" name=\"defualt_ETA\" ng-model=\"model.defualt_ETA\" required><div \nng-messages=\"chargesSettingFrom.defualt_ETA.$error\" ng-if=\"chargesSettingFrom.defualt_ETA.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Defualt ETA field is required</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"25\"><label>Per ETA Charge</label><input type=\"number\" name=\"per_ETA_charge\" \nng-model=\"model.per_ETA_charge\" required><div ng-messages=\"chargesSettingFrom.per_ETA_charge.$error\" \nng-if=\"chargesSettingFrom.per_ETA_charge.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nPer ETA Charge field is required</span></div></div></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container flex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"25\"><label>Defualt Prescription</label><input type=\"number\" \nname=\"defualt_prescription\" ng-model=\"model.defualt_prescription\" required><div \nng-messages=\"chargesSettingFrom.defualt_prescription.$error\" ng-if=\"chargesSettingFrom.defualt_prescription.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Defualt Prescription field is required</span></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"25\"><label>Per Prescription Charge\n</label><input type=\"number\" name=\"per_prescription_charge\" ng-model=\"model.per_prescription_charge\" required><div \nng-messages=\"chargesSettingFrom.per_prescription_charge.$error\" \nng-if=\"chargesSettingFrom.per_prescription_charge.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nPer Prescription Charge field is required</span></div></div></md-input-container></div><div layout=\"row\" layout-wrap>\n<md-input-container flex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"25\"><label>Defualt Patient</label><input type=\"number\" \nname=\"defualt_patient\" ng-model=\"model.defualt_patient\" required><div \nng-messages=\"chargesSettingFrom.defualt_patient.$error\" ng-if=\"chargesSettingFrom.defualt_patient.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Defualt Patient field is required</span></div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"25\"><label>Per Patient Charge</label><input type=\"number\" \nname=\"per_patient_charge\" ng-model=\"model.per_patient_charge\" required><div \nng-messages=\"chargesSettingFrom.per_patient_charge.$error\" ng-if=\"chargesSettingFrom.per_patient_charge.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Per Patient Charge field is required</span></div></div>\n</md-input-container></div><div layout=\"row\" layout-wrap><md-input-container ng-if=\"model.type==\'demand_pharmacy\'\" \nflex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"25\"><label>Default Prescription Night</label><input type=\"number\" \nname=\"defualt_prescription_night\" ng-model=\"model.defualt_prescription_night\" required><div \nng-messages=\"chargesSettingFrom.defualt_prescription_night.$error\" \nng-if=\"chargesSettingFrom.defualt_prescription_night.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nDefault Prescription Night field is required</span></div></div></md-input-container><md-input-container \nng-if=\"model.type==\'demand_pharmacy\'\" flex=\"100\" flex-gt-sm=\"25\" flex-gt-md=\"25\"><label>Mini Charges Night</label>\n<input type=\"number\" name=\"mini_charges_night\" ng-model=\"model.mini_charges_night\" required><div \nng-messages=\"chargesSettingFrom.mini_charges_night.$error\" ng-if=\"chargesSettingFrom.mini_charges_night.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Mini Charges Night field is required</span></div></div>\n</md-input-container></div><div align=\"center\"><md-button class=\"md-raised md-primary\" \nng-disabled=\"!chargesSettingFrom.$valid\" ng-click=\"SaveData(form,model)\">{{btn}}</md-button><md-button \nclass=\"md-accent md-raised\" ng-click=\"ResetData()\">Reset</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"Cancel()\">Cancel</md-button></div></form></div></div></div>");
$templateCache.put("app/main/DemandOrder/DemandOrder.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-bank\"></md-icon><span translate=\"Order\">\nDemand Order</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"Search\" ng-model=\"model.Search\" \nng-change=\"GetSerch(model.Search)\" class=\"search-input\" ng-model-options=\"{ debounce: debounceTime }\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" \nflex-gt-sm=\"33\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button md-raised md-hue-2\" \nng-click=\"toggle()\" aria-label=\"Search\"><md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip \nmd-visible=\"\" md-direction=\"\">Advance Search</md-tooltip></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"ShowContentBox\"><i ng-show=\"flgforIcon\" ng-click=\"toggle()\" \nclass=\"icon-close-circle-outline right closeIcon\"></i><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\"><label>Pharmacy</label><md-select \nname=\"pharmacy_name\" ng-model=\"modelSearch.pharmacy_name\" md-on-close=\"clearSearchTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\" ng-change=\"GetAllDynamicHospital()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.search\" type=\"search\" placeholder=\"Search for a Pharmacy..\" \nclass=\"demo-header-searchbox md-text\" ng-keydown=\"onSearchChange($event)\"></md-select-header><md-option \nng-value=\"o.pharmacy_name\" ng-repeat=\"o in lstPharmacy | filter:vm.search \"><span>{{o.pharmacy_name}}</span>\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-sm=\"50\" flex-gt-md=\"15\" ng-if=\"searchtype!=\'patient\'\"><label>Hospital</label><md-select name=\"hospital_name\" \nng-model=\"modelSearch.hospital_name\" md-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\" \nng-change=\"GetAllDynamicHospital()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.search\" \ntype=\"search\" placeholder=\"Search for a Hospital..\" class=\"demo-header-searchbox md-text\" \nng-keydown=\"onSearchChange($event)\"></md-select-header><md-option ng-value=\"item.hospitalName\" \nng-repeat=\"item in lstHospitalname | filter:vm.search \"><span>{{item.hospitalName}}</span></md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\">\n<label>Patient</label><md-select name=\"patient_firstname\" ng-model=\"modelSearch.patient_firstname\" \nmd-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\" ng-change=\"GetAllDynamicHospital()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.search\" type=\"search\" \nplaceholder=\"Search for a Patient..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"onSearchChange($event)\">\n</md-select-header><md-option ng-value=\"item.first_name\" \nng-repeat=\"item in lstPatient | filter:vm.search || orderBy:\'first_name\'\"><span>\n{{item.first_name}} {{item.middle_name}} {{item.last_name}}</span></md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\"><label>Order Status\n</label><md-select name=\"AppName\" ng-model=\"modelSearch.order_status\" md-on-close=\"clearSearchTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\" ng-change=\"GetAllDynamicHospital()\"><md-option value=\"-2\">\nCo-pay Verification</md-option><md-option value=\"-1\">Co-pay Approval</md-option><md-option value=\"7\">\nCo-pay Direct to Pharmacy</md-option><md-option value=\"1\">New</md-option><md-option value=\"2\">OnHold</md-option>\n<md-option value=\"3\">Ready to Pick</md-option><md-option value=\"4\">Driver Picked Up</md-option><md-option value=\"5\">\nCompleted</md-option><md-option value=\"6\">Canceled</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"25\" flex-gt-md=\"20\"><label>From Date</label><input type=\"date\" \nid=\"time\" min-date=\"modelSearch.StartDate\" format=\"MM-DD-YYYY\" ng-model=\"modelSearch.StartDate\"></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"25\" flex-gt-md=\"20\"><label>To Date</label>\n<input type=\"date\" id=\"time1\" max-date=\"modelSearch.EndDate\" format=\"MM-DD-YYYY\" ng-model=\"modelSearch.EndDate\">\n</md-input-container><div align=\"left\"><md-button class=\"md-icon-button md-accent md-raised md-hue-2\" \nng-click=\"GetAllDynamicHospital(true)\" aria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip \nmd-visible=\"\" md-direction=\"\">Search</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-warn md-raised md-hue-2\" ng-click=\"init();GetAllDynamicHospital(true);\" \naria-label=\"Reset Search\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">\nReset Search</md-tooltip></md-button></div></div></div><ul class=\"tabsList\"><li ng-click=\"ResetModel3(\'demand\')\" \nng-if=\"flaglink == 3 && demandView\"><a href=\"\" class=\"active\">ON DEMAND</a></li><li ng-click=\"ResetModel3(\'demand\')\" \nng-if=\"flaglink != 3 && demandView\"><a href=\"\">ON DEMAND</a></li></ul><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><table id=\"Hospital\" class=\"dataTable row-border cell-border hover\" datatable=\"\" \ndt-instance=\"vm.dtInstanceHospital\" dt-columns=\"dtColumnsHospital\" dt-options=\"dtOptions\"><thead><tr><th class=\"all\">\n<div class=\"table-header\"><span class=\"column-title\">id</span></div></th><th class=\"all\"><div class=\"table-header\">\n<span class=\"column-title\">Pharmacy Details</span></div></th><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">Hospital Details</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Patient Information</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Order Information</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Deliverd At</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Created On</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Charge($)</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">\nStatus</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th>\n<th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Doordash Order</span></div></th></tr></thead>\n</table></div></div></div></div><style type=\"text/css\" media=\"screen\">\n#processing1 {\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        z-index: 1;\r\n        background-color: rgba(203, 203, 203, 0.6);\r\n    }\r\n\r\n    #processing1 .page-loader {\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 50%;\r\n        margin-left: -100px;\r\n        margin-top: -100px;\r\n        z-index: 2;\r\n    }\r\n\r\n    #PushContent .dataTables_wrapper .dataTables_scroll .dataTables_scrollHead {\r\n        min-height: 0px !important;\r\n    }\n</style>");
$templateCache.put("app/main/Driver/Driver.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account-network\"></md-icon><span translate=\"Driver\">Driver</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\" flex-gt-sm=\"33\" align=\"center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" \nng-model=\"modelSearch.search\" ng-change=\"reloadTableData(true)\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \ntranslate translate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button md-raised md-hue-2\" ng-click=\"toggle()\" aria-label=\"Search\">\n<md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Advance Search\n</md-tooltip></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"ShowContentBox\"><i \nng-show=\"flgforIcon\" ng-click=\"toggle()\" class=\"icon-close-circle-outline right closeIcon\"></i><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\"><label>\nOrder Status</label><md-select name=\"AppName\" ng-model=\"advanceSearch.status\" md-on-close=\"clearSearchTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\" ng-change=\"reloadTableData()\"><md-option value=\"0\">Pending</md-option>\n<md-option value=\"1\">Submitted</md-option><md-option value=\"2\">Approved</md-option></md-select></md-input-container>\n<div align=\"left\"><md-button class=\"md-icon-button md-accent md-raised md-hue-2\" ng-click=\"reloadTable(true)\" \naria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Search\n</md-tooltip></md-button><md-button class=\"md-icon-button md-warn md-raised md-hue-2\" \nng-click=\"init();reloadTableData(true);\" aria-label=\"Reset Search\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>\n<md-tooltip md-visible=\"\" md-direction=\"\">Reset Search</md-tooltip></md-button></div></div></div><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"Drivertable\" \nclass=\"dataTable cell-border row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-columns=\"dtColumns\" \ndt-options=\"dtOptions\" width=\"100%\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">No\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Gender</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">DOB</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Phone</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Address</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Vehicle License Plate</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Vehicle Make and Model</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Vehicle Year</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Vehicle Color</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Vehicle Own/Rent</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Licence Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Licence Expiry Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Payment mode</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Payment Registered Id</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Account Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Routing Number</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Is Verified</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Profile Status</span></div></th><th \nclass=\"all\"><div class=\"table-header\"><span class=\"column-title\">Driver Application Status</span></div></th><th \nclass=\"all\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead></table></div>\n</div></div></div>");
$templateCache.put("app/main/Forgotpassword/Forgotpassword.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\" \nstyle=\"height: 450px\"><div class=\"logo md-accent-bg\" \nstyle=\"width: 50%;\r\n            height: 20%;background-repeat: no-repeat;background-color: transparent\"></div><div \nclass=\"title\">Reset Your Password</div><form name=\"forgotPasswordForm\"><md-input-container class=\"md-block\"><input \ntype=\"email\" name=\"email\" ng-model=\"model.email\" placeholder=\"Email address\" required><div \nng-messages=\"forgotPasswordForm.email.$error\" ng-if=\"forgotPasswordForm.email.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Email field is required</span></div><div ng-message=\"email\"><span>\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" ng-click=\"ResetPassword()\" \nng-disabled=\"forgotPasswordForm.$invalid\">Reset Password</md-button></form><div class=\"login\" layout=\"row\" \nlayout-align=\"center center\"><a class=\"link\" ui-sref=\"app.login\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/DriverApplication/DriverApplication.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-open-in-app\"></md-icon><span translate=\"Driver Application\">Driver Application</span></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\" flex-gt-sm=\"33\" align=\"center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" \nng-model=\"modelSearch.search\" ng-change=\"reloadTableData(true)\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \ntranslate translate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button md-raised md-hue-2\" ng-click=\"toggle()\" aria-label=\"Search\">\n<md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Advance Search\n</md-tooltip></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"ShowContentBox\"><i \nng-show=\"flgforIcon\" ng-click=\"toggle()\" class=\"icon-close-circle-outline right closeIcon\"></i><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\"><label>\nOrder Status</label><md-select name=\"AppName\" ng-model=\"advanceSearch.status\" md-on-close=\"clearSearchTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\" ng-change=\"reloadTableData()\"><md-option value=\"0\">Pending</md-option>\n<md-option value=\"1\">Submitted</md-option><md-option value=\"2\">Approved</md-option></md-select></md-input-container>\n<div align=\"left\"><md-button class=\"md-icon-button md-accent md-raised md-hue-2\" ng-click=\"reloadTable(true)\" \naria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Search\n</md-tooltip></md-button><md-button class=\"md-icon-button md-warn md-raised md-hue-2\" \nng-click=\"init();reloadTableData(true);\" aria-label=\"Reset Search\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>\n<md-tooltip md-visible=\"\" md-direction=\"\">Reset Search</md-tooltip></md-button></div></div></div><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"driverApplicationTable\" \nclass=\"dataTable cell-border row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-columns=\"dtColumns\" \ndt-options=\"dtOptions\" width=\"100%\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">No\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Date of Birth</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Social Security Number</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Home Adddress</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Previous Addresses</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Education</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">License Image</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Applicant Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Applicant Email</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Applicant Signature</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Phone</span></div></th><th class=\"all\"><div\n class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th class=\"all\"><div class=\"table-header\">\n<span class=\"column-title\">Action</span></div></th></tr></thead></table></div></div></div></div>");
$templateCache.put("app/main/Hospice/Hospice.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-wrap \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" layout-gt-sm=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-pharmacy\"></md-icon><span translate=\"Hospice\">Hospice</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"modelsearch\" ng-model=\"modelSearch.search\" ng-change=\"reloadTableData(true)\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"SEARCH\" flex></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nid=\"pharmacyTable\" class=\"dataTable cell-border row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" \ndt-columns=\"dtColumns\" dt-options=\"dtOptions\" width=\"100%\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Hospice Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">User</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Email</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Phone</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Address</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Zip Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Invoice Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Billing Period Days</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Payment Period Days</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Email Verified</span></div></th><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">IsActive</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">\nAction</span></div></th></tr></thead></table></div></div></div></div>");
$templateCache.put("app/main/Hospital/Hospital.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-hospital\"></md-icon><span translate=\"Hospital\">Hospital</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"Search\" ng-model=\"model.Search\" ng-change=\"GetSearch(model.Search)\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" \nflex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button md-raised md-hue-2\" ng-click=\"toggle()\" aria-label=\"Search\"><md-icon \nmd-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Advance Search</md-tooltip>\n</md-button><md-button class=\"md-icon-button md-raised md-hue-2\" ng-click=\"ShowAnnouncementModel($event)\" \naria-label=\"Assign using Excel\"><md-icon md-font-icon=\"icon-import\"></md-icon><md-tooltip md-visible=\"\" \nmd-direction=\"\">Send Announcement</md-tooltip></md-button></div></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"ShowContentBox\"><i ng-show=\"flgforIcon\" ng-click=\"toggle()\" \nclass=\"icon-close-circle-outline right closeIcon\"></i><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\"><label>Zip Code</label><input \nng-model=\"modelSearch.zipcode\" type=\"number\" class=\"demo-header-searchbox md-text\" ng-keydown=\"onSearchChange($event)\">\n</md-input-container><div align=\"left\"><md-button class=\"md-icon-button md-accent md-raised md-hue-2\" \nng-click=\"reloadTableData(true)\" aria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip \nmd-visible=\"\" md-direction=\"\">Search</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-warn md-raised md-hue-2\" ng-click=\"init();reloadTableData(true);\" aria-label=\"Reset Search\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Reset Search</md-tooltip>\n</md-button></div></div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"pharmacyTable\" \nclass=\"dataTable cell-border row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-columns=\"dtColumns\" \ndt-options=\"dtOptions\" width=\"100%\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">No\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Hospital Name</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Phone</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">SPOC Email</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">SPOC Phone</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Address</span></div></th><th class=\"all\">\n<div class=\"table-header\"><span class=\"column-title\">Zip Code</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Invoice Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Billing Period Days</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Payment Period Days</span></div></th><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead></table></div></div></div></div>\n<div class=\"page-layout simple tabbed\" layout=\"column\" ng-show=\"flag\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"ResetModel()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"subtitle secondary-text\"><span translate=\"Hospital\">Hospital\n</span></div></div></div></div></div><div class=\"content layout-margin\"><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"AddStatusForm\" novalidate \nclass=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\"><label>Billing Days</label><input type=\"number\" \nname=\"billing_period_days\" ng-model=\"modelData.billing_period_days\" required><div \nng-messages=\"AddStatusForm.billing_period_days.$error\" ng-if=\"AddStatusForm.billing_period_days.$touched\"><div \nng-message=\"required\"><span>Billing Days is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\"><label>Payment Days</label><input type=\"number\" \nname=\"payment_period_days\" ng-model=\"modelData.payment_period_days\" required><div \nng-messages=\"AddStatusForm.payment_period_days.$error\" ng-if=\"AddStatusForm.payment_period_days.$touched\"><div \nng-message=\"required\"><span>Payment days is required</span></div></div></md-input-container></div><div align=\"center\">\n<md-button class=\"md-raised md-primary\" ng-disabled=\"!AddStatusForm.$valid\" \nng-click=\"AddDays(modelData,AddStatusForm)\">Save</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"ResetModel()\">Cancel</md-button></div></form></div></div></div>");
$templateCache.put("app/main/Invoice/Invoice.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-coin\"></md-icon><span translate=\"Invoice\">Invoice</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\" flex-gt-sm=\"33\" align=\"center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" \nng-model=\"modelSearch.search\" ng-change=\"reloadTable(true)\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \ntranslate translate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button md-raised md-hue-2\" ng-click=\"toggle()\" aria-label=\"Search\">\n<md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Advance Search\n</md-tooltip></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"ShowContentBox\"><i \nng-show=\"flgforIcon\" ng-click=\"toggle()\" class=\"icon-close-circle-outline right closeIcon\"></i><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\"><label>\nClient Type</label><md-select name=\"type\" ng-model=\"modelSearch.client_type\" ng-change=\"getAllClient()\"><md-option \nvalue=\"Hospital\">Hospital</md-option><md-option value=\"Pharmacy\">Pharmacy</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\"><label>Client</label>\n<md-select name=\"AppName\" ng-model=\"modelSearch.client_id\" md-on-close=\"clearSearchTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\" ng-disabled=\"modelSearch.client_type==\'\'\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.search\" type=\"search\" placeholder=\"Search for a client..\" \nclass=\"demo-header-searchbox md-text\" ng-keydown=\"onSearchChange($event)\"></md-select-header><md-option \nng-value=\"o._id\" ng-repeat=\"o in lstclient | filter:vm.search \"><span ng-if=\"modelSearch.client_type==\'Hospital\'\">\n{{o.hospitalName}}</span> <span ng-if=\"modelSearch.client_type==\'Pharmacy\'\">{{o.pharmacy_name}}</span></md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" \nflex-gt-md=\"15\"><label>Order Status</label><md-select name=\"AppName\" ng-model=\"modelSearch.status\" \nmd-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\" ng-change=\"reloadTable()\"><md-option \nvalue=\"Pending\">Pending</md-option><md-option value=\"Verification\">Verification</md-option><md-option \nvalue=\"Completed\">Completed</md-option></md-select></md-input-container><div align=\"left\"><md-button \nclass=\"md-icon-button md-accent md-raised md-hue-2\" ng-click=\"reloadTable(true)\" aria-label=\"Search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Search</md-tooltip></md-button>\n<md-button class=\"md-icon-button md-warn md-raised md-hue-2\" ng-click=\"init();reloadTable(true);\" \naria-label=\"Reset Search\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">\nReset Search</md-tooltip></md-button></div></div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table id=\"issueReportTable\" class=\"dataTable cell-border row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" \ndt-columns=\"dtColumns\" dt-options=\"dtOptions\" width=\"100%\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Client Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Client Type</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Invoice No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Invoice Url</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Amount</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Invoice Period</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Created Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Payment Method</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Payment ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">\nAction</span></div></th></tr></thead></table></div></div></div></div>");
$templateCache.put("app/main/IssueReport/IssueReport.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-alert-box\"></md-icon><span translate=\"Issue Report\">Issue Report</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\" flex-gt-sm=\"33\" align=\"center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" \nng-model=\"modelSearch.search\" ng-change=\"reloadTable(true)\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \ntranslate translate-attr-placeholder=\"SEARCH\" flex></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"issueReportTable\" \nclass=\"dataTable cell-border row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-columns=\"dtColumns\" \ndt-options=\"dtOptions\" width=\"100%\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">No\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Pharmacy Name</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Probleam Desription</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">File</span></div></th></tr></thead></table>\n</div></div></div></div>");
$templateCache.put("app/main/Module/Module.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account-network\"></md-icon><span translate=\"Module Management\">Module Management</span></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\" flex-gt-sm=\"33\" align=\"center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" \nng-model=\"Search\" ng-change=\"GetSerch(Search)\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" \nlayout-align=\"end center\"><div ng-if=\"FlgAddedEditlocal\"><md-button class=\"md-icon-button md-raised md-hue-2\" \nng-click=\"Reset()\" aria-label=\"Search \"><md-icon md-font-icon=\"icon-plus \"></md-icon><md-tooltip md-visible=\" \" \nmd-direction=\" \">Add New Module</md-tooltip></md-button></div></div></div><div class=\"content-card md-padding\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable cell-border row-border hover\" datatable=\"ng\" dt-options=\"dtCustomOptions\" dt-instance=\"dtInstance\" \ndt-column-defs=\"vm.dtColumnDefs\" width=\"100%\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Module\n</span></div></th><th class=\"all dt-center\"><div class=\"table-header\"><span class=\"column-title\">Is Active</span></div>\n</th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody>\n<tr ng-repeat=\"o in lstModules | filter: Search\"><td style=\"text-align: center\">{{ $index+1 }}</td><td>\n{{ o.module_name }}</td><td class=\"dt-center\"><span style=\"font-size: 20px;color: green\" ng-if=\"o.status==1\">&#x2714;\n</span> <span style=\"font-size: 20px;color: red\" ng-if=\"o.status==0\">&#x2716;</span></td><td class=\"dt-center\">\n<md-button class=\"edit-button md-icon-button\" ng-click=\"editModuleById(o) \"><md-icon md-font-icon=\"icon-pencil \" \nclass=\"s18 green-500-fg\"></md-icon><md-tooltip md-visible=\" \" md-direction=\" \">Edit</md-tooltip></md-button><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"DeleteModule(o._id) \"><md-icon md-font-icon=\"icon-trash \" \nclass=\"s18 red-500-fg\"></md-icon><md-tooltip md-visible=\" \" md-direction=\" \">Delete</md-tooltip></md-button></td></tr>\n</tbody></table></div></div></div></div><div class=\"page-layout simple tabbed\" layout=\"column \" ng-show=\"flag \"><div \nclass=\"header md-accent-bg\" layout=\"row \" layout-align=\"start center \"><div class=\"white-fg\" layout=\"row \" \nlayout-align=\"start center \" flex><md-button class=\"goto-products-button md-icon-button\" aria-label=\"Go to Vehicle \" \nng-click=\"ResetModel() \"><md-icon md-font-icon=\"icon-arrow-left \"></md-icon></md-button><div layout=\"row \" \nlayout-align=\"start center \"><div layout=\"column \" layout-align=\"start start \"><div class=\"subtitle secondary-text\">\n<span translate=\"Module Management\">Module Management</span></div></div></div></div><div></div></div><div \nclass=\"content\" layout-margin><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><md-content\n class=\"md-padding\"><form name=\"formModule \" novalidate class=\"md-inline-form\" aria-invalid=\"false \"><div \nclass=\"content\"><div layout=\"row \" layout-wrap><md-input-container class=\"md-block\" flex=\"100 \" flex-gt-sm=\"25 \">\n<label>Module Name</label><input type=\"text\" name=\"module\" ng-model=\"model.module_name\" required><div \nng-messages=\"formModule.module_name.$error \" ng-if=\"formModule.module_name.$touched \" role=\"alert \"><div \nng-message=\"required \"><span>Module Name field is required</span></div></div></md-input-container></div><div \nlayout=\"row \" layout-wrap><md-checkbox class=\"md-primary\" ng-model=\"model.status\" aria-label=\"Checkbox 1\"><span>Status\n</span></md-checkbox></div><div align=\"left \"><md-button class=\"md-raised md-primary\" \nng-disabled=\"!formModule.$valid \" ng-click=\"CreateModule(model) \">Save</md-button><md-button \nclass=\"md-accent md-raised\" ng-click=\"Reset() \">Reset</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"ResetModel() \">Cancel</md-button></div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/ModuleMgmt/ModuleMgmt.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-cube-outline\"></md-icon><span translate=\"Module Management\">Module Management</span></div></div><div\n class=\"search\" layout=\"row\" layout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\" flex-gt-sm=\"33\" align=\"center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" \nng-model=\"Search\" ng-change=\"GetSerch(Search)\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" \nlayout-align=\"end center\"><div ng-if=\"FlgAddedEditlocal\"><md-button class=\"md-icon-button md-raised md-hue-2\" \nng-click=\"Reset()\" aria-label=\"Search \"><md-icon md-font-icon=\"icon-plus \"></md-icon><md-tooltip md-visible=\" \" \nmd-direction=\" \">Add New Module</md-tooltip></md-button></div></div></div><div class=\"content-card\" layout=\"column \" \nflex><div class=\"content fullpage-datatable\" layout=\"column \" flex><table class=\"dataTable row-border hover\" \ndatatable=\"ng \" dt-instance=\"dtInstance \" dt-options=\"dtOptions \" dt-column-defs=\"dtColumnDefs \"><thead><tr><th \nclass=\"all\"><div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Module Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Is Active</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Display Order</span></div></th><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"o in lstModule \"><td>{{ $index+1 }}</td><td>{{o.Module}}</td><td class=\"dt-center\"><span \nstyle=\"font-size: 20px;color: green\" ng-if=\"o.IsActive==1\">&#x2714;</span> <span style=\"font-size: 20px;color: red\" \nng-if=\"o.IsActive==0\">&#x2716;</span></td><td>{{o.DisplayOrder}}</td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"editModuleById(o) \"><md-icon md-font-icon=\"icon-pencil \" class=\"s18 green-500-fg\"></md-icon><md-tooltip \nmd-visible=\" \" md-direction=\" \">Edit</md-tooltip></md-button><md-button class=\"edit-button md-icon-button\" \nng-click=\"DeleteModule(o.id) \"><md-icon md-font-icon=\"icon-trash \" class=\"s18 red-500-fg\"></md-icon><md-tooltip \nmd-visible=\" \" md-direction=\" \">Delete</md-tooltip></md-button></td></tr></tbody></table></div></div></div></div><div \nclass=\"page-layout simple tabbed\" layout=\"column \" ng-show=\"flag \"><div class=\"header md-accent-bg\" layout=\"row \" \nlayout-align=\"start center \"><div class=\"white-fg\" layout=\"row \" layout-align=\"start center \" flex><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"Go to Vehicle \" ng-click=\"ResetModel() \"><md-icon \nmd-font-icon=\"icon-arrow-left \"></md-icon></md-button><div layout=\"row \" layout-align=\"start center \"><div \nlayout=\"column \" layout-align=\"start start \"><div class=\"subtitle secondary-text\"><span translate=\"Module Management\">\nModule Management</span></div></div></div></div><div></div></div><div class=\"content\" layout-margin><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><md-content class=\"md-padding\"><form \nname=\"formModule \" novalidate class=\"md-inline-form\" aria-invalid=\"false \"><div class=\"content\"><div layout=\"row \" \nlayout-wrap><md-input-container class=\"md-block\" flex=\"100 \" flex-gt-sm=\"25 \"><label>Module Name</label><input \ntype=\"text \" name=\"module\" ng-model=\"model.Module\" required><div ng-messages=\"formModule.module.$error \" \nng-if=\"formModule.module.$touched \" role=\"alert \"><div ng-message=\"required \"><span>Module Name field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"100 \" flex-gt-sm=\"25 \"><label>\nDisplay Order</label><input type=\"number \" name=\"DisplayOrder \" ng-model=\"model.DisplayOrder \"><div \nng-messages=\"formModule.DisplayOrder.$error \" ng-if=\"formModule.DisplayOrder.$touched \" role=\"alert \"><div \nng-message=\"required \"><span>Display Order field is required</span></div></div></md-input-container></div><div \nlayout=\"row \" layout-wrap><md-checkbox class=\"md-primary\" ng-model=\"model.IsActive\" aria-label=\"Checkbox 1\"><span>\nIsActive</span></md-checkbox></div><div align=\"left \"><md-button class=\"md-raised md-primary\" \nng-disabled=\"!formModule.$valid \" ng-click=\"SaveModule(model) \">Save</md-button><md-button class=\"md-accent md-raised\" \nng-click=\"Reset() \">Reset</md-button><md-button class=\"md-raised md-warn\" ng-click=\"ResetModel() \">Cancel</md-button>\n</div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/OnePrice/OnePrice.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-bank\"></md-icon><span translate=\"One Price order\">\nOne Price Order</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"Search\" ng-model=\"model.Search\" \nng-change=\"GetSerch(model.Search)\" class=\"search-input\" ng-model-options=\"{ debounce: debounceTime }\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" \nflex-gt-sm=\"33\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button md-raised md-hue-2\" \nng-click=\"toggle()\" aria-label=\"Search\"><md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip \nmd-visible=\"\" md-direction=\"\">Advance Search</md-tooltip></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"ShowContentBox\"><i ng-show=\"flgforIcon\" ng-click=\"toggle()\" \nclass=\"icon-close-circle-outline right closeIcon\"></i><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\"><label>Pharmacy</label><md-select \nname=\"pharmacy_name\" ng-model=\"modelSearch.pharmacy_name\" md-on-close=\"clearSearchTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\" ng-change=\"GetAllDynamicHospital()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.search\" type=\"search\" placeholder=\"Search for a Pharmacy..\" \nclass=\"demo-header-searchbox md-text\" ng-keydown=\"onSearchChange($event)\"></md-select-header><md-option \nng-value=\"o.pharmacy_name\" ng-repeat=\"o in lstPharmacy | filter:vm.search \"><span>{{o.pharmacy_name}}</span>\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-sm=\"50\" flex-gt-md=\"15\" ng-if=\"searchtype!=\'patient\'\"><label>Hospital</label><md-select name=\"hospital_name\" \nng-model=\"modelSearch.hospital_name\" md-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\" \nng-change=\"GetAllDynamicHospital()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.search\" \ntype=\"search\" placeholder=\"Search for a Hospital..\" class=\"demo-header-searchbox md-text\" \nng-keydown=\"onSearchChange($event)\"></md-select-header><md-option ng-value=\"item.hospitalName\" \nng-repeat=\"item in lstHospitalname | filter:vm.search \"><span>{{item.hospitalName}}</span></md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\">\n<label>Patient</label><md-select name=\"patient_firstname\" ng-model=\"modelSearch.patient_firstname\" \nmd-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\" ng-change=\"GetAllDynamicHospital()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.search\" type=\"search\" \nplaceholder=\"Search for a Patient..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"onSearchChange($event)\">\n</md-select-header><md-option ng-value=\"item.first_name\" \nng-repeat=\"item in lstPatient | filter:vm.search || orderBy:\'first_name\'\"><span>\n{{item.first_name}} {{item.middle_name}} {{item.last_name}}</span></md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\"><label>Order Status\n</label><md-select name=\"AppName\" ng-model=\"modelSearch.order_status\" md-on-close=\"clearSearchTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\" ng-change=\"GetAllDynamicHospital()\"><md-option value=\"-2\">\nCo-pay Verification</md-option><md-option value=\"-1\">Co-pay Approval</md-option><md-option value=\"7\">\nCo-pay Direct to Pharmacy</md-option><md-option value=\"1\">New</md-option><md-option value=\"2\">OnHold</md-option>\n<md-option value=\"3\">Ready to Pick</md-option><md-option value=\"4\">Driver Picked Up</md-option><md-option value=\"5\">\nCompleted</md-option><md-option value=\"6\">Canceled</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"25\" flex-gt-md=\"20\"><label>From Date</label><input type=\"date\" \nid=\"time\" min-date=\"modelSearch.StartDate\" format=\"MM-DD-YYYY\" ng-model=\"modelSearch.StartDate\"></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"25\" flex-gt-md=\"20\"><label>To Date</label>\n<input type=\"date\" id=\"time1\" max-date=\"modelSearch.EndDate\" format=\"MM-DD-YYYY\" ng-model=\"modelSearch.EndDate\">\n</md-input-container><div align=\"left\"><md-button class=\"md-icon-button md-accent md-raised md-hue-2\" \nng-click=\"GetAllDynamicHospital(true)\" aria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip \nmd-visible=\"\" md-direction=\"\">Search</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-warn md-raised md-hue-2\" ng-click=\"init();GetAllDynamicHospital(true);\" \naria-label=\"Reset Search\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">\nReset Search</md-tooltip></md-button></div></div></div><ul class=\"tabsList\"><li \nng-click=\"ResetModel3(\'one_price_charges\')\" ng-if=\"flaglink == 3 && demandView\"><a href=\"\" class=\"active\">ONE PRICE</a>\n</li><li ng-click=\"ResetModel3(\'one_price_charges\')\" ng-if=\"flaglink != 3 && demandView\"><a href=\"\">ONE PRICE</a></li>\n</ul><div class=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"Hospital\" \nclass=\"dataTable row-border cell-border hover\" datatable=\"\" dt-instance=\"vm.dtInstanceHospital\" \ndt-columns=\"dtColumnsHospital\" dt-options=\"dtOptions\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">id</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">\nPharmacy Details</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Hospital Details\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Patient Information\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Order Information\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Deliverd At</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Created On</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Charge($)</span></div></th><th \nclass=\"all\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\">Action</span></div></th><th class=\"all\"><div class=\"table-header\"><span\n class=\"column-title\">Doordash Order</span></div></th></tr></thead></table></div></div></div></div><style \ntype=\"text/css\" media=\"screen\">\n#processing1 {\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        z-index: 1;\r\n        background-color: rgba(203, 203, 203, 0.6);\r\n    }\r\n\r\n    #processing1 .page-loader {\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 50%;\r\n        margin-left: -100px;\r\n        margin-top: -100px;\r\n        z-index: 2;\r\n    }\r\n\r\n    #PushContent .dataTables_wrapper .dataTables_scroll .dataTables_scrollHead {\r\n        min-height: 0px !important;\r\n    }\n</style>");
$templateCache.put("app/main/Order/Order.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-bank\"></md-icon><span translate=\"Order\">Order\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"Search\" ng-model=\"model.Search\" \nng-change=\"GetSerch(model.Search)\" class=\"search-input\" ng-model-options=\"{ debounce: debounceTime }\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" \nflex-gt-sm=\"33\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button md-raised md-hue-2\" \nng-click=\"toggle()\" aria-label=\"Search\"><md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip \nmd-visible=\"\" md-direction=\"\">Advance Search</md-tooltip></md-button></div></div><div id=\"loaderDiv\"><div \nclass=\"loading-spiner\"><img src=\"../../../assets/images/loader.gif\" \nstyle=\"margin-left: 35rem;height: 150px;\r\n                width: 150px\"></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"ShowContentBox\"><i ng-show=\"flgforIcon\" ng-click=\"toggle()\" \nclass=\"icon-close-circle-outline right closeIcon\"></i><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\"><label>Pharmacy</label><md-select \nname=\"pharmacy_name\" ng-model=\"modelSearch.pharmacy_name\" md-on-close=\"clearSearchTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\" ng-change=\"GetAllDynamicHospital()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.search\" type=\"search\" placeholder=\"Search for a Pharmacy..\" \nclass=\"demo-header-searchbox md-text\" ng-keydown=\"onSearchChange($event)\"></md-select-header><md-option \nng-value=\"o.pharmacy_name\" ng-repeat=\"o in lstPharmacy | filter:vm.search \"><span>{{o.pharmacy_name}}</span>\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-sm=\"50\" flex-gt-md=\"15\" ng-if=\"searchtype!=\'patient\'\"><label>Hospital</label><md-select name=\"hospital_name\" \nng-model=\"modelSearch.hospital_name\" md-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\" \nng-change=\"GetAllDynamicHospital()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.search\" \ntype=\"search\" placeholder=\"Search for a Hospital..\" class=\"demo-header-searchbox md-text\" \nng-keydown=\"onSearchChange($event)\"></md-select-header><md-option ng-value=\"item.hospitalName\" \nng-repeat=\"item in lstHospitalname | filter:vm.search \"><span>{{item.hospitalName}}</span></md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\">\n<label>Patient</label><md-select name=\"patient_firstname\" ng-model=\"modelSearch.patient_firstname\" \nmd-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\" ng-change=\"GetAllDynamicHospital()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.search\" type=\"search\" \nplaceholder=\"Search for a Patient..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"onSearchChange($event)\">\n</md-select-header><md-option ng-value=\"item.first_name\" \nng-repeat=\"item in lstPatient | filter:vm.search || orderBy:\'first_name\'\"><span>\n{{item.first_name}} {{item.middle_name}} {{item.last_name}}</span></md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\"><label>Order Status\n</label><md-select name=\"AppName\" ng-model=\"modelSearch.order_status\" md-on-close=\"clearSearchTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\" ng-change=\"GetAllDynamicHospital()\"><md-option value=\"-2\">\nCo-pay Verification</md-option><md-option value=\"-1\">Co-pay Approval</md-option><md-option value=\"7\">\nCo-pay Direct to Pharmacy</md-option><md-option value=\"1\">New</md-option><md-option value=\"2\">OnHold</md-option>\n<md-option value=\"3\">Ready to Pick</md-option><md-option value=\"4\">Driver Picked Up</md-option><md-option value=\"5\">\nCompleted</md-option><md-option value=\"6\">Canceled</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"25\" flex-gt-md=\"20\"><label>From Date</label><input type=\"date\" \nid=\"time\" min-date=\"modelSearch.StartDate\" format=\"MM-DD-YYYY\" ng-model=\"modelSearch.StartDate\"></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"25\" flex-gt-md=\"20\"><label>To Date</label>\n<input type=\"date\" id=\"time1\" max-date=\"modelSearch.EndDate\" format=\"MM-DD-YYYY\" ng-model=\"modelSearch.EndDate\">\n</md-input-container><div align=\"left\"><md-button class=\"md-icon-button md-accent md-raised md-hue-2\" \nng-click=\"GetAllDynamicHospital(true)\" aria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip \nmd-visible=\"\" md-direction=\"\">Search</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-warn md-raised md-hue-2\" ng-click=\"init();GetAllDynamicHospital(true);\" \naria-label=\"Reset Search\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">\nReset Search</md-tooltip></md-button></div></div></div><ul class=\"tabsList\"><li ng-click=\"ResetTab(\'hospital\')\" \nng-if=\"flaglink == 0\"><a href=\"\" class=\"active\">HOSPTAL</a></li><li ng-click=\"ResetTab(\'hospital\')\" \nng-if=\"flaglink != 0\"><a href=\"\">HOSPTAL</a></li><li ng-click=\"ResetModel1(\'pharmacy\')\" ng-if=\"flaglink == 1\"><a \nhref=\"\" class=\"active\">PHARMACY</a></li><li ng-click=\"ResetModel1(\'pharmacy\')\" ng-if=\"flaglink != 1\"><a href=\"\">\nPHARMACY</a></li><li ng-click=\"ResetModel2(\'patient\')\" ng-if=\"flaglink == 2\"><a href=\"\" class=\"active\">PATIENT</a></li>\n<li ng-click=\"ResetModel2(\'patient\')\" ng-if=\"flaglink != 2\"><a href=\"\">PATIENT</a></li></ul><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"Hospital\" \nclass=\"dataTable row-border cell-border hover\" datatable=\"\" dt-instance=\"vm.dtInstanceHospital\" \ndt-columns=\"dtColumnsHospital\" dt-options=\"dtOptions\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">id</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">\nPharmacy Details</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Hospital Details\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Patient Information\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Order Information\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Deliverd At</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Created On</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Charge($)</span></div></th><th \nclass=\"all\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\">Action</span></div></th><th class=\"all\"><div class=\"table-header\"><span\n class=\"column-title\">Doordash Order</span></div></th></tr></thead></table></div></div></div></div><style \ntype=\"text/css\" media=\"screen\">\n#processing1 {\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        z-index: 1;\r\n        background-color: rgba(203, 203, 203, 0.6);\r\n    }\r\n\r\n    #processing1 .page-loader {\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 50%;\r\n        margin-left: -100px;\r\n        margin-top: -100px;\r\n        z-index: 2;\r\n    }\r\n\r\n    #PushContent .dataTables_wrapper .dataTables_scroll .dataTables_scrollHead {\r\n        min-height: 0px !important;\r\n    }\n</style>");
$templateCache.put("app/main/OrderCharges/OrderCharges.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account-check\"></md-icon><span translate=\"Order Charges\">Order Charges</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\" flex-gt-sm=\"33\" align=\"center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" \nng-model-options=\"{ debounce: 1500 }\" ng-model=\"modelSearch.Search\" ng-change=\"GetSerch(modelSearch.Search)\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"SEARCH\" flex></div><div \nlayout=\"row\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"25\" layout-align=\"end center\"><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"ExportOrderCharges()\"><md-icon md-font-icon=\"icon-cloud-download\" \nstyle=\"color: rgb(250,250,250);font-size: 30px\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Import Excel\n</md-tooltip></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"OrderCharge\" \nclass=\"dataTable cell-border row-border hover\" datatable=\"\" dt-instance=\"dtInstance\" dt-columns=\"dtColumns\" \ndt-options=\"dtOptions\" width=\"100%\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">No\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Order Id</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Miles</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Perscription</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Patient</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Min-Charges</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Extra Mile Charges</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Extra ETA</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Prescription Charges</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Patient Charges</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Return Charges</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total Charges</span></div></th></tr>\n</thead></table></div></div></div></div>");
$templateCache.put("app/main/Patient/Patient.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account\"></md-icon><span translate=\"Patient\">Patient</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\" flex-gt-sm=\"33\" align=\"center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" \nng-model=\"modelSearch.search\" ng-change=\"reloadTableData(true)\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \ntranslate translate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" \nlayout-align=\"end center\"></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"PatientTable\" \nclass=\"dataTable cell-border row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-columns=\"dtColumns\" \ndt-options=\"dtOptions\" width=\"100%\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">No\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Patient Detail</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">SignUp At</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Selected Pharmacy Detail</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Primary Care Physician</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Profile Status Verified\n</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr>\n</thead></table></div></div></div></div><div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" \nlayout=\"row\" ng-show=\"flag\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div \nclass=\"header\" layout=\"row\" layout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" \nlayout-gt-xs=\"row\" layout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\" ng-click=\"back()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><span \ntranslate=\"{{patient_name}}\">{{patient_name}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\" flex-gt-sm=\"33\" align=\"center\" ng-show=\"tabFlag == 1\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" \nng-model=\"modelSearch.search\" ng-change=\"reloadOneTimeTableData(true)\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SEARCH\" flex></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\" flex-gt-sm=\"33\" align=\"center\" ng-show=\"tabFlag == 2\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" \nng-model=\"modelSearch.search\" ng-change=\"reloadRefillTableData(true)\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" \nflex-gt-sm=\"33\" layout=\"row\" layout-align=\"end center\"></div></div><ul class=\"tabsList\" style=\"background:white\"><li \nng-click=\"selectedTab(\'onetime\')\" ng-show=\"tabFlag != 1\"><a href=\"\">ONE TIME ORDER</a></li><li \nng-click=\"selectedTab(\'onetime\')\" ng-show=\"tabFlag == 1\"><a href=\"\" class=\"active\">ONE TIME ORDER</a></li><li \nng-click=\"selectedTab(\'refill\')\" ng-show=\"tabFlag != 2\"><a href=\"\">REFILL ORDER</a></li><li \nng-click=\"selectedTab(\'refill\')\" ng-show=\"tabFlag == 2\"><a href=\"\" class=\"active\">REFILL ORDER</a></li></ul><div \nclass=\"content-card\" layout=\"column\" flex ng-show=\"tabFlag == 1\"><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><table id=\"OneTimeTable\" class=\"dataTable cell-border row-border hover\" datatable=\"\" \ndt-instance=\"vm.dtInstance1\" dt-columns=\"dtColumns1\" dt-options=\"dtOptions1\" width=\"100%\"><thead><tr><th class=\"all\">\n<div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Order Id</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Patient Details</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Pharmacy Details</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Driver Details</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Delivery Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Order Status</span></div></th><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead></table></div></div><div \nclass=\"content-card\" layout=\"column\" flex ng-show=\"tabFlag == 2\"><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><table id=\"RefillOrderTable\" class=\"dataTable cell-border row-border hover\" datatable=\"\" \ndt-instance=\"vm.dtInstance2\" dt-columns=\"dtColumns2\" dt-options=\"dtOptions2\" width=\"100%\"><thead><tr><th class=\"all\">\n<div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Order Id</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Patient Details</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Pharmacy Details</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"># Of Medications</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"># of Refills</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Duration Of Refill</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"># of Refills Remian</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Order request on</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Next Order on</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">IsActive</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Refill Complete</span></div></th><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead></table></div></div></div></div>\n<style>\n.tabsList li a.active {\r\n        border-bottom: 2px solid rgb(3, 155, 229);\r\n        color: rgba(0, 0, 0, 0.90);\r\n    }\n</style>");
$templateCache.put("app/main/Pharmacy/Pharmacy.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-wrap \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" layout-gt-sm=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-pharmacy\"></md-icon><span translate=\"Pharmacy\">Pharmacy</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input id=\"modelsearch\" ng-model=\"modelSearch.search\" ng-change=\"reloadTableData(true)\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" \nflex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button md-raised md-hue-2\" ng-click=\"toggle()\" aria-label=\"Search\"><md-icon \nmd-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Advance Search</md-tooltip>\n</md-button><md-button class=\"md-icon-button md-raised md-hue-2\" ng-click=\"ShowAnnouncementModel($event)\" \naria-label=\"Assign using Excel\"><md-icon md-font-icon=\"icon-import\"></md-icon><md-tooltip md-visible=\"\" \nmd-direction=\"\">Send Announcement</md-tooltip></md-button></div></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"ShowContentBox\"><i ng-show=\"flgforIcon\" ng-click=\"toggle()\" \nclass=\"icon-close-circle-outline right closeIcon\"></i><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"25\" flex-gt-md=\"15\"><label>Zip Code</label><input \ntype=\"number\" id=\"zip_code\" ng-model=\"modelSearch.zip_code\"></md-input-container><md-input-container class=\"md-block\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"25\" flex-gt-md=\"15\"><label>Email Verified</label><md-select name=\"type\" \nng-model=\"model.verified\" required><md-option value=\"1\">Yes</md-option><md-option value=\"0\">No</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"25\" flex-gt-md=\"15\">\n<label>IsActive</label><md-select name=\"type\" ng-model=\"model.Approved\" required><md-option value=\"1\">Yes</md-option>\n<md-option value=\"0\">No</md-option></md-select></md-input-container><div align=\"left\"><md-button \nclass=\"md-icon-button md-accent md-raised md-hue-2\" ng-click=\"reloadTableData(true)\" aria-label=\"Search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Search</md-tooltip></md-button>\n<md-button class=\"md-icon-button md-warn md-raised md-hue-2\" ng-click=\"initModel();reloadTableData(true);\" \naria-label=\"Reset Search\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">\nReset Search</md-tooltip></md-button></div></div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table id=\"pharmacyTable\" class=\"dataTable cell-border row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" \ndt-columns=\"dtColumns\" dt-options=\"dtOptions\" width=\"100%\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Pharmacy Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">User</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Email</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Phone</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Address</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Zip Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Invoice Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Billing Period Days</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Payment Period Days</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Email Verified</span></div></th><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">IsActive</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">\nAction</span></div></th></tr></thead></table></div></div></div></div>");
$templateCache.put("app/main/PharmacyTraining/PharmacyTraining.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-pill\"></md-icon><span translate=\"Pharmacy Training\">Pharmacy Training</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" \nflex-gt-sm=\"33\" layout=\"row\" layout-align=\"end center\"><div><md-button class=\"md-icon-button md-raised md-hue-2\" \nng-click=\"ResetEdit()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">\nAdd Training</md-tooltip></md-button></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border cell-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"all\"><div \nclass=\"table-header\" style=\"width: 4%\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Training Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Video</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">IsActive</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Date</span></div></th><th class=\"all\" data-orderable=\"false\"><div \nclass=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in lstTraining \"><td style=\"width: 4%; text-align: center\">{{$index+1}}</td><td>{{item.type}}</td><td>\n{{item.name}}</td><td><a href=\"{{item.video_url}}\" target=\"_blank\"><img src=\"/assets/images/video.png\" width=\"50px\">\n</a></td><td style=\"width: 12%; text-align: center\"><md-button ng-if=\"item.is_active==1\" \nstyle=\"font-size: 20px;color: green\" ng-click=\"UpdateIsActive(item._id,0)\">&#x2714;<md-tooltip md-visible=\"\" \nmd-direction=\"\">DeActive</md-tooltip></md-button><md-button ng-if=\"item.is_active!=1\" \nstyle=\"font-size: 20px;color: red\" ng-click=\"UpdateIsActive(item._id,1)\">&#x2716;<md-tooltip md-visible=\"\" \nmd-direction=\"\">Active</md-tooltip></md-button></td><td>{{item.created_date |date : \"MM-dd-yyyy HH:mm:ss a\"}}</td><td \nstyle=\"text-align: center\"><md-button class=\"edit-button md-icon-button\" ng-click=\"UpdateVideo(item)\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s18 green-500-fg\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Edit\n</md-tooltip></md-button><md-button class=\"edit-button md-icon-button\" ng-click=\"DeleteTraining(item._id)\"><md-icon \nmd-font-icon=\"icon-trash\" class=\"s18 red-500-fg\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Delete\n</md-tooltip></md-button></td></tr></tbody></table></div></div></div></div><div class=\"page-layout simple tabbed\" \nlayout=\"column\" ng-show=\"flag\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" \naria-label=\"Go to products\" ng-click=\"gotoOrderList()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button>\n<div layout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"subtitle secondary-text\"><span translate=\"Add Pharmacy Training\">Add Pharmacy Training</span></div></div></div>\n</div><div></div></div><div class=\"content\" layout-margin><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"formPharmacyTraining\" novalidate \nclass=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><div layout=\"row\" layout-wrap><md-input-container \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><label>Type</label><md-select name=\"type\" ng-model=\"model.type\" required>\n<md-option value=\"Pharmacy\">Pharmacy</md-option><md-option value=\"Hospital\">Hospital</md-option><div \nng-messages=\"formPharmacyTraining.type.$error\" ng-if=\"formPharmacyTraining.type.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Type field is required</span></div></div></md-select></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><label>Name</label><input \ntype=\"text\" name=\"name\" ng-model=\"model.name\" required maxlength=\"256\" md-maxlength=\"256\"><div \nng-messages=\"formPharmacyTraining.name.$error\" ng-if=\"formPharmacyTraining.name.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Training Name field is required</span></div></div></md-input-container></div><div \nlayout=\"row\" layout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><label>Vedio URL</label>\n<input type=\"url\" name=\"video_url\" ng-model=\"model.video_url\" required><div \nng-messages=\"formPharmacyTraining.video_url.$error\" ng-if=\"formPharmacyTraining.video_url.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Vedio URL field is required</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"25\"><md-checkbox md-no-ink \naria-label=\"Checkbox No Ink\" ng-model=\"model.is_active\" class=\"md-primary\">IsActive</md-checkbox></md-input-container>\n</div><div align=\"center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!formPharmacyTraining.$valid\" \nng-click=\"CreateVideo(form,model)\">{{btn}}</md-button><md-button class=\"md-accent md-raised\" ng-click=\"ResetData()\">\nReset</md-button><md-button class=\"md-raised md-warn\" ng-click=\"Cancel()\">Cancel</md-button></div></form></div></div>\n</div>");
$templateCache.put("app/main/PharmacyUserManual/PharmacyUserManual.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-library-plus\"></md-icon><span translate=\"Pharmacy User Manual\">Pharmacy User Manual</span></div>\n</div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" \nflex-gt-sm=\"33\" layout=\"row\" layout-align=\"end center\"><div><md-button class=\"md-icon-button md-raised md-hue-2\" \nng-click=\"ResetEdit()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Add Manual\n</md-tooltip></md-button></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border cell-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"all\"><div \nclass=\"table-header\" style=\"width: 4%\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">PDF</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">IsActive</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Date</span></div></th><th class=\"all\" data-orderable=\"false\"><div \nclass=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in lstUsermanual | orderBy: \'name\'\"><td style=\"width: 4%; text-align: center\">{{$index+1}}</td><td>\n{{item.type}}</td><td>{{item.name}}</td><td><a href=\"{{item.url}}\" target=\"_blank\"><img src=\"/assets/images/pdf.png\" \nwidth=\"50px\"></a></td><td ng-if=\"item.is_active==1\" style=\"width: 10%; text-align: center\"><span \nstyle=\"font-size: 20px;color: green\">&#x2714;</span></td><td ng-if=\"item.is_active!=1\" \nstyle=\"width: 10%; text-align: center\"><span style=\"font-size: 20px;color: red\">&#x2716;</span></td><td>\n{{item.created_date| date : \"MM-dd-yyyy HH:mm:ss a\"}}</td><td style=\"text-align: center\"><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"UpdatePDF(item)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s18 green-500-fg\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Edit</md-tooltip></md-button><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"DeleteManual(item._id)\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"s18 red-500-fg\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Delete</md-tooltip></md-button><md-button \nng-if=\"!item.is_active\" class=\"edit-button md-icon-button\" ng-click=\"UpdateIsActive(item._id,1)\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"s20 green-500-fg\"></md-icon><md-tooltip md-visible=\"\" \nmd-direction=\"\">Activate Manual</md-tooltip></md-button><md-button ng-if=\"item.is_active\" \nclass=\"edit-button md-icon-button\" ng-click=\"UpdateIsActive(item._id,0)\" aria-label=\"\"><md-icon \nmd-font-icon=\"icon-close-circle\" class=\"s20 red-500-fg\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">\nInactive Manual</md-tooltip></md-button></td></tr></tbody></table></div></div></div></div><div \nclass=\"page-layout simple tabbed\" layout=\"column\" ng-show=\"flag\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" ng-click=\"gotoOrderList()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"subtitle secondary-text\"><span \ntranslate=\"Add Pharmacy User Manual\">Add Pharmacy User Manual</span></div></div></div></div><div></div></div><div \nclass=\"content\" layout-margin><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form \nname=\"formUserManual\" novalidate class=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><div layout=\"row\" \nlayout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><label>Type</label><md-select name=\"type\" \nng-model=\"model.type\" required><md-option value=\"Pharmacy\">Pharmacy</md-option><md-option value=\"Hospital\">Hospital\n</md-option><div ng-messages=\"formPharmacyTraining.type.$error\" ng-if=\"formPharmacyTraining.type.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Type field is required</span></div></div></md-select>\n</md-input-container></div><div layout=\"row\" layout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><label>Name</label><input type=\"text\" name=\"name\" ng-model=\"model.name\" required maxlength=\"256\" \nmd-maxlength=\"256\"><div ng-messages=\"formUserManual.name.$error\" ng-if=\"formUserManual.name.$touched\" role=\"alert\"><div\n ng-message=\"required\"><span>Name field is required</span></div></div></md-input-container></div><div \nng-show=\"FlgImage\" class=\"row\" flex=\"100\" flex-gt-xs=\"50\"><a href=\"{{url}}\" target=\"_blank\"><img \nng-src=\"assets/images/pdf.png\" id=\"PDFFile\" width=\"150px\"></a><md-button class=\"md-raised md-primary\" \nng-click=\"RemoveImage()\">Remove</md-button></div><div layout=\"row\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\">\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-sm=\"50\"><label>Upload PDF</label><md-input-container \nclass=\"md-block\" flex><lf-ng-md-file-input id=\"fileInput\" name=\"filesPDF\" lf-files=\"MediafilesPDF\" \nlf-api=\"apiMediaPDF\" lf-required lf-mimetype=\"application/pdf\" preview></lf-ng-md-file-input><div \nng-messages=\"form.filesPDF.$error\" style=\"color:red\"><div ng-message=\"required\">You must Select file.</div><div \nng-message=\"mimetype\">Only PDF file supported</div></div></md-input-container></md-input-container></div><div \nalign=\"center\"><md-button class=\"md-raised md-primary\" ng-click=\"CreateManual(form,model)\">{{btn}}</md-button>\n<md-button class=\"md-accent md-raised\" ng-click=\"ResetData()\">Reset</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"Cancel()\">Cancel</md-button></div></form></div></div></div>");
$templateCache.put("app/main/PickupOrder/PickupOrder.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-bank\"></md-icon><span translate=\"Order\">\nPickup Order</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"Search\" ng-model=\"model.Search\" \nng-change=\"GetSerch(model.Search)\" class=\"search-input\" ng-model-options=\"{ debounce: debounceTime }\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" \nflex-gt-sm=\"33\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button md-raised md-hue-2\" \nng-click=\"toggle()\" aria-label=\"Search\"><md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip \nmd-visible=\"\" md-direction=\"\">Advance Search</md-tooltip></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"ShowContentBox\"><i ng-show=\"flgforIcon\" ng-click=\"toggle()\" \nclass=\"icon-close-circle-outline right closeIcon\"></i><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\"><label>Pharmacy</label><md-select \nname=\"pharmacy_name\" ng-model=\"modelSearch.pharmacy_name\" md-on-close=\"clearSearchTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\" ng-change=\"GetAllDynamicHospital()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.search\" type=\"search\" placeholder=\"Search for a Pharmacy..\" \nclass=\"demo-header-searchbox md-text\" ng-keydown=\"onSearchChange($event)\"></md-select-header><md-option \nng-value=\"o.pharmacy_name\" ng-repeat=\"o in lstPharmacy | filter:vm.search \"><span>{{o.pharmacy_name}}</span>\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-sm=\"50\" flex-gt-md=\"15\" ng-if=\"searchtype!=\'patient\'\"><label>Hospital</label><md-select name=\"hospital_name\" \nng-model=\"modelSearch.hospital_name\" md-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\" \nng-change=\"GetAllDynamicHospital()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.search\" \ntype=\"search\" placeholder=\"Search for a Hospital..\" class=\"demo-header-searchbox md-text\" \nng-keydown=\"onSearchChange($event)\"></md-select-header><md-option ng-value=\"item.hospitalName\" \nng-repeat=\"item in lstHospitalname | filter:vm.search \"><span>{{item.hospitalName}}</span></md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\">\n<label>Patient</label><md-select name=\"patient_firstname\" ng-model=\"modelSearch.patient_firstname\" \nmd-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\" ng-change=\"GetAllDynamicHospital()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.search\" type=\"search\" \nplaceholder=\"Search for a Patient..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"onSearchChange($event)\">\n</md-select-header><md-option ng-value=\"item.first_name\" \nng-repeat=\"item in lstPatient | filter:vm.search || orderBy:\'first_name\'\"><span>\n{{item.first_name}} {{item.middle_name}} {{item.last_name}}</span></md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\"><label>Order Status\n</label><md-select name=\"AppName\" ng-model=\"modelSearch.order_status\" md-on-close=\"clearSearchTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\" ng-change=\"GetAllDynamicHospital()\"><md-option value=\"-2\">\nCo-pay Verification</md-option><md-option value=\"-1\">Co-pay Approval</md-option><md-option value=\"7\">\nCo-pay Direct to Pharmacy</md-option><md-option value=\"1\">New</md-option><md-option value=\"2\">OnHold</md-option>\n<md-option value=\"3\">Ready to Pick</md-option><md-option value=\"4\">Driver Picked Up</md-option><md-option value=\"5\">\nCompleted</md-option><md-option value=\"6\">Canceled</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"25\" flex-gt-md=\"20\"><label>From Date</label><input type=\"date\" \nid=\"time\" min-date=\"modelSearch.StartDate\" format=\"MM-DD-YYYY\" ng-model=\"modelSearch.StartDate\"></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"25\" flex-gt-md=\"20\"><label>To Date</label>\n<input type=\"date\" id=\"time1\" max-date=\"modelSearch.EndDate\" format=\"MM-DD-YYYY\" ng-model=\"modelSearch.EndDate\">\n</md-input-container><div align=\"left\"><md-button class=\"md-icon-button md-accent md-raised md-hue-2\" \nng-click=\"GetAllDynamicHospital(true)\" aria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip \nmd-visible=\"\" md-direction=\"\">Search</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-warn md-raised md-hue-2\" ng-click=\"init();GetAllDynamicHospital(true);\" \naria-label=\"Reset Search\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">\nReset Search</md-tooltip></md-button></div></div></div><ul class=\"tabsList\"><li ng-click=\"ResetModel3(\'pickup\')\" \nng-if=\"flaglink == 3 && demandView\"><a href=\"\" class=\"active\">PICKUP</a></li><li ng-click=\"ResetModel3(\'pickup\')\" \nng-if=\"flaglink != 3 && demandView\"><a href=\"\">PICKUP</a></li></ul><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><table id=\"Hospital\" class=\"dataTable row-border cell-border hover\" datatable=\"\" \ndt-instance=\"vm.dtInstanceHospital\" dt-columns=\"dtColumnsHospital\" dt-options=\"dtOptions\"><thead><tr><th class=\"all\">\n<div class=\"table-header\"><span class=\"column-title\">id</span></div></th><th class=\"all\"><div class=\"table-header\">\n<span class=\"column-title\">Pharmacy Details</span></div></th><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">Hospital Details</span></div></th><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">Hospice Details</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Patient Information</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Order Information</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Deliverd At</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Created On</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Charge($)</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">\nStatus</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th>\n<th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Doordash Order</span></div></th></tr></thead>\n</table></div></div></div></div><style type=\"text/css\" media=\"screen\">\n#processing1 {\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        z-index: 1;\r\n        background-color: rgba(203, 203, 203, 0.6);\r\n    }\r\n\r\n    #processing1 .page-loader {\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 50%;\r\n        margin-left: -100px;\r\n        margin-top: -100px;\r\n        z-index: 2;\r\n    }\r\n\r\n    #PushContent .dataTables_wrapper .dataTables_scroll .dataTables_scrollHead {\r\n        min-height: 0px !important;\r\n    }\n</style>");
$templateCache.put("app/main/Roles/Roles.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-cube-outline\"></md-icon><span translate=\"Roles\">Roles</span></div><div \nclass=\"product-count secondary-text\" hide-xs><span>Total Roles :</span> <b>{{lstRoles.length}}</b></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\" flex-gt-sm=\"33\" align=\"center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" \nng-model=\"Search\" ng-change=\"GetSerch(Search)\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" \nlayout-align=\"end center\"><div><md-button class=\"md-icon-button md-raised md-hue-2\" ng-click=\"ResetEdit()\" \naria-label=\"Search \"><md-icon md-font-icon=\"icon-plus \"></md-icon><md-tooltip md-visible=\" \" md-direction=\" \">\nAdd New Roles</md-tooltip></md-button></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable cell-border row-border hover\" \ndatatable=\"ng\" dt-instance=\"dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"all\"><div class=\"table-header\">\n<span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Role Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Role Description</span></div></th><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">Action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in lstRoles | orderBy: \'RoleName\'\"><td style=\"width: 4%; text-align: center\" ng-model=\"item.id\">\n{{$index+1}}</td><td>{{item.RoleName}}</td><td>{{item.Description}}</td><td style=\"width: 20%; text-align: center\">\n<md-button class=\"edit-button md-icon-button\" ng-click=\"FetchRoleById(item)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s18 green-500-fg\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Edit</md-tooltip></md-button><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"DeleteRole(item)\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"s18 red-500-fg\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Delete</md-tooltip></md-button></td></tr>\n</tbody></table></div></div></div></div><div class=\"page-layout simple tabbed\" layout=\"column\" ng-show=\"flag\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" aria-label=\"Go to products\" \nng-click=\"gotoOrderList()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"subtitle secondary-text\"><span \ntranslate=\"Role List\">Role List</span></div></div></div></div><div></div></div><div class=\"content\" layout-margin><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"FormManageRoles\" novalidate \nclass=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><div layout=\"row\" layout-wrap><md-input-container \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>Role name</label><input type=\"text\" name=\"RoleName\" \nng-model=\"model.RoleName\" required maxlength=\"256\" md-maxlength=\"256\"><div \nng-messages=\"FormManageRoles.RoleName.$error\" ng-if=\"FormManageRoles.RoleName.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Role name field is required</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><input type=\"text\" name=\"Description\" ng-model=\"model.Description\" \nplaceholder=\"Description \"></md-input-container></div><div align=\"center\"><md-button class=\"md-raised md-primary\" \nng-click=\"CreateRole(model)\" ng-disabled=\"FormManageRoles.$invalid\">save</md-button><md-button \nclass=\"md-accent md-raised\" ng-click=\"ResetData()\">Reset</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"Reset()\">cancel</md-button></div></form></div></div></div>");
$templateCache.put("app/main/ScheduleDelivery/ScheduleDelivery.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-calendar-clock\"></md-icon><span translate=\"Schedule Delivery\">Schedule Delivery</span></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"Search\" ng-model=\"model.Search\" \nng-change=\"GetSearch(model.Search)\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button md-raised md-hue-2\" ng-click=\"toggle()\" aria-label=\"Search\">\n<md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Advance Search\n</md-tooltip></md-button></div></div><div id=\"loaderDiv\"><div class=\"loading-spiner\"><img \nsrc=\"../../../assets/images/loader.gif\" style=\"margin-left: 35rem;height: 150px;\r\n                    width: 150px\">\n</div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"ShowContentBox\"><i ng-show=\"flgforIcon\" \nng-click=\"toggle()\" class=\"icon-close-circle-outline right closeIcon\"></i><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\"><label>Pharmacy</label>\n<md-select name=\"pharmacy_id\" ng-model=\"modelSearch.pharmacy_id\" md-on-close=\"clearSearchTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\" ng-change=\"GetAllDynamicHospital()\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.search\" type=\"search\" placeholder=\"Search for a Pharmacy..\" \nclass=\"demo-header-searchbox md-text\" ng-keydown=\"onSearchChange($event)\"></md-select-header><md-option \nng-value=\"o._id\" ng-repeat=\"o in lstPharmacy | filter:vm.search \"><span>{{o.pharmacy_name}}</span></md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" \nflex-gt-md=\"15\"><label>Driver</label><md-select name=\"driver_id\" ng-model=\"modelSearch.driver_id\" \nmd-on-close=\"clearSearchTerm()\" data-md-container-class=\"selectdemoSelectHeader\" ng-change=\"GetAllDynamicHospital()\">\n<md-select-header class=\"demo-select-header\"><input ng-model=\"vm.search1\" type=\"search\" \nplaceholder=\"Search for a Driver..\" class=\"demo-header-searchbox md-text\" ng-keydown=\"onSearchChange($event)\">\n</md-select-header><md-option ng-value=\"item._id\" ng-repeat=\"item in lstdriver | filter:vm.search1 \"><span>\n{{item.first_name}} {{item.last_name}}</span></md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\"><label>Order Status</label><md-select \nname=\"AppName\" ng-model=\"modelSearch.status\" md-on-close=\"clearSearchTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\" ng-change=\"GetAllDynamicHospital()\"><md-option value=\"picked up\">\nPicked Up</md-option><md-option value=\"delivered\">Delivered</md-option><md-option value=\"pending\">Pending</md-option>\n<md-option value=\"sent to driver\">Sent to Driver</md-option><md-option value=\"completed\">Completed</md-option>\n<md-option value=\"accept\">Accept</md-option><md-option value=\"reject\">Reject</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\">\n<label>From Date</label><input ng-model=\"modelSearch.from_date\" type=\"date\" class=\"demo-header-searchbox md-text\" \nng-change=\"GetAllDynamicHospital()\" ng-keydown=\"onSearchChange($event)\"></md-input-container><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\"><label>To Date</label><input \nng-model=\"modelSearch.to_date\" type=\"date\" class=\"demo-header-searchbox md-text\" ng-change=\"GetAllDynamicHospital()\" \nng-keydown=\"onSearchChange($event)\"></md-input-container><div align=\"left\" class=\"sd-wrapper\"><md-button \nclass=\"md-icon-button md-accent md-raised md-hue-2\" ng-click=\"GetAllDynamicHospital(true)\" aria-label=\"Search\"><md-icon\n md-font-icon=\"icon-magnify\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Search</md-tooltip></md-button>\n<md-button class=\"md-icon-button md-warn md-raised md-hue-2\" ng-click=\"init();GetAllDynamicHospital(true);\" \naria-label=\"Reset Search\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">\nReset Search</md-tooltip></md-button></div></div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table id=\"ScheduleDeliveryTable\" class=\"dataTable cell-border row-border hover\" datatable=\"\" \ndt-instance=\"vm.dtInstance\" dt-columns=\"dtColumns\" dt-options=\"dtOptions\" width=\"100%\"><thead><tr><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">Bucket Number</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Order Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Pharmacy Details</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Total Order</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Timing</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Driver Details</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">\nAction</span></div></th></tr></thead></table></div></div></div></div><style>\n.loading-spiner {\r\n        /* margin-bottom: :6rem; */\r\n    }\r\n    .loaderDiv{\r\n    position:absolute;\r\n    top:0;\r\n    left:0;\r\n    width:100%;\r\n    height:100%;\r\n    z-index:1000;\r\n    background-color:grey;\r\n    opacity: .8;\r\n    }\n</style>");
$templateCache.put("app/main/SuggestPharmacy/Suggestpharmacy.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-wrap \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" layout-gt-sm=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-pharmacy\"></md-icon><span translate=\"Suggest Pharmacy\">Suggest Pharmacy</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" ng-model=\"modelSearch.search\" \nng-change=\"reloadTableData(true)\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button md-raised md-hue-2\" ng-click=\"toggle()\" aria-label=\"Search\">\n<md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Advance Search\n</md-tooltip></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"ShowContentBox\"><i \nng-show=\"flgforIcon\" ng-click=\"toggle()\" class=\"icon-close-circle-outline right closeIcon\"></i><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"25\" flex-gt-md=\"15\"><label>\nZip Code</label><input type=\"number\" id=\"zip_code\" ng-model=\"modelSearch.zip_code\"></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"25\" flex-gt-md=\"15\"><label>Email Verified\n</label><md-select name=\"type\" ng-model=\"model.verified\" required><md-option value=\"1\">Yes</md-option><md-option \nvalue=\"0\">No</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-sm=\"25\" flex-gt-md=\"15\"><label>IsActive</label><md-select name=\"type\" \nng-model=\"model.Approved\" required><md-option value=\"1\">Yes</md-option><md-option value=\"0\">No</md-option></md-select>\n</md-input-container><div align=\"left\"><md-button class=\"md-icon-button md-accent md-raised md-hue-2\" \nng-click=\"reloadTableData(true)\" aria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip \nmd-visible=\"\" md-direction=\"\">Search</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-warn md-raised md-hue-2\" ng-click=\"initModel();reloadTableData(true);\" \naria-label=\"Reset Search\"><md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">\nReset Search</md-tooltip></md-button></div></div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex>\n<table id=\"pharmacyTable\" class=\"dataTable cell-border row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" \ndt-columns=\"dtColumns\" dt-options=\"dtOptions\" width=\"100%\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Pharmacy Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Patient name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Email</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Phone</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Address</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Zip Code</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Date</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Action\n</span></div></th></tr></thead></table></div></div></div></div>");
$templateCache.put("app/main/Testimonial/Testimonial.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-calendar-clock\"></md-icon><span translate=\"Testimonial\">Testimonial</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"Search\" ng-model=\"model.Search\" \nng-change=\"GetSearch(model.Search)\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" \nlayout-align=\"end center\"></div></div><div class=\"content-card\" layout=\"column\" flex><ul class=\"tabsList\"><li \nng-click=\"ResetModel1(\'patient\')\" ng-if=\"flaglink == 0\"><a href=\"\" class=\"active\">PATIENT</a></li><li \nng-click=\"ResetModel1(\'patient\')\" ng-if=\"flaglink != 0\"><a href=\"\">PATIENT</a></li><li \nng-click=\"ResetModel2(\'pharmacy\')\" ng-if=\"flaglink == 1\"><a href=\"\" class=\"active\">PHARMACY</a></li><li \nng-click=\"ResetModel2(\'pharmacy\')\" ng-if=\"flaglink != 1\"><a href=\"\">PHARMACY</a></li></ul><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table id=\"TestimonialTable\" \nclass=\"dataTable cell-border row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-columns=\"dtColumns\" \ndt-options=\"dtOptions\" width=\"100%\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">No\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \nng-if=\"flaglink == 0\">Patient Information</span> <span class=\"column-title\" ng-if=\"flaglink == 1\">Pharmacy Details\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data to Display\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Courteous Driver\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Recommended</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Comments</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Experience</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Created Date</span></div></th><th \nclass=\"all\"><div class=\"table-header\"><span class=\"column-title\">Docs</span></div></th><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\">Image</span></div></th><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">Action</span></div></th></tr></thead></table></div></div></div></div>");
$templateCache.put("app/main/TransferPharamcy/TransferPharamcy.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account-switch\"></md-icon><span translate=\"Transfer Pharamcy Request\">Transfer Pharamcy Request\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\" \nflex-gt-sm=\"33\" align=\"center\"><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"modelsearch\" ng-model=\"modelSearch.search\" ng-change=\"reloadTable(true)\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" \nflex-gt-sm=\"33\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button md-raised md-hue-2\" \nng-click=\"toggle()\" aria-label=\"Search\"><md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip \nmd-visible=\"\" md-direction=\"\">Advance Search</md-tooltip></md-button></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"ShowContentBox\"><i ng-show=\"flgforIcon\" ng-click=\"toggle()\" \nclass=\"icon-close-circle-outline right closeIcon\"></i><div layout=\"row\" layout-wrap><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\" flex-gt-md=\"15\"><label>Order Status</label><md-select \nname=\"AppName\" ng-model=\"advanceSearch.status\" md-on-close=\"clearSearchTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\" ng-change=\"reloadTable()\"><md-option value=\"Pending\">Pending\n</md-option><md-option value=\"Approve\">Approve</md-option><md-option value=\"Reject\">Reject</md-option></md-select>\n</md-input-container><div align=\"left\"><md-button class=\"md-icon-button md-accent md-raised md-hue-2\" \nng-click=\"reloadTable(true)\" aria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip \nmd-visible=\"\" md-direction=\"\">Search</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-warn md-raised md-hue-2\" ng-click=\"init();reloadTable(true);\" aria-label=\"Reset Search\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Reset Search</md-tooltip>\n</md-button></div></div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nid=\"transferPharmacyTable\" class=\"dataTable cell-border row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" \ndt-columns=\"dtColumns\" dt-options=\"dtOptions\" width=\"100%\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Pharmacy Details</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Patient Details</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Preferred Pharmacy</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Medications</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Status</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Action</span></div></th></tr></thead></table></div></div></div></div>");
$templateCache.put("app/main/User/User.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account-check\"></md-icon><span translate=\"User Management\">User Management</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\" flex-gt-sm=\"33\" align=\"center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" \nng-model-options=\"{ debounce: 1500 }\" ng-model=\"modelSearch.Search\" ng-change=\"GetSerch(modelSearch.Search)\" \nclass=\"search-input\" type=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"SEARCH\" flex></div><div \nlayout=\"row\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"25\" layout-align=\"end center\" style=\"padding: 3px\"><div><md-button\n class=\"md-icon-button md-raised md-hue-2\" ng-click=\"ResetEdit()\" aria-label=\"Add User\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-visible=\"\" md-direction=\"\">Add User</md-tooltip></md-button></div>\n</div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" \nflex><table id=\"Usertable\" class=\"dataTable tableD2 table-fixed\" datatable=\"\" dt-instance=\"dtInstance\" \ndt-columns=\"dtColumns\" dt-options=\"dtOptions\" width=\"100%\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Email</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Role</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Action\n</span></div></th></tr></thead></table></div></div></div></div><div class=\"page-layout simple tabbed\" layout=\"column\" \nng-show=\"flag\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" \naria-label=\"Go to products\" ng-click=\"ResetModel()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"subtitle secondary-text\"><span translate=\"Manage User\">Manage User</span></div></div></div></div></div><div \nclass=\"content layout-margin\"><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form \nname=\"AddUserForm\" novalidate class=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\"><label>Email Address\n</label><input type=\"Email\" name=\"email\" ng-model=\"model.email\" md-maxlength=\"100\" ng-pattern=\"/^.+@.+\\..+$/\" required>\n<div ng-messages=\"AddUserForm.email.$error\" ng-if=\"AddUserForm.email.$touched\"><div ng-message=\"required\"><span>\nEmail is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid E-mail address</span></div><div \nng-message=\"md-maxlength\"><span>Email must be in between 100 characters long</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\"><label>First Name</label><input \ntype=\"text\" name=\"firstName\" ng-model=\"model.firstName\" required><div ng-messages=\"AddUserForm.firstName.$error\" \nng-if=\"AddUserForm.firstName.$touched\"><div ng-message=\"required\"><span>First Name is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\"><label>Last Name\n</label><input type=\"text\" name=\"lastName\" ng-model=\"model.lastName\" required><div \nng-messages=\"AddUserForm.lastName.$error\" ng-if=\"AddUserForm.lastName.$touched\"><div ng-message=\"required\"><span>\nLast Name is required</span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-sm=\"50\" ng-if=\"editflg==false\"><label>Password</label><input type=\"password\" name=\"password\" \nautocomplete=\"on\" ng-model=\"model.password\" required><div ng-messages=\"AddUserForm.password.$error\" \nng-if=\"AddUserForm.password.$touched\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPassword is required</span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-sm=\"50\"><label>Role</label><md-select ng-model=\"model.role_id\" \nng-change=\"GetAllPermissionByRole()\"><md-option value=\"{{o._id}}\" ng-repeat=\"o in lstRoles| orderBy: \'RoleName\'\">\n{{o.RoleName}}</md-option></md-select></md-input-container></div><div align=\"center\"><md-button \nclass=\"md-raised md-primary\" ng-disabled=\"!AddUserForm.$valid\" ng-click=\"CreateUser(model)\">Save</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"ResetModel()\">Cancel</md-button></div></form></div></div></div><style>\n.cropArea {\r\n        background: #E4E4E4;\r\n        overflow: hidden;\r\n        width: 100%;\r\n        height: 350px;\r\n    }\n</style>");
$templateCache.put("app/main/UserPermission/UserPermission.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-wrap \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" layout-gt-sm=\"column\" \nlayout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-lock\">\n</md-icon><span translate=\"User Permission\">User Permission</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex=\"60\" flex-gt-xs=\"60\" flex-gt-sm=\"33\" align=\"center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input id=\"modelsearch\" ng-model=\"Search\" \nclass=\"search-input\" ng-change=\"GetSerch(Search)\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"SEARCH\" flex></div><div flex=\"40\" flex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" \nlayout-align=\"end center\"></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><div class=\"row\"><md-input-container class=\"md-block\" flex>\n<label>Role</label><md-select ng-model=\"model.role_id\" ng-change=\"GetAllPermissionByRole()\"><md-option value=\"\">\nSelect Role</md-option><md-option value=\"{{o._id}}\" ng-repeat=\"o in lstRoles| orderBy: \'RoleName\'\">{{o.RoleName}}\n</md-option></md-select></md-input-container></div><table class=\"dataTable tableD2 table-fixed\" datatable=\"ng\" \ndt-options=\"dtCustomOptions\" dt-instance=\"dtInstance\" dt-column-defs=\"dtColumnDefs\"><thead><tr><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\">No</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Module</span></div></th><th class=\"all\"><div class=\"table-header\"><span\n class=\"column-title\"><md-checkbox value=\"modelPermission.View\" ng-model=\"modelPermission.View\" aria-label=\"View\" \nclass=\"md-accent\" ng-change=\"ChangePermissionAllView()\">View</md-checkbox></span></div></th><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\"><md-checkbox value=\"modelPermission.Add\" \nng-model=\"modelPermission.Add\" aria-label=\"View\" class=\"md-accent\" ng-change=\"ChangePermissionAllAdd()\">Add\n</md-checkbox></span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\"><md-checkbox \nvalue=\"modelPermission.Update\" ng-model=\"modelPermission.Update\" aria-label=\"View\" class=\"md-accent\" \nng-change=\"ChangePermissionAllUpdate()\">Update</md-checkbox></span></div></th><th class=\"all\"><div \nclass=\"table-header\"><span class=\"column-title\"><md-checkbox value=\"modelPermission.Delete\" \nng-model=\"modelPermission.Delete\" aria-label=\"View\" class=\"md-accent\" ng-change=\"ChangePermissionAllDelete()\">Delete\n</md-checkbox></span></div></th></tr></thead><tbody><tr ng-repeat=\"o in lstModules\"><td \nstyle=\"width: 4%;text-align: center\">{{$index+1}}</td><td class=\"text-left\">{{o.module_name}}</td><td \nclass=\"text-center\"><md-checkbox ng-model=\"o.Show\" value=\"o.Show\" ng-change=\"ChangePermission(o)\" aria-label=\"View\" \nclass=\"md-accent\"></md-checkbox></td><td class=\"text-center\"><md-checkbox ng-model=\"o.Added\" value=\"o.Added\" \nng-change=\"ChangePermission(o)\" aria-label=\"Add\" class=\"md-accent\"></md-checkbox></td><td class=\"text-center\">\n<md-checkbox ng-model=\"o.Modified\" value=\"o.Modified\" ng-change=\"ChangePermission(o)\" aria-label=\"Update\" \nclass=\"md-accent\"></md-checkbox></td><td class=\"text-center\"><md-checkbox ng-model=\"o.Deleted\" value=\"o.Deleted\" \nng-change=\"ChangePermission(o)\" aria-label=\"View\" class=\"md-accent\"></md-checkbox></td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/Zipcode/Zipcode.html","<div id=\"e-commerce-products\" class=\"page-layout carded fullwidth\" layout=\"row\" ng-show=\"!flag\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-wrap layout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-gt-xs=\"row\" \nlayout-gt-sm=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-drawing-box\"></md-icon><span translate=\"Zipcodes\">Zipcode</span></div></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-button class=\"md-raised md-hue-2\" \nstyle=\"padding-left: 15px;padding-right: 15px\" ng-click=\"find_zip(model.Search)\">find zipcode</md-button></div><div \nflex=\"40\" flex-gt-xs=\"40\" flex-gt-sm=\"33\" layout=\"row\" layout-align=\"end center\"><div><md-button \nclass=\"md-icon-button md-raised md-hue-2\" ng-click=\"ResetEdit()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip md-visible=\"\" md-direction=\"\">Add New Zipcode</md-tooltip></md-button></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nid=\"Hospital\" class=\"dataTable row-border cell-border hover\" datatable=\"\" dt-instance=\"vm.dtInstanceHospital\" \ndt-columns=\"dtColumnsHospital\" dt-options=\"dtOptions\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\">No</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Zip\n</span></div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr>\n</thead></table></div></div></div></div><div class=\"page-layout simple tabbed\" layout=\"column\" ng-show=\"flag\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" aria-label=\"Go to Brand\" \nng-click=\"backToAllZip()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"subtitle secondary-text\"><span \ntranslate=\"Add Zip code\">Add Zip code</span></div></div></div></div><div></div></div><div class=\"content\" \nlayout-margin><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><form \nname=\"FormManageBrand\" novalidate class=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><div layout=\"row\" \nlayout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><label>Zipcode</label><input type=\"text\" \nname=\"zip\" ng-model=\"model.zip\" required maxlength=\"6\" md-maxlength=\"6\"><div ng-messages=\"FormManageBrand.name.$error\" \nng-if=\"FormManageBrand.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Zipcode field is required</span>\n</div></div></md-input-container></div><div layout=\"row\" layout-wrap><label>\nOR (choose file for uplading multiple zipcodes)</label></div><div layout=\"row\" layout-wrap><md-input-container \nflex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><input type=\"file\" file-model=\"myFile\" id=\"myFileInput\">\n</md-input-container></div><div><md-button class=\"md-raised md-primary\" ng-click=\"createZip(model)\">save</md-button>\n<md-button class=\"md-raised md-warn\" ng-click=\"cancel()\">cancel</md-button></div></form></div></div></div>");
$templateCache.put("app/main/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\" style=\"height: 570px\"><div \nclass=\"logo md-accent-bg\" \nstyle=\"width: 50%;\r\n            height: 20%;background-repeat: no-repeat;background-color: transparent\"></div><div \nclass=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><form name=\"loginForm\" novalidate><md-input-container\n class=\"md-block\" md-no-float><label>UserName</label><input type=\"text\" name=\"email\" auto-fillable-field \nng-model=\"model.UserName\" required ng-change=\"setUserName()\"><div ng-messages=\"loginForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>UserName is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><label>Password</label><input type=\"password\" name=\"password\" \nauto-fillable-field ng-model=\"model.Password\" required ng-change=\"setPassword()\" autocomplete=\"on\"><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password is required</span></div>\n</div></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><md-checkbox class=\"remember-me\" ng-model=\"model.RemeberMe\" \naria-label=\"Remember Me\"><span>Remember Me</span></md-checkbox></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-click=\"Login(model,loginForm.$valid,true)\">LOG IN\n</md-button></form></div></div></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Row Color\" md-menu-origin \nng-click=\"$mdOpenMenu($event)\" ng-class=\"selectedColor.class\"><span ng-show=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-show=\"!selectedColor.palette\">Select Color</span>\n</md-button><md-menu-content class=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-if=\"!selectedColor.palette\">Select Color</span>\n<md-button class=\"remove-color-button md-icon-button\" ng-click=\"removeColor()\" aria-label=\"Remove Color\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-if=\"!selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in palettes\" ng-click=\"activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-if=\"selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+selectedPalette+\'-\'+hue+\'-bg\'\" \nng-repeat=\"(hue, values) in selectedHues\" ng-click=\"selectColor(selectedPalette,hue)\" layout=\"row\" \nlayout-align=\"start end\" md-ink-ripple><span class=\"label\">{{hue}} </span><i \nng-if=\"selectedPalette == selectedColor.palette && hue == selectedColor.hue\" class=\"s16 icon-check\"></i></div></div>\n</div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div>");
$templateCache.put("app/main/DriverApplication/dialogs/ApplicationDetail.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:800px;min-width:400px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Driver Application</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"closeModel1()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-content class=\"content\" ms-scroll><h3><b>Name : </b>\n{{objDriverApplication.last_name}} {{objDriverApplication.first_name}} {{objDriverApplication.middle_name}}</h3><h3><b>\nDate of Birth : </b>{{objDriverApplication.dob | date:\'MM-dd-yyyy\'}}</h3><h3><b>Social Security Number : </b>\n{{objDriverApplication.Social_security_no}}</h3><h3><b>Social Security Number Photo copy : </b><a \nng-show=\"objDriverApplication.ss_image != null\" href=\"{{objDriverApplication.ss_image}}\" target=\"_blank\" \nerr-src=\"assets/images/no-image.png\" height=\"50px\" width=\"50px\" style=\"padding:2px\"><img \nsrc=\"{{objDriverApplication.ss_image}}\" err-src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.ss_image == null\" src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3><h3 \nng-if=\"objDriverApplication.current_address != null \"><b>Home Adddress : </b>{{objDriverApplication.current_address}}\n</h3><h3 ng-if=\"objDriverApplication.current_address == null || objDriverApplication.current_address == \'null\' \"><b>\nHome Adddress : </b><span ng-if=\"objDriverApplication.street != null \">{{objDriverApplication.street}}</span> <span \nng-if=\"objDriverApplication.city != null \">, {{objDriverApplication.city}} </span><span \nng-if=\"objDriverApplication.state != null \">,{{objDriverApplication.state}} </span><span \nng-if=\"objDriverApplication.zip != null \">,{{objDriverApplication.zip}}.</span></h3><h3><b>How Long?(years) : </b>\n{{objDriverApplication.how_long}}</h3><h3 ng-if=\"objDriverApplication.previous_address != null \"><b>\nPrevious Adddress : </b>{{objDriverApplication.previous_address}}</h3><h3 \nng-if=\"objDriverApplication.previous_address == null || objDriverApplication.previous_address == \'null\' \"><b>\nPrevious Addresses : </b><span ng-if=\"objDriverApplication.street1 != null \">{{objDriverApplication.street1}}</span> \n<span ng-if=\"objDriverApplication.city1 != null \">, {{objDriverApplication.city1}} </span><span \nng-if=\"objDriverApplication.state1 != null \">,{{objDriverApplication.state1}} </span><span \nng-if=\"objDriverApplication.zip1 != null \">,{{objDriverApplication.zip1}}.</span></h3><h3><b>How Long?(years) : </b>\n{{objDriverApplication.how_long1}}</h3><h3><b>Have you used any other SS#? : </b>{{objDriverApplication.other_ss}}</h3>\n<h3><b>Other Social Security Number : </b>{{objDriverApplication.other_social_security_no}}</h3><h3><b>\nAre you a US Citizen? : </b>{{objDriverApplication.US_Citizen}}</h3><h3><b>Are you a legal immigrant? : </b>\n{{objDriverApplication.legal_immigrant}}</h3><h3><b>Do you have the legal right to work in the United States? : </b>\n{{objDriverApplication.L_work_right}}</h3><h3><b>Driver License photo copy: </b></h3><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\"><h3><b>Front Image : </b><a \nng-show=\"objDriverApplication.front_side != null\" href=\"{{objDriverApplication.front_side}}\" target=\"_blank\" \nerr-src=\"assets/images/no-image.png\" height=\"50px\" width=\"50px\" style=\"padding:2px\"><img \nsrc=\"{{objDriverApplication.front_side}}\" err-src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.front_side == null\" src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3>\n</md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\"><h3><b>\nBack Image : </b><a ng-show=\"objDriverApplication.back_side != null\" href=\"{{objDriverApplication.back_side}}\" \ntarget=\"_blank\" err-src=\"assets/images/no-image.png\" height=\"50px\" width=\"50px\" style=\"padding:2px\"><img \nsrc=\"{{objDriverApplication.back_side}}\" err-src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.back_side == null\" src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3>\n</md-input-container></div><h3><b>Do you have CA ID card? : </b>{{objDriverApplication.is_ca_id}}</h3><h3><b>\nCA ID Card photo copy : </b></h3><div layout=\"row\" layout-wrap><md-input-container class=\"md-block\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-sm=\"50\"><h3><b>Front Image : </b><a ng-show=\"objDriverApplication.ca_id_image_front != null\" \nhref=\"{{objDriverApplication.ca_id_image_front}}\" target=\"_blank\" err-src=\"assets/images/no-image.png\" height=\"50px\" \nwidth=\"50px\" style=\"padding:2px\"><img src=\"{{objDriverApplication.ca_id_image_front}}\" \nerr-src=\"assets/images/no-image.png\" style=\"display:block;width:170px;height:170px;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.ca_id_image_front == null\" src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3>\n</md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\"><h3><b>\nBack Image : </b><a ng-show=\"objDriverApplication.ca_id_image_back != null\" \nhref=\"{{objDriverApplication.ca_id_image_back}}\" target=\"_blank\" err-src=\"assets/images/no-image.png\" height=\"50px\" \nwidth=\"50px\" style=\"padding:2px\"><img src=\"{{objDriverApplication.ca_id_image_back}}\" \nerr-src=\"assets/images/no-image.png\" style=\"display:block;width:170px;height:170px;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.ca_id_image_back == null\" src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3>\n</md-input-container></div><h3><b>V.I.N (vehicle Identification Number) : </b>{{objDriverApplication.vin_no}}</h3><h3>\n<b>VIN Image : </b><a ng-show=\"objDriverApplication.vin_no_image != null\" href=\"{{objDriverApplication.vin_no_image}}\" \ntarget=\"_blank\" err-src=\"assets/images/no-image.png\" height=\"50px\" width=\"50px\" style=\"padding:2px\"><img \nsrc=\"{{objDriverApplication.vin_no_image}}\" err-src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.vin_no_image == null\" src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3><h3><b>\nREAR Car License Image : </b><a ng-show=\"objDriverApplication.license_plat_image != null\" \nhref=\"{{objDriverApplication.license_plat_image}}\" target=\"_blank\" err-src=\"assets/images/no-image.png\" height=\"50px\" \nwidth=\"50px\" style=\"padding:2px\"><img src=\"{{objDriverApplication.license_plat_image}}\" \nerr-src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.license_plat_image == null\" src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3><h3><b>\nProof Of OwnerShip Image : </b><a ng-show=\"objDriverApplication.proof_of_ownership != null\" \nhref=\"{{objDriverApplication.proof_of_ownership}}\" target=\"_blank\" height=\"50px\" width=\"50px\" style=\"padding:2px\"><img \nsrc=\"{{objDriverApplication.proof_of_ownership}}\" err-src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.proof_of_ownership == null\" src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3><h3><b>\nInsurance Image : </b><a ng-show=\"objDriverApplication.proof_of_insurance != null\" \nhref=\"{{objDriverApplication.proof_of_insurance}}\" target=\"_blank\" height=\"50px\" width=\"50px\" style=\"padding:2px\"><img \nsrc=\"{{objDriverApplication.proof_of_insurance}}\" err-src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.proof_of_insurance == null\" src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3><h3><b>\nAre you working for Uber? : </b>{{objDriverApplication.uber}}</h3><h3><b>Are you working for Lyft? : </b>\n{{objDriverApplication.lyft}}</h3><h3><b>Are you working for any other delivery service company?</b>\n{{objDriverApplication.working_other_company}}</h3><h3><b>Company Name : </b>{{objDriverApplication.company_name}}</h3>\n<h3><b>How Long?(years) : </b>{{objDriverApplication.how_long_in_company}}</h3><h3><b>\nWhat is your Role in this Company? : </b>{{objDriverApplication.your_job_role}}</h3><h3><b>Employment Experience : </b>\n</h3><h3><b>Company 1 Name : </b>{{objDriverApplication.exp_company_name1}}</h3><h3><b>Dates of employed From : </b>\n{{objDriverApplication.exp_company_date_from1 | date:\'MM-dd-yyyy\'}} <b>To : </b>\n{{objDriverApplication.exp_company_date_to1 | date:\'MM-dd-yyyy\'}}</h3><h3><b>Company 2 Name : </b>\n{{objDriverApplication.exp_company_name2}}</h3><h3><b>Dates of employed From : </b>\n{{objDriverApplication.exp_company_date_from2 | date:\'MM-dd-yyyy\'}} <b>To : </b>\n{{objDriverApplication.exp_company_date_to2 | date:\'MM-dd-yyyy\'}}</h3><h3><b>Education: </b>\n{{objDriverApplication.Education}}</h3><h3><b>\nHave you been ever denied a license, permit or privilege to operate motor vehicle? : </b>\n{{objDriverApplication.denied}}</h3><h3><b>\nHas your driver’s license ever been suspended, revoked, placed on probation, or have you ever received a warning notice from the State that issued your license? : \n</b>{{objDriverApplication.suspended}}</h3><h3><b>Suspended Reason : </b>{{objDriverApplication.suspended_reason}}</h3>\n<h3><b>Have you had any accident in past 3 years? : </b>{{objDriverApplication.accident}}</h3><h3><b>\nAccident Details : </b>{{objDriverApplication.accident_reason}}</h3><h3><b>\nHave you had any TRAFFIC CONVICTIONS AND FORFEITURES in past 3 years (other than parking violation?) : </b>\n{{objDriverApplication.T_violation}}</h3><h3><b>Violation Details : </b>{{objDriverApplication.violation_details}}</h3>\n<h3><b>Have you ever been convicted of a felony? : </b>{{objDriverApplication.felony}}</h3><h3><b>Felony Details : </b>\n{{objDriverApplication.felony_details}}</h3><h3><b>\nEither as an adult or a juvenile, have you ever been detained for investigation, named as a suspect in a police report, held on suspicion, questioned, fingerprinted, or arrested by any Law Enforcement Agency? : \n</b>{{objDriverApplication.arrested}}</h3><h3><b>Arrested by Enforcement Agency Details : </b>\n{{objDriverApplication.arrested_details}}</h3><h3><b>Has anyone ever called the police on or about you? : </b>\n{{objDriverApplication.called_police}}</h3><h3><b>Called Police Details : </b>\n{{objDriverApplication.called_police_details}}</h3><h3><b>\nI will NOT hold accountable BaltoRx and/or its affiliates to cover any type of driving and/or traffic related violations, such as parking ticket, moving violation fees, dues, schooling, court fees, attorney’s fees, DUI fees, bail fees etc. It is my responsibilities to fulfill the obligations and I agree, : \n</b>{{objDriverApplication.agree_rule}}</h3><h3><b>Applicant Name : </b>{{objDriverApplication.applicant_name}}</h3>\n<h3><b>Applicant Email : </b>{{objDriverApplication.applicant_email}}</h3><h3><b>Applicant Signature : </b><a \nng-show=\"objDriverApplication.applicant_signature != null\" href=\"{{objDriverApplication.applicant_signature}}\" \ntarget=\"_blank\" height=\"50px\" width=\"50px\" style=\"padding:2px\"><img src=\"{{objDriverApplication.applicant_signature}}\" \nerr-src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.applicant_signature == null\" src=\"{{objDriverApplication.applicant_signature}}\" \nerr-src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3>\n</md-content></md-dialog-content><div class=\"footer\"><md-button class=\"md-raised md-primary\" \nng-click=\"DownloadApplication()\">Print</md-button></div></md-dialog><style>\n.footer {\r\n                position: fixed;\r\n                left: 0;\r\n                bottom: 0;\r\n                width: 100%;\r\n                color: white;\r\n                text-align: right;\r\n        }\n</style>");
$templateCache.put("app/main/Testimonial/dialogs/TestimonialDetail.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:800px;min-width:400px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Testimonial</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"closeModel1()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-content class=\"content\" ms-scroll><div \nstyle=\"padding-bottom:8px\"><h1 ng-if=\"objTestimonial.pharmacy == null\"><b>Patient Information</b></h1><h1 \nng-if=\"objTestimonial.pharmacy != null\"><b>Pharmacy Details</b></h1><hr><h3><b>Name :</b>\n {{objTestimonial.firstname}} {{objTestimonial.middlename || \'\'}} {{objTestimonial.lastname}}</h3><h3 \nng-if=\"objTestimonial.pharmacy != null\"><b>Pharmacy :</b> {{objTestimonial.pharmacy}}</h3><h3><b>Phone Number :</b>\n {{objTestimonial.phone_number}}</h3><h3><b>E-mail :</b> {{objTestimonial.email}}</h3><h3><b>City : </b>\n{{objTestimonial.city}}</h3><h3><b>State : </b>{{objTestimonial.state}}</h3></div><div style=\"padding-bottom:8px\"><h2>\n<b>How would you like your name to be displayed?</b></h2><h3 ng-if=\"objTestimonial.pharmacy == null\"><b>Name : </b>\n{{objTestimonial.name}}</h3><h3 ng-if=\"objTestimonial.pharmacy != null\"><b>Pharmacy Name : </b>\n{{objTestimonial.pharmacy_name}}</h3><h3 ng-if=\"objTestimonial.pharmacy != null\"><b>Pharmacist Name : </b>\n{{objTestimonial.Pharmacist_name}}</h3><h3><b>City : </b>{{objTestimonial.display_city}}</h3><h3><b>State : </b>\n{{objTestimonial.display_state}}</h3></div><div style=\"padding-bottom:8px\"><h3 ng-if=\"objTestimonial.pharmacy == null\">\n<b>\n1) Would you like to record a video up to 20 seconds describing your experience in receiving medications within hours from BaltoRx?\n</b></h3><h3 ng-if=\"objTestimonial.pharmacy != null\"><b>\n1) Would you like to record a video up to 20 seconds describing your experience in working with BaltoRx?</b></h3><h3><a\n target=\"_blank\" href=\"{{Path}}Testimonial/Video/{{objTestimonial.video_record}}\">{{objTestimonial.video_record}}</a>\n</h3></div><div style=\"padding-bottom:8px\"><h3 ng-if=\"objTestimonial.pharmacy == null\"><b>\n2) Would you like to record an audio clip up to 20 seconds describing your experience in receiving medications within hours from BaltoRx?\n</b></h3><h3 ng-if=\"objTestimonial.pharmacy != null\"><b>\n2) Would you like to record an audio clip up to 20 seconds describing your experience in working with BaltoRx?</b></h3>\n<h3><a target=\"_blank\" href=\"{{Path}}Testimonial/Audio/{{objTestimonial.audio_record}}\">{{objTestimonial.audio_record}}\n</a></h3></div><div style=\"padding-bottom:8px\"><h3 ng-if=\"objTestimonial.pharmacy == null\"><b>\n3) How was your experience receiving your medications within hours from BaltoRx?</b></h3><h3 \nng-if=\"objTestimonial.pharmacy != null\"><b>3) How was your experience working with BaltoRx?</b></h3><h3>\n{{objTestimonial.experience}}</h3></div><div style=\"padding-bottom:8px\"><h3 ng-if=\"objTestimonial.pharmacy == null\"><b>\nIs/was BaltoRx’s driver courteous?</b> {{objTestimonial.driver_courteous}}</h3><h3 \nng-if=\"objTestimonial.pharmacy != null\"><b>Are BaltoRx’s driver courteous?</b> {{objTestimonial.driver_courteous}}</h3>\n</div><div style=\"padding-bottom:8px\"><h3 ng-if=\"objTestimonial.pharmacy == null\"><b>\nWould you recommend to your friends and family?</b> {{objTestimonial.recommended}}</h3><h3 \nng-if=\"objTestimonial.pharmacy != null\"><b>Would you recommend to other friendly pharmacies in your network?</b>\n {{objTestimonial.recommended}}</h3></div><div style=\"padding-bottom:8px\"><h3><b>Comments : </b>\n{{objTestimonial.comments}}</h3></div><div style=\"padding-bottom:8px\"><h3><b>Would you like to add your picture?</b>\n</h3><h3><a target=\"_blank\" href=\"{{Path}}Testimonial/Image/{{objTestimonial.picture}}\"><img \nsrc=\"{{Path}}Testimonial/Image/{{objTestimonial.picture}}\"></a></h3></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo1\"></span> <span class=\"logo-text\">BaltoRx\n</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\">\n<h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader>\n<md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 \ntranslate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" \naria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"></span> <span class=\"logo-text\">BaltoRx</span></div>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"{{RoutePath}}MediaUploads/UserUpload/{{UserImage}}\" err-src=\"assets/images/avatars/profile.jpg\"></div><span \nclass=\"username\" hide-xs>{{UserName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs>\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-divider></md-menu-divider><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"ChangePssword()\">\nChannge Password</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"></span> <span class=\"logo-text\">BaltoRx\n</span></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\">\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"{{RoutePath}}MediaUploads/UserUpload/{{UserImage}}\" err-src=\"assets/images/avatars/profile.jpg\"></div><span \nclass=\"username\" hide-xs>{{UserName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs>\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-divider></md-menu-divider><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"ChangePssword()\">\nChannge Password</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"></div><span \nclass=\"username\" hide-xs>{{UserName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs>\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-divider></md-menu-divider><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"ChangePssword()\">\nChannge Password</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\r\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\r\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\r\n\r\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </div>\r\n\r\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\r\n           ng-if=\"node.uisref && node.title\">\r\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\r\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\r\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\r\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\r\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\r\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\r\n            ng-include=\"\'navigation-nested.html\'\"></li>\r\n    </ul>\n</script>");
$templateCache.put("app/main/DemandOrder/dialogs/OrderDetailInformation/DemandOrderControllerDetailInformation.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:1000px;min-width:600px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Order Id {{lstorderInformation.order_id}} Information</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-content \nclass=\"content\" ms-scroll><div style=\"padding-bottom:8px\"><h1><b>Pharmacy Information</b></h1><hr><h3><b>Name :</b>\n {{lstorderInformation.pharmacy_name || \'-\'}}</h3><h3><b>Latitude :</b>\n {{lstorderInformation.pharmacy_latitude || \'-\'}}</h3><h3><b>Logitude :</b>\n {{lstorderInformation.pharmacy_longitude || \'-\'}}</h3><h3><b>Address : </b>\n{{lstorderInformation.pharmacy_address || \'-\'}}</h3><h3><b>Payment Status : </b>\n{{lstorderInformation.pharmacy_payment_status || \'-\'}}</h3><h3><b>Pick up note: </b>\n{{lstorderInformation.pickup_note || \"-\" }}</h3></div><div style=\"padding:8px\" \nng-if=\"lstorderInformation.type == \'hospital\'\"><h1><b>Hospital Information</b></h1><hr><h3><b>Name :</b>\n {{lstorderInformation.hospital_name || \'-\'}}</h3><h3><b>Hospital Number : </b>\n{{lstorderInformation.hospital_number || \'-\'}}</h3></div><div style=\"padding:8px\"><h1><b>Patient Information</b></h1>\n<hr><h3><b>Patient-1 Name: :</b>\n {{lstorderInformation.patients[0].first_name || \'-\'}} {{lstorderInformation.patients[0].middle_name}} {{lstorderInformation.patients[0].last_name}}\n</h3><h3><b>Patient-2 Name :</b>\n {{lstorderInformation.patients[1].first_name || \'-\'}} {{lstorderInformation.patients[1].middle_name}} {{lstorderInformation.patients[1].last_name}}\n</h3><h3><b>Patient-3 Name : </b>\n{{lstorderInformation.patients[2].first_name || \'-\'}} {{lstorderInformation.patients[2].middle_name}} {{lstorderInformation.patients[2].last_name}}\n</h3><h3><b>Address : </b>{{lstorderInformation.patient_address || lstorderInformation.patient_address1 || \'-\'}}</h3>\n<h3><b>Phone Number :</b> {{lstorderInformation.patient_phone_number || \'-\'}}</h3><h3><b>Drop off note: </b>\n{{lstorderInformation.dropoff_note || \"-\" }}</h3></div><div style=\"padding:8px\"><h1><b>Order Information</b></h1><hr>\n<h3><b>Order Id :</b> {{lstorderInformation.order_id || \'-\'}}</h3><h3><b>Order Person Name :</b>\n {{lstorderInformation.pharmacy[0].pharmacy_order_person_name || \'-\' }}</h3><h3><b>Order Person Role :</b>\n {{lstorderInformation.pharmacy[0].pharmacy_order_person_title || \'-\' }}</h3><h3><b>Instructions :</b>\n {{lstorderInformation.instructions || \'-\' }}</h3><h3><b>Prescriptions :</b>\n {{lstorderInformation.total_number_of_prescriptions}} <a href=\"{{lstorderInformation.prescriptions_list_image}}\" \ntarget=\"_blank\" \nng-if=\"lstorderInformation.prescriptions_list_image!=\'\' && lstorderInformation.prescriptions_list_image!=null\">View</a>\n</h3><h3><b>Delivery Type : </b>{{lstorderInformation.delivery_type}}</h3><h3><b>Left at Image/ Signature :</b> <img \nsrc=\"{{lstorderInformation.signature}}\" height=\"200px\" width=\"200px\" alt=\"\"></h3><h3><b>\nInstructions : {{lstorderInformation.instructions || \"-\" }}</b></h3></div><div style=\"padding:8px\" \nng-if=\"lstorderInformation.is_demand_order\"><h1><b>Driver Information</b></h1><hr><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id==null  \"><b>Driver Name :</b> {{lstorderInformation.driver_name}}\n</h3><h3 ng-if=\"lstorderInformation.lyft_delivery_order_id!=null\"><b>Driver Name :</b>\n {{lstorderInformation.driver_name}}</h3><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id!=null&&lstorderInformation.lyftInfo.driver.phone_number\"><b>\nDriver Phone no :</b> {{lstorderInformation.doordash_data.data.phone_number}}</h3><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id==null&&lstorderInformation.driver_image!=null\"><b>Driver Image :</b> \n<a href=\"{{lstorderInformation.signature}}\" target=\"_blank\"><img ng-src=\"{{lstorderInformation.driver_image }}\" \nerr-src=\"assets/images/no-image.png\" height=\"200px\" width=\"200px\"></a></h3><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id==null\"><b>Driver Status :</b> {{lstorderInformation.driver_status }}\n</h3><h3><b>Drop-off note : </b>{{ lstorderInformation.dropoff_note }}</h3><h3><b>pick-up note : </b>\n{{ lstorderInformation.pickup_note }}</h3><h3 ng-if=\"lstorderInformation.lyftInfo.status\"><b>Order delivery status : \n</b>{{ORDER_STATUS[lstorderInformation.lyftInfo.status]}}</h3><h3 ng-if=\"\"><b>Picked up at : </b>\n{{storderInformation.doordash_data.pickup_time_actual | date:\'MMM dd yyyy , hh:mm a\' }}</h3><h3 ng-if=\"\"><b>\nDropoff at : </b>{{storderInformation.doordash_data.dropoff_time_actual | date:\'MMM dd yyyy , hh:mm a\' }}</h3><h3><b>\nInstructions : </b>{{ lstorderInformation.instructions }}</h3><h3 ng-if=\"\"><b>Failure reason : </b>\n{{ lstorderInformation.lyft_failure_reason }}</h3></div><div style=\"padding:8px\"><h1><b>Charges Information</b></h1>\n<hr><h3><b>Miles :</b> {{lstorderInformation.chargesdetails[0].miles || \'0.00\'}}</h3><h3><b>Miles Charges($) :</b>\n ${{ lstorderInformation.chargesdetails[0].miles_charges || \'0\'| number:2 }}</h3><h3><b>Prescription : </b>\n{{ lstorderInformation.chargesdetails[0].prescription || \'0\'}}</h3><h3><b>Prescription Charges($): </b>\n${{lstorderInformation.chargesdetails[0].prescription_charges || \'0\'| number:2 }}</h3><h3><b>Patient Charges($) : </b>\n${{ lstorderInformation.chargesdetails[0].patient_charges || \'0\'| number:2 }}</h3><h3><b>Min-Charges($) :</b>\n ${{ lstorderInformation.chargesdetails[0].mini_charges || \'0\'| number:2 }}</h3><h3><b>Extra ETA :</b>\n {{lstorderInformation.chargesdetails[0].ETA || \'0.00\'}}</h3><h3><b>Extra Mile Charges($ ) : </b>\n${{lstorderInformation.chargesdetails[0].ETA_charges || \'0\'| number:2 }}</h3><h3><b>Return Order Charges($) : </b>\n${{lstorderInformation.chargesdetails[0].return_order_charges || \'0\'| number:2 }}</h3><h3 \nng-if=\"lstorderInformation.chargesdetails[0].additional_charges\"><b>Additional charges($) : </b>\n${{lstorderInformation.chargesdetails[0].additional_charges || \'0\'| number:2 }}</h3><h3><b>Total Charges($) : </b>\n${{lstorderInformation.chargesdetails[0].total_charge || \'0\'| number:2 }}</h3></div></md-content></md-dialog-content>\n</md-dialog><style>\nh1 {\r\n        font-family: cursive;\r\n    }\r\n\r\n    .footer {\r\n        position: fixed;\r\n        left: 0;\r\n        bottom: 0;\r\n        width: 100%;\r\n        color: white;\r\n        text-align: center;\r\n    }\n</style>");
$templateCache.put("app/main/DemandOrder/dialogs/OrderDetails/DemandOrderDetails.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:800px;min-width:400px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Order Details</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"closeModel1()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-content class=\"content\" ms-scroll><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border cell-border hover\" dt-options=\"dtOptionsOrderDetails\" datatable=\"ng\" width=\"100%\"><thead>\n<tr><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Order Id</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Miles</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Perscription</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Patient</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Min-Charges ($)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Extra Mile Charges ($)</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Extra ETA</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Prescription Charges ($)</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Patient Charges ($)</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Return Charges ($)</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total Charges ($)</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"item in getOrderDetailData\"><td style=\"text-align: center\">{{ $index + 1 }}</td><td \nstyle=\"text-align: center\">{{item.order_id}}</td><td style=\"text-align: center\">{{item.miles}}</td><td \nstyle=\"text-align: center\">{{item.prescription}}</td><td style=\"text-align: center\">{{item.patient}}</td><td \nstyle=\"text-align: center\">{{item.mini_charges}}</td><td style=\"text-align: center\">{{item.miles_charges}}</td><td \nstyle=\"text-align: center\">{{item.ETA_charges}}</td><td style=\"text-align: center\">{{item.prescription_charges}}</td>\n<td style=\"text-align: center\">{{item.patient_charges}}</td><td style=\"text-align: center\">\n{{item.return_order_charges}}</td><td style=\"text-align: center\">{{item.total_charge}}</td></tr></tbody></table></div>\n</div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Driver/dialogs/DriverAnnouncement/DriverAnnouncement.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:800px;min-width:400px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Send Announcement</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><form name=\"formAnnouncement\" novalidate \nclass=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><div layout=\"row\" layout-wrap><md-input-container \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><label>Title</label><input type=\"text\" name=\"title\" \nng-model=\"model.title\" required maxlength=\"100\" md-maxlength=\"100\"><div ng-messages=\"formAnnouncement.title.$error\" \nng-if=\"formAnnouncement.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Title field is required</span>\n</div></div></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><label>Announcement Message</label><textarea ng-model=\"model.message\" md-select-on-focus required>\n</textarea><div ng-messages=\"formAnnouncement.message.$error\" ng-if=\"formAnnouncement.message.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span>Announcement message field is required</span></div></div></md-input-container></div>\n<div align=\"center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!formAnnouncement.$valid\" \nng-click=\"SendAnnouncement(model.title,model.message)\">Send</md-button><md-button class=\"md-accent md-raised\" \nng-click=\"initModel()\">Reset</md-button><md-button class=\"md-raised md-warn\" ng-click=\"closeModel()\">Cancel</md-button>\n</div></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Driver/dialogs/DriverApplicationDetail/DriverApplicationDetail.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:800px;min-width:400px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Driver Application</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"closeModel1()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-content class=\"content\" ms-scroll><h3><b>Name : </b>\n{{objDriverApplication.last_name}} {{objDriverApplication.first_name}} {{objDriverApplication.middle_name}}</h3><h3><b>\nDate of Birth : </b>{{objDriverApplication.dob | date:\'MM-dd-yyyy\'}}</h3><h3><b>Social Security Number : </b>\n{{objDriverApplication.Social_security_no}}</h3><h3><b>Social Security Number Photo copy : </b><a \nng-show=\"objDriverApplication.ss_image != null\" href=\"{{objDriverApplication.ss_image}}\" target=\"_blank\" \nerr-src=\"assets/images/no-image.png\" height=\"50px\" width=\"50px\" style=\"padding:2px\"><img \nsrc=\"{{objDriverApplication.ss_image}}\" err-src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.ss_image == null\" src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3><h3 \nng-if=\"objDriverApplication.current_address != null \"><b>Home Adddress : </b>{{objDriverApplication.current_address}}\n</h3><h3 ng-if=\"objDriverApplication.current_address == null || objDriverApplication.current_address == \'null\' \"><b>\nHome Adddress : </b><span ng-if=\"objDriverApplication.street != null \">{{objDriverApplication.street}}</span> <span \nng-if=\"objDriverApplication.city != null \">, {{objDriverApplication.city}} </span><span \nng-if=\"objDriverApplication.state != null \">,{{objDriverApplication.state}} </span><span \nng-if=\"objDriverApplication.zip != null \">,{{objDriverApplication.zip}}.</span></h3><h3><b>How Long?(years) : </b>\n{{objDriverApplication.how_long}}</h3><h3 ng-if=\"objDriverApplication.previous_address != null \"><b>\nPrevious Adddress : </b>{{objDriverApplication.previous_address}}</h3><h3 \nng-if=\"objDriverApplication.previous_address == null || objDriverApplication.previous_address == \'null\' \"><b>\nPrevious Addresses : </b><span ng-if=\"objDriverApplication.street1 != null \">{{objDriverApplication.street1}}</span> \n<span ng-if=\"objDriverApplication.city1 != null \">, {{objDriverApplication.city1}} </span><span \nng-if=\"objDriverApplication.state1 != null \">,{{objDriverApplication.state1}} </span><span \nng-if=\"objDriverApplication.zip1 != null \">,{{objDriverApplication.zip1}}.</span></h3><h3><b>How Long?(years) : </b>\n{{objDriverApplication.how_long1}}</h3><h3><b>Have you used any other SS#? : </b>{{objDriverApplication.other_ss}}</h3>\n<h3><b>Other Social Security Number : </b>{{objDriverApplication.other_social_security_no}}</h3><h3><b>\nAre you a US Citizen? : </b>{{objDriverApplication.US_Citizen}}</h3><h3><b>Are you a legal immigrant? : </b>\n{{objDriverApplication.legal_immigrant}}</h3><h3><b>Do you have the legal right to work in the United States? : </b>\n{{objDriverApplication.L_work_right}}</h3><h3><b>Driver License photo copy: </b></h3><div layout=\"row\" layout-wrap>\n<md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\"><h3><b>Front Image : </b><a \nng-show=\"objDriverApplication.front_side != null\" href=\"{{objDriverApplication.front_side}}\" target=\"_blank\" \nerr-src=\"assets/images/no-image.png\" height=\"50px\" width=\"50px\" style=\"padding:2px\"><img \nsrc=\"{{objDriverApplication.front_side}}\" err-src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.front_side == null\" src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3>\n</md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\"><h3><b>\nBack Image : </b><a ng-show=\"objDriverApplication.back_side != null\" href=\"{{objDriverApplication.back_side}}\" \ntarget=\"_blank\" err-src=\"assets/images/no-image.png\" height=\"50px\" width=\"50px\" style=\"padding:2px\"><img \nsrc=\"{{objDriverApplication.back_side}}\" err-src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.back_side == null\" src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3>\n</md-input-container></div><h3><b>Do you have CA ID card? : </b>{{objDriverApplication.is_ca_id}}</h3><h3><b>\nCA ID Card photo copy : </b></h3><div layout=\"row\" layout-wrap><md-input-container class=\"md-block\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-sm=\"50\"><h3><b>Front Image : </b><a ng-show=\"objDriverApplication.ca_id_image_front != null\" \nhref=\"{{objDriverApplication.ca_id_image_front}}\" target=\"_blank\" err-src=\"assets/images/no-image.png\" height=\"50px\" \nwidth=\"50px\" style=\"padding:2px\"><img src=\"{{objDriverApplication.ca_id_image_front}}\" \nerr-src=\"assets/images/no-image.png\" style=\"display:block;width:170px;height:170px;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.ca_id_image_front == null\" src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3>\n</md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\"><h3><b>\nBack Image : </b><a ng-show=\"objDriverApplication.ca_id_image_back != null\" \nhref=\"{{objDriverApplication.ca_id_image_back}}\" target=\"_blank\" err-src=\"assets/images/no-image.png\" height=\"50px\" \nwidth=\"50px\" style=\"padding:2px\"><img src=\"{{objDriverApplication.ca_id_image_back}}\" \nerr-src=\"assets/images/no-image.png\" style=\"display:block;width:170px;height:170px;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.ca_id_image_back == null\" src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3>\n</md-input-container></div><h3><b>V.I.N (vehicle Identification Number) : </b>{{objDriverApplication.vin_no}}</h3><h3>\n<b>VIN Image : </b><a ng-show=\"objDriverApplication.vin_no_image != null\" href=\"{{objDriverApplication.vin_no_image}}\" \ntarget=\"_blank\" err-src=\"assets/images/no-image.png\" height=\"50px\" width=\"50px\" style=\"padding:2px\"><img \nsrc=\"{{objDriverApplication.vin_no_image}}\" err-src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.vin_no_image == null\" src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3><h3><b>\nREAR Car License Image : </b><a ng-show=\"objDriverApplication.license_plat_image != null\" \nhref=\"{{objDriverApplication.license_plat_image}}\" target=\"_blank\" err-src=\"assets/images/no-image.png\" height=\"50px\" \nwidth=\"50px\" style=\"padding:2px\"><img src=\"{{objDriverApplication.license_plat_image}}\" \nerr-src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.license_plat_image == null\" src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3><h3><b>\nProof Of OwnerShip Image : </b><a ng-show=\"objDriverApplication.proof_of_ownership != null\" \nhref=\"{{objDriverApplication.proof_of_ownership}}\" target=\"_blank\" height=\"50px\" width=\"50px\" style=\"padding:2px\"><img \nsrc=\"{{objDriverApplication.proof_of_ownership}}\" err-src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.proof_of_ownership == null\" src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3><h3><b>\nInsurance Image : </b><a ng-show=\"objDriverApplication.proof_of_insurance != null\" \nhref=\"{{objDriverApplication.proof_of_insurance}}\" target=\"_blank\" height=\"50px\" width=\"50px\" style=\"padding:2px\"><img \nsrc=\"{{objDriverApplication.proof_of_insurance}}\" err-src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.proof_of_insurance == null\" src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3><h3><b>\nAre you working for Uber? : </b>{{objDriverApplication.uber}}</h3><h3><b>Are you working for Lyft? : </b>\n{{objDriverApplication.lyft}}</h3><h3><b>Are you working for any other delivery service company?</b>\n{{objDriverApplication.working_other_company}}</h3><h3><b>Company Name : </b>{{objDriverApplication.company_name}}</h3>\n<h3><b>How Long?(years) : </b>{{objDriverApplication.how_long_in_company}}</h3><h3><b>\nWhat is your Role in this Company? : </b>{{objDriverApplication.your_job_role}}</h3><h3><b>Employment Experience : </b>\n</h3><h3><b>Company 1 Name : </b>{{objDriverApplication.exp_company_name1}}</h3><h3><b>Dates of employed From : </b>\n{{objDriverApplication.exp_company_date_from1 | date:\'MM-dd-yyyy\'}} <b>To : </b>\n{{objDriverApplication.exp_company_date_to1 | date:\'MM-dd-yyyy\'}}</h3><h3><b>Company 2 Name : </b>\n{{objDriverApplication.exp_company_name2}}</h3><h3><b>Dates of employed From : </b>\n{{objDriverApplication.exp_company_date_from2 | date:\'MM-dd-yyyy\'}} <b>To : </b>\n{{objDriverApplication.exp_company_date_to2 | date:\'MM-dd-yyyy\'}}</h3><h3><b>Education: </b>\n{{objDriverApplication.Education}}</h3><h3><b>\nHave you been ever denied a license, permit or privilege to operate motor vehicle? : </b>\n{{objDriverApplication.denied}}</h3><h3><b>\nHas your driver’s license ever been suspended, revoked, placed on probation, or have you ever received a warning notice from the State that issued your license? : \n</b>{{objDriverApplication.suspended}}</h3><h3><b>Suspended Reason : </b>{{objDriverApplication.suspended_reason}}</h3>\n<h3><b>Have you had any accident in past 3 years? : </b>{{objDriverApplication.accident}}</h3><h3><b>\nAccident Details : </b>{{objDriverApplication.accident_reason}}</h3><h3><b>\nHave you had any TRAFFIC CONVICTIONS AND FORFEITURES in past 3 years (other than parking violation?) : </b>\n{{objDriverApplication.T_violation}}</h3><h3><b>Violation Details : </b>{{objDriverApplication.violation_details}}</h3>\n<h3><b>Have you ever been convicted of a felony? : </b>{{objDriverApplication.felony}}</h3><h3><b>Felony Details : </b>\n{{objDriverApplication.felony_details}}</h3><h3><b>\nEither as an adult or a juvenile, have you ever been detained for investigation, named as a suspect in a police report, held on suspicion, questioned, fingerprinted, or arrested by any Law Enforcement Agency? : \n</b>{{objDriverApplication.arrested}}</h3><h3><b>Arrested by Enforcement Agency Details : </b>\n{{objDriverApplication.arrested_details}}</h3><h3><b>Has anyone ever called the police on or about you? : </b>\n{{objDriverApplication.called_police}}</h3><h3><b>Called Police Details : </b>\n{{objDriverApplication.called_police_details}}</h3><h3><b>\nI will NOT hold accountable BaltoRx and/or its affiliates to cover any type of driving and/or traffic related violations, such as parking ticket, moving violation fees, dues, schooling, court fees, attorney’s fees, DUI fees, bail fees etc. It is my responsibilities to fulfill the obligations and I agree, : \n</b>{{objDriverApplication.agree_rule}}</h3><h3><b>Applicant Name : </b>{{objDriverApplication.applicant_name}}</h3>\n<h3><b>Applicant Email : </b>{{objDriverApplication.applicant_email}}</h3><h3><b>Applicant Signature : </b><a \nng-show=\"objDriverApplication.applicant_signature != null\" href=\"{{objDriverApplication.applicant_signature}}\" \ntarget=\"_blank\" height=\"50px\" width=\"50px\" style=\"padding:2px\"><img src=\"{{objDriverApplication.applicant_signature}}\" \nerr-src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"> </a><img \nng-show=\"objDriverApplication.applicant_signature == null\" src=\"{{objDriverApplication.applicant_signature}}\" \nerr-src=\"assets/images/no-image.png\" \nstyle=\"display:block;width:170px;height:170px;margin-left:auto;margin-right:auto;border-bottom: none\"></h3>\n</md-content></md-dialog-content><div class=\"footer\"><md-button class=\"md-raised md-primary\" \nng-click=\"DownloadApplication()\">Print</md-button></div></md-dialog><style>\n.footer {\r\n        position: fixed;\r\n        left: 0;\r\n        bottom: 0;\r\n        width: 100%;\r\n        color: white;\r\n        text-align: right;\r\n    }\n</style>");
$templateCache.put("app/main/Hospice/dialogs/pharmacyAnnouncement/pharmacyAnnouncement.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:800px;min-width:400px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Send Announcement</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><form name=\"formAnnouncement\" novalidate \nclass=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><div layout=\"row\" layout-wrap><md-input-container \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><label>Title</label><input type=\"text\" name=\"title\" \nng-model=\"model.title\" required maxlength=\"100\" md-maxlength=\"100\"><div ng-messages=\"formAnnouncement.title.$error\" \nng-if=\"formAnnouncement.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Title field is required</span>\n</div></div></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><label>Announcement Message</label><textarea ng-model=\"model.message\" md-select-on-focus required>\n</textarea><div ng-messages=\"formAnnouncement.message.$error\" ng-if=\"formAnnouncement.message.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span>Announcement message field is required</span></div></div></md-input-container></div>\n<div align=\"center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!formAnnouncement.$valid\" \nng-click=\"Announcement()\">Send</md-button><md-button class=\"md-accent md-raised\" ng-click=\"initModel()\">Reset\n</md-button><md-button class=\"md-raised md-warn\" ng-click=\"closeModel()\">Cancel</md-button></div></form>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/Hospice/dialogs/pharmacyEdit/pharmacyEdit.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:800px;min-width:400px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Update Billing Period and Payment Period Days</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><form \nname=\"AddStatusForm\" novalidate class=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\"><label>Billing Days</label>\n<input type=\"number\" name=\"billing_period_days\" ng-model=\"model.billing_period_days\" min=\"0\" required><div \nng-messages=\"AddStatusForm.billing_period_days.$error\" ng-if=\"AddStatusForm.billing_period_days.$touched\"><div \nng-message=\"required\"><span>Billing Days is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\"><label>Payment Days</label><input type=\"number\" \nname=\"payment_period_days\" ng-model=\"model.payment_period_days\" min=\"0\" required><div \nng-messages=\"AddStatusForm.payment_period_days.$error\" ng-if=\"AddStatusForm.payment_period_days.$touched\"><div \nng-message=\"required\"><span>Payment days is required</span></div></div></md-input-container></div><div align=\"center\">\n<md-button class=\"md-raised md-primary\" ng-disabled=\"!AddStatusForm.$valid\" ng-click=\"AddDays()\">Save</md-button>\n<md-button class=\"md-raised md-warn\" ng-click=\"closeModel()\">Cancel</md-button></div></form></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/Hospital/dialogs/HospitalAnnouncement/HospitalAnnouncement.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:800px;min-width:400px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Send Announcement</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><form name=\"formAnnouncement\" novalidate \nclass=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><div layout=\"row\" layout-wrap><md-input-container \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><label>Title</label><input type=\"text\" name=\"title\" \nng-model=\"model.title\" required maxlength=\"100\" md-maxlength=\"100\"><div ng-messages=\"formAnnouncement.title.$error\" \nng-if=\"formAnnouncement.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Title field is required</span>\n</div></div></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><label>Announcement Message</label><textarea ng-model=\"model.message\" md-select-on-focus required>\n</textarea><div ng-messages=\"formAnnouncement.message.$error\" ng-if=\"formAnnouncement.message.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span>Announcement message field is required</span></div></div></md-input-container></div>\n<div align=\"center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!formAnnouncement.$valid\" \nng-click=\"Announcement()\">Send</md-button><md-button class=\"md-accent md-raised\" ng-click=\"initModel()\">Reset\n</md-button><md-button class=\"md-raised md-warn\" ng-click=\"closeModel()\">Cancel</md-button></div></form>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/Invoice/dialogs/invoiceUpdate/invoiceUpdate.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:800px;min-width:400px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Update Payment Mode for Invoice No: {{ invoice_no }}</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div id=\"loaderDiv\" ng-if=\"show_loader\"><div \nclass=\"loading-spiner\"><img src=\"../../../assets/images/loader.gif\" \nstyle=\"margin-left: 25rem;height: 150px;\r\n        width: 150px\"></div></div><md-dialog-content ms-scroll><form \nname=\"AddStatusForm\" novalidate class=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\"><label>Payment Type:\n</label><md-select name=\"payment_type\" ng-model=\"model.payment_type\" required><md-option value=\"\" disabled=\"disabled\">\nSelect Payment Type</md-option><md-option value=\"cheque\"><md-icon md-font-icon=\"icon-payment\" class=\"blue-500-fg\">\n</md-icon>Cheque</md-option><md-option value=\"cash\"><md-icon md-font-icon=\"icon-payment\" class=\"blue-500-fg\"></md-icon>\nCash</md-option><md-option value=\"CC in VT\"><md-icon md-font-icon=\"icon-payment\" class=\"blue-500-fg\"></md-icon>CC in VT\n</md-option><md-option value=\"zelle\"><md-icon md-font-icon=\"icon-payment\" class=\"blue-500-fg\"></md-icon>Zelle\n</md-option></md-select><div ng-messages=\"AddStatusForm.payment_mode.$error\" \nng-if=\"AddStatusForm.payment_mode.$touched\"><div ng-message=\"required\"><span>Payment mode is required</span></div>\n</div></md-input-container></div><div align=\"center\"><md-button class=\"md-raised md-primary\" \nng-disabled=\"!AddStatusForm.$valid\" ng-click=\"save()\">Save</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"closeModel()\">Cancel</md-button></div></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Order/dialogs/OrderDetailInformation/OrderDetailInformation.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:1000px;min-width:600px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Order Id {{lstorderInformation.order_id}} Information</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-content \nclass=\"content\" ms-scroll><div style=\"padding-bottom:8px\"><h1><b>Pharmacy Information</b></h1><hr><h3><b>Name :</b>\n {{lstorderInformation.pharmacy_name || \'-\'}}</h3><h3><b>Latitude :</b>\n {{lstorderInformation.pharmacy_latitude || \'-\'}}</h3><h3><b>Logitude :</b>\n {{lstorderInformation.pharmacy_longitude || \'-\'}}</h3><h3><b>Address : </b>\n{{lstorderInformation.pharmacy_address || \'-\'}}</h3><h3><b>Payment Status : </b>\n{{lstorderInformation.pharmacy_payment_status || \'-\'}}</h3><h3><b>Pick up note: </b>\n{{lstorderInformation.pickup_note || \"-\" }}</h3></div><div style=\"padding:8px\" \nng-if=\"lstorderInformation.type == \'hospital\'\"><h1><b>Hospital Information</b></h1><hr><h3><b>Name :</b>\n {{lstorderInformation.hospital_name || \'-\'}}</h3><h3><b>Hospital Number : </b>\n{{lstorderInformation.hospital_number || \'-\'}}</h3></div><div style=\"padding:8px\"><h1><b>Patient Information</b></h1>\n<hr><h3><b>Patient-1 Name: :</b>\n {{lstorderInformation.patients[0].first_name || \'-\'}} {{lstorderInformation.patients[0].middle_name}} {{lstorderInformation.patients[0].last_name}}\n</h3><h3><b>Patient-2 Name :</b>\n {{lstorderInformation.patients[1].first_name || \'-\'}} {{lstorderInformation.patients[1].middle_name}} {{lstorderInformation.patients[1].last_name}}\n</h3><h3><b>Patient-3 Name : </b>\n{{lstorderInformation.patients[2].first_name || \'-\'}} {{lstorderInformation.patients[2].middle_name}} {{lstorderInformation.patients[2].last_name}}\n</h3><h3><b>Address : </b>{{lstorderInformation.patient_address || lstorderInformation.patient_address1 || \'-\'}}</h3>\n<h3><b>Phone Number :</b> {{lstorderInformation.patient_phone_number || \'-\'}}</h3><h3><b>Drop off note: </b>\n{{lstorderInformation.dropoff_note || \"-\" }}</h3></div><div style=\"padding:8px\"><h1><b>Order Information</b></h1><hr>\n<h3><b>Order Id :</b> {{lstorderInformation.order_id || \'-\'}}</h3><h3><b>Order Person Name :</b>\n {{lstorderInformation.pharmacy[0].pharmacy_order_person_name || \'-\' }}</h3><h3><b>Order Person Role :</b>\n {{lstorderInformation.pharmacy[0].pharmacy_order_person_title || \'-\' }}</h3><h3><b>Instructions :</b>\n {{lstorderInformation.instructions || \'-\' }}</h3><h3><b>Prescriptions :</b>\n {{lstorderInformation.total_number_of_prescriptions}} <a href=\"{{lstorderInformation.prescriptions_list_image}}\" \ntarget=\"_blank\" \nng-if=\"lstorderInformation.prescriptions_list_image!=\'\' && lstorderInformation.prescriptions_list_image!=null\">View</a>\n</h3><h3><b>Medication List :</b> <span ng-if=\"lstorderInformation.medication_list\"><span \nng-repeat=\"item in lstorderInformation.medication_list\">{{item}} <span ng-if=\"!$last\">,</span></span></span></h3><h3>\n<b>Delivery Type : </b>{{lstorderInformation.delivery_type}}</h3><h3><b>Left at Image/ Signature : </b><a \nng-if=\"lstorderInformation.lyft_delivery_order_id!==null\" \nhref=\"{{lstorderInformation.doordash_data.data.dropoff_verification_image_url}}\" target=\"_blank\"><img \nng-src=\"{{lstorderInformation.doordash_data.data.dropoff_verification_image_url}}\" \nerr-src=\"assets/images/no-image.png\" height=\"200px\" width=\"200px\"></a><a \nng-if=\"lstorderInformation.lyft_delivery_order_id==null\" href=\"{{lstorderInformation.lyftInfo.signature}}\" \ntarget=\"_blank\"><img ng-src=\"{{lstorderInformation.signature}}\" err-src=\"assets/images/no-image.png\" height=\"200px\" \nwidth=\"200px\"></a></h3><h3><b>Instructions : {{lstorderInformation.instructions || \"-\" }}</b></h3></div><div \nstyle=\"padding:8px\" ng-if=\"lstorderInformation.lyft_delivery_order_id!=null\"><h1><b>Driver Information</b></h1><hr><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id==null || lstorderInformation.lyftInfo.status ==\'dropped_off\' \"><b>\nDriver Name :</b> {{lstorderInformation.driver_name}}</h3><h3 ng-if=\"lstorderInformation.lyft_delivery_order_id!=null\">\n<b>Driver Name :</b> {{lstorderInformation.driver_name}}</h3><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id!==null&&lstorderInformation.doordash_data.data.dasher_dropoff_phone_number\">\n<b>Driver Phone no :</b> {{lstorderInformation.doordash_data.data.dasher_dropoff_phone_number}}</h3><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id==null&&lstorderInformation.driver_image!=null\"><b>Driver Iamge :</b> \n<a href=\"{{lstorderInformation.signature}}\" target=\"_blank\"><img ng-src=\"{{lstorderInformation.driver_image }}\" \nerr-src=\"assets/images/no-image.png\" height=\"200px\" width=\"200px\"></a></h3><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id!=null && lstorderInformation.lyft_delivery_status === \'DASHER_CONFIRMED\' \">\n<b>Driver Status :</b> Dasher Accepted</h3><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id!=null && lstorderInformation.lyft_delivery_status === \'DASHER_ENROUTE_TO_PICKUP\' \">\n<b>Driver Status :</b> Dasher enroute to pickup</h3><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id!=null && lstorderInformation.lyft_delivery_status === \'DASHER_CONFIRMED_PICKUP_ARRIVAL\' \">\n<b>Driver Status :</b> Dasher Arrived at Pickup</h3><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id!=null && lstorderInformation.lyft_delivery_status === \'DASHER_PICKED_UP\' \">\n<b>Driver Status :</b>Delivery Picked Up</h3><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id!=null && lstorderInformation.lyft_delivery_status === \'DASHER_ENROUTE_TO_DROPOFF\' \">\n<b>Driver Status :</b> Dasher Enroute to Dropoff</h3><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id!=null && lstorderInformation.lyft_delivery_status === \'DASHER_CONFIRMED_DROPOFF_ARRIVAL\' \">\n<b>Driver Status :</b> Dasher Arrived at Dropoff</h3><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id!=null && lstorderInformation.lyft_delivery_status === \'DASHER_DROPPED_OFF\' \">\n<b>Driver Status :</b> Delivered</h3><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id!=null && lstorderInformation.lyft_delivery_status === \'DELIVERY_CANCELLED\'\">\n<b>Driver Status :</b> Canceled</h3><h3 ng-if=\"lstorderInformation.lyft_delivery_order_id==null\"><b>Driver Status :</b>\n {{lstorderInformation.driver_status }}</h3><h3><b>Drop-off note : </b>{{ lstorderInformation.dropoff_note }}</h3><h3>\n<b>pick-up note : </b>{{ lstorderInformation.pickup_note }}</h3><h3 \nng-if=\"lstorderInformation.lyftInfo.arrived_pickup\"><b>Arrived Picked up at : </b>\n{{lstorderInformation.lyftInfo.arrived_pickup.time_ms | date:\'MMM dd yyyy , hh:mm a\' }}</h3><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id!==null&&lstorderInformation.doordash_data.data.pickup_time_estimated\">\n<b>Pickup estimated at : </b>\n{{lstorderInformation.doordash_data.data.pickup_time_estimated | date:\'MMM dd yyyy , hh:mm a\' }}</h3><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id!==null&&lstorderInformation.doordash_data.data.dropoff_time_estimated\">\n<b>Dropoff estimated at : </b>\n{{lstorderInformation.doordash_data.data.dropoff_time_estimated | date:\'MMM dd yyyy , hh:mm a\' }}</h3><h3><b>\nInstructions : </b>{{ lstorderInformation.instructions }}</h3><h3 \nng-if=\"lstorderInformation.lyft_failure_reason!=null\"><b>Failure reason : </b>\n{{ lstorderInformation.lyft_failure_reason }}</h3></div><div style=\"padding:8px\"><h1><b>Charges Information</b></h1>\n<hr><h3><b>Miles :</b> {{lstorderInformation.chargesdetails[0].miles || \'0.00\'}}</h3><h3><b>Miles Charges($) :</b>\n ${{ lstorderInformation.chargesdetails[0].miles_charges || \'0\'| number:2 }}</h3><h3><b>Prescription : </b>\n{{ lstorderInformation.chargesdetails[0].prescription || \'0\'}}</h3><h3><b>Prescription Charges($): </b>\n${{lstorderInformation.chargesdetails[0].prescription_charges || \'0\'| number:2 }}</h3><h3><b>Patient Charges($) : </b>\n${{ lstorderInformation.chargesdetails[0].patient_charges || \'0\'| number:2 }}</h3><h3><b>Min-Charges($) :</b>\n ${{ lstorderInformation.chargesdetails[0].mini_charges || \'0\'| number:2 }}</h3><h3><b>Extra ETA :</b>\n {{lstorderInformation.chargesdetails[0].ETA || \'0.00\'}}</h3><h3><b>Extra Mile Charges($ ) : </b>\n${{lstorderInformation.chargesdetails[0].ETA_charges || \'0\'| number:2 }}</h3><h3><b>Return Order Charges($) : </b>\n${{lstorderInformation.chargesdetails[0].return_order_charges || \'0\'| number:2 }}</h3><h3 \nng-if=\"lstorderInformation.chargesdetails[0].gas_surcharge\"><b>Gas surcharges($) : </b>\n${{lstorderInformation.chargesdetails[0].gas_surcharge || \'0\'| number:2 }}</h3><h3><b>Total Charges($) : </b>\n${{lstorderInformation.chargesdetails[0].total_charge || \'0\'| number:2 }}</h3></div><div \nng-if=\"lstorderInformation.co_pay ==\'yes\'\" style=\"padding:8px\"><h1><b>Co-pay Charges Information</b></h1><hr><h3><b>\nCo-pay Pre-authorized Amount :</b> {{lstorderInformation.auto_approve_co_pay_amount || \'0.00\'}}</h3><h3><b>\nCo-pay actual amount :</b> {{lstorderInformation.co_pay_amount || \'0.00\'}}</h3><h3><b>Co-pay by :</b>\n {{lstorderInformation.co_pay_by || \'0.00\'}}</h3></div></md-content></md-dialog-content></md-dialog><style>\nh1 {\r\n        font-family: cursive;\r\n    }\r\n    \r\n    .footer {\r\n        position: fixed;\r\n        left: 0;\r\n        bottom: 0;\r\n        width: 100%;\r\n        color: white;\r\n        text-align: center;\r\n    }\n</style>");
$templateCache.put("app/main/Patient/dialogs/OneTimeOrderDetailInformation/OneTimeOrderDetailInformation.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:1000px;min-width:600px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Order Id Information</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-content class=\"content\" ms-scroll><div \nstyle=\"padding-bottom:8px\"><h1><b>Pharmacy Information</b></h1><hr><h3><b>Name : </b>{{data.pharmacy_name || \'-\'}}</h3>\n<h3><b>Latitude : </b>{{data.pharmacy_latitude || \'-\'}}</h3><h3><b>Logitude : </b>{{data.pharmacy_longitude || \'-\'}}\n</h3><h3><b>Address : </b>{{data.pharmacy_address || \'-\'}}</h3><h3><b>Payment Status : </b>\n{{data.payment_status || \'-\'}}</h3><h3><b>Pharmacy Charge($) : </b>{{data.pharmacy_charge || \'-\'}}</h3></div><div \nstyle=\"padding:8px\"><h1><b>Driver Information</b></h1><hr><h3><b>Name : </b>{{data.driver_name || \'-\'}}</h3><h3 \nng-if=\"data.driver_image!=\'\' && data.driver_image!=null\"><b>Image : </b><a href=\"{{data.driver_image}}\" \ntarget=\"_blank\">View</a></h3><h3><b>Status : </b>{{data.driver_status || \'-\'}}</h3><h3><b>Delivery Date & Time : </b>\n{{data.delivery_date ||\'-\' | date:\"MM-dd-yyyy hh:mm::ss a\"}}</h3></div><div style=\"padding:8px\"><h1><b>\nPatient Information</b></h1><hr><h3><b>Patient Name : </b>\n{{data.patient_firstname || \'-\'}} {{data.patient_middlename}} {{data.patient_lastname}}</h3><h3><b>Address : </b>\n{{data.patient_address|| data.patient_address1 || \'-\'}}</h3><h3><b>Phone Number : </b>\n{{data.patient_phone_number || \'-\'}}</h3><h3><b>Latitude : </b>{{data.patient_latitude ||\'-\'}}</h3><h3><b>Longitude : \n</b>{{data.patient_longitude || \'-\'}}</h3></div><div style=\"padding:8px\"><h1><b>Order Information</b></h1><hr><h3><b>\nOrder Id : </b>{{data.order_id || \'-\'}}</h3><h3><b>Ordering Person Name : </b>{{data.ordering_personnel}}</h3><h3><b>\nTotal Number Of Prescriptions : </b>{{data.total_number_of_prescriptions || \'-\' }}</h3><h3><b>Distance : </b>\n{{data.distance || \'-\' }}</h3><h3><b>Pickedup At : </b>{{data.pickedup_at || \'-\' | date:\"MM-dd-yyyy hh:mm::ss a\" }}\n</h3><h3><b>Delivered At : </b>{{data.delivered_at || \'-\' | date:\"MM-dd-yyyy hh:mm::ss a\"}}</h3><h3 \nstyle=\"display:flex\"><b>Order Status :</b><div ng-if=\"data.order_status == -2\">Co-pay Verification</div><div \nng-if=\"data.order_status == -1\">Co-pay Approval</div><div ng-if=\"data.order_status == 7\">Co-pay Direct to Pharmacy\n</div><div ng-if=\"data.order_status == 1\">New</div><div ng-if=\"data.order_status == 2\">OnHold</div><div \nng-if=\"data.order_status == 3\">Ready to Pick</div><div ng-if=\"data.order_status == 4\">Driver Picked Up</div><div \nng-if=\"data.order_status == 5\">Completed</div><div ng-if=\"data.order_status == 6\">Canceled</div></h3><h3><b>\nPharmacy Payment Status : </b>{{data.pharmacy_payment_status || \'-\' }}</h3></div></md-content></md-dialog-content>\n</md-dialog><style>\nh1 {\r\n        font-family: cursive;\r\n    }\r\n    \r\n    .footer {\r\n        position: fixed;\r\n        left: 0;\r\n        bottom: 0;\r\n        width: 100%;\r\n        color: white;\r\n        text-align: center;\r\n    }\n</style>");
$templateCache.put("app/main/Order/dialogs/OrderDetails/OrderDetails.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:800px;min-width:400px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Order Details</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"closeModel1()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-content class=\"content\" ms-scroll><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border cell-border hover\" dt-options=\"dtOptionsOrderDetails\" datatable=\"ng\" width=\"100%\"><thead>\n<tr><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Order Id</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Miles</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Perscription</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Patient</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Min-Charges ($)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Extra Mile Charges ($)</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Extra ETA</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Prescription Charges ($)</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Patient Charges ($)</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Return Charges ($)</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total Charges ($)</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"item in getOrderDetailData\"><td style=\"text-align: center\">{{ $index + 1 }}</td><td \nstyle=\"text-align: center\">{{item.order_id}}</td><td style=\"text-align: center\">{{item.miles}}</td><td \nstyle=\"text-align: center\">{{item.prescription}}</td><td style=\"text-align: center\">{{item.patient}}</td><td \nstyle=\"text-align: center\">{{item.mini_charges}}</td><td style=\"text-align: center\">{{item.miles_charges}}</td><td \nstyle=\"text-align: center\">{{item.ETA_charges}}</td><td style=\"text-align: center\">{{item.prescription_charges}}</td>\n<td style=\"text-align: center\">{{item.patient_charges}}</td><td style=\"text-align: center\">\n{{item.return_order_charges}}</td><td style=\"text-align: center\">{{item.total_charge}}</td></tr></tbody></table></div>\n</div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Patient/dialogs/ReFillOrderDetailInformation/ReFillOrderDetailInformation.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:1000px;min-width:600px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Order Id Information</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-content class=\"content\" ms-scroll><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border cell-border hover\" dt-options=\"dtOptionsOrderDetails\" datatable=\"ng\" width=\"100%\"><thead>\n<tr><th class=\"all\" style=\"text-align: center\"><div class=\"table-header\"><span class=\"column-title\">No</span></div>\n</th><th class=\"secondary-text\" style=\"text-align: center\"><div class=\"table-header\"><span class=\"column-title\">\nOrder Id</span></div></th><th class=\"secondary-text\" style=\"text-align: center\"><div class=\"table-header\"><span \nclass=\"column-title\">Order Request On</span></div></th></tr></thead><tbody><tr ng-repeat=\"item in lstorderInformation\">\n<td style=\"text-align: center\">{{$index +1}}</td><td style=\"text-align: center\">{{item.order_id}}</td><td \nstyle=\"text-align: center\">{{item.created_on | date:\"MM-dd-yyyy hh:mm:ss a\"}}</td></tr></tbody></table></div></div>\n</md-content></md-dialog-content></md-dialog><style>\nh1 {\r\n        font-family: cursive;\r\n    }\r\n    \r\n    .footer {\r\n        position: fixed;\r\n        left: 0;\r\n        bottom: 0;\r\n        width: 100%;\r\n        color: white;\r\n        text-align: center;\r\n    }\n</style>");
$templateCache.put("app/main/Patient/dialogs/PreferedPharmacyDetailInformation/PreferedPharmacyDetailInformation.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:1000px;min-width:600px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Preffered Pharmacy Information</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-content class=\"content\" ms-scroll><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border cell-border hover\" dt-options=\"dtOptionsOrderDetails\" datatable=\"ng\" width=\"100%\"><thead>\n<tr><th class=\"all\" style=\"text-align: center\"><div class=\"table-header\"><span class=\"column-title\">No</span></div>\n</th><th class=\"secondary-text\" style=\"text-align: center\"><div class=\"table-header\"><span class=\"column-title\">Name\n</span></div></th><th class=\"secondary-text\" style=\"text-align: center\"><div class=\"table-header\"><span \nclass=\"column-title\">Address</span></div></th><th class=\"secondary-text\" style=\"text-align: center\"><div \nclass=\"table-header\"><span class=\"column-title\">State</span></div></th><th class=\"secondary-text\" \nstyle=\"text-align: center\"><div class=\"table-header\"><span class=\"column-title\">City</span></div></th><th \nclass=\"secondary-text\" style=\"text-align: center\"><div class=\"table-header\"><span class=\"column-title\">Zip</span></div>\n</th><th class=\"secondary-text\" style=\"text-align: center\"><div class=\"table-header\"><span class=\"column-title\">\nMobile Number</span></div></th></tr></thead><tbody><tr ng-repeat=\"item in lstorderInformation\"><td \nstyle=\"text-align: center\">{{$index +1}}</td><td style=\"text-align: center\">{{item.pharmacy_name}}</td><td \nstyle=\"text-align: center\">{{item.pharmacy_address}}</td><td style=\"text-align: center\">{{item.pharmacy_state}}</td><td\n style=\"text-align: center\">{{item.pharmacy_city}}</td><td style=\"text-align: center\">{{item.pharmacy_zip_code}}</td>\n<td style=\"text-align: center\">{{item.pharmacy_mobilenumber}}</td></tr></tbody></table></div></div></md-content>\n</md-dialog-content></md-dialog><style>\nh1 {\r\n        font-family: cursive;\r\n    }\r\n    \r\n    .footer {\r\n        position: fixed;\r\n        left: 0;\r\n        bottom: 0;\r\n        width: 100%;\r\n        color: white;\r\n        text-align: center;\r\n    }\n</style>");
$templateCache.put("app/main/Pharmacy/dialogs/pharmacyAnnouncement/pharmacyAnnouncement.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:800px;min-width:400px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Send Announcement</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><form name=\"formAnnouncement\" novalidate \nclass=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><div layout=\"row\" layout-wrap><md-input-container \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><label>Title</label><input type=\"text\" name=\"title\" \nng-model=\"model.title\" required maxlength=\"100\" md-maxlength=\"100\"><div ng-messages=\"formAnnouncement.title.$error\" \nng-if=\"formAnnouncement.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Title field is required</span>\n</div></div></md-input-container></div><div layout=\"row\" layout-wrap><md-input-container flex=\"100\" flex-gt-sm=\"100\" \nflex-gt-md=\"100\"><label>Announcement Message</label><textarea ng-model=\"model.message\" md-select-on-focus required>\n</textarea><div ng-messages=\"formAnnouncement.message.$error\" ng-if=\"formAnnouncement.message.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span>Announcement message field is required</span></div></div></md-input-container></div>\n<div align=\"center\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!formAnnouncement.$valid\" \nng-click=\"Announcement()\">Send</md-button><md-button class=\"md-accent md-raised\" ng-click=\"initModel()\">Reset\n</md-button><md-button class=\"md-raised md-warn\" ng-click=\"closeModel()\">Cancel</md-button></div></form>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/Pharmacy/dialogs/pharmacyEdit/pharmacyEdit.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:800px;min-width:400px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Update Billing Period and Payment Period Days</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><form \nname=\"AddStatusForm\" novalidate class=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><div layout=\"row\" \nlayout-wrap><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\"><label>Billing Days</label>\n<input type=\"number\" name=\"billing_period_days\" ng-model=\"model.billing_period_days\" min=\"0\" required><div \nng-messages=\"AddStatusForm.billing_period_days.$error\" ng-if=\"AddStatusForm.billing_period_days.$touched\"><div \nng-message=\"required\"><span>Billing Days is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-sm=\"50\"><label>Payment Days</label><input type=\"number\" \nname=\"payment_period_days\" ng-model=\"model.payment_period_days\" min=\"0\" required><div \nng-messages=\"AddStatusForm.payment_period_days.$error\" ng-if=\"AddStatusForm.payment_period_days.$touched\"><div \nng-message=\"required\"><span>Payment days is required</span></div></div></md-input-container></div><div align=\"center\">\n<md-button class=\"md-raised md-primary\" ng-disabled=\"!AddStatusForm.$valid\" ng-click=\"AddDays()\">Save</md-button>\n<md-button class=\"md-raised md-warn\" ng-click=\"closeModel()\">Cancel</md-button></div></form></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/PickupOrder/dialogs/OrderDetailInformation/PickupOrderControllerDetailInformation.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:1000px;min-width:600px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Order Id {{lstorderInformation.order_id}} Information</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-content \nclass=\"content\" ms-scroll><div style=\"padding-bottom:8px\"><h1><b>Pharmacy Information</b></h1><hr><h3><b>Name :</b>\n {{lstorderInformation.pharmacy_name || \'-\'}}</h3><h3><b>Latitude :</b>\n {{lstorderInformation.pharmacy_latitude || \'-\'}}</h3><h3><b>Logitude :</b>\n {{lstorderInformation.pharmacy_longitude || \'-\'}}</h3><h3><b>Address : </b>\n{{lstorderInformation.pharmacy_address || \'-\'}}</h3><h3><b>Payment Status : </b>\n{{lstorderInformation.pharmacy_payment_status || \'-\'}}</h3><h3><b>Pick up note: </b>\n{{lstorderInformation.pickup_note || \"-\" }}</h3></div><div style=\"padding:8px\" \nng-if=\"lstorderInformation.type == \'hospital\'\"><h1><b>Hospital Information</b></h1><hr><h3><b>Name :</b>\n {{lstorderInformation.hospital_name || \'-\'}}</h3><h3><b>Hospital Number : </b>\n{{lstorderInformation.hospital_number || \'-\'}}</h3></div><div style=\"padding:8px\"><h1><b>Patient Information</b></h1>\n<hr><h3><b>Patient-1 Name: :</b>\n {{lstorderInformation.patients[0].first_name || \'-\'}} {{lstorderInformation.patients[0].middle_name}} {{lstorderInformation.patients[0].last_name}}\n</h3><h3><b>Patient-2 Name :</b>\n {{lstorderInformation.patients[1].first_name || \'-\'}} {{lstorderInformation.patients[1].middle_name}} {{lstorderInformation.patients[1].last_name}}\n</h3><h3><b>Patient-3 Name : </b>\n{{lstorderInformation.patients[2].first_name || \'-\'}} {{lstorderInformation.patients[2].middle_name}} {{lstorderInformation.patients[2].last_name}}\n</h3><h3><b>Address : </b>{{lstorderInformation.patient_address || lstorderInformation.patient_address1 || \'-\'}}</h3>\n<h3><b>Phone Number :</b> {{lstorderInformation.patient_phone_number || \'-\'}}</h3><h3><b>Drop off note: </b>\n{{lstorderInformation.dropoff_note || \"-\" }}</h3></div><div style=\"padding:8px\"><h1><b>Order Information</b></h1><hr>\n<h3><b>Order Id :</b> {{lstorderInformation.order_id || \'-\'}}</h3><h3><b>Order Person Name :</b>\n {{lstorderInformation.pharmacy[0].pharmacy_order_person_name || \'-\' }}</h3><h3><b>Order Person Role :</b>\n {{lstorderInformation.pharmacy[0].pharmacy_order_person_title || \'-\' }}</h3><h3><b>Instructions :</b>\n {{lstorderInformation.instructions || \'-\' }}</h3><h3><b>Pickup Item Descriptions :</b>\n {{lstorderInformation.itemToPick || \'-\'}}</h3><h3><b>Quantity:</b>\n {{lstorderInformation.total_number_of_prescriptions}} <a href=\"{{lstorderInformation.prescriptions_list_image}}\" \ntarget=\"_blank\" \nng-if=\"lstorderInformation.prescriptions_list_image!=\'\' && lstorderInformation.prescriptions_list_image!=null\">View</a>\n</h3><h3><b>Delivery Type : </b>{{lstorderInformation.delivery_type}}</h3><h3><b>Left at Image/ Signature :</b> <img \nsrc=\"{{lstorderInformation.signature}}\" height=\"200px\" width=\"200px\" alt=\"\"></h3><h3><b>\nInstructions : {{lstorderInformation.instructions || \"-\" }}</b></h3></div><div style=\"padding:8px\" \nng-if=\"lstorderInformation.is_demand_order\"><h1><b>Driver Information</b></h1><hr><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id==null  \"><b>Driver Name :</b> {{lstorderInformation.driver_name}}\n</h3><h3 ng-if=\"lstorderInformation.lyft_delivery_order_id!=null\"><b>Driver Name :</b>\n {{lstorderInformation.driver_name}}</h3><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id!=null&&lstorderInformation.lyftInfo.driver.phone_number\"><b>\nDriver Phone no :</b> {{lstorderInformation.doordash_data.data.phone_number}}</h3><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id==null&&lstorderInformation.driver_image!=null\"><b>Driver Image :</b> \n<a href=\"{{lstorderInformation.signature}}\" target=\"_blank\"><img ng-src=\"{{lstorderInformation.driver_image }}\" \nerr-src=\"assets/images/no-image.png\" height=\"200px\" width=\"200px\"></a></h3><h3 \nng-if=\"lstorderInformation.lyft_delivery_order_id==null\"><b>Driver Status :</b> {{lstorderInformation.driver_status }}\n</h3><h3><b>Drop-off note : </b>{{ lstorderInformation.dropoff_note }}</h3><h3><b>pick-up note : </b>\n{{ lstorderInformation.pickup_note }}</h3><h3 ng-if=\"lstorderInformation.lyftInfo.status\"><b>Order delivery status : \n</b>{{ORDER_STATUS[lstorderInformation.lyftInfo.status]}}</h3><h3 ng-if=\"\"><b>Picked up at : </b>\n{{storderInformation.doordash_data.pickup_time_actual | date:\'MMM dd yyyy , hh:mm a\' }}</h3><h3 ng-if=\"\"><b>\nDropoff at : </b>{{storderInformation.doordash_data.dropoff_time_actual | date:\'MMM dd yyyy , hh:mm a\' }}</h3><h3><b>\nInstructions : </b>{{ lstorderInformation.instructions }}</h3><h3 ng-if=\"\"><b>Failure reason : </b>\n{{ lstorderInformation.lyft_failure_reason }}</h3></div><div style=\"padding:8px\"><h1><b>Charges Information</b></h1>\n<hr><h3><b>Miles :</b> {{lstorderInformation.chargesdetails[0].miles || \'0.00\'}}</h3><h3><b>Miles Charges($) :</b>\n ${{ lstorderInformation.chargesdetails[0].miles_charges || \'0\'| number:2 }}</h3><h3><b>Prescription : </b>\n{{ lstorderInformation.chargesdetails[0].prescription || \'0\'}}</h3><h3><b>Prescription Charges($): </b>\n${{lstorderInformation.chargesdetails[0].prescription_charges || \'0\'| number:2 }}</h3><h3><b>Patient Charges($) : </b>\n${{ lstorderInformation.chargesdetails[0].patient_charges || \'0\'| number:2 }}</h3><h3><b>Min-Charges($) :</b>\n ${{ lstorderInformation.chargesdetails[0].mini_charges || \'0\'| number:2 }}</h3><h3><b>Extra ETA :</b>\n {{lstorderInformation.chargesdetails[0].ETA || \'0.00\'}}</h3><h3><b>Extra Mile Charges($ ) : </b>\n${{lstorderInformation.chargesdetails[0].ETA_charges || \'0\'| number:2 }}</h3><h3><b>Return Order Charges($) : </b>\n${{lstorderInformation.chargesdetails[0].return_order_charges || \'0\'| number:2 }}</h3><h3 \nng-if=\"lstorderInformation.chargesdetails[0].additional_charges\"><b>Additional charges($) : </b>\n${{lstorderInformation.chargesdetails[0].additional_charges || \'0\'| number:2 }}</h3><h3><b>Total Charges($) : </b>\n${{lstorderInformation.chargesdetails[0].total_charge || \'0\'| number:2 }}</h3></div></md-content></md-dialog-content>\n</md-dialog><style>\nh1 {\r\n        font-family: cursive;\r\n    }\r\n\r\n    .footer {\r\n        position: fixed;\r\n        left: 0;\r\n        bottom: 0;\r\n        width: 100%;\r\n        color: white;\r\n        text-align: center;\r\n    }\n</style>");
$templateCache.put("app/main/PickupOrder/dialogs/OrderDetails/PickupOrderDetails.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:800px;min-width:400px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Order Details</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"closeModel1()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-content class=\"content\" ms-scroll><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border cell-border hover\" dt-options=\"dtOptionsOrderDetails\" datatable=\"ng\" width=\"100%\"><thead>\n<tr><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">No</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Order Id</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Miles</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Perscription</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Patient</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Min-Charges ($)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Extra Mile Charges ($)</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Extra ETA</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Prescription Charges ($)</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Patient Charges ($)</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Return Charges ($)</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total Charges ($)</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"item in getOrderDetailData\"><td style=\"text-align: center\">{{ $index + 1 }}</td><td \nstyle=\"text-align: center\">{{item.order_id}}</td><td style=\"text-align: center\">{{item.miles}}</td><td \nstyle=\"text-align: center\">{{item.prescription}}</td><td style=\"text-align: center\">{{item.patient}}</td><td \nstyle=\"text-align: center\">{{item.mini_charges}}</td><td style=\"text-align: center\">{{item.miles_charges}}</td><td \nstyle=\"text-align: center\">{{item.ETA_charges}}</td><td style=\"text-align: center\">{{item.prescription_charges}}</td>\n<td style=\"text-align: center\">{{item.patient_charges}}</td><td style=\"text-align: center\">\n{{item.return_order_charges}}</td><td style=\"text-align: center\">{{item.total_charge}}</td></tr></tbody></table></div>\n</div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/Roles/dialogs/RemoveCountryModel/RemoveCountryModel.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><h2>Manage Country</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-content class=\"widget-page\"><md-content><form name=\"formImport\" \nclass=\"md-inline-form\"><md-content class=\"md-padding\"><md-input-container class=\"md-block\" flex-gt-sm=\"50\"><label>\nCountry</label><md-select name=\"Country\" ng-model=\"model.Country\"><md-option value=\"All\">All</md-option><md-option \nng-repeat=\"o in lstCountry\" value=\"{{o.Country}}\">{{o.Country}}</md-option></md-select></md-input-container><md-button \nclass=\"md-raised md-primary\" ng-disabled=\"!formImport.$valid\" ng-click=\"SaveCountry(model.Country)\">Save</md-button>\n</md-content></form><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptions\" \ndt-column-defs=\"CountrydtColumnDefs1\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">\nNo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Country</span>\n</div></th><th class=\"all\"><div class=\"table-header\"><span class=\"column-title\">Action</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"item in lstCountryData\"><td style=\"width: 4%; text-align: center\">{{$index+1}}</td><td>{{item}}\n</td><td style=\"width: 4%; text-align: center\"><md-button class=\"md-icon-button md-raised md-warn md-raised md-hue-2\" \nng-if=\"vm.FlgDeletedAccess\" ng-click=\"DeleteCountry(item)\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button>\n</td></tr></tbody></table></md-content></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/ScheduleDelivery/dialog/ChangeDriver/ChangeDriver.html","<md-dialog aria-label=\"New Task\" class=\"task-dialog\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><h2>Assign/Change Driver for #{{lstData1.bucket_no}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll class=\"white-bg\"><md-content class=\"widget-page\"><div>\n<lable>Select Driver Name</lable></div><md-input-container class=\"md-block\"><md-select ng-model=\"model._id\" \nname=\"drivername\" aria-label=\"driver\" style=\"border-bottom: 0.5px solid black\"><md-option ng-value=\"\">\n----- Select Driver -----</md-option><md-option ng-value=\"item._id\" \nng-repeat=\"item in lstAllDriver | filter:vm.search \"><span>\n{{item.first_name }} {{item.middle_name}} {{ item.last_name}}</span></md-option></md-select></md-input-container><div \nalign=\"left\"><md-button class=\"md-raised md-primary\" ng-click=\"UpdateDriverName()\" ng-disabled=\"model._id == null\">save\n</md-button><md-button class=\"md-raised md-warn\" ng-click=\"Reset()\">cancel</md-button></div></md-content>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/ScheduleDelivery/dialog/ViewScheduleDelivery/ViewScheduleDelivery.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"max-width: fit-content;width: fit-content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Delivery Schedule For b#{{bucket_no}}</h2><span flex>\n</span><md-button ng-if=\"optimizedRouteWaypoints\" class=\"md-icon-button\" ng-click=\"openRoute()\"><md-icon \nmd-font-icon=\"icon-directions\" aria-label=\"Open bingmap route\" style=\"font-size: xx-large\"></md-icon></md-button>\n<md-button class=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-content class=\"content\" ms-scroll><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border cell-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\">\n<thead><tr><th class=\"all\"><div class=\"table-header\" style=\"text-align: center\"><span class=\"column-title\">No</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\" style=\"text-align: center\"><span class=\"column-title\" \nstyle=\"text-align: center\">Order Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" \nstyle=\"text-align: center\"><span class=\"column-title\">Delivery Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\" style=\"text-align: center\"><span class=\"column-title\">Delivered Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\" style=\"text-align: center\"><span class=\"column-title\">Delivery Type\n</span></div></th><th class=\"secondary-text\" width=\"auto\"><div class=\"table-header\" style=\"text-align: center\"><span \nclass=\"column-title\">Patient Details</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Instructions</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Image/Signature</span></div></th><th class=\"secondary-text\"><div class=\"table-header\" \nstyle=\"text-align: center\"><span class=\"column-title\">Billing Status</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\" style=\"text-align: center\"><span class=\"column-title\">Order Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\" style=\"text-align: center\"><span class=\"column-title\">Action</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"item in lstdata1\"><td style=\"text-align: center\">{{ $index + 1 }}</td><td\n style=\"text-align: center\">{{item.order_ids}}</td><td style=\"text-align: center\" width=\"20%\">\n{{item.displayDeliveryDate }}</td><td style=\"text-align: center\" width=\"20%\">\n{{item.delivered_at ||\'-\' | date: \'MM/dd/yyyy hh:mm:ss a\'}}</td><td style=\"text-align: center\">\n{{item.delivery_type ||\'-\'}}</td><td style=\"text-align: left\" width=\"15%\"><b>Name : </b>\n{{item.patients[0].first_name }} {{item.patients[0].last_name}} {{item.patients[0].middle_name}}<br><b>Address : </b>\n{{item.patient_address1}}<br><b>City : </b>{{item.patient_city}}<br><b>State : </b>{{item.patient_state}}<br></td><td \nstyle=\"text-align: center\">{{item.instructions ||\'-\'}}</td><td align=\"certer\"><a href=\"{{item.signature}}\" \ntarget=\"_blank\"><img style=\"width: 195px\" ng-src=\"{{item.signature}}\" err-src=\"assets/images/no-image.png\"></a></td>\n<td><span style=\"text-align:center;font-size: 15px;background-color:#fF7330;color:white;padding:5px\" \nng-if=\"item.billing_status == \'Pending\' || item.billing_status == \'pending\'\">{{item.billing_status }}</span> <span \nstyle=\"text-align: center;font-size: 15px;background-color: green;color:white;padding:5px\" \nng-if=\"item.billing_status == \'Billing\' || item.billing_status == \'billing\'\">{{item.billing_status }}</span> <span \nstyle=\"text-align: center;font-size: 15px;background-color: blue;color:white;padding:5px\" \nng-if=\"item.billing_status == \'Completed\' || item.billing_status == \'completed\'\">{{item.billing_status }}</span></td>\n<td ng-if=\"item.order_status == -2\" width=\"15%\"><span \nstyle=\"text-align: center;font-size: 15px; background-color:#ff9790 ;color:white;padding:5px\">Co-pay Verification\n</span></td><td ng-if=\"item.order_status == -1\" width=\"15%\"><span \nstyle=\"text-align: center;font-size: 15px;background-color: #ceb5f9 ; color:white;padding:5px\">Co-pay Approval</span>\n</td><td ng-if=\"item.order_status == 1  && item.type!=\'pharmacy\'\" width=\"15%\"><span \nstyle=\"text-align: center;font-size: 15px;background-color:  #00bde3;color:white;padding:5px\">New</span></td><td \nng-if=\"item.order_status == 1   && item.type==\'pharmacy\' \" width=\"15%\"><span \nstyle=\"text-align: center;font-size: 15px;background-color: #00bde3;\r\n                                    color:white;padding:5px\">\nWaiting</span></td><td ng-if=\"item.order_status == 2\" width=\"15%\"><span \nstyle=\"text-align: center;font-size: 15px;background-color: rgba(255, 0, 0.1); color:white;padding:5px\">OnHold</span>\n</td><td ng-if=\"item.order_status == 3\" width=\"15%\"><span \nstyle=\"text-align: center;font-size: 15px;background-color: orange;color:white;padding:5px\">Ready to Pick-Up</span>\n</td><td ng-if=\"item.order_status == 4\" width=\"17%\"><span \nstyle=\"text-align: center;font-size: 15px;background-color: green;color:white;padding:5px\">Driver Picked Up</span></td>\n<td ng-if=\"item.order_status == 5\" width=\"15%\"><span \nstyle=\"text-align: center;font-size: 15px;background-color: blue;color:white;padding:5px\">Completed </span><br><br>\n<span style=\"text-align: center\"><b>Receiver Name : </b>{{item.acceptorname || \'-\' }}</span><br><span \nstyle=\"text-align: center\"><b>Relationship with Patient : </b>{{item.patient_relations || \'-\' }}</span></td><td \nng-if=\"item.order_status == 6\" width=\"15%\"><span \nstyle=\"text-align: center;font-size: 15px;background-color: red;color:white;padding:5px\">Cancelled</span></td><td \nng-if=\"item.order_status == 8\" width=\"15%\"><span \nstyle=\"text-align: center;font-size: 15px;background-color:  rgb(100, 205, 157);color:white;padding:5px\">Return Pending\n</span></td><td ng-if=\"item.order_status == 9\" width=\"25%\"><span \nstyle=\"text-align: center;font-size: 15px;background-color:  rgb(210, 190, 119);color:white;padding:5px\">\nReturn Completed</span><br><br><span style=\"text-align: center\"><b>Date : </b>\n{{item.return_at[0].recived_at || \'-\' | date: \'MM/dd/yyyy hh:mm:ss a\'}}</span><br><span style=\"text-align: center\"><b>\nReceiver Name : </b>{{item.return_at[0].recived_name}}</span><br><span style=\"text-align: center\"><b>Return Reason : \n</b>{{item.return_at[0].reason}}</span></td><td ng-if=\"item.order_status !== 5\"><div \nstyle=\"margin-top: 20px; text-align: center\"><input type=\"file\" id=\"fileInput\" \nonchange=\"angular.element(this).scope().fileChanged(event)\"> <input type=\"datetime-local\" id=\"dateTimeInput\" \nng-model=\"item.deliveryDateTime\"> <button class=\"md-button md-raised md-primary\" \nng-click=\"submitFile(item.order_ids, item.deliveryDateTime)\">Make Deliver</button></div></td><td \nng-if=\"item.order_status == 5\"><div style=\"margin-top: 20px; text-align: center\"><p>-</p></div></td></tr></tbody>\n</table></div></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/SuggestPharmacy/dialogs/suggestpharmacyEdit/suggestpharmacyEdit.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:800px;min-width:400px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Suggest Pharmacy Edit Email</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><div id=\"loaderDiv\" ng-if=\"show_loader\"><div class=\"loading-spiner\"><img \nsrc=\"../../../assets/images/loader.gif\" style=\"margin-left: 25rem;height: 150px;\r\n        width: 150px\"></div></div>\n<md-dialog-content ms-scroll><form name=\"AddStatusForm\" novalidate class=\"ms-stepper\" aria-invalid=\"false\" \nstyle=\"padding: 24px\"><div layout=\"row\" layout-wrap><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-sm=\"50\"><label>Edit Email</label><input type=\"text\" name=\"old_email\" ng-model=\"model.old_email\" \nvalue=\"model.old_email\" required><div ng-messages=\"AddStatusForm.old_email.$error\" \nng-if=\"AddStatusForm.old_email.$touched\"><div ng-message=\"required\"><span>Email is required</span></div></div>\n</md-input-container></div><div align=\"center\"><md-button class=\"md-raised md-primary\" \nng-disabled=\"!AddStatusForm.$valid\" ng-click=\"save()\">Save</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"closeModel()\">Cancel</md-button></div></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/ScheduleDelivery/dialog/LyftBatchingDelivery/LyftBatchingDelivery.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"max-width: fit-content;width: fit-content\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Delivery Schedule For #{{bucket_no}}</h2><span flex>\n</span><md-button ng-if=\"bingmap_route\" class=\"md-icon-button\" ng-click=\"openRoute()\"><md-icon \nmd-font-icon=\"icon-directions\" aria-label=\"Open bingmap route\" style=\"font-size: xx-large\"></md-icon></md-button>\n<md-button class=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><div id=\"loaderDiv\" ng-if=\"showLoader\"><div class=\"loading-spiner\"><img \nsrc=\"../../../assets/images/loader.gif\" style=\"margin-left: 8rem;height: 150px;\r\n            width: 150px\"></div></div>\n<md-dialog-content ms-scroll><md-content class=\"content\" ms-scroll><div class=\"content-card\" layout=\"column\" flex><div>\n<md-button class=\"btn1\" ng-click=\"transfer();\">Transfer to Doordash</md-button></div></div></md-content>\n</md-dialog-content></md-dialog><style>\n.btn1 {\r\n        background-color: rgb(179, 228, 255);\r\n        padding: 5px;\r\n        margin: 0 0 6px 7rem;\r\n        font-size: 15px;\r\n    }\r\n\r\n    .dateTime {\r\n        display: inline-block;\r\n        position: relative;\r\n        padding: 2px;\r\n        /* margin: 18px 0; */\r\n        vertical-align: middle;\r\n    }\r\n\r\n    .loaderDiv {\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        z-index: 1000;\r\n        background-color: grey;\r\n        opacity: .8;\r\n    }\r\n\r\n    .pickupNote {\r\n        font-weight: 500;\r\n        font-family: sans-serif;\r\n        color: red;\r\n    }\r\n\r\n    .btn1:hover {\r\n        color: rgb(2, 136, 209);\r\n        font-weight: bold;\r\n    }\r\n\r\n    .no_date {\r\n        color: red;\r\n        font-weight: bold;\r\n    }\n</style>");
$templateCache.put("app/main/User/dialogs/ChangePassword/ChangePassword.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:400px;min-width:400px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Change Password of {{DisplayEmail}}</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"closeModel1()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><form \nname=\"FormChangePassword\" novalidate class=\"ms-stepper\" aria-invalid=\"false\" style=\"padding: 24px\"><md-content \nclass=\"content\" ms-scroll><md-input-container class=\"md-block\" flex-gt-sm=\"100\"><label>Password</label><input \nname=\"password\" type=\"password\" autocomplete=\"on\" ng-model=\"model.password\" ng-required=\"true\" md-maxlength=\"100\"><div \nng-messages=\"FormChangePassword.password.$error\" ng-if=\"FormChangePassword.password.$touched\"><div \nng-message=\"required\"><span>Password is required</span></div><div ng-message=\"md-maxlength\"><span>\nPassword is 100 char long</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm=\"100\">\n<label>Confirm password</label><input name=\"confirmpassword\" type=\"password\" autocomplete=\"on\" \nng-model=\"model.confirmpassword\" ng-required=\"true\" md-maxlength=\"100\"><div \nng-messages=\"FormChangePassword.confirmpassword.$error\" ng-if=\"FormChangePassword.confirmpassword.$touched\"><div \nng-message=\"required\"><span>Confirm password is required</span></div><div ng-message=\"md-maxlength\"><span>\nConfirm password is 100 char long</span></div></div></md-input-container><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-raised md-accent\" ng-disabled=\"FormChangePassword.$invalid\" \nng-click=\"ChangePassword($event,model)\">Change Password</md-button><md-button class=\"md-raised md-default\" \nng-click=\"Reset()\">Cancel</md-button></div><br></md-content></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/User/dialogs/PasswordConfirmation/PasswordConfirmation.html","<md-dialog class=\"task-dialog\" style=\"width:400px;min-width:400px\" aria-label=\"New Task\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Password Verification</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"closeModel1()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><form name=\"FormPassword\" novalidate class=\"ms-stepper\" \naria-invalid=\"false\" style=\"padding: 24px\"><div id=\"processing1\" style=\"display: none\"><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\" value=\"...\" \nmd-diameter=\"100\" class=\"page-loader\"></md-progress-circular></div></div><md-content class=\"content\" ms-scroll><div \nclass=\"row\" ng-if=\"flg==1\"><label><b>Password will send to customer email</b></label></div><div class=\"row\" \nng-if=\"flg==0\"><label>Are you sure to change Password of <u>{{username}}</u> Customer?</label></div><div class=\"row\" \nng-if=\"flg==1\"><label>Are you sure to Reset Password of <u>{{username}}</u> Customer?</label></div><div class=\"row\">\n<md-input-container class=\"md-block\"><label>Password</label><input name=\"password\" type=\"password\" ng-model=\"password\" \nng-required=\"true\"><div ng-messages=\"FormPassword.password.$error\" ng-if=\"FormPassword.password.$touched\"><div \nng-message=\"required\"><span>Password is required</span></div><div ng-message=\"md-maxlength\"><span>\nPassword is 100 char long</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-raised md-accent\" ng-disabled=\"FormPassword.$invalid\" ng-click=\"RestPassword(password)\" \nng-if=\"flg==1\">Reset</md-button><md-button class=\"md-raised md-accent\" ng-disabled=\"FormPassword.$invalid\" \nng-click=\"changePassword(password)\" ng-if=\"flg==0\">Ok</md-button><md-button class=\"md-raised md-default\" \nng-click=\"Reset()\">Cancel</md-button></div><br></md-content></form></md-dialog-content><style type=\"text/css\" \nmedia=\"screen\">\n#processing1 {\r\n            position: absolute;\r\n            top: 0;\r\n            left: 0;\r\n            width: 100%;\r\n            height: 100%;\r\n            z-index: 1;\r\n            background-color: rgba(203, 203, 203, 0.6);\r\n        }\r\n        \r\n        #processing1 .page-loader {\r\n            position: absolute;\r\n            top: 50%;\r\n            left: 50%;\r\n            margin-left: -100px;\r\n            margin-top: -100px;\r\n            z-index: 2;\r\n        }\n</style></md-dialog>");
$templateCache.put("app/main/Zipcode/dialogs/ZipCodeInformation/ZipCodeInformation.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width:1000px;min-width:600px\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Zipcode Information</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"closeModel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-content class=\"content\" ms-scroll><div \nstyle=\"padding-bottom:8px\" ng-show=\"!search_enable\"><input type=\"text\" maxlength=\"6\" ng-model=\"model.zip\" \nplaceholder=\"Enter Zip \" \nstyle=\"border-style: solid;border-width: 1px;padding: 5px;\r\n                    font-size: 21px;\r\n                    font-weight: 500\">\n<md-button class=\"md-raised md-primary ml-25\" style=\"background-color: dodgerblue;margin-top: 0\" \nng-click=\"search_zip(model)\"><b>Search</b></md-button></div><div ng-show=\"search_enable\"><table \nclass=\"dataTable row-border cell-border hover\"><thead><tr><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\" style=\"text-align: center\">Zip</span></div></th><th class=\"all\"><div class=\"table-header\"><span \nclass=\"column-title\" style=\"text-align: center\">Action</span></div></th></tr></thead><tbody><tr><th><h1 \nng-if=\"!no_zip\">{{ zipcode }}</h1><h1 ng-if=\"no_zip\">No Zip found</h1></th><th><md-button ng-if=\"!no_zip\" \nng-click=\"delete_zip()\"><md-icon md-font-icon=\"icon-trash\" class=\"s18 red-500-fg\"></md-icon><md-tooltip md-visible=\"\" \nmd-direction=\"\">Delete Zip</md-tooltip></md-button></th></tr></tbody></table></div></md-content><div></div>\n</md-dialog-content></md-dialog><style>\nh1 {\r\n        font-family: cursive;\r\n    }\r\n\r\n    .footer {\r\n        position: fixed;\r\n        left: 0;\r\n        bottom: 0;\r\n        width: 100%;\r\n        color: white;\r\n        text-align: center;\r\n    }\n</style>");
$templateCache.put("app/main/login/dialogs/ForgotPassword/ForgotPassword.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F\n</span></div><div class=\"title\" translate=\"Forgot Password\">Forgot Password</div><form name=\"ForgotPasswordForm\" \nnovalidate><md-input-container class=\"md-block\" md-no-float><label>Username or email address</label><input type=\"text\" \nname=\"email\" ng-model=\"model.Email\" required><div ng-messages=\"ForgotPasswordForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>User name or email is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Forgot Password\" \nng-click=\"ForgotPassword(model)\" ng-disabled=\"ForgotPasswordForm.$invalid || ForgotPasswordForm.$pristine\">\nForgot Password</md-button></form></div></div></div>");
$templateCache.put("app/main/login/dialogs/Register/Register.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"title\" \ntranslate=\"NEW CUSTOMERS\">NEW CUSTOMERS</div><form name=\"RegisterForm\" novalidate><md-input-container class=\"md-block\" \nmd-no-float><label>User Name<md-icon class=\"md-warn\">*</md-icon></label><input type=\"text\" name=\"username\" \nng-model=\"model.username\" required><div ng-messages=\"RegisterForm.username.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>User Name is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><label>Email Address<md-icon class=\"md-warn\">*</md-icon></label><input type=\"email\" \nname=\"email\" ng-model=\"model.email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"RegisterForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Email is required</span></div><div \nng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><label>Password</label><input type=\"password\" name=\"password\" \nautocomplete=\"on\" ng-model=\"model.password\" required><div ng-messages=\"RegisterForm.password.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Password is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><label>Confirm Password<md-icon class=\"md-warn\">*</md-icon></label>\n<input type=\"password\" name=\"cpassword\" ng-model=\"model.cpassword\" required><div \nng-messages=\"RegisterForm.cpassword.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nConfirm Password is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float>\n<label>Phone Number</label><input name=\"phone\" ng-model=\"model.phone\" type=\"number\" placeholder=\"1234567890\" \nmax=\"9999999999\" min=\"0\"><div ng-messages=\"RegisterForm.phone.$error\"><div ng-message=\"max\" class=\"my-message\">\nPhone Number can\'t be longer than 10 number.</div></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Country</label><md-select name=\"country\" ng-model=\"model.country\" \nng-change=\"GetAllStateByCountry(model.country)\"><md-option ng-repeat=\"o in lstCountry\" value=\" {{o.Country}}\">\n{{o.Country}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex><label>State\n</label><md-select name=\"state\" ng-model=\"model.state\" ng-disabled=\"model.country==\'\'\"><md-option \nng-repeat=\"o in lstState\" value=\"{{o.Name}}\">{{ o.Name }}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><label>City</label><input type=\"text\" name=\"city\" \nng-model=\"model.city\"></md-input-container><label>Gender</label><md-input-container class=\"md-block\" flex>\n<md-radio-group ng-model=\"model.gender\"><md-radio-button value=\"Male\" class=\"md-primary\">Male</md-radio-button>\n<md-radio-button value=\"Female\" class=\"md-primary\">Female</md-radio-button></md-radio-group></md-input-container>\n<md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Register\" ng-click=\"Register(model)\" \nng-disabled=\"RegisterForm.$invalid || RegisterForm.$pristine\">Register</md-button><md-button type=\"reset\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"Register\" ng-click=\"Cancel()\">Cancel</md-button></form></div>\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><a href=\"{{card.link}}\" ng-if=\"card.type==\'link\'\" target=\"_blank\"><img \nclass=\"image\" ng-src=\"{{card.full_picture}}\"><div class=\"text-center\" ng-click=\"GotoLink(d)\"><i \nclass=\"icon-link play-icon\"></i></div></a><a href=\"{{card.source}}\" ng-if=\"card.type==\'video\'\" target=\"_blank\"><img \nclass=\"image\" ng-src=\"{{card.full_picture}}\"><div class=\"text-center\" ng-click=\"playVideo(d)\"><i \nclass=\"icon-play play-icon\"></i></div></a><a ng-if=\"card.type==\'photo\'\"><img class=\"image\" \nng-src=\"{{card.full_picture}}\"></a></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" ng-if=\"card.name\">\n{{card.name}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.message\">{{card.message}}</div><div \nclass=\"text pt-16\" ng-if=\"card.description\">{{card.description}}</div></div><div class=\"buttons m-8\"><md-icon \nmd-font-icon=\"icon-heart\" class=\"s24\"></md-icon>{{card.likes.summary.total_count}}<md-icon md-font-icon=\"icon-comment\" \nclass=\"s24\"></md-icon>{{card.comments.summary.total_count}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps\" layout=\"row\" layout-align=\"start center\"><div class=\"step md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{step.stepNumber}} \n</span><span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\">\n</span></div><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");}]);